
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("9imjS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "CmdbLandingPageViewOld", () => $ecd8aa28ab12ad3e$export$a27bcd6df4355097);
$parcel$export(module.exports, "CmdbLandingPageView", () => $ecd8aa28ab12ad3e$export$badc5c3c0edac849);
$parcel$export(module.exports, "ConditionalRedirectOrRouteView", () => $ecd8aa28ab12ad3e$export$8f126bd42a3e2335);
$parcel$export(module.exports, "default", () => $ecd8aa28ab12ad3e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $bzlbR = parcelRequire("bzlbR");

var $e9YVH = parcelRequire("e9YVH");

var $j8qoE = parcelRequire("j8qoE");

var $l3q9P = parcelRequire("l3q9P");

var $inOMI = parcelRequire("inOMI");

var $blEB6 = parcelRequire("blEB6");

var $6GLlD = parcelRequire("6GLlD");

var $ivzw9 = parcelRequire("ivzw9");

var $7tQej = parcelRequire("7tQej");
var $doZTA = parcelRequire("doZTA");
const $ecd8aa28ab12ad3e$export$a27bcd6df4355097 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6GLlD.default), {
        appName: (0, $e9YVH.APP_NAMES).INSIGHT_LANDING_PAGE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ivzw9.InsightAppBaseV2), null, ({ workspaceId: workspaceId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8qoE.InsightGlobalConfigContainer), {
            isGlobal: true,
            workspaceId: workspaceId,
            createAnalyticsEvent: createAnalyticsEvent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l3q9P.InsightLandingPageContainer), {
            workspaceId: workspaceId,
            createAnalyticsEvent: createAnalyticsEvent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $inOMI.LandingPage), null)))));
};
const $ecd8aa28ab12ad3e$export$badc5c3c0edac849 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6GLlD.default), {
        appName: (0, $e9YVH.APP_NAMES).INSIGHT_LANDING_PAGE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ivzw9.InsightAppBaseV2), null, ({ workspaceId: workspaceId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8qoE.InsightGlobalConfigContainer), {
            isGlobal: true,
            workspaceId: workspaceId,
            createAnalyticsEvent: createAnalyticsEvent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l3q9P.InsightLandingPageContainer), {
            workspaceId: workspaceId,
            createAnalyticsEvent: createAnalyticsEvent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bzlbR.CmdbAsyncActionsContainer), {
            workspaceId: workspaceId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $inOMI.LandingPage), null))))));
};
const $ecd8aa28ab12ad3e$export$8f126bd42a3e2335 = ()=>{
    const [{ location: location, route: route }] = (0, $doZTA.useRouter)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    if ((0, $blEB6.isInsightRoute)(location.pathname)) {
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({
            action: 'redirected',
            actionSubject: 'routeView'
        }), 'jsmCmdbAssetsRouteRedirect landing-page', {
            redirectedFrom: route.path,
            redirectedTo: (0, $blEB6.getRootPath)()
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
            to: (0, $blEB6.getLandingPageUrl)()
        });
    }
    return (0, $4R6GH.fg)('assets_rearch_async_actions') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ecd8aa28ab12ad3e$export$badc5c3c0edac849, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ecd8aa28ab12ad3e$export$a27bcd6df4355097, null);
};
var $ecd8aa28ab12ad3e$export$2e2bcd8739ae039 = $ecd8aa28ab12ad3e$export$8f126bd42a3e2335;

});
parcelRegister("bzlbR", function(module, exports) {

$parcel$export(module.exports, "CmdbAsyncActionsContainer", () => $258ba00e46975356$export$43fcf5148d300a7a);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $2NMNM = parcelRequire("2NMNM");

var $fAfhm = parcelRequire("fAfhm");
const $258ba00e46975356$export$43fcf5148d300a7a = ({ workspaceId: workspaceId, children: children })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagsService)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "CmdbAsyncActions",
        packageName: "jiraServicedeskCmdbAsyncActions",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fAfhm.CmdbAsyncActionsStoreContainer), {
        isGlobal: true,
        workspaceId: workspaceId,
        createAnalyticsEvent: createAnalyticsEvent,
        showFlag: showFlag,
        dismissFlag: dismissFlag,
        formatMessage: formatMessage
    }, children));
};

});
parcelRegister("fAfhm", function(module, exports) {

$parcel$export(module.exports, "CmdbAsyncActionsStoreContainer", () => $3a5792d3cb9ea101$export$e6bd8f42407e77f7);
$parcel$export(module.exports, "useCmdbAsyncBulkEdit", () => $3a5792d3cb9ea101$export$95dcd216f519a772);
$parcel$export(module.exports, "useCmdbAsyncBulkQrCode", () => $3a5792d3cb9ea101$export$e5e9cc568fb5dd9);
$parcel$export(module.exports, "useCmdbAsyncActions", () => $3a5792d3cb9ea101$export$b7f849aee72f4fd6);

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");

var $eOSXz = parcelRequire("eOSXz");

var $564bj = parcelRequire("564bj");

var $2xnjS = parcelRequire("2xnjS");
const $3a5792d3cb9ea101$export$d4c72bab9d6cc13a = {
    isPolling: false,
    // Stores reference to the reject function of the polling promise so we can cancel it externally
    pollingReject: undefined,
    pollingTimeoutIds: undefined,
    tasks: undefined,
    bulkDelete: {
        isSubmitting: false
    },
    bulkEdit: {
        isSubmitting: false
    },
    bulkExport: {
        isSubmitting: false
    },
    bulkQrCode: {
        isSubmitting: false
    },
    isDismissing: []
};
const $3a5792d3cb9ea101$var$store = (0, $iXqE5.createStore)({
    initialState: $3a5792d3cb9ea101$export$d4c72bab9d6cc13a,
    actions: $eOSXz.actions
});
const $3a5792d3cb9ea101$export$e6bd8f42407e77f7 = (0, $gg7kZ.createContainer)($3a5792d3cb9ea101$var$store, {
    onInit: (0, $2xnjS.fetchInitialTasks),
    onCleanup: (0, $564bj.cancelPolling)
});
const $3a5792d3cb9ea101$export$e6aa8ccef89c70b4 = (0, $3sQ5x.createHook)($3a5792d3cb9ea101$var$store);
const $3a5792d3cb9ea101$export$eab033628dba127a = (0, $3sQ5x.createHook)($3a5792d3cb9ea101$var$store, {
    selector: ({ bulkDelete: bulkDelete })=>bulkDelete
});
const $3a5792d3cb9ea101$export$95dcd216f519a772 = (0, $3sQ5x.createHook)($3a5792d3cb9ea101$var$store, {
    selector: ({ bulkEdit: bulkEdit })=>bulkEdit
});
const $3a5792d3cb9ea101$export$77f3a7125c3728e0 = (0, $3sQ5x.createHook)($3a5792d3cb9ea101$var$store, {
    selector: ({ bulkExport: bulkExport })=>bulkExport
});
const $3a5792d3cb9ea101$export$e5e9cc568fb5dd9 = (0, $3sQ5x.createHook)($3a5792d3cb9ea101$var$store, {
    selector: ({ bulkQrCode: bulkQrCode })=>bulkQrCode
});
const $3a5792d3cb9ea101$export$b7f849aee72f4fd6 = (0, $3sQ5x.createActionsHook)($3a5792d3cb9ea101$var$store);

});
parcelRegister("eOSXz", function(module, exports) {

$parcel$export(module.exports, "actions", () => $6017372c86063979$export$e324594224ef24da);

var $5C9BP = parcelRequire("5C9BP");

var $cw6qU = parcelRequire("cw6qU");

var $2yc90 = parcelRequire("2yc90");

var $iZKRA = parcelRequire("iZKRA");
const $6017372c86063979$export$e324594224ef24da = {
    submitBulkExportTask: $2yc90.submitBulkExportTask,
    submitBulkQrCodeTask: $iZKRA.submitBulkQrCodeTask,
    submitBulkDeleteTask: $5C9BP.submitBulkDeleteTask,
    submitBulkEditTask: $cw6qU.submitBulkEditTask
};

});
parcelRegister("5C9BP", function(module, exports) {

$parcel$export(module.exports, "submitBulkDeleteTask", () => $53175569f6f3e8c7$export$d381dd6d470705e9);

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $iRdzc = parcelRequire("iRdzc");

var $fmoqT = parcelRequire("fmoqT");

var $gpISd = parcelRequire("gpISd");

var $lNC72 = parcelRequire("lNC72");

var $kYIR2 = parcelRequire("kYIR2");

var $fTrfQ = parcelRequire("fTrfQ");
const $53175569f6f3e8c7$export$d381dd6d470705e9 = ({ objectCount: objectCount, ...body })=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        if (getState().bulkDelete.isSubmitting) return;
        setState({
            bulkDelete: {
                isSubmitting: true
            }
        });
        try {
            const { taskId: taskId } = await (0, $gpISd.createAsyncBulkDeleteTask)(workspaceId, {
                ...body
            });
            setState({
                tasks: (0, $fmoqT.mergeTasks)(getState().tasks, [
                    {
                        taskId: taskId,
                        operationType: (0, $iRdzc.OPERATION_TYPE_BULK_DELETE),
                        status: (0, $iRdzc.STATUS_QUEUED)
                    }
                ]),
                bulkDelete: {
                    isSubmitting: false
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'submitAsyncBulkDeleteTask succeeded');
            dispatch((0, $kYIR2.showSuccessFlag)({
                id: taskId,
                objectCount: objectCount,
                action: (0, $iRdzc.OPERATION_TYPE_BULK_DELETE)
            }));
            dispatch((0, $fTrfQ.startTaskPolling)());
        } catch (error) {
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                error: error instanceof Error ? error : undefined,
                meta: {
                    id: 'submitAsyncBulkDeleteTask',
                    packageName: 'jiraServicedeskCmdbAsyncActions',
                    teamName: 'falcons'
                }
            });
            setState({
                bulkDelete: {
                    isSubmitting: false
                }
            });
            dispatch((0, $lNC72.showErrorFlag)({
                action: (0, $iRdzc.OPERATION_TYPE_BULK_DELETE),
                objectCount: objectCount
            }));
            throw error;
        }
    };

});
parcelRegister("iRdzc", function(module, exports) {

$parcel$export(module.exports, "OPERATION_TYPE_BULK_EDIT", () => $1ee808f0bfcaa90a$export$c4a0fd6df07697e9);
$parcel$export(module.exports, "OPERATION_TYPE_BULK_DELETE", () => $1ee808f0bfcaa90a$export$940d318e182226db);
$parcel$export(module.exports, "OPERATION_TYPE_BULK_EXPORT", () => $1ee808f0bfcaa90a$export$c331466741bc25dd);
$parcel$export(module.exports, "OPERATION_TYPE_BULK_QR_CODE", () => $1ee808f0bfcaa90a$export$ac103f1dc164db47);
$parcel$export(module.exports, "STATUS_QUEUED", () => $1ee808f0bfcaa90a$export$5151c63487c6074a);
$parcel$export(module.exports, "STATUS_COMPLETED", () => $1ee808f0bfcaa90a$export$81f34347d5a84d5f);
const $1ee808f0bfcaa90a$export$c4a0fd6df07697e9 = 'BulkEdit';
const $1ee808f0bfcaa90a$export$940d318e182226db = 'BulkDelete';
const $1ee808f0bfcaa90a$export$c331466741bc25dd = 'BulkExport';
const $1ee808f0bfcaa90a$export$ac103f1dc164db47 = 'QrCode';
const $1ee808f0bfcaa90a$export$5151c63487c6074a = 'Queued';
const $1ee808f0bfcaa90a$export$f1c7e78b7edcac86 = 'InProgress';
const $1ee808f0bfcaa90a$export$81f34347d5a84d5f = 'Completed';
const $1ee808f0bfcaa90a$export$d4ce95d919eced6d = 'Archived';
const $1ee808f0bfcaa90a$export$7ee58d019dd6dcbe = (id)=>id;

});

parcelRegister("fmoqT", function(module, exports) {

$parcel$export(module.exports, "mergeTasks", () => $9809f166e6f25c7e$export$e574549178e429d1);
const $9809f166e6f25c7e$export$e574549178e429d1 = (existingTasks, newTasks)=>{
    const taskMap = new Map();
    (existingTasks ?? []).forEach((item)=>taskMap.set(item.taskId, item));
    (newTasks ?? []).forEach((item)=>taskMap.set(item.taskId, {
            ...taskMap.get(item.taskId),
            ...item
        }));
    return Array.from(taskMap.values());
};

});

parcelRegister("gpISd", function(module, exports) {

$parcel$export(module.exports, "createAsyncBulkDeleteTask", () => $89badbed27fd1383$export$bc219e67a7d1e34);

var $4VpwK = parcelRequire("4VpwK");

var $eJOOa = parcelRequire("eJOOa");
const $89badbed27fd1383$export$bc219e67a7d1e34 = (workspaceId, params)=>(0, $4VpwK.performCmdbPostRequest)((0, $eJOOa.getCmdbAsyncBulkDeleteUrl)(workspaceId), {
        body: JSON.stringify(params)
    });

});

parcelRegister("lNC72", function(module, exports) {

$parcel$export(module.exports, "showErrorFlag", () => $7b3e1e8e73749b52$export$dfa2148cdb92917d);

var $24ov5 = parcelRequire("24ov5");

var $lASGq = parcelRequire("lASGq");
const $7b3e1e8e73749b52$export$dfa2148cdb92917d = ({ objectCount: objectCount, action: action })=>async (_, { showFlag: showFlag, formatMessage: formatMessage })=>{
        showFlag({
            type: 'error',
            title: formatMessage((0, $24ov5.matchTaskOperationType)(action, {
                BulkExport: ()=>(0, $lASGq.default).submitErrorFlagTitleBulkExport,
                QrCode: ()=>(0, $lASGq.default).submitErrorFlagTitleBulkQrCode,
                BulkEdit: ()=>(0, $lASGq.default).submitErrorFlagTitleBulkEdit,
                BulkDelete: ()=>(0, $lASGq.default).submitErrorFlagTitleBulkDelete
            }), {
                objectCount: objectCount
            }),
            description: formatMessage((0, $lASGq.default).submitErrorFlagDescription)
        });
    };

});
parcelRegister("24ov5", function(module, exports) {

$parcel$export(module.exports, "matchTaskByOperationType", () => $78b76af4281c1cd8$export$510ebc46a739e819);
$parcel$export(module.exports, "matchTaskOperationType", () => $78b76af4281c1cd8$export$cf557b9c27a92ef6);
$parcel$export(module.exports, "matchResultsModalTaskByOperationType", () => $78b76af4281c1cd8$export$2f361ae89fd2f09);

var $iRdzc = parcelRequire("iRdzc");
const $78b76af4281c1cd8$var$throwUnknownOperationType = (operationType)=>{
    throw new Error(`Unknown operation type: ${operationType}`);
};
const $78b76af4281c1cd8$export$510ebc46a739e819 = (task, handlers)=>{
    const operationType = task.operationType;
    switch(operationType){
        case 0, $iRdzc.OPERATION_TYPE_BULK_EDIT:
            // Unfortunately typescript doesn't support narrowing on generics, but this is valid as T extends Task
            // @ts-expect-error - TS2345 - Argument of type 'T' is not assignable to parameter of type 'Extract<T, { operationType: "BulkEdit"; }>'. Type 'Task' is not assignable to type 'Extract<T, { operationType: "BulkEdit"; }>'. Type 'BaseTask & { operationType: "BulkEdit"; } & { status: "Queued" | "InProgress"; }' is not assignable to type 'Extract<T, { operationType: "BulkEdit"; }>'
            return handlers.BulkEdit(task);
        case 0, $iRdzc.OPERATION_TYPE_BULK_DELETE:
            // Unfortunately typescript doesn't support narrowing on generics, but this is valid as T extends Task
            // @ts-expect-error - TS2345 - Argument of type 'T' is not assignable to parameter of type 'Extract<T, { operationType: "BulkDelete"; }>'. Type 'Task' is not assignable to type 'Extract<T, { operationType: "BulkDelete"; }>'. Type 'BaseTask & { operationType: "BulkDelete"; } & { status: "Queued" | "InProgress"; }' is not assignable to type 'Extract<T, { operationType: "BulkDelete"; }>'
            return handlers.BulkDelete(task);
        case 0, $iRdzc.OPERATION_TYPE_BULK_EXPORT:
            // Unfortunately typescript doesn't support narrowing on generics, but this is valid as T extends Task
            // @ts-expect-error - TS2345 - Argument of type 'T' is not assignable to parameter of type 'Extract<T, { operationType: "BulkExport"; }>'. Type 'Task' is not assignable to type 'Extract<T, { operationType: "BulkExport"; }>'. Type 'BaseTask & { operationType: "BulkExport"; } & { status: "Queued" | "InProgress"; }' is not assignable to type 'Extract<T, { operationType: "BulkExport"; }>'
            return handlers.BulkExport(task);
        case 0, $iRdzc.OPERATION_TYPE_BULK_QR_CODE:
            // Unfortunately typescript doesn't support narrowing on generics, but this is valid as T extends Task
            // @ts-expect-error - TS2345 - Argument of type 'T' is not assignable to parameter of type 'Extract<T, { operationType: "QrCode"; }>'. Type 'Task' is not assignable to type 'Extract<T, { operationType: "QrCode"; }>'. Type 'BaseTask & { operationType: "QrCode"; } & { status: "Queued" | "InProgress"; }' is not assignable to type 'Extract<T, { operationType: "QrCode"; }>'
            return handlers.QrCode(task);
        default:
            return $78b76af4281c1cd8$var$throwUnknownOperationType(operationType);
    }
};
const $78b76af4281c1cd8$export$cf557b9c27a92ef6 = (operationType, handlers)=>{
    switch(operationType){
        case 0, $iRdzc.OPERATION_TYPE_BULK_EDIT:
            return handlers.BulkEdit();
        case 0, $iRdzc.OPERATION_TYPE_BULK_DELETE:
            return handlers.BulkDelete();
        case 0, $iRdzc.OPERATION_TYPE_BULK_EXPORT:
            return handlers.BulkExport();
        case 0, $iRdzc.OPERATION_TYPE_BULK_QR_CODE:
            return handlers.QrCode();
        default:
            return $78b76af4281c1cd8$var$throwUnknownOperationType(operationType);
    }
};
const $78b76af4281c1cd8$export$2f361ae89fd2f09 = (task, handlers)=>{
    const operationType = task.operationType;
    switch(operationType){
        case 0, $iRdzc.OPERATION_TYPE_BULK_EDIT:
            // Unfortunately typescript doesn't support narrowing on generics, but this is valid as T extends Task
            // @ts-expect-error - TS2345 - Argument of type 'T' is not assignable to parameter of type 'Extract<T, { operationType: "BulkDelete"; }>'. Type 'ResultsModalTask' is not assignable to type 'Extract<T, { operationType: "BulkDelete"; }>'. Type 'BaseTask & OperationType<"BulkDelete"> & Status<"Completed"> & ResultPayload<ObjectResultPayload>' is not assignable to type 'Extract<T, { operationType: "BulkDelete"; }>'.
            return handlers.BulkEdit(task);
        case 0, $iRdzc.OPERATION_TYPE_BULK_DELETE:
            // Unfortunately typescript doesn't support narrowing on generics, but this is valid as T extends Task
            // @ts-expect-error - TS2345 - Argument of type 'T' is not assignable to parameter of type 'Extract<T, { operationType: "BulkDelete"; }>'. Type 'ResultsModalTask' is not assignable to type 'Extract<T, { operationType: "BulkDelete"; }>'. Type 'BaseTask & OperationType<"BulkDelete"> & Status<"Completed"> & ResultPayload<ObjectResultPayload>' is not assignable to type 'Extract<T, { operationType: "BulkDelete"; }>'.
            return handlers.BulkDelete(task);
        default:
            return $78b76af4281c1cd8$var$throwUnknownOperationType(operationType);
    }
};

});

parcelRegister("lASGq", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7c66f7d510213b1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e7c66f7d510213b1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    submitSuccessFlagTitleBulkExport: {
        "id": "servicedesk-cmdb-async-actions.common.submit-success-flag-title-bulk-export",
        "defaultMessage": "Action started: Export {objectCount, plural, one{{objectCount} object} other{{objectCount} objects}}"
    },
    submitSuccessFlagTitleBulkQrCode: {
        "id": "servicedesk-cmdb-async-actions.common.submit-success-flag-title-bulk-qr-code",
        "defaultMessage": "Action started: Print QR code for {objectCount, plural, one{{objectCount} object} other{{objectCount} objects}}"
    },
    submitSuccessFlagTitleBulkDelete: {
        "id": "servicedesk-cmdb-async-actions.common.submit-success-flag-title-bulk-delete",
        "defaultMessage": "Action started: Delete {objectCount, plural, one{{objectCount} object} other{{objectCount} objects}}"
    },
    submitSuccessFlagTitleBulkEdit: {
        "id": "servicedesk-cmdb-async-actions.common.submit-success-flag-title-bulk-edit",
        "defaultMessage": "Action started: Edit {objectCount, plural, one{{objectCount} object} other{{objectCount} objects}}"
    },
    submitSuccessFlagDescription: {
        "id": "servicedesk-cmdb-async-actions.common.submit-success-flag-description",
        "defaultMessage": "This action may take a while. You will receive a notification once the work is complete."
    },
    submitErrorFlagTitleBulkExport: {
        "id": "servicedesk-cmdb-async-actions.common.submit-error-flag-title-bulk-export",
        "defaultMessage": "Action failed: Export {objectCount, plural, one{{objectCount} object} other{{objectCount} objects}}"
    },
    submitErrorFlagTitleBulkQrCode: {
        "id": "servicedesk-cmdb-async-actions.common.submit-error-flag-title-bulk-qr-code",
        "defaultMessage": "Action failed: Print QR code for {objectCount, plural, one{{objectCount} object} other{{objectCount} objects}}"
    },
    submitErrorFlagTitleBulkDelete: {
        "id": "servicedesk-cmdb-async-actions.common.submit-error-flag-title-bulk-delete",
        "defaultMessage": "Action failed: Delete {objectCount, plural, one{{objectCount} object} other{{objectCount} objects}}"
    },
    submitErrorFlagTitleBulkEdit: {
        "id": "servicedesk-cmdb-async-actions.common.submit-error-flag-title-bulk-edit",
        "defaultMessage": "Action failed: Edit {objectCount, plural, one{{objectCount} object} other{{objectCount} objects}}"
    },
    submitErrorFlagDescription: {
        "id": "servicedesk-cmdb-async-actions.common.submit-error-flag-description",
        "defaultMessage": "Please check your network and try again"
    }
});

});


parcelRegister("kYIR2", function(module, exports) {

$parcel$export(module.exports, "showSuccessFlag", () => $0fccdcf8dec0c533$export$fef8478a2c810f18);

var $5uXOq = parcelRequire("5uXOq");

var $75Jbm = parcelRequire("75Jbm");

var $24ov5 = parcelRequire("24ov5");

var $lASGq = parcelRequire("lASGq");
const $0fccdcf8dec0c533$export$fef8478a2c810f18 = ({ id: id, objectCount: objectCount, action: action })=>async (_, { showFlag: showFlag, formatMessage: formatMessage })=>{
        showFlag({
            id: id,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($75Jbm))), {
                label: ""
            }),
            type: 'info',
            title: formatMessage((0, $24ov5.matchTaskOperationType)(action, {
                BulkExport: ()=>(0, $lASGq.default).submitSuccessFlagTitleBulkExport,
                QrCode: ()=>(0, $lASGq.default).submitSuccessFlagTitleBulkQrCode,
                BulkEdit: ()=>(0, $lASGq.default).submitSuccessFlagTitleBulkEdit,
                BulkDelete: ()=>(0, $lASGq.default).submitSuccessFlagTitleBulkDelete
            }), {
                objectCount: objectCount
            }),
            description: formatMessage((0, $lASGq.default).submitSuccessFlagDescription)
        });
    };

});
parcelRegister("75Jbm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $529c0c456318696f$var$_react = $529c0c456318696f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $529c0c456318696f$var$_refresh = $529c0c456318696f$var$_interopRequireDefault((parcelRequire("gPelT")));
function $529c0c456318696f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $529c0c456318696f$var$RefreshIcon = (props)=>/*#__PURE__*/ $529c0c456318696f$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M8 6.003v2.995a1 1 0 1 0 2 0V5.102C10 4.494 9.507 4 8.9 4H5a1 1 0 0 0 0 2.003z"/><path fill-rule="nonzero" d="M9.428 18.018C7.351 16.989 6 14.807 6 12.37c0-2.266 1.167-4.319 3.02-5.425.48-.286.646-.922.371-1.421a.98.98 0 0 0-1.364-.386C5.557 6.611 4 9.35 4 12.37c0 3.248 1.802 6.158 4.57 7.529.498.247 1.095.026 1.332-.493.237-.52.025-1.141-.474-1.388"/><path d="M14 15.002v3.896c0 .608.493 1.102 1.1 1.102H19a1 1 0 0 0 0-2.003h-3v-2.995a1 1 0 1 0-2 0"/><path d="M14.097 4.596c-.237.52-.025 1.14.474 1.387 2.077 1.029 3.428 3.21 3.428 5.647 0 2.266-1.167 4.32-3.021 5.425a1.063 1.063 0 0 0-.37 1.42c.274.5.885.673 1.364.387 2.47-1.473 4.027-4.212 4.027-7.232 0-3.248-1.802-6.158-4.57-7.528A.96.96 0 0 0 15.002 4a1 1 0 0 0-.905.596"/></g></svg>`
    }, props, {
        newIcon: $529c0c456318696f$var$_refresh.default
    }));
$529c0c456318696f$var$RefreshIcon.displayName = 'RefreshIcon';
var $529c0c456318696f$var$_default = module.exports.default = $529c0c456318696f$var$RefreshIcon;

});
parcelRegister("gPelT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f34e41ee33b1e524435b178556b66735>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c3fc8ad083e2745c$var$_react = $c3fc8ad083e2745c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c3fc8ad083e2745c$var$_baseNew = $c3fc8ad083e2745c$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $c3fc8ad083e2745c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Refresh".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for expanding a object or panel.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c3fc8ad083e2745c$var$RefreshIcon = (props)=>/*#__PURE__*/ $c3fc8ad083e2745c$var$_react.default.createElement($c3fc8ad083e2745c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.25 6V1.75H2m5.5 12.48c-3.218-.254-5.75-2.447-5.75-5.73 0-3.368 2.42-4.921 4-6.29m4 7.77v4.25H14M8.5 1.75c3.218.255 5.75 2.447 5.75 5.73 0 3.352-2.397 4.906-3.977 6.27"/>`
    }, props));
$c3fc8ad083e2745c$var$RefreshIcon.displayName = 'RefreshIcon';
var $c3fc8ad083e2745c$var$_default = module.exports.default = $c3fc8ad083e2745c$var$RefreshIcon;

});



parcelRegister("fTrfQ", function(module, exports) {

$parcel$export(module.exports, "startTaskPolling", () => $08b85901855d7f32$export$2888c4840b025e2a);

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $iRdzc = parcelRequire("iRdzc");


var $dhudo = parcelRequire("dhudo");

var $4oSvI = parcelRequire("4oSvI");

var $fmoqT = parcelRequire("fmoqT");

var $g9wgy = parcelRequire("g9wgy");

var $80E7L = parcelRequire("80E7L");
const $08b85901855d7f32$export$126d20606b8a2eb9 = 6;
const $08b85901855d7f32$export$2888c4840b025e2a = ()=>async ({ getState: getState, setState: setState, dispatch: dispatch }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        if (getState().isPolling) return;
        try {
            setState({
                isPolling: true
            });
            await new Promise((resolve, reject)=>{
                // Store the reject function to be able to call it later to cancel polling
                setState({
                    pollingReject: reject
                });
                $08b85901855d7f32$export$bd8e6abf001160db({
                    consecutiveErrors: 0,
                    getState: getState,
                    setState: setState,
                    dispatch: dispatch,
                    workspaceId: workspaceId,
                    createAnalyticsEvent: createAnalyticsEvent,
                    resolve: resolve,
                    reject: reject
                });
            });
        } catch (error) {
            if (error instanceof (0, $dhudo.ConsecutivePollingError)) (0, $xJtdX.fireCmdbErrorAnalytics)({
                error: error instanceof Error ? error : undefined,
                meta: {
                    id: 'consecutivePollTasks',
                    packageName: 'jiraServicedeskCmdbAsyncActions',
                    teamName: 'falcons'
                }
            });
        } finally{
            setState({
                isPolling: false,
                pollingReject: undefined,
                pollingTimeoutIds: undefined
            });
        }
    };
const $08b85901855d7f32$export$bd8e6abf001160db = async ({ consecutiveErrors: consecutiveErrors, getState: getState, setState: setState, dispatch: dispatch, workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent, resolve: resolve, reject: reject })=>{
    try {
        const newTasks = (await (0, $g9wgy.getAllTasks)(workspaceId)).tasks;
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'pollTasks succeeded');
        // If polling has been cancelled, do not update the state and show flags
        if (getState().isPolling) {
            const newCompletedTasks = (0, $4oSvI.getCompletedTasks)(getState().tasks, newTasks);
            const mergedTasks = (0, $fmoqT.mergeTasks)(getState().tasks, newTasks);
            if (newCompletedTasks.length) dispatch((0, $80E7L.showCompletedFlags)(newCompletedTasks));
            setState({
                tasks: mergedTasks
            });
            // Cancel polling if all tasks are completed or not present
            if (mergedTasks.every((task)=>task.status === (0, $iRdzc.STATUS_COMPLETED))) {
                resolve();
                return;
            }
            const timeoutId = setTimeout(()=>{
                $08b85901855d7f32$export$bd8e6abf001160db({
                    consecutiveErrors: 0,
                    getState: getState,
                    setState: setState,
                    dispatch: dispatch,
                    workspaceId: workspaceId,
                    createAnalyticsEvent: createAnalyticsEvent,
                    resolve: resolve,
                    reject: reject
                });
            }, (0, $3cdf5122ac1304e2$export$e5c3b75cb29e562d));
            setState({
                pollingTimeoutIds: [
                    ...getState().pollingTimeoutIds ?? [],
                    timeoutId
                ]
            });
        }
    } catch (error) {
        (0, $xJtdX.fireCmdbErrorAnalytics)({
            error: error instanceof Error ? error : undefined,
            meta: {
                id: 'pollTasks',
                packageName: 'jiraServicedeskCmdbAsyncActions',
                teamName: 'falcons'
            }
        });
        if (getState().isPolling) {
            if (consecutiveErrors + 1 === $08b85901855d7f32$export$126d20606b8a2eb9) {
                reject(new (0, $dhudo.ConsecutivePollingError)('Task polling failed due to consecutive errors'));
                return;
            }
            const timeoutId = setTimeout(()=>{
                $08b85901855d7f32$export$bd8e6abf001160db({
                    consecutiveErrors: consecutiveErrors + 1,
                    getState: getState,
                    setState: setState,
                    dispatch: dispatch,
                    workspaceId: workspaceId,
                    createAnalyticsEvent: createAnalyticsEvent,
                    resolve: resolve,
                    reject: reject
                });
            }, (0, $3cdf5122ac1304e2$export$e5c3b75cb29e562d));
            setState({
                pollingTimeoutIds: [
                    ...getState().pollingTimeoutIds ?? [],
                    timeoutId
                ]
            });
        }
    }
};

});
const $3cdf5122ac1304e2$export$e5c3b75cb29e562d = 10000;

parcelRegister("dhudo", function(module, exports) {

$parcel$export(module.exports, "CancelledPollingError", () => $a23797195308bdd9$export$82a97abb9eef9574);
$parcel$export(module.exports, "ConsecutivePollingError", () => $a23797195308bdd9$export$c7929430af8a16ba);
/* eslint-disable max-classes-per-file */ class $a23797195308bdd9$export$82a97abb9eef9574 extends Error {
    constructor(message){
        super(message);
        this.name = 'CancelledPollingError';
    }
}
class $a23797195308bdd9$export$c7929430af8a16ba extends Error {
    constructor(message){
        super(message);
        this.name = 'ConsecutivePollingError';
    }
}

});

parcelRegister("4oSvI", function(module, exports) {

$parcel$export(module.exports, "getCompletedTasks", () => $9caceb354a87562d$export$7a201e616c9e1a4d);

var $iRdzc = parcelRequire("iRdzc");
const $9caceb354a87562d$export$7a201e616c9e1a4d = (existingTasks, newTasks)=>{
    const existingTaskMap = new Map();
    (existingTasks ?? []).forEach((task)=>existingTaskMap.set(task.taskId, task));
    const newCompletedTasks = (newTasks ?? []).filter((task)=>task.status === (0, $iRdzc.STATUS_COMPLETED));
    const tasksToUpdate = [];
    newCompletedTasks.forEach((completedTask)=>{
        const existingTask = existingTaskMap.get(completedTask.taskId);
        if (!existingTask) // Task completed but didn't exist in state
        tasksToUpdate.push(completedTask);
        else if (existingTask.status !== (0, $iRdzc.STATUS_COMPLETED)) // Task in state was not completed but is now completed server side
        tasksToUpdate.push(completedTask);
    });
    return tasksToUpdate;
};

});

parcelRegister("g9wgy", function(module, exports) {

$parcel$export(module.exports, "getAllTasks", () => $13b6c8fcbc536816$export$d1f442602a91e7cc);

var $4VpwK = parcelRequire("4VpwK");

var $hvoOI = parcelRequire("hvoOI");
const $13b6c8fcbc536816$export$d1f442602a91e7cc = (workspaceId)=>{
    return (0, $4VpwK.performCmdbGetRequest)((0, $hvoOI.getCmdbTasksUrl)(workspaceId));
};

});
parcelRegister("hvoOI", function(module, exports) {

$parcel$export(module.exports, "getCmdbTasksUrl", () => $aaeff6dccddba8db$export$6194ab06c369c51d);

var $klJ8b = parcelRequire("klJ8b");
const $aaeff6dccddba8db$export$6194ab06c369c51d = (workspaceId)=>`${(0, $klJ8b.getCmdbRestBaseUrl)(workspaceId)}/tasks`;

});


parcelRegister("80E7L", function(module, exports) {

$parcel$export(module.exports, "showCompletedFlags", () => $b0cb25f9dc0f198b$export$c9bfd2f84e843224);

var $jbxCC = parcelRequire("jbxCC");

var $24ov5 = parcelRequire("24ov5");

var $lL4fC = parcelRequire("lL4fC");

var $abhRB = parcelRequire("abhRB");

var $dtiLn = parcelRequire("dtiLn");

var $SRLhP = parcelRequire("SRLhP");

var $5OGKb = parcelRequire("5OGKb");
const $b0cb25f9dc0f198b$export$c9bfd2f84e843224 = (completedTasks)=>({ dispatch: dispatch }, { workspaceId: workspaceId, showFlag: showFlag, dismissFlag: dismissFlag })=>{
        completedTasks.forEach((task)=>{
            // Dismiss "Action started" flag if still present
            dismissFlag(task.taskId);
            // Pass the dismiss action to the flag component
            const onDismissed = ()=>{
                // Dismiss the flag from the UI
                dismissFlag(task.taskId);
                // Dismiss the task on the server
                dispatch((0, $5OGKb.dismissTask)({
                    taskId: task.taskId
                }));
            };
            const taskUrl = (0, $jbxCC.getCmdbTaskByIdUrl)(workspaceId, task.taskId);
            showFlag((0, $24ov5.matchTaskByOperationType)(task, {
                BulkEdit: (bulkEditTask)=>(0, $abhRB.bulkEditFlagHandler)({
                        task: bulkEditTask,
                        taskUrl: taskUrl,
                        onDismissed: onDismissed
                    }),
                BulkDelete: (bulkDeleteTask)=>(0, $lL4fC.bulkDeleteFlagHandler)({
                        task: bulkDeleteTask,
                        taskUrl: taskUrl,
                        onDismissed: onDismissed
                    }),
                BulkExport: (bulkExportTask)=>(0, $dtiLn.bulkExportFlagHandler)({
                        task: bulkExportTask,
                        taskUrl: taskUrl,
                        onDismissed: onDismissed
                    }),
                QrCode: (qrCodeTask)=>(0, $SRLhP.qrCodeFlagHandler)({
                        task: qrCodeTask,
                        taskUrl: taskUrl,
                        onDismissed: onDismissed
                    })
            }));
        });
    };

});
parcelRegister("jbxCC", function(module, exports) {

$parcel$export(module.exports, "getCmdbTaskByIdUrl", () => $f9b7843d5897ebfb$export$4d71337e7d7c3627);
$parcel$export(module.exports, "getCmdbTaskArchiveUrl", () => $f9b7843d5897ebfb$export$7107cbf1ad1ef8d8);

var $klJ8b = parcelRequire("klJ8b");
const $f9b7843d5897ebfb$export$4d71337e7d7c3627 = (workspaceId, taskId)=>`${(0, $klJ8b.getCmdbRestBaseUrl)(workspaceId)}/task/${taskId}`;
const $f9b7843d5897ebfb$export$7107cbf1ad1ef8d8 = (workspaceId, taskId)=>`${$f9b7843d5897ebfb$export$4d71337e7d7c3627(workspaceId, taskId)}/archive`;

});

parcelRegister("lL4fC", function(module, exports) {

$parcel$export(module.exports, "bulkDeleteFlagHandler", () => $8ca1f05a762491a1$export$2b35d0037205a79d);

var $5uXOq = parcelRequire("5uXOq");

var $3KRpp = parcelRequire("3KRpp");

var $koVbs = parcelRequire("koVbs");

var $82H85 = parcelRequire("82H85");

var $505aW = parcelRequire("505aW");

var $j2LMc = parcelRequire("j2LMc");
const $8ca1f05a762491a1$export$9ea91b3916eea06b = ({ task: task, flagProps: flagProps, onDismissed: onDismissed })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const objectsProcessed = task.resultPayload.objectsProcessed;
    const flagActions = (0, $5uXOq.useMemo)(()=>[
            {
                content: formatMessage((0, $505aW.default).completedFlagViewReportNonfinal)
            }
        ], [
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.SuccessFlag), {
        ...flagProps,
        title: formatMessage((0, $j2LMc.default).flagTitle, {
            objectsProcessed: objectsProcessed
        }),
        id: task.taskId,
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $82H85.CompletedFlagDescription), {
            task: task
        }, !task.resultPayload.hasError ? formatMessage((0, $505aW.default).completedFlagDescriptionNonfinal) : formatMessage((0, $505aW.default).completedFlagErrorDescriptionNonfinal)),
        actions: task.resultPayload.hasError ? flagActions : undefined,
        onDismissed: onDismissed,
        testId: "servicedesk-cmdb-async-actions.common.ui.flags.completed-flag-bulk-delete"
    });
};
const $8ca1f05a762491a1$export$2b35d0037205a79d = (props)=>({
        id: props.task.taskId,
        render: (flagProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8ca1f05a762491a1$export$9ea91b3916eea06b, {
                ...props,
                flagProps: flagProps
            })
    });

});
parcelRegister("82H85", function(module, exports) {

$parcel$export(module.exports, "CompletedFlagDescription", () => $2908669a8b53b329$export$cabe46edefed4c59);

var $5uXOq = parcelRequire("5uXOq");

var $34Rrn = parcelRequire("34Rrn");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");

var $koVbs = parcelRequire("koVbs");

var $dMwN8 = parcelRequire("dMwN8");
const $2908669a8b53b329$export$915e9e7bd4f0f96d = ({ errorCount: errorCount })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.100",
        alignBlock: "center",
        testId: "servicedesk-cmdb-async-actions.common.ui.flags.completed-flag-description.error-message"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($34Rrn))), {
        label: formatMessage((0, $dMwN8.default).warningIcon),
        color: "var(--ds-icon-warning, #E56910)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        weight: "medium",
        color: "color.text.warning"
    }, formatMessage((0, $dMwN8.default).errorsEncountered, {
        errorCount: errorCount
    })));
};
const $2908669a8b53b329$export$cabe46edefed4c59 = ({ task: task, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.100"
    }, task.resultPayload.hasError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2908669a8b53b329$export$915e9e7bd4f0f96d, {
        errorCount: task.resultPayload.objectsEncounteredError
    }), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        testId: "servicedesk-cmdb-async-actions.common.ui.flags.completed-flag-description.children-wrapper"
    }, children));
};

});
parcelRegister("dMwN8", function(module, exports) {

$parcel$export(module.exports, "default", () => $b68cb409d814c2de$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b68cb409d814c2de$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    warningIcon: {
        "id": "servicedesk-cmdb-async-actions.common.flags.completed-flag-description.warning-icon",
        "defaultMessage": "Warning"
    },
    errorsEncountered: {
        "id": "servicedesk-cmdb-async-actions.common.flags.completed-flag-description.errors-encountered",
        "defaultMessage": "{errorCount, plural,\n    \t\t=0 {Error encountered}\n    \t\tone {{errorCount} error encountered}\n    \t\tother {{errorCount} errors encountered}\n\t\t}"
    }
});

});


parcelRegister("505aW", function(module, exports) {

$parcel$export(module.exports, "default", () => $de74901bbd56c305$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $de74901bbd56c305$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    completedFlagDescriptionNonfinal: {
        "id": "servicedesk-cmdb-async-actions.common.completed-flag-description-nonfinal",
        "defaultMessage": "This action was completed successfully"
    },
    completedFlagErrorDescriptionNonfinal: {
        "id": "servicedesk-cmdb-async-actions.common.completed-flag-error-description-nonfinal",
        "defaultMessage": "Use the link below to check the outcome of your bulk action and view the objects that encountered error"
    },
    completedFlagViewReportNonfinal: {
        "id": "servicedesk-cmdb-async-actions.common.flags.completed-flag-view-report-nonfinal",
        "defaultMessage": "View report"
    }
});

});

parcelRegister("j2LMc", function(module, exports) {

$parcel$export(module.exports, "default", () => $7dbc88d3bf821a2c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7dbc88d3bf821a2c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    flagTitle: {
        "id": "servicedesk-cmdb-async-actions.common.flags.completed-flag-bulk-delete.flag-title",
        "defaultMessage": "{objectsProcessed, plural,\n    \t\t=0 {Action complete: Delete}\n    \t\tone {Action complete: Delete {objectsProcessed} object}\n    \t\tother {Action complete: Delete {objectsProcessed} objects}\n\t\t}"
    }
});

});


parcelRegister("abhRB", function(module, exports) {

$parcel$export(module.exports, "bulkEditFlagHandler", () => $2481ae240d91a5ed$export$baf8c2432df5f1d1);

var $5uXOq = parcelRequire("5uXOq");

var $3KRpp = parcelRequire("3KRpp");

var $koVbs = parcelRequire("koVbs");

var $2KAtx = parcelRequire("2KAtx");

var $lEb4X = parcelRequire("lEb4X");

var $82H85 = parcelRequire("82H85");

var $69r4m = parcelRequire("69r4m");

var $505aW = parcelRequire("505aW");

var $5PDbS = parcelRequire("5PDbS");

var $02kdu = parcelRequire("02kdu");
const $2481ae240d91a5ed$export$860f6c8e73756062 = ({ task: task, flagProps: flagProps, onDismissed: onDismissed })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const objectsProcessed = task.resultPayload.objectsProcessed;
    const flagActions = (0, $5uXOq.useMemo)(()=>[
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2KAtx.ModalEntryPointPressableTrigger), {
                    entryPoint: (0, $lEb4X.cmdbAsyncActionsResultsEntryPoint),
                    modalProps: (0, $69r4m.cmdbAsyncActionsResultsEntrypointModalProps),
                    entryPointProps: (0, $5PDbS.getCmdbAsyncActionsResultsModalEntrypointProps)(task),
                    interactionName: "cmdb-async-actions-results-modal",
                    useInternalModal: true
                }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
                        ref: ref
                    }, formatMessage((0, $505aW.default).completedFlagViewReportNonfinal))),
                onClick: ()=>onDismissed(task.taskId)
            }
        ], [
        formatMessage,
        onDismissed,
        task
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.SuccessFlag), {
        ...flagProps,
        title: formatMessage((0, $02kdu.default).flagTitle, {
            objectsProcessed: objectsProcessed
        }),
        id: task.taskId,
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $82H85.CompletedFlagDescription), {
            task: task
        }, !task.resultPayload.hasError ? formatMessage((0, $505aW.default).completedFlagDescriptionNonfinal) : formatMessage((0, $505aW.default).completedFlagErrorDescriptionNonfinal)),
        actions: task.resultPayload.hasError ? flagActions : undefined,
        onDismissed: onDismissed,
        testId: "servicedesk-cmdb-async-actions.common.ui.flags.completed-flag-bulk-edit"
    });
};
const $2481ae240d91a5ed$export$baf8c2432df5f1d1 = (props)=>({
        id: props.task.taskId,
        render: (flagProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2481ae240d91a5ed$export$860f6c8e73756062, {
                ...props,
                flagProps: flagProps
            })
    });

});
parcelRegister("lEb4X", function(module, exports) {

$parcel$export(module.exports, "cmdbAsyncActionsResultsEntryPoint", () => $b7514736b1fa1422$export$f293eb996a7b28cc);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $b7514736b1fa1422$export$f293eb996a7b28cc = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("eH6o9")).then(({ CmdbAsyncActionsResultsModal: CmdbAsyncActionsResultsModal })=>CmdbAsyncActionsResultsModal), {
        moduleId: "d84134e3"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("eH6o9", function(module, exports) {

let $ab2a0976e2429b69$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ab2a0976e2429b69$var$load("2Ovoy").then(()=>parcelRequire('3Xr6z'));

});


parcelRegister("69r4m", function(module, exports) {

$parcel$export(module.exports, "cmdbAsyncActionsResultsEntrypointModalProps", () => $2cbd51ffdd52f0c8$export$18e02f180fe877f8);

var $9q9kr = parcelRequire("9q9kr");
const $2cbd51ffdd52f0c8$export$18e02f180fe877f8 = {
    width: (0, $9q9kr.RESULTS_MODAL_WIDTH)
};

});
parcelRegister("9q9kr", function(module, exports) {

$parcel$export(module.exports, "RESULTS_MODAL_WIDTH", () => $683a14d5ad251158$export$c8747c4f4579143a);
$parcel$export(module.exports, "BULK_EDIT_COLUMNS", () => $683a14d5ad251158$export$f5444868038df03);

var $l9N2z = parcelRequire("l9N2z");
const $683a14d5ad251158$export$c8747c4f4579143a = 'x-large';
const $683a14d5ad251158$export$f5444868038df03 = [
    (0, $l9N2z.default).affectedObjectsHeaderNonFinal,
    (0, $l9N2z.default).attributesEditedHeaderNonFinal,
    (0, $l9N2z.default).actionPerformedHeaderNonFinal,
    (0, $l9N2z.default).errorsHeaderNonFinal
];

});
parcelRegister("l9N2z", function(module, exports) {

$parcel$export(module.exports, "default", () => $5473615085c8106e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5473615085c8106e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    affectedObjectsHeaderNonFinal: {
        "id": "servicedesk-cmdb-async-actions-results-modal.common.affected-objects-header",
        "defaultMessage": "Affected object"
    },
    attributesEditedHeaderNonFinal: {
        "id": "servicedesk-cmdb-async-actions-results-modal.common.attribute-edited-header",
        "defaultMessage": "Attribute edited"
    },
    actionPerformedHeaderNonFinal: {
        "id": "servicedesk-cmdb-async-actions-results-modal.common.action-performed-header",
        "defaultMessage": "Action performed"
    },
    errorsHeaderNonFinal: {
        "id": "servicedesk-cmdb-async-actions-results-modal.common.errors-header",
        "defaultMessage": "Error"
    }
});

});



parcelRegister("5PDbS", function(module, exports) {

$parcel$export(module.exports, "getCmdbAsyncActionsResultsModalEntrypointProps", () => $d37d7e869379ce35$export$982b6b582222d38e);
const $d37d7e869379ce35$export$982b6b582222d38e = ({ taskId: taskId })=>({
        taskId: taskId
    });

});

parcelRegister("02kdu", function(module, exports) {

$parcel$export(module.exports, "default", () => $4090163772689ba1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4090163772689ba1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    flagTitle: {
        "id": "servicedesk-cmdb-async-actions.common.flags.completed-flag-bulk-edit.flag-title",
        "defaultMessage": "{objectsProcessed, plural,\n    \t\t=0 {Action complete: Edit}\n    \t\tone {Action complete: Edit {objectsProcessed} object}\n    \t\tother {Action complete: Edit {objectsProcessed} objects}\n\t\t}"
    }
});

});


parcelRegister("dtiLn", function(module, exports) {

$parcel$export(module.exports, "bulkExportFlagHandler", () => $d2126e87e2a0b397$export$18187318bf1df780);

var $5uXOq = parcelRequire("5uXOq");

var $3KRpp = parcelRequire("3KRpp");

var $koVbs = parcelRequire("koVbs");

var $82H85 = parcelRequire("82H85");

var $505aW = parcelRequire("505aW");

var $lGMpb = parcelRequire("lGMpb");
const $d2126e87e2a0b397$export$9a516da0426837b3 = ({ task: task, taskUrl: taskUrl, flagProps: flagProps, onDismissed: onDismissed })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const objectsProcessed = task.resultPayload.objectsProcessed;
    const flagActions = (0, $5uXOq.useMemo)(()=>[
            {
                content: formatMessage((0, $lGMpb.default).downloadExportNonfinal),
                href: taskUrl,
                download: true
            }
        ], [
        formatMessage,
        taskUrl
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.SuccessFlag), {
        ...flagProps,
        title: formatMessage((0, $lGMpb.default).flagTitle, {
            objectsProcessed: objectsProcessed
        }),
        id: task.taskId,
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $82H85.CompletedFlagDescription), {
            task: task
        }, !task.resultPayload.hasError ? formatMessage((0, $505aW.default).completedFlagDescriptionNonfinal) : undefined),
        actions: !task.resultPayload.hasError ? flagActions : undefined,
        onDismissed: onDismissed,
        testId: "servicedesk-cmdb-async-actions.common.ui.flags.completed-flag-bulk-export"
    });
};
const $d2126e87e2a0b397$export$18187318bf1df780 = (props)=>({
        id: props.task.taskId,
        render: (flagProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d2126e87e2a0b397$export$9a516da0426837b3, {
                ...props,
                flagProps: flagProps
            })
    });

});
parcelRegister("lGMpb", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec6281d74d714d22$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ec6281d74d714d22$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    flagTitle: {
        "id": "servicedesk-cmdb-async-actions.common.flags.completed-flag-bulk-export.flag-title",
        "defaultMessage": "{objectsProcessed, plural,\n    \t\t=0 {Action complete: Export}\n    \t\tone {Action complete: Export {objectsProcessed} object}\n    \t\tother {Action complete: Export {objectsProcessed} objects}\n\t\t}"
    },
    downloadExportNonfinal: {
        "id": "servicedesk-cmdb-async-actions.common.flags.completed-bulk-export-flag.download-export-nonfinal",
        "defaultMessage": "Download export"
    }
});

});


parcelRegister("SRLhP", function(module, exports) {

$parcel$export(module.exports, "qrCodeFlagHandler", () => $d6afe4ea9a1edf51$export$c7457667617d9d08);

var $5uXOq = parcelRequire("5uXOq");

var $3KRpp = parcelRequire("3KRpp");

var $koVbs = parcelRequire("koVbs");

var $82H85 = parcelRequire("82H85");

var $505aW = parcelRequire("505aW");

var $fu3V7 = parcelRequire("fu3V7");
const $d6afe4ea9a1edf51$export$1698fbb007856211 = ({ task: task, taskUrl: taskUrl, flagProps: flagProps, onDismissed: onDismissed })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const objectsProcessed = task.resultPayload.objectsProcessed;
    const flagActions = (0, $5uXOq.useMemo)(()=>[
            {
                content: formatMessage((0, $fu3V7.default).downloadPdfNonfinal),
                href: taskUrl,
                download: true
            }
        ], [
        formatMessage,
        taskUrl
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.SuccessFlag), {
        ...flagProps,
        title: formatMessage((0, $fu3V7.default).flagTitle, {
            objectsProcessed: objectsProcessed
        }),
        id: task.taskId,
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $82H85.CompletedFlagDescription), {
            task: task
        }, !task.resultPayload.hasError ? formatMessage((0, $505aW.default).completedFlagDescriptionNonfinal) : undefined),
        actions: !task.resultPayload.hasError ? flagActions : undefined,
        onDismissed: onDismissed,
        testId: "servicedesk-cmdb-async-actions.common.ui.flags.completed-flag-qr-code"
    });
};
const $d6afe4ea9a1edf51$export$c7457667617d9d08 = (props)=>({
        id: props.task.taskId,
        render: (flagProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d6afe4ea9a1edf51$export$1698fbb007856211, {
                ...props,
                flagProps: flagProps
            })
    });

});
parcelRegister("fu3V7", function(module, exports) {

$parcel$export(module.exports, "default", () => $431376789140fbac$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $431376789140fbac$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    flagTitle: {
        "id": "servicedesk-cmdb-async-actions.common.flags.completed-flag-qr-code.flag-title",
        "defaultMessage": "{objectsProcessed, plural,\n    \t\t=0 {Action complete: Print QR code}\n    \t\tone {Action complete: Print QR code for {objectsProcessed} object}\n    \t\tother {Action complete: Print QR code for {objectsProcessed} objects}\n\t\t}"
    },
    downloadPdfNonfinal: {
        "id": "servicedesk-cmdb-async-actions.common.flags.completed-qr-code-flag.download-pdf-nonfinal",
        "defaultMessage": "Download PDF"
    }
});

});


parcelRegister("5OGKb", function(module, exports) {

$parcel$export(module.exports, "dismissTask", () => $20a8c52758575002$export$a478448c6707d080);

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $lSsXb = parcelRequire("lSsXb");
const $20a8c52758575002$export$a478448c6707d080 = ({ taskId: taskId })=>async ({ getState: getState, setState: setState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        // This is just to prevent multiple dismiss requests for the same task, won't ever be shown in the UI
        if (getState().isDismissing.includes(taskId)) return;
        setState({
            isDismissing: [
                ...getState().isDismissing,
                taskId
            ]
        });
        try {
            await (0, $lSsXb.dismissTaskById)(workspaceId, taskId);
            setState({
                tasks: [
                    ...(getState().tasks ?? [])?.filter((task)=>task.taskId !== taskId)
                ],
                isDismissing: [
                    ...getState().isDismissing.filter((existingTaskId)=>existingTaskId !== taskId)
                ]
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'dismissTask succeeded');
        } catch (error) {
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                error: error instanceof Error ? error : undefined,
                meta: {
                    id: 'dismissTask',
                    packageName: 'jiraServicedeskCmdbAsyncActions',
                    teamName: 'falcons'
                }
            });
            setState({
                isDismissing: [
                    ...getState().isDismissing.filter((existingTaskId)=>existingTaskId !== taskId)
                ]
            });
        // We are intentionally swallowing the error here as we don't want a failure to be a blocking action and should be hidden from the user
        }
    };

});
parcelRegister("lSsXb", function(module, exports) {

$parcel$export(module.exports, "dismissTaskById", () => $7803b2e41f8e6fff$export$70a045fc9df8a39d);

var $4VpwK = parcelRequire("4VpwK");

var $jbxCC = parcelRequire("jbxCC");
const $7803b2e41f8e6fff$export$70a045fc9df8a39d = (workspaceId, taskId)=>{
    return (0, $4VpwK.performCmdbPostRequest)((0, $jbxCC.getCmdbTaskArchiveUrl)(workspaceId, taskId), {
        body: JSON.stringify({
            dismissed: true
        })
    });
};

});





parcelRegister("cw6qU", function(module, exports) {

$parcel$export(module.exports, "submitBulkEditTask", () => $e44a5ccf98105b79$export$327e6e4fb0736756);

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $iRdzc = parcelRequire("iRdzc");

var $fmoqT = parcelRequire("fmoqT");

var $bDlPY = parcelRequire("bDlPY");

var $lNC72 = parcelRequire("lNC72");

var $kYIR2 = parcelRequire("kYIR2");

var $fTrfQ = parcelRequire("fTrfQ");
const $e44a5ccf98105b79$export$327e6e4fb0736756 = ({ objectCount: objectCount, ...body })=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        if (getState().bulkEdit.isSubmitting) return;
        setState({
            bulkEdit: {
                isSubmitting: true
            }
        });
        try {
            const { taskId: taskId } = await (0, $bDlPY.createAsyncBulkEditTask)(workspaceId, {
                ...body
            });
            setState({
                tasks: (0, $fmoqT.mergeTasks)(getState().tasks, [
                    {
                        taskId: taskId,
                        operationType: (0, $iRdzc.OPERATION_TYPE_BULK_EDIT),
                        status: (0, $iRdzc.STATUS_QUEUED)
                    }
                ]),
                bulkEdit: {
                    isSubmitting: false
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'submitAsyncBulkEditTask succeeded');
            dispatch((0, $kYIR2.showSuccessFlag)({
                id: taskId,
                objectCount: objectCount,
                action: (0, $iRdzc.OPERATION_TYPE_BULK_EDIT)
            }));
            dispatch((0, $fTrfQ.startTaskPolling)());
        } catch (error) {
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                error: error instanceof Error ? error : undefined,
                meta: {
                    id: 'submitAsyncBulkEditTask',
                    packageName: 'jiraServicedeskCmdbAsyncActions',
                    teamName: 'falcons'
                }
            });
            setState({
                bulkEdit: {
                    isSubmitting: false
                }
            });
            dispatch((0, $lNC72.showErrorFlag)({
                action: (0, $iRdzc.OPERATION_TYPE_BULK_EDIT),
                objectCount: objectCount
            }));
            throw error;
        }
    };

});
parcelRegister("bDlPY", function(module, exports) {

$parcel$export(module.exports, "createAsyncBulkEditTask", () => $733a14596ca44221$export$78ce27891c7c0411);

var $4VpwK = parcelRequire("4VpwK");

var $eJOOa = parcelRequire("eJOOa");
const $733a14596ca44221$export$78ce27891c7c0411 = (workspaceId, params)=>(0, $4VpwK.performCmdbPostRequest)((0, $eJOOa.getCmdbAsyncBulkEditUrl)(workspaceId), {
        body: JSON.stringify({
            objectEntry: {
                objectTypeId: params.filters.objectTypeId,
                attributes: params.attributeOperations
            },
            filters: params.filters
        })
    });

});


parcelRegister("2yc90", function(module, exports) {

$parcel$export(module.exports, "submitBulkExportTask", () => $5d0567a5ed6d26f1$export$afec378dd533375d);

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $iRdzc = parcelRequire("iRdzc");

var $fmoqT = parcelRequire("fmoqT");

var $kRDs3 = parcelRequire("kRDs3");

var $lNC72 = parcelRequire("lNC72");

var $kYIR2 = parcelRequire("kYIR2");

var $fTrfQ = parcelRequire("fTrfQ");
const $5d0567a5ed6d26f1$export$afec378dd533375d = ({ objectCount: objectCount, ...body })=>async ({ getState: getState, setState: setState, dispatch: dispatch }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        if (getState().bulkExport.isSubmitting) return;
        setState({
            bulkExport: {
                isSubmitting: true
            }
        });
        try {
            const { taskId: taskId } = await (0, $kRDs3.createAsyncBulkExportTask)(workspaceId, {
                ...body
            });
            setState({
                tasks: (0, $fmoqT.mergeTasks)(getState().tasks, [
                    {
                        taskId: taskId,
                        operationType: (0, $iRdzc.OPERATION_TYPE_BULK_EXPORT),
                        status: (0, $iRdzc.STATUS_QUEUED)
                    }
                ]),
                bulkExport: {
                    isSubmitting: false
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'submitAsyncBulkExportTask succeeded');
            dispatch((0, $kYIR2.showSuccessFlag)({
                id: taskId,
                objectCount: objectCount,
                action: (0, $iRdzc.OPERATION_TYPE_BULK_EXPORT)
            }));
            dispatch((0, $fTrfQ.startTaskPolling)());
        } catch (error) {
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                error: error instanceof Error ? error : undefined,
                meta: {
                    id: 'submitAsyncBulkExportTask',
                    packageName: 'jiraServicedeskCmdbAsyncActions',
                    teamName: 'falcons'
                }
            });
            setState({
                bulkExport: {
                    isSubmitting: false
                }
            });
            dispatch((0, $lNC72.showErrorFlag)({
                action: (0, $iRdzc.OPERATION_TYPE_BULK_EXPORT),
                objectCount: objectCount
            }));
            throw error;
        }
    };

});
parcelRegister("kRDs3", function(module, exports) {

$parcel$export(module.exports, "createAsyncBulkExportTask", () => $3f1ab51cf6df367a$export$9a27b34ed9dfe3bb);

var $4VpwK = parcelRequire("4VpwK");

var $eJOOa = parcelRequire("eJOOa");
const $3f1ab51cf6df367a$export$9a27b34ed9dfe3bb = (workspaceId, params)=>(0, $4VpwK.performCmdbPostRequest)((0, $eJOOa.getCmdbAsyncObjectExportUrl)(workspaceId), {
        body: JSON.stringify(params)
    });

});


parcelRegister("iZKRA", function(module, exports) {

$parcel$export(module.exports, "submitBulkQrCodeTask", () => $0751d58d278d45b9$export$22f6482695c3c60c);

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $iRdzc = parcelRequire("iRdzc");

var $fmoqT = parcelRequire("fmoqT");

var $39rUH = parcelRequire("39rUH");

var $lNC72 = parcelRequire("lNC72");

var $kYIR2 = parcelRequire("kYIR2");

var $fTrfQ = parcelRequire("fTrfQ");
const $0751d58d278d45b9$export$22f6482695c3c60c = ({ objectCount: objectCount, size: size, ...body })=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        if (getState().bulkQrCode.isSubmitting) return;
        setState({
            bulkQrCode: {
                isSubmitting: true
            }
        });
        try {
            const { taskId: taskId } = await (0, $39rUH.createAsyncBulkQrCodeTask)(workspaceId, size, {
                ...body
            });
            setState({
                tasks: (0, $fmoqT.mergeTasks)(getState().tasks, [
                    {
                        taskId: taskId,
                        operationType: (0, $iRdzc.OPERATION_TYPE_BULK_QR_CODE),
                        status: (0, $iRdzc.STATUS_QUEUED)
                    }
                ]),
                bulkQrCode: {
                    isSubmitting: false
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'submitAsyncBulkQrCodeTask succeeded');
            dispatch((0, $kYIR2.showSuccessFlag)({
                id: taskId,
                objectCount: objectCount,
                action: (0, $iRdzc.OPERATION_TYPE_BULK_QR_CODE)
            }));
            dispatch((0, $fTrfQ.startTaskPolling)());
        } catch (error) {
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                error: error instanceof Error ? error : undefined,
                meta: {
                    id: 'submitAsyncBulkQrCodeTask',
                    packageName: 'jiraServicedeskCmdbAsyncActions',
                    teamName: 'falcons'
                }
            });
            setState({
                bulkQrCode: {
                    isSubmitting: false
                }
            });
            dispatch((0, $lNC72.showErrorFlag)({
                action: (0, $iRdzc.OPERATION_TYPE_BULK_QR_CODE),
                objectCount: objectCount
            }));
            throw error;
        }
    };

});
parcelRegister("39rUH", function(module, exports) {

$parcel$export(module.exports, "createAsyncBulkQrCodeTask", () => $d5487158ffdb326f$export$2ed432cc0e33a12d);

var $4VpwK = parcelRequire("4VpwK");

var $eJOOa = parcelRequire("eJOOa");
const $d5487158ffdb326f$export$2ed432cc0e33a12d = (workspaceId, size, params)=>(0, $4VpwK.performCmdbPostRequest)((0, $eJOOa.getCmdbAsyncBulkQrCodeUrl)(workspaceId, {
        size: size
    }), {
        body: JSON.stringify(params)
    });

});



parcelRegister("564bj", function(module, exports) {

$parcel$export(module.exports, "cancelPolling", () => $5e44861368590d82$export$1a7da92a8e07d110);

var $dhudo = parcelRequire("dhudo");
const $5e44861368590d82$export$cfd66e6c9491ee05 = new (0, $dhudo.CancelledPollingError)('Polling cancelled');
const $5e44861368590d82$export$1a7da92a8e07d110 = ()=>async ({ getState: getState, setState: setState })=>{
        if (getState().isPolling) {
            getState().pollingTimeoutIds?.forEach((timeoutId)=>{
                clearTimeout(timeoutId);
            });
            setState({
                isPolling: false
            });
            getState().pollingReject?.($5e44861368590d82$export$cfd66e6c9491ee05);
        }
    };

});

parcelRegister("2xnjS", function(module, exports) {

$parcel$export(module.exports, "fetchInitialTasks", () => $3b6f085711badec0$export$cf59b8673dd061d2);


var $fTrfQ = parcelRequire("fTrfQ");
const $3b6f085711badec0$export$cf59b8673dd061d2 = ()=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        const timeoutId = setTimeout(()=>{
            if (!getState().isPolling && !getState().tasks) dispatch((0, $fTrfQ.startTaskPolling)());
        }, (0, $3cdf5122ac1304e2$export$e5c3b75cb29e562d));
        setState({
            pollingTimeoutIds: [
                ...getState().pollingTimeoutIds ?? [],
                timeoutId
            ]
        });
    };

});



parcelRegister("l3q9P", function(module, exports) {

$parcel$export(module.exports, "useLandingPageState", () => $593269b3737b438e$export$687b2bc7971fc6ba);
$parcel$export(module.exports, "InsightLandingPageContainer", () => $593269b3737b438e$export$45375f66f83e006e);

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $aLE8f = parcelRequire("aLE8f");
const $593269b3737b438e$var$initialState = {
    schemaState: {
        type: 'loading'
    },
    recentObjectState: {
        type: 'loading'
    }
};
const $593269b3737b438e$var$Store = (0, $iXqE5.createStore)({
    initialState: $593269b3737b438e$var$initialState,
    actions: $aLE8f.actions
});
const $593269b3737b438e$export$687b2bc7971fc6ba = (0, $3sQ5x.createHook)($593269b3737b438e$var$Store, {
    selector: (state)=>state
});
const $593269b3737b438e$export$fe0bccfd53a856df = ()=>async ({ dispatch: dispatch })=>{
        await Promise.all([
            dispatch((0, $aLE8f.actions).fetchRecentObjects()),
            dispatch((0, $aLE8f.actions).fetchSchemas())
        ]);
    };
const $593269b3737b438e$export$45375f66f83e006e = (0, $gg7kZ.createContainer)($593269b3737b438e$var$Store, {
    onInit: $593269b3737b438e$export$fe0bccfd53a856df
});

});
parcelRegister("aLE8f", function(module, exports) {

$parcel$export(module.exports, "actions", () => $d041b2fc406ece50$export$e324594224ef24da);

var $32DZx = parcelRequire("32DZx");

var $fax03 = parcelRequire("fax03");

var $1zNyP = parcelRequire("1zNyP");
const $d041b2fc406ece50$export$e324594224ef24da = {
    fetchSchemas: $fax03.fetchSchemas,
    fetchRecentObjects: $32DZx.fetchRecentObjects,
    insertCreatedSchema: $1zNyP.insertCreatedSchema
};

});
parcelRegister("32DZx", function(module, exports) {

$parcel$export(module.exports, "fetchRecentObjects", () => $140611e5786ba096$export$e90246a6e71788c9);

var $xJtdX = parcelRequire("xJtdX");

var $eusud = parcelRequire("eusud");

var $8zOmE = parcelRequire("8zOmE");

var $eJOOa = parcelRequire("eJOOa");
const $140611e5786ba096$export$40097b1e4a3beaba = 20;
const $140611e5786ba096$export$e90246a6e71788c9 = ()=>async ({ setState: setState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        try {
            const response = await (0, $eusud.performGetRequest)((0, $eJOOa.getCmdbObjectRecentUrl)(workspaceId, {
                maxResults: $140611e5786ba096$export$40097b1e4a3beaba
            }));
            setState({
                recentObjectState: {
                    type: 'success',
                    recentObjects: response.values
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchRecentObjects succeeded');
        } catch (error) {
            const typesafeError = error instanceof Error ? error : new Error('Unknown error');
            setState({
                recentObjectState: {
                    type: 'error',
                    error: typesafeError
                }
            });
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                error: typesafeError,
                meta: {
                    id: 'fetchRecentObjects',
                    packageName: 'jiraServicedeskInsightLandingPageStore',
                    teamName: 'falcons'
                }
            });
        }
    };

});

parcelRegister("fax03", function(module, exports) {

$parcel$export(module.exports, "fetchSchemas", () => $bcf87724c64ef3ff$export$efff2a18d6c80f6e);

var $xJtdX = parcelRequire("xJtdX");

var $eusud = parcelRequire("eusud");

var $8zOmE = parcelRequire("8zOmE");

var $2loaL = parcelRequire("2loaL");
const $bcf87724c64ef3ff$export$40097b1e4a3beaba = 1000;
const $bcf87724c64ef3ff$export$efff2a18d6c80f6e = ()=>async ({ setState: setState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        try {
            // Currently, Insight returns the list sorted alphabetically by default
            const response = await (0, $eusud.performGetRequest)((0, $2loaL.getCmdbObjectSchemaListUrl)(workspaceId, {
                maxResults: $bcf87724c64ef3ff$export$40097b1e4a3beaba
            }));
            setState({
                schemaState: {
                    type: 'success',
                    schemas: response.values
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchObjectSchemas succeeded');
        } catch (error) {
            const typesafeError = error instanceof Error ? error : new Error('Unknown error');
            setState({
                schemaState: {
                    type: 'error',
                    error: typesafeError
                }
            });
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                error: typesafeError,
                meta: {
                    id: 'fetchSchemas',
                    packageName: 'jiraServicedeskInsightLandingPageStore',
                    teamName: 'falcons'
                }
            });
        }
    };

});
parcelRegister("2loaL", function(module, exports) {

$parcel$export(module.exports, "getCmdbObjectSchemaByIdUrl", () => $ef2507ddcf3d945c$export$7a8f746315e81598);
$parcel$export(module.exports, "getCmdbObjectSchemaByIdObjectTypesUrl", () => $ef2507ddcf3d945c$export$40fed922a68615f0);
$parcel$export(module.exports, "getCmdbObjectSchemaByIdObjectTypesFlatUrl", () => $ef2507ddcf3d945c$export$ba2d9684559c6a7);
$parcel$export(module.exports, "getCmdbObjectSchemaAllObjectTypesFlatUrl", () => $ef2507ddcf3d945c$export$5feed0fbe07a00c4);
$parcel$export(module.exports, "getCmdbObjectSchemaCreateUrl", () => $ef2507ddcf3d945c$export$f3ba592db0974a77);
$parcel$export(module.exports, "getCmdbObjectSchemaListUrl", () => $ef2507ddcf3d945c$export$e92eb77a52cdaa41);
$parcel$export(module.exports, "getCmdbFindAllAttributesUrl", () => $ef2507ddcf3d945c$export$6ffa97ba17b941e9);

var $ebyGx = parcelRequire("ebyGx");

var $klJ8b = parcelRequire("klJ8b");
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/objectschema
 */ const $ef2507ddcf3d945c$var$getCmdbObjectSchemaUrl = (workspaceId)=>`${(0, $klJ8b.getCmdbRestBaseUrl)(workspaceId)}/objectschema`;
const $ef2507ddcf3d945c$export$7a8f746315e81598 = (workspaceId, schemaId)=>`${$ef2507ddcf3d945c$var$getCmdbObjectSchemaUrl(workspaceId)}/${schemaId}`;
const $ef2507ddcf3d945c$export$40fed922a68615f0 = (workspaceId, schemaId, queryParams)=>`${$ef2507ddcf3d945c$export$7a8f746315e81598(workspaceId, schemaId)}/objecttypes?${(0, $ebyGx.stringify)(queryParams)}`;
const $ef2507ddcf3d945c$export$ba2d9684559c6a7 = (workspaceId, schemaId, queryParams)=>`${$ef2507ddcf3d945c$export$7a8f746315e81598(workspaceId, schemaId)}/objecttypes/flat${queryParams ? `?${(0, $ebyGx.stringify)(queryParams)}` : ''}`;
const $ef2507ddcf3d945c$export$5feed0fbe07a00c4 = (workspaceId, schemaId, queryParams)=>`${$ef2507ddcf3d945c$var$getCmdbObjectSchemaUrl(workspaceId)}/all/${schemaId}/objecttypes/flat?${(0, $ebyGx.stringify)(queryParams)}`;
const $ef2507ddcf3d945c$export$f3ba592db0974a77 = (workspaceId)=>`${$ef2507ddcf3d945c$var$getCmdbObjectSchemaUrl(workspaceId)}/create`;
const $ef2507ddcf3d945c$export$e92eb77a52cdaa41 = (workspaceId, queryParams)=>`${$ef2507ddcf3d945c$var$getCmdbObjectSchemaUrl(workspaceId)}/list?${(0, $ebyGx.stringify)(queryParams)}`;
const $ef2507ddcf3d945c$export$6ffa97ba17b941e9 = (workspaceId, schemaId)=>`${(0, $klJ8b.getCmdbRestBaseUrl)(workspaceId)}/objectschema/${schemaId}/attributes?${(0, $ebyGx.stringify)({
        extended: true
    })}`;

});


parcelRegister("1zNyP", function(module, exports) {

$parcel$export(module.exports, "insertCreatedSchema", () => $c5ccb235d5644188$export$1f8e1e114cb40f07);

var $1hjRs = parcelRequire("1hjRs");

var $fax03 = parcelRequire("fax03");
const $c5ccb235d5644188$export$31e3f102b22b5018 = (objectSchemas)=>objectSchemas.sort((a, b)=>a.name.localeCompare(b.name));
const $c5ccb235d5644188$var$clientSideUpdate = (createdSchema, { getState: getState, setState: setState })=>{
    const originalState = (0, $1hjRs.getSchemaStateOrThrow)(getState());
    const updatedSchemas = $c5ccb235d5644188$export$31e3f102b22b5018(originalState.schemas.concat([
        createdSchema
    ]));
    setState({
        schemaState: {
            ...originalState,
            schemas: updatedSchemas
        }
    });
};
const $c5ccb235d5644188$var$serverSideRefresh = ({ dispatch: dispatch })=>{
    dispatch((0, $fax03.fetchSchemas)());
};
const $c5ccb235d5644188$export$1f8e1e114cb40f07 = (createdSchema)=>async (storeActionApi)=>{
        $c5ccb235d5644188$var$clientSideUpdate(createdSchema, storeActionApi);
        $c5ccb235d5644188$var$serverSideRefresh(storeActionApi);
    };

});
parcelRegister("1hjRs", function(module, exports) {

$parcel$export(module.exports, "getSchemaStateOrThrow", () => $45e92e7f4d1009ac$export$ee89b40e85dd4154);
const $45e92e7f4d1009ac$export$ee89b40e85dd4154 = (state)=>{
    const { schemaState: schemaState } = state;
    if (schemaState.type !== 'success') throw new Error(`Unexpected schemaState.type value: ${schemaState.type}`);
    else return schemaState;
};

});




parcelRegister("inOMI", function(module, exports) {

$parcel$export(module.exports, "LandingPage", () => $9eff7819654ac184$export$355f3d6a1f8b250c);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fuUnn = parcelRequire("fuUnn");
var $jbeEq = parcelRequire("jbeEq");

var $l1N8i = parcelRequire("l1N8i");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $kY99m = parcelRequire("kY99m");

var $aV5bt = parcelRequire("aV5bt");

var $6amFc = parcelRequire("6amFc");

var $cS37j = parcelRequire("cS37j");

var $co1wz = parcelRequire("co1wz");

var $4R6GH = parcelRequire("4R6GH");

var $id7K0 = parcelRequire("id7K0");

var $koVbs = parcelRequire("koVbs");

var $3HwlS = parcelRequire("3HwlS");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");

var $1eAGE = parcelRequire("1eAGE");

var $63xWe = parcelRequire("63xWe");

var $hKGUh = parcelRequire("hKGUh");

var $7DxXA = parcelRequire("7DxXA");

var $j8qoE = parcelRequire("j8qoE");

var $l3q9P = parcelRequire("l3q9P");

var $duHa2 = parcelRequire("duHa2");

var $9O52b = parcelRequire("9O52b");

var $i5MrJ = parcelRequire("i5MrJ");

var $cfud7 = parcelRequire("cfud7");

var $5Ny9E = parcelRequire("5Ny9E");

var $iXNW4 = parcelRequire("iXNW4");

var $blEB6 = parcelRequire("blEB6");

var $cNd4s = parcelRequire("cNd4s");

var $hDzhb = parcelRequire("hDzhb");

var $f9Ytl = parcelRequire("f9Ytl");

var $2XH7B = parcelRequire("2XH7B");

var $c0oSL = parcelRequire("c0oSL");

var $dtVyR = parcelRequire("dtVyR");

var $cGbmp = parcelRequire("cGbmp");

var $dppTu = parcelRequire("dppTu");
const $9eff7819654ac184$export$355f3d6a1f8b250c = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { workspaceId: workspaceId } = (0, $7DxXA.useWorkspaceContext)();
    const [{ schemaState: schemaState }] = (0, $l3q9P.useLandingPageState)();
    const [{ config: globalConfigData }] = (0, $j8qoE.useInsightGlobalConfig)();
    const [{ isProvisioned: isProvisioned, provisioningLoading: provisioningLoading, myRoles: myRoles, myRolesLoading: myRolesLoading, provisioningError: provisioningError, myRolesError: myRolesError }, { fetchProvisioningStatus: fetchProvisioningStatus, fetchMyDataManagerRoles: fetchMyDataManagerRoles }] = (0, $j8qoE.useDataManager)();
    const [isSchemaModalOpen, setIsSchemaModalOpen] = (0, $5uXOq.useState)(false);
    const handleSchemaModalState = (isOpen)=>{
        setIsSchemaModalOpen(isOpen);
    };
    const { insightAdministrator: isAdmin, restrictedObjectSchemaIds: restrictedObjectSchemaIds, insightReporting: insightReporting, limitInfo: { objectCount: objectCount, objectLimit: objectLimit, billingCycle: billingCycle, limitState: limitState = 'disabled' } } = globalConfigData ?? {
        insightAdministrator: false,
        restrictedObjectSchemaIds: [],
        insightReporting: false,
        limitInfo: {
            objectCount: 0,
            objectLimit: Number.MAX_SAFE_INTEGER,
            billingCycle: 'monthly',
            limitState: 'disabled'
        }
    };
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const dataManagerLink = (0, $5uXOq.useMemo)(()=>(0, $blEB6.getDataManagerUrl)(), []);
    const adaptersLink = (0, $5uXOq.useMemo)(()=>(0, $blEB6.getDataManagerAdaptersUrl)(), []);
    const configLink = (0, $5uXOq.useMemo)(()=>(0, $blEB6.getGlobalConfigUrl)(), []);
    const reportsLink = (0, $5uXOq.useMemo)(()=>(0, $blEB6.getAssetsReportsUrl)(), []); // @ts-expect-error - TS7006 - Parameter 'analyticsEvent' implicitly has an 'any' type.
    const onClickConfigLink = (0, $5uXOq.useCallback)((analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'servicedeskInsightGlobalConfigPageNavigation');
    }, []); // @ts-expect-error - TS7006 - Parameter 'analyticsEvent' implicitly has an 'any' type.
    const onClickReportsLink = (0, $5uXOq.useCallback)((analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'servicedeskAssetsReportsPageNavigation');
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        if (myRoles === undefined && myRolesLoading !== true && myRolesError === undefined) fetchMyDataManagerRoles();
    }, [
        fetchMyDataManagerRoles,
        myRoles,
        myRolesError,
        myRolesLoading
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isProvisioned === undefined && provisioningLoading !== true && provisioningError === undefined) fetchProvisioningStatus();
    }, [
        fetchProvisioningStatus,
        isProvisioned,
        provisioningError,
        provisioningLoading
    ]);
    if (!workspaceId) return null;
    const showDataManagerLink = ()=>{
        if (isProvisioned && myRoles) {
            const hasDMRoles = myRoles.some((myRole)=>(0, $cfud7.DATA_MANAGER_ROLES).includes(myRole));
            const hasAdapterRoles = myRoles.some((myRole)=>(0, $cfud7.DATA_MANAGER_ADAPTERS_ROLES).includes(myRole));
            if (hasDMRoles) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0oSL.DataManagerLink), {
                to: dataManagerLink,
                app: "data-manager"
            }, formatMessage((0, $dtVyR.messages).dataManagerLink));
            if (hasAdapterRoles) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0oSL.DataManagerLink), {
                to: adaptersLink,
                app: "adapters"
            }, formatMessage((0, $dtVyR.messages).adaptersLink));
            return undefined;
        }
        return undefined;
    };
    const isInsightReportsEnabled = ()=>(0, $co1wz.ff)('jsm-assets-reporting_seqk0') && (isSiteAdmin || isAdmin) && insightReporting;
    const nav4Enabled = (0, $3HwlS.getWillShowNav4)() || (0, $4R6GH.fg)('assets_as_an_app_v2');
    const documentTitle = (0, $dtVyR.messages).documentTitleCmdbAssets;
    const navRefreshTitle = (0, $dtVyR.messages).navRefreshAssetsSchemasTile;
    const renderLandingPageContent = ()=>nav4Enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $9eff7819654ac184$var$overflowStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $9eff7819654ac184$var$breadCrumbsWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jbeEq.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fuUnn.default), {
            testId: "servicedesk-insight-landing-page.ui.breadcrumbs-item-assets",
            href: (0, $blEB6.getLandingPageUrl)(),
            text: formatMessage((0, $dtVyR.messages).assetsBreadcrumbs),
            component: (0, $hDzhb.default)
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $id7K0.DocumentTitle), {
            title: formatMessage(navRefreshTitle)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cS37j.default), {
            disableTitleStyles: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9eff7819654ac184$var$PageHeaderWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aV5bt.AsyncCBPChangeboarding), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
            size: "large",
            as: "h1"
        }, formatMessage(navRefreshTitle))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $9eff7819654ac184$var$dividerStyles
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $9eff7819654ac184$var$navRefreshPageContainerStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
            space: "space.500"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: [
                $9eff7819654ac184$var$leftColumnNavRefreshStyles,
                $9eff7819654ac184$var$minWidthStyles
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9eff7819654ac184$var$PageDescription, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXNW4.FormattedLinkMessage), {
            message: (0, $dtVyR.messages).descriptionCmdbAssets,
            linkProps: {
                target: '_blank',
                href: 'https://support.atlassian.com/jira-service-management-cloud/docs/get-to-know-asset-and-service-management-with-insight/'
            }
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $9eff7819654ac184$var$rightColumnNavRefreshStyles
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9eff7819654ac184$var$PageBodyContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
            space: "space.500"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $9eff7819654ac184$var$leftColumnNavRefreshStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9O52b.RapidSearchBar), {
            workspaceId: workspaceId,
            restrictedObjectSchemaIds: restrictedObjectSchemaIds.map((id)=>(0, $5Ny9E.toSchemaId)(String(id))),
            renderSearchTextfield: ({ searchTextfieldProps: searchTextfieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                    id: "searchDescriptionLabel",
                    xcss: $9eff7819654ac184$var$screenReaderOnlyStyles
                }, formatMessage((0, $dtVyR.messages).searchPlaceholderAriaLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
                    id: "searchDescription",
                    testId: "servicedesk-insight-landing-page.ui.textfield",
                    placeholder: formatMessage((0, $dtVyR.messages).searchPlaceholder),
                    "aria-label": formatMessage((0, $dtVyR.messages).searchPlaceholder),
                    "aria-describedby": "searchDescriptionLabel",
                    ...searchTextfieldProps
                }))
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $9eff7819654ac184$var$rightColumnNavRefreshStyles
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9eff7819654ac184$var$PageRowContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $9eff7819654ac184$var$leftColumnNavRefreshStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i5MrJ.SchemaContainer), {
            onSchemaModalStateChange: handleSchemaModalState
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $9eff7819654ac184$var$rightColumnNavRefreshStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dppTu.UsagePanel), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $duHa2.ObjectContainer), null)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f9Ytl.DataManagerGAChangeBoardingModal), null))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9eff7819654ac184$var$PageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $id7K0.DocumentTitle), {
            title: formatMessage(documentTitle)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cS37j.default), {
            disableTitleStyles: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9eff7819654ac184$var$PageHeaderWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aV5bt.AsyncCBPChangeboarding), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
            size: "large"
        }, formatMessage(documentTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9eff7819654ac184$var$LinksContainer, null, showDataManagerLink(), isAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2XH7B.ConfigLink), {
            to: configLink,
            onClick: onClickConfigLink
        }, formatMessage((0, $dtVyR.messages).configLink)), isInsightReportsEnabled() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cGbmp.AsyncInsightLandingPageReportsLink), {
            to: reportsLink,
            onClick: onClickReportsLink
        }, formatMessage((0, $dtVyR.messages).reportsLink))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f9Ytl.DataManagerGAChangeBoardingModal), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9eff7819654ac184$var$PageDescription, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXNW4.FormattedLinkMessage), {
            message: (0, $dtVyR.messages).descriptionCmdbAssets,
            linkProps: {
                target: '_blank',
                href: 'https://support.atlassian.com/jira-service-management-cloud/docs/get-to-know-asset-and-service-management-with-insight/'
            }
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9eff7819654ac184$var$PageBodyContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9O52b.RapidSearchBar), {
            workspaceId: workspaceId,
            restrictedObjectSchemaIds: restrictedObjectSchemaIds.map((id)=>(0, $5Ny9E.toSchemaId)(String(id))),
            renderSearchTextfield: ({ searchTextfieldProps: searchTextfieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
                    testId: "servicedesk-insight-landing-page.ui.textfield",
                    placeholder: formatMessage((0, $dtVyR.messages).searchPlaceholder),
                    "aria-label": formatMessage((0, $dtVyR.messages).searchPlaceholder),
                    ...searchTextfieldProps
                })
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9eff7819654ac184$var$PageRowContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $9eff7819654ac184$var$leftColumnStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i5MrJ.SchemaContainer), {
            onSchemaModalStateChange: handleSchemaModalState
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9eff7819654ac184$var$RightColumn, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dppTu.UsagePanel), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $duHa2.ObjectContainer), null)))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "servicedeskInsightLandingPage",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        attributes: {
            isSiteAdmin: isSiteAdmin
        }
    }, schemaState.type === 'success' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        attributes: {
            numberOfSchemas: schemaState.schemas.length
        }
    }), (0, $4R6GH.fg)('jsm_cbp_pre-release_banner') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKGUh.PreReleaseBanner), {
        location: "assets"
    }), (0, $4R6GH.fg)('jsm_assets_cbp_limits_and_notifications') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $63xWe.ObjectUsageProvider), {
        isJiraAdmin: isAdmin,
        objectCount: objectCount,
        objectLimit: objectLimit,
        billingPeriod: billingCycle === 'annual' ? 'annual' : 'monthly',
        limitState: limitState
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eAGE.LimitsBanner), {
        displayWithOffset: true
    }), renderLandingPageContent(), !nav4Enabled && !isSchemaModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6amFc.IntercomChatWithErrorBoundry), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, renderLandingPageContent(), !nav4Enabled && !isSchemaModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6amFc.IntercomChatWithErrorBoundry), null)));
};
const $9eff7819654ac184$var$LEFT_COLUMN_MIN_WIDTH = 260;
const $9eff7819654ac184$var$LEFT_COLUMN_NAV_REFRESH_MIN_WIDTH = 376;
const $9eff7819654ac184$var$RIGHT_COLUMN_NAV_REFRESH_MIN_WIDTH = 240; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9eff7819654ac184$var$PageHeaderWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2lx2vrvc _1n261g80 _1bah1yb4 _1p57utpp _1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9eff7819654ac184$var$PageDescription = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyrv47k _18u0idpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9eff7819654ac184$var$PageContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12fjxaq",
            __cmplp.className
        ])
    });
});
const $9eff7819654ac184$var$dividerStyles = (0, $8CUq3.xcss)({
    border: 0.5,
    borderStyle: 'solid',
    borderColor: 'color.border',
    position: 'absolute',
    // not tokenize due to no space.negative.500, maximum 400.
    right: '-40px',
    left: '-40px'
});
const $9eff7819654ac184$var$navRefreshPageContainerStyle = (0, $8CUq3.xcss)({
    margin: '0 auto',
    paddingTop: 'space.250',
    maxWidth: '1072px',
    minWidth: '656px'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9eff7819654ac184$var$PageBodyContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulp1jfw _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9eff7819654ac184$var$PageRowContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulp1jfw _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $9eff7819654ac184$var$leftColumnNavRefreshStyles = (0, $8CUq3.xcss)({
    flex: 7,
    minWidth: `${$9eff7819654ac184$var$LEFT_COLUMN_NAV_REFRESH_MIN_WIDTH}px`
});
const $9eff7819654ac184$var$rightColumnNavRefreshStyles = (0, $8CUq3.xcss)({
    flex: 3,
    minWidth: `${$9eff7819654ac184$var$RIGHT_COLUMN_NAV_REFRESH_MIN_WIDTH}px`
});
const $9eff7819654ac184$var$leftColumnStyles = (0, $8CUq3.xcss)({
    flex: 3,
    minWidth: `${$9eff7819654ac184$var$LEFT_COLUMN_MIN_WIDTH}px`
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9eff7819654ac184$var$RightColumn = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9eff7819654ac184$var$LinksContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx2vrvc",
            __cmplp.className
        ])
    });
});
const $9eff7819654ac184$var$screenReaderOnlyStyles = (0, $8CUq3.xcss)({
    position: 'absolute',
    width: '1px',
    height: '1px',
    margin: 'space.negative.025',
    padding: 'space.0',
    overflow: 'hidden',
    clip: 'rect(0, 0, 0, 0)',
    border: 0
});
const $9eff7819654ac184$var$overflowStyle = (0, $8CUq3.xcss)({
    overflowX: 'auto',
    overflowY: 'hidden',
    paddingLeft: 'space.050'
});
const $9eff7819654ac184$var$breadCrumbsWrapper = (0, $8CUq3.xcss)({
    marginTop: 'space.250',
    marginBottom: 'space.negative.150'
});
const $9eff7819654ac184$var$minWidthStyles = (0, $8CUq3.xcss)({
    minWidth: '656px'
});

});
parcelRegister("aV5bt", function(module, exports) {

$parcel$export(module.exports, "AsyncCBPChangeboarding", () => $ad8fe02a892f3b5a$export$1f80d68b6f7c82c4);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ad8fe02a892f3b5a$var$CBPChangeboardingWrapper = (0, $kxZPA.lazy)(()=>(parcelRequire("9463K")), {
    moduleId: "./src/packages/servicedesk/insight-common/cbp-changeboarding/src/ui/index.tsx"
});
const $ad8fe02a892f3b5a$export$1f80d68b6f7c82c4 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jsm-assets-va-changeboarding",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ad8fe02a892f3b5a$var$CBPChangeboardingWrapper, props));

});
parcelRegister("9463K", function(module, exports) {

let $69993009ec38bb97$var$load = (parcelRequire("28QjX"))(4);
module.exports = $69993009ec38bb97$var$load("hjaPG").then(()=>parcelRequire('62h1J'));

});


parcelRegister("6amFc", function(module, exports) {

$parcel$export(module.exports, "IntercomChatWithErrorBoundry", () => $f030428868479ed4$export$d662d9f13d958170);

var $5uXOq = parcelRequire("5uXOq");

var $aIZdc = parcelRequire("aIZdc");

var $7CMCs = parcelRequire("7CMCs");

var $6s1PB = parcelRequire("6s1PB");

var $1ZkYG = parcelRequire("1ZkYG");

var $ezu0U = parcelRequire("ezu0U");

var $cNd4s = parcelRequire("cNd4s");


var $cg58a = parcelRequire("cg58a");

var $9wAhM = parcelRequire("9wAhM");
const $f030428868479ed4$var$IntercomChat = ()=>{
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const { isUserEligible: isUserEligible } = (0, $ezu0U.useGetUserEligibility)();
    const { isUserOnPremiumTrial: isUserOnPremiumTrial } = (0, $cg58a.useIsUserOnPremiumTrial)(isUserEligible);
    const isTargetUser = !(0, $aIZdc.isFedRamp)() && isUserEligible && isSiteAdmin;
    const isTargetUserOnPremiumTrial = !(0, $aIZdc.isFedRamp)() && isUserOnPremiumTrial && isSiteAdmin;
    if (isTargetUser && (0, $6s1PB.expValEquals)('jsm_premium_upsell_intercom_integration_experiment', 'cohort', 'variation')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1ZkYG.IntercomContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9wAhM.IntercomLoader), null));
    if (isTargetUserOnPremiumTrial && (0, $6s1PB.UNSAFE_noExposureExp)('jsm_premium_upsell_intercom_integration_experiment')[0].get('cohort', 'not-enrolled') !== 'variation' && (0, $6s1PB.expValEquals)('live_chat_for_assets_in_premium_trial_experiment', 'cohort', 'variation')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1ZkYG.IntercomContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9wAhM.IntercomLoader), {
        isTargetUserOnPremiumTrial: true
    }));
    return null;
};
const $f030428868479ed4$export$d662d9f13d958170 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "cmdb-intercom-chat-error-boundary",
        packageName: (0, $8a45c4a7ca296e16$export$b8b9d90f9e5bd72b),
        fallback: "unmount",
        teamName: (0, $8a45c4a7ca296e16$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f030428868479ed4$var$IntercomChat, null));

});
parcelRegister("1ZkYG", function(module, exports) {

$parcel$export(module.exports, "IntercomContextProvider", () => $78d651191d44842f$export$e350e97f8273d273);
$parcel$export(module.exports, "useIntercom", () => $78d651191d44842f$export$624db904a0be2d69);

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");


var $3jNao = parcelRequire("3jNao");

var $emBKY = parcelRequire("emBKY");
const $78d651191d44842f$var$initialState = {
    isIntercomInitialized: false,
    isBooted: false
};
const $78d651191d44842f$export$e350e97f8273d273 = (0, $gg7kZ.createContainer)();
const $78d651191d44842f$var$Store = (0, $iXqE5.createStore)({
    initialState: $78d651191d44842f$var$initialState,
    actions: {
        initialize: ({ appId: appId })=>({ getState: getState, setState: setState })=>{
                if (!getState().isIntercomInitialized && !(0, $emBKY.isSSR)) {
                    (0, $3jNao.intercomScript)(appId);
                    setState({
                        isIntercomInitialized: true
                    });
                }
            },
        boot: (userData, appId)=>({ getState: getState, setState: setState })=>{
                const w = window;
                if (!getState().isBooted && getState().isIntercomInitialized && w.Intercom && typeof w.Intercom === 'function') {
                    const intercomSettings = {
                        api_base: (0, $efb8f20a37b03ff7$export$d3c97ae769b4eede),
                        app_id: appId,
                        ...userData
                    };
                    w.intercomSettings = intercomSettings;
                    w.Intercom('boot', intercomSettings);
                    setState({
                        isBooted: true
                    });
                }
            },
        shutdown: ()=>({ getState: getState, setState: setState })=>{
                if (!getState().isBooted) return;
                const w = window;
                if (w.Intercom) {
                    w.Intercom('shutdown');
                    delete w.intercomSettings;
                    setState({
                        isBooted: false
                    });
                }
            },
        trackEvent: (event, metaData)=>({ getState: getState })=>{
                const w = window;
                if (getState().isIntercomInitialized && w.Intercom && typeof w.Intercom === 'function') {
                    if (metaData) w.Intercom('trackEvent', event, metaData);
                    else w.Intercom('trackEvent', event);
                }
            },
        onShow: (onshow)=>({ getState: getState })=>{
                const w = window;
                if (getState().isIntercomInitialized && w.Intercom && typeof w.Intercom === 'function') w.Intercom('onShow', onshow);
            }
    },
    name: 'intercomStateStore',
    containedBy: $78d651191d44842f$export$e350e97f8273d273
});
const $78d651191d44842f$export$624db904a0be2d69 = (0, $3sQ5x.createHook)($78d651191d44842f$var$Store);

});
const $efb8f20a37b03ff7$export$d3c97ae769b4eede = 'https://api-iam.intercom.io';

parcelRegister("3jNao", function(module, exports) {

$parcel$export(module.exports, "intercomScript", () => $2942cb24d5063d72$export$2e17567d564811a9);
/* eslint-disable @typescript-eslint/no-explicit-any */ const $2942cb24d5063d72$export$2e17567d564811a9 = (appId)=>{
    const w = window;
    const ic = w.Intercom;
    if (typeof ic === 'function') {
        ic('reattach_activator');
        ic('update', w.intercomSettings);
    } else {
        const d = document;
        const i = (...args)=>{
            i.c(args);
        };
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        i.q = [];
        i.c = (args)=>{
            i.q.push(args);
        };
        w.Intercom = i;
        const l = ()=>{
            const s = d.createElement('script');
            s.type = 'text/javascript';
            s.async = true;
            s.src = `https://widget.intercom.io/widget/${appId}`;
            const x = d.getElementsByTagName('script')[0];
            x?.parentNode?.insertBefore(s, x);
        };
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (document.readyState === 'complete') l();
        else if (w.attachEvent) w.attachEvent('onload', l);
        else w.addEventListener('load', l, false);
    }
};

});

parcelRegister("emBKY", function(module, exports) {

$parcel$export(module.exports, "isSSR", () => $5f6cb8026ddc9a06$export$48d7c418edadb60c);
const $5f6cb8026ddc9a06$export$48d7c418edadb60c = typeof window === 'undefined';

});


parcelRegister("ezu0U", function(module, exports) {

$parcel$export(module.exports, "useGetUserEligibility", () => $3b8df7d619206ad5$export$9f6b7262f3ba0b28);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");


var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");

var $9OXo1 = parcelRequire("9OXo1");


var $eSiyx = parcelRequire("eSiyx");

var $cwVSB = parcelRequire("cwVSB");
const $3b8df7d619206ad5$export$9f6b7262f3ba0b28 = ()=>{
    const [isUserEligible, setIsUserEligible] = (0, $5uXOq.useState)(false);
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const { serviceDesk: jsmEdition } = (0, $k9JTq.useAppEditions)();
    (0, $5uXOq.useEffect)(()=>{
        const loadUserEligibilityInfo = async ()=>{
            try {
                if (jsmEdition !== (0, $ldyPw.STANDARD_EDITION)) {
                    setIsUserEligible(false);
                    return;
                }
                const entitlementDetails = tenantContext.productEntitlementDetails?.[0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61];
                const { billingSourceSystem: billingSourceSystem, entitlementId: entitlementId, trialEndTime: trialEndTime } = entitlementDetails || {};
                const isUsingCcp = billingSourceSystem === 'CCP';
                if (isUsingCcp) {
                    if (!entitlementId) throw new Error('Empty entitlement ID');
                    const ccpEntitlementDetails = await (0, $eSiyx.fetchEntitlementDetails)(entitlementId);
                    const isCCPPaidPlan = ccpEntitlementDetails?.subscriptionv2?.trial === null;
                    setIsUserEligible(isCCPPaidPlan);
                } else if (trialEndTime) {
                    // HAMS Billing System
                    const trialDaysLeft = (0, $cwVSB.getTrialDaysLeft)(Date.now(), trialEndTime);
                    const notInTrialOrGracePeriod = trialDaysLeft < -(0, $cwVSB.GRACE_PERIOD_DAYS);
                    setIsUserEligible(notInTrialOrGracePeriod);
                } else setIsUserEligible(true);
            } catch (e) {
                (0, $jcw0u.default)({
                    meta: {
                        id: 'useGetUserEligibility',
                        packageName: (0, $1d21bc43afc62b3b$export$b8b9d90f9e5bd72b),
                        teamName: (0, $1d21bc43afc62b3b$export$d57b6b390e78d90f)
                    },
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    error: e,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        };
        loadUserEligibilityInfo();
    }, [
        jsmEdition,
        tenantContext.productEntitlementDetails
    ]);
    return {
        isUserEligible: isUserEligible
    };
};

});
const $c06e1abca7c13910$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $c06e1abca7c13910$export$e9c56aa3b027d98f = 'jira-customer-service';
const $c06e1abca7c13910$export$1346c9aa3cbb477d = 'jira-software';
const $c06e1abca7c13910$export$202f50ee62667e32 = 'jira-product-discovery';
const $c06e1abca7c13910$export$db515c8cec1e6f79 = 'jira-core';
const $c06e1abca7c13910$export$c811f21c9ad05dc2 = 'confluence';
const $c06e1abca7c13910$export$961148c98d198270 = 'opsgenie';

const $1d21bc43afc62b3b$export$b8b9d90f9e5bd72b = 'jiraServicedeskStandardToPremiumModal';
const $1d21bc43afc62b3b$export$d57b6b390e78d90f = 'itops-mithril';

parcelRegister("eSiyx", function(module, exports) {

$parcel$export(module.exports, "fetchEntitlementDetails", () => $3ee63ee0a4241e21$export$c37c3206d7762a15);
$parcel$export(module.exports, "fetchHamsPremiumEstimate", () => $3ee63ee0a4241e21$export$16a69469a3e8e116);
$parcel$export(module.exports, "fetchHamsEntitlementDetails", () => $3ee63ee0a4241e21$export$d028394d9ed389b9);

var $7f4tk = parcelRequire("7f4tk");
const $3ee63ee0a4241e21$export$c37c3206d7762a15 = async (entitlementId)=>(0, $7f4tk.default)(`/gateway/api/ccp/api/v1/entitlements/${entitlementId}/details`);
const $3ee63ee0a4241e21$export$16a69469a3e8e116 = async (cloudId, entitlementId)=>(0, $7f4tk.default)(`/gateway/api/billing-ux/cloud/${cloudId}/billing/entitlements/${entitlementId}/edition/premium/estimate`);
const $3ee63ee0a4241e21$export$d028394d9ed389b9 = async (cloudId)=>(0, $7f4tk.default)(`/gateway/api/billing-ux/cloud/${cloudId}/billing/entitlement-group`);

});

parcelRegister("cwVSB", function(module, exports) {

$parcel$export(module.exports, "getTrialDaysLeft", () => $15400db85ab4fccc$export$954628993bf3188e);
$parcel$export(module.exports, "GRACE_PERIOD_DAYS", () => $15400db85ab4fccc$export$e84660e485ee4d09);
const $15400db85ab4fccc$export$9dbbf537dffaafc7 = (timestamp)=>new Date(timestamp).setUTCHours(0, 0, 0, 0);
const $15400db85ab4fccc$export$954628993bf3188e = (currentDate, trialEndTime)=>Math.ceil(($15400db85ab4fccc$export$9dbbf537dffaafc7(trialEndTime) - currentDate) / 86400000);
const $15400db85ab4fccc$export$e84660e485ee4d09 = 14;

});


const $8a45c4a7ca296e16$export$b8b9d90f9e5bd72b = 'jiraCmdbIntercomIntegration';
const $8a45c4a7ca296e16$export$d57b6b390e78d90f = 'itops-mithril';

parcelRegister("cg58a", function(module, exports) {

$parcel$export(module.exports, "useIsUserOnPremiumTrial", () => $847694aa214eca9b$export$70ee35d5fbc30849);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");


var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");

var $koeKL = parcelRequire("koeKL");

var $5oBMG = parcelRequire("5oBMG");


var $9TYBD = parcelRequire("9TYBD");
const $847694aa214eca9b$export$70ee35d5fbc30849 = (isUserEligibleOnStandardPaid)=>{
    const [isUserOnPremiumTrial, setIsUserOnPremiumTrial] = (0, $5uXOq.useState)(false);
    const productEntitlementDetails = (0, $5oBMG.useProductEntitlementDetails)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { serviceDesk: jsmEdition } = (0, $k9JTq.useAppEditions)();
    (0, $5uXOq.useEffect)(()=>{
        if (isUserEligibleOnStandardPaid) {
            setIsUserOnPremiumTrial(false);
            return;
        }
        const loadPremiumTrialStatus = async ()=>{
            try {
                if (jsmEdition !== (0, $ldyPw.PREMIUM_EDITION)) {
                    setIsUserOnPremiumTrial(false);
                    return;
                }
                const entitlementDetails = productEntitlementDetails?.[0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61];
                const { billingSourceSystem: billingSourceSystem, trialEndTime: trialEndTime } = entitlementDetails || {};
                // CCP Billing System
                if (billingSourceSystem === 'CCP' && trialEndTime) setIsUserOnPremiumTrial(true);
                else {
                    if (!cloudId) throw new Error('Empty cloudId');
                    // HAMS Billing System
                    const hamsEntitlementDetails = await (0, $9TYBD.fetchHamsEntitlementDetails)(cloudId);
                    const jsmEntitlement = hamsEntitlementDetails?.entitlements?.find((entitlement)=>entitlement.productKey === (0, $9TYBD.JSM_PRODUCT_KEY));
                    const isHamsPremiumTrial = jsmEntitlement?.trialEditionEndDate || jsmEntitlement?.trialEndDate;
                    setIsUserOnPremiumTrial(!!isHamsPremiumTrial);
                }
            } catch (e) {
                (0, $jcw0u.default)({
                    meta: {
                        id: 'useIsUserOnPremiumTrial',
                        packageName: (0, $8a45c4a7ca296e16$export$b8b9d90f9e5bd72b),
                        teamName: (0, $8a45c4a7ca296e16$export$d57b6b390e78d90f)
                    },
                    error: e instanceof Error ? e : undefined,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        };
        loadPremiumTrialStatus();
    }, [
        isUserEligibleOnStandardPaid,
        jsmEdition,
        productEntitlementDetails,
        cloudId
    ]);
    return {
        isUserOnPremiumTrial: isUserOnPremiumTrial
    };
};

});
parcelRegister("9TYBD", function(module, exports) {

$parcel$export(module.exports, "JSM_PRODUCT_KEY", () => $a249c5987c171df5$export$ac0a7a08e53e9d3b);
$parcel$export(module.exports, "fetchHamsEntitlementDetails", () => $a249c5987c171df5$export$d028394d9ed389b9);

var $7f4tk = parcelRequire("7f4tk");
const $a249c5987c171df5$export$ac0a7a08e53e9d3b = 'jira-servicedesk.ondemand';
const $a249c5987c171df5$export$d028394d9ed389b9 = async (cloudId)=>(0, $7f4tk.default)(`/gateway/api/billing-ux/cloud/${cloudId}/billing/entitlement-group`);

});


parcelRegister("9wAhM", function(module, exports) {

$parcel$export(module.exports, "IntercomLoader", () => $be9970b8278d590c$export$ab1ac0351c367595);

var $5uXOq = parcelRequire("5uXOq");

var $1ZkYG = parcelRequire("1ZkYG");

var $cYlk7 = parcelRequire("cYlk7");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $9OXo1 = parcelRequire("9OXo1");

var $oS8XS = parcelRequire("oS8XS");

const $be9970b8278d590c$var$getEventName = (eventName, isTargetUserOnPremiumTrial)=>{
    return isTargetUserOnPremiumTrial ? `${eventName} premiumTrial` : eventName;
};
const $be9970b8278d590c$export$ab1ac0351c367595 = ({ isTargetUserOnPremiumTrial: isTargetUserOnPremiumTrial })=>{
    const [{ isIntercomInitialized: isIntercomInitialized }, { initialize: initialize, boot: boot, trackEvent: trackEvent, onShow: onShow, shutdown: shutdown }] = (0, $1ZkYG.useIntercom)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { intercomHmac: intercomHmac } = (0, $oS8XS.useIntercomHmac)();
    const user = (0, $cYlk7.useCurrentUser)()?.data?.user || {};
    const { cloudId: cloudId, atlassianAccountId: atlassianAccountId, userFullname: userFullname } = (0, $9OXo1.useTenantContext)();
    (0, $5uXOq.useEffect)(()=>{
        if (!atlassianAccountId || !intercomHmac) return;
        if (!isIntercomInitialized) initialize({
            appId: (0, $eac0ceb1f34be3c9$export$7eaa56945d1970dc)
        });
        if (isIntercomInitialized) {
            boot({
                user_id: atlassianAccountId,
                name: userFullname || '',
                // @ts-expect-error - TS2339 - Property 'emailAddress' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'. | TS2339 - Property 'emailAddress' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
                email: user?.emailAddress || '',
                user_hash: intercomHmac,
                company: {
                    company_id: cloudId
                }
            }, (0, $eac0ceb1f34be3c9$export$7eaa56945d1970dc));
            onShow(()=>{
                trackEvent($be9970b8278d590c$var$getEventName('intercomChatButton clicked', isTargetUserOnPremiumTrial));
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'intercomChatButton'
                }), 'intercomMessengerLauncher', {
                    premiumTrial: isTargetUserOnPremiumTrial ?? false
                });
            });
            trackEvent($be9970b8278d590c$var$getEventName('intercomChatButton viewed', isTargetUserOnPremiumTrial));
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'intercomChatButton viewed', 'intercomMessengerLauncher', {
                premiumTrial: isTargetUserOnPremiumTrial ?? false
            });
        }
        return ()=>{
            shutdown();
        };
    }, [
        intercomHmac,
        isIntercomInitialized,
        atlassianAccountId,
        userFullname,
        // @ts-expect-error - TS2339 - Property 'emailAddress' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'. | TS2339 - Property 'emailAddress' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
        user?.emailAddress,
        cloudId,
        createAnalyticsEvent,
        boot,
        initialize,
        onShow,
        shutdown,
        trackEvent,
        isTargetUserOnPremiumTrial
    ]);
    return null;
};

});
parcelRegister("oS8XS", function(module, exports) {

$parcel$export(module.exports, "useIntercomHmac", () => $bb148f45bcb2cbe0$export$8ab143228c6f49a2);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");


var $7KCwB = parcelRequire("7KCwB");
const $bb148f45bcb2cbe0$export$8ab143228c6f49a2 = ()=>{
    const [intercomHmac, setIntercomHmac] = (0, $5uXOq.useState)('');
    (0, $5uXOq.useEffect)(()=>{
        (async ()=>{
            try {
                const res = await (0, $7KCwB.fetchIntercomHmac)();
                setIntercomHmac(res.userIntercomHmac);
            } catch (e) {
                (0, $jcw0u.default)({
                    meta: {
                        id: 'fetchIntercomHmac',
                        packageName: (0, $8a45c4a7ca296e16$export$b8b9d90f9e5bd72b),
                        teamName: (0, $8a45c4a7ca296e16$export$d57b6b390e78d90f)
                    },
                    error: e instanceof Error ? e : undefined,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        })();
    }, []);
    return {
        intercomHmac: intercomHmac
    };
};

});
parcelRegister("7KCwB", function(module, exports) {

$parcel$export(module.exports, "fetchIntercomHmac", () => $f7e64ad50c9ebef1$export$8b69b6b1b03dc079);

var $7f4tk = parcelRequire("7f4tk");
const $f7e64ad50c9ebef1$export$8b69b6b1b03dc079 = async ()=>(0, $7f4tk.default)('/gateway/api/jsm/onboarding/intercom/v1/hmac');

});


const $eac0ceb1f34be3c9$export$7eaa56945d1970dc = 'odnoznr4';



parcelRegister("id7K0", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $938046587fdeeb52$export$dd5ad0b65cf665da);

var $5uXOq = parcelRequire("5uXOq");

var $cSD7y = parcelRequire("cSD7y");

var $4CAXd = parcelRequire("4CAXd");
// eslint-disable-next-line jira/react/no-class-components
class $938046587fdeeb52$var$DocumentTitleOld extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $4CAXd.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber = (0, $4CAXd.DocumentTitleSubscriber) } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4CAXd.DocumentTitleHelperOld), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}
const $938046587fdeeb52$export$dd5ad0b65cf665da = (0, $cSD7y.componentWithFG)('jira-concurrent-document-title', (0, $4CAXd.DocumentTitleHelper), $938046587fdeeb52$var$DocumentTitleOld);

});

// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("1eAGE", function(module, exports) {

$parcel$export(module.exports, "LimitsBanner", () => $51c8e3f5c87490d6$export$276b2f7a0e2a1206);

var $5uXOq = parcelRequire("5uXOq");

var $lkmWu = parcelRequire("lkmWu");

var $42CjB = parcelRequire("42CjB");

var $84THj = parcelRequire("84THj");

var $dD7Zc = parcelRequire("dD7Zc");

var $bU3PY = parcelRequire("bU3PY");

var $e4yMr = parcelRequire("e4yMr");

var $dC5iT = parcelRequire("dC5iT");
var $h9kUS = parcelRequire("h9kUS");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");


var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $blEB6 = parcelRequire("blEB6");

var $63xWe = parcelRequire("63xWe");

var $jvhnv = parcelRequire("jvhnv");
const $51c8e3f5c87490d6$export$276b2f7a0e2a1206 = ({ displayWithOffset: displayWithOffset, isObjectView: isObjectView = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onDismiss = (0, $63xWe.useObjectUsageDismiss)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const objectUsageInfo = (0, $63xWe.useObjectUsageInfo)('limits-banner');
    if (objectUsageInfo.type === 'none') return null;
    let appearance = 'announcement';
    const { userRole: userRole, billingPeriod: billingPeriod, type: type } = objectUsageInfo;
    const isAdmin = userRole === 'admin';
    let content = null;
    const getFilteredMessageContent = (contentToFormat, url)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...contentToFormat,
            values: {
                p: (msg)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, msg),
                a: (msg)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
                        appearance: "inverse",
                        href: url,
                        onClick: ()=>(0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'cmdbConsumptionBasedPricingNotification')
                    }, msg),
                b: (msg)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                        weight: "bold"
                    }, msg)
            }
        });
    const increaseUsageUrl = (0, $blEB6.getFeatureUsagePageUrl)({
        showChangeLimitModal: true
    });
    const getMonthlyContent = ()=>{
        switch(type){
            case '80-percent':
                content = isAdmin ? getFilteredMessageContent((0, $jvhnv.messages).admin80PercentMonthly, increaseUsageUrl) : null;
                break;
            case '90-percent':
                appearance = 'warning';
                content = isAdmin ? getFilteredMessageContent((0, $jvhnv.messages).admin90PercentMonthly, increaseUsageUrl) : getFilteredMessageContent((0, $jvhnv.messages).agent90PercentMonthly, '');
                break;
            case 'limit-reached':
                appearance = 'error';
                content = isAdmin ? getFilteredMessageContent((0, $jvhnv.messages).adminLimitReachedMonthly, increaseUsageUrl) : getFilteredMessageContent((0, $jvhnv.messages).agentLimitReachedMonthly, '');
                break;
            default:
                return null;
        }
    };
    const getYearlyContent = ()=>{
        switch(type){
            case '80-percent':
                content = isAdmin ? getFilteredMessageContent((0, $jvhnv.messages).admin80PercentYearly, increaseUsageUrl) : null;
                break;
            case '90-percent':
                appearance = 'warning';
                content = isAdmin ? getFilteredMessageContent((0, $jvhnv.messages).admin90PercentYearly, increaseUsageUrl) : getFilteredMessageContent((0, $jvhnv.messages).agent90PercentYearly, '');
                break;
            case 'limit-reached':
                appearance = 'error';
                content = isAdmin ? getFilteredMessageContent((0, $jvhnv.messages).adminLimitReachedYearly, increaseUsageUrl) : getFilteredMessageContent((0, $jvhnv.messages).agentLimitReachedYearly, '');
                break;
            default:
                return null;
        }
    };
    const getBannerIcon = ()=>{
        if (type === '90-percent') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))), {
            color: "currentColor",
            LEGACY_secondaryColor: "inherit",
            label: formatMessage((0, $jvhnv.messages).warningIcon),
            spacing: "spacious"
        });
        if (type === 'limit-reached') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
            color: "currentColor",
            LEGACY_secondaryColor: "inherit",
            label: formatMessage((0, $jvhnv.messages).errorIcon),
            spacing: "spacious"
        });
        return undefined;
    };
    switch(billingPeriod){
        case 'monthly':
            getMonthlyContent();
            break;
        case 'annual':
            getYearlyContent();
            break;
        default:
            return null;
    }
    const getBannerContent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$238d30785c4bca84),
            sourceName: "cmdbConsumptionBasedPricingNotification"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $51c8e3f5c87490d6$var$outerBannerWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lkmWu.default), {
            appearance: appearance,
            icon: getBannerIcon(),
            testId: "servicedesk-cmdb-object-usage-messaging.ui.limits-banner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $51c8e3f5c87490d6$var$bannerContentWrapper
        }, content), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $51c8e3f5c87490d6$var$bannerCloseWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
            appearance: "subtle",
            onClick: ()=>{
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'cmdbConsumptionBasedPricingNotification');
                onDismiss();
            },
            spacing: "compact",
            icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($84THj))), {
                    ...iconProps,
                    LEGACY_size: "medium",
                    color: type === '90-percent' ? `var(--ds-text-warning-inverse, ${0, $829f609a65d26a98$export$7d61b15e0da132af})` : `var(--ds-text-inverse, ${0, $829f609a65d26a98$export$29a4f05edc054374})`,
                    spacing: "spacious"
                }),
            label: formatMessage((0, $jvhnv.messages).dismissBanner)
        })))));
    if (isObjectView) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $51c8e3f5c87490d6$var$objectViewOffsetWrapper,
        testId: "servicedesk-cmdb-object-usage-messaging.ui.limits-banner.limits-banner-object-view-offset-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $51c8e3f5c87490d6$var$layoutOffsetInner
    }, getBannerContent()));
    return displayWithOffset ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $51c8e3f5c87490d6$var$layoutOffsetWrapper,
        testId: "servicedesk-cmdb-object-usage-messaging.ui.limits-banner.limits-banner-layout-offset-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $51c8e3f5c87490d6$var$layoutOffsetInner
    }, getBannerContent())) : getBannerContent();
};
const $51c8e3f5c87490d6$var$bannerCloseWrapper = (0, $8CUq3.xcss)({
    position: 'absolute',
    right: 'space.150',
    top: '50%',
    transform: 'translateY(-50%)'
});
const $51c8e3f5c87490d6$var$outerBannerWrapper = (0, $8CUq3.xcss)({
    position: 'relative'
});
const $51c8e3f5c87490d6$var$bannerContentWrapper = (0, $8CUq3.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    paddingRight: 'space.400',
    [(0, $h9kUS.media).above.sm]: {
        paddingRight: 'space.500'
    }
});
// nested wrappers due to no space.negative.500, maximum 400.
const $51c8e3f5c87490d6$var$layoutOffsetWrapper = (0, $8CUq3.xcss)({
    marginBottom: 'space.0',
    marginLeft: 'space.negative.400',
    marginRight: 'space.negative.400'
});
// nested wrappers due to no space.negative.500, maximum 400.
const $51c8e3f5c87490d6$var$objectViewOffsetWrapper = (0, $8CUq3.xcss)({
    marginTop: 'space.negative.200',
    marginLeft: 'space.negative.400',
    marginRight: 'space.negative.400',
    marginBottom: 'space.300'
});
const $51c8e3f5c87490d6$var$layoutOffsetInner = (0, $8CUq3.xcss)({
    marginLeft: 'space.negative.100',
    marginRight: 'space.negative.100'
});

});
var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';

parcelRegister("63xWe", function(module, exports) {

$parcel$export(module.exports, "useObjectUsageDismiss", () => $a711c016e8269a5a$export$488ff4bad70ebd64);
$parcel$export(module.exports, "useObjectUsageRefreshObjectCount", () => $a711c016e8269a5a$export$555b8f9a7e864563);
$parcel$export(module.exports, "useObjectUsageInfo", () => $a711c016e8269a5a$export$4adfcc0459dd98ca);
$parcel$export(module.exports, "useBillingPeriod", () => $a711c016e8269a5a$export$65fa1dba3c6d4da1);
$parcel$export(module.exports, "useLimitState", () => $a711c016e8269a5a$export$c52f3408141b34f0);
$parcel$export(module.exports, "ObjectUsageProvider", () => $a711c016e8269a5a$export$dcd40a00452817a6);

var $5uXOq = parcelRequire("5uXOq");

var $7DxXA = parcelRequire("7DxXA");

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");

var $5vvVt = parcelRequire("5vvVt");

var $bGnUR = parcelRequire("bGnUR");

var $2oKkj = parcelRequire("2oKkj");
const $a711c016e8269a5a$var$Store = (0, $iXqE5.createStore)({
    initialState: $5vvVt.initialState,
    actions: $2oKkj.actions
});
const $a711c016e8269a5a$var$useActions = (0, $3sQ5x.createActionsHook)($a711c016e8269a5a$var$Store);
const $a711c016e8269a5a$export$488ff4bad70ebd64 = ()=>{
    const { dismissMessage: dismissMessage } = $a711c016e8269a5a$var$useActions();
    return dismissMessage;
};
const $a711c016e8269a5a$export$555b8f9a7e864563 = ()=>{
    const { refreshObjectCount: refreshObjectCount } = $a711c016e8269a5a$var$useActions();
    return (createAnalyticsEvent)=>refreshObjectCount(createAnalyticsEvent);
};
const $a711c016e8269a5a$export$4adfcc0459dd98ca = (0, $3sQ5x.createStateHook)($a711c016e8269a5a$var$Store, {
    selector: (0, $bGnUR.getObjectUsageInfo)
});
const $a711c016e8269a5a$export$65fa1dba3c6d4da1 = (0, $3sQ5x.createStateHook)($a711c016e8269a5a$var$Store, {
    selector: ({ billingPeriod: billingPeriod })=>billingPeriod
});
const $a711c016e8269a5a$export$c52f3408141b34f0 = (0, $3sQ5x.createStateHook)($a711c016e8269a5a$var$Store, {
    selector: ({ limitState: limitState })=>limitState
});
const $a711c016e8269a5a$var$dispatchInitialState = ()=>({ dispatch: dispatch }, { isJiraAdmin: isJiraAdmin, objectCount: objectCount, objectLimit: objectLimit, billingPeriod: billingPeriod, limitState: limitState, workspaceId: workspaceId })=>{
        dispatch((0, $2oKkj.actions).setInitialData({
            isJiraAdmin: isJiraAdmin,
            objectCount: objectCount,
            objectLimit: objectLimit,
            billingPeriod: billingPeriod,
            limitState: limitState,
            workspaceId: workspaceId
        }));
    };
const $a711c016e8269a5a$var$ObjectUsageStoreContainer = (0, $gg7kZ.createContainer)($a711c016e8269a5a$var$Store, {
    onInit: $a711c016e8269a5a$var$dispatchInitialState,
    onUpdate: $a711c016e8269a5a$var$dispatchInitialState,
    displayName: 'JsmCmdbObjectUsageStoreContainer'
});
const $a711c016e8269a5a$export$dcd40a00452817a6 = ({ children: children, isJiraAdmin: isJiraAdmin, objectCount: objectCount, objectLimit: objectLimit, billingPeriod: billingPeriod, limitState: limitState })=>{
    const { workspaceId: workspaceId } = (0, $7DxXA.useWorkspaceContext)();
    if (!workspaceId) throw new Error('workspaceId not defined');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a711c016e8269a5a$var$ObjectUsageStoreContainer, {
        isJiraAdmin: isJiraAdmin,
        objectCount: objectCount,
        objectLimit: objectLimit,
        billingPeriod: billingPeriod,
        limitState: limitState,
        workspaceId: workspaceId,
        isGlobal: true
    }, children);
};

});
parcelRegister("5vvVt", function(module, exports) {

$parcel$export(module.exports, "LOCAL_STORAGE", () => $c9dc651325ead5e5$export$c6a7366241a86d6d);
$parcel$export(module.exports, "DISMISSED_FOR_THRESHOLD_TYPE_KEY", () => $c9dc651325ead5e5$export$98e7ecfcc5c7cd3e);
$parcel$export(module.exports, "NONE", () => $c9dc651325ead5e5$export$c53d0f541b41b88e);
$parcel$export(module.exports, "initialState", () => $c9dc651325ead5e5$export$d4c72bab9d6cc13a);

var $bSSG7 = parcelRequire("bSSG7");
const $c9dc651325ead5e5$export$c6a7366241a86d6d = (0, $bSSG7.createLocalStorageProvider)('jsm-assets-object-usage-info');
const $c9dc651325ead5e5$export$98e7ecfcc5c7cd3e = 'dismissed';
const $c9dc651325ead5e5$export$c53d0f541b41b88e = {
    type: 'none'
};
const $c9dc651325ead5e5$export$d4c72bab9d6cc13a = {
    userRole: 'agent',
    billingPeriod: 'monthly',
    objectCount: 0,
    objectLimit: Number.MAX_SAFE_INTEGER,
    isDismissed: false,
    limitState: 'disabled',
    workspaceId: ''
};

});

parcelRegister("bGnUR", function(module, exports) {

$parcel$export(module.exports, "getObjectUsageInfo", () => $8f4665ac37150861$export$deea34ac3e790cc5);

var $5vvVt = parcelRequire("5vvVt");

var $lKvGx = parcelRequire("lKvGx");
const $8f4665ac37150861$export$deea34ac3e790cc5 = (state, location)=>{
    const { objectCount: objectCount, objectLimit: objectLimit, limitState: limitState, userRole: userRole, billingPeriod: billingPeriod, isDismissed: isDismissed } = state;
    if (limitState === 'disabled') return 0, $5vvVt.NONE;
    return (0, $lKvGx.determineObjectUsageInfo)({
        isJiraAdmin: userRole === 'admin',
        objectCount: objectCount,
        objectLimit: objectLimit,
        billingPeriod: billingPeriod,
        location: location,
        limitState: limitState,
        isDismissed: isDismissed
    });
};

});
parcelRegister("lKvGx", function(module, exports) {

$parcel$export(module.exports, "determineThreshold", () => $4198127f7bc6f02f$export$d2c1acdb7ab100ba);
$parcel$export(module.exports, "determineObjectUsageInfo", () => $4198127f7bc6f02f$export$6fe2fd277c274d8);

var $4R6GH = parcelRequire("4R6GH");

var $5vvVt = parcelRequire("5vvVt");
const $4198127f7bc6f02f$export$d2c1acdb7ab100ba = ({ objectCount: objectCount, objectLimit: objectLimit })=>{
    if (objectCount >= objectLimit) return 'limit-reached';
    if (objectCount >= objectLimit * 0.9) return '90-percent';
    if (objectCount >= objectLimit * 0.8) return '80-percent';
    return 'none';
};
const $4198127f7bc6f02f$export$6fe2fd277c274d8 = ({ isJiraAdmin: isJiraAdmin, objectCount: objectCount, objectLimit: objectLimit, billingPeriod: billingPeriod, location: location, limitState: limitState, isDismissed: isDismissed })=>{
    if (!(0, $4R6GH.fg)('jsm_assets_cbp_limits_and_notifications')) return 0, $5vvVt.NONE;
    const userRole = isJiraAdmin ? 'admin' : 'agent';
    const objectsRemaining = Math.max(objectLimit - objectCount, 0);
    const threshold = $4198127f7bc6f02f$export$d2c1acdb7ab100ba({
        objectCount: objectCount,
        objectLimit: objectLimit
    });
    const limitReachedUsageInfo = {
        type: threshold,
        userRole: userRole,
        billingPeriod: billingPeriod,
        objectsRemaining: objectsRemaining
    };
    switch(threshold){
        case 'limit-reached':
            switch(location){
                case 'create-object':
                    if (limitState === 'notify-only') return 0, $5vvVt.NONE;
                    return limitReachedUsageInfo;
                case 'import-data-modal':
                    return limitReachedUsageInfo;
                case 'assets-feature-usage-dashboard':
                case 'limits-banner':
                default:
                    if (isDismissed) return 0, $5vvVt.NONE;
                    return limitReachedUsageInfo;
            }
        case '90-percent':
            switch(location){
                case 'import-data-modal':
                    return limitReachedUsageInfo;
                case 'assets-feature-usage-dashboard':
                case 'limits-banner':
                case 'create-object':
                default:
                    if (isDismissed) return 0, $5vvVt.NONE;
                    return limitReachedUsageInfo;
            }
        case '80-percent':
            if (isDismissed) return 0, $5vvVt.NONE;
            switch(location){
                case 'assets-feature-usage-dashboard':
                case 'limits-banner':
                case 'create-object':
                    if (userRole === 'agent') // 80% not shown for agents in object create + limits-banner
                    return 0, $5vvVt.NONE;
                    return limitReachedUsageInfo;
                case 'import-data-modal':
                    // 80% not shown for any userRole in import data modal
                    return 0, $5vvVt.NONE;
                default:
                    return 0, $5vvVt.NONE;
            }
        case 'none':
            return 0, $5vvVt.NONE;
        default:
            return 0, $5vvVt.NONE;
    }
};

});


parcelRegister("2oKkj", function(module, exports) {

$parcel$export(module.exports, "actions", () => $5f1d81c2e9b9cee2$export$e324594224ef24da);

var $1Yo63 = parcelRequire("1Yo63");

var $kN2r5 = parcelRequire("kN2r5");

var $bZQIa = parcelRequire("bZQIa");
const $5f1d81c2e9b9cee2$export$e324594224ef24da = {
    setInitialData: $bZQIa.setInitialData,
    dismissMessage: $1Yo63.dismissMessage,
    refreshObjectCount: $kN2r5.refreshObjectCount
};

});
parcelRegister("1Yo63", function(module, exports) {

$parcel$export(module.exports, "dismissMessage", () => $c7b2c9c8b2a86057$export$ce591ff86214e2a8);

var $5vvVt = parcelRequire("5vvVt");

var $lKvGx = parcelRequire("lKvGx");
const $c7b2c9c8b2a86057$export$ce591ff86214e2a8 = ()=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const { objectCount: objectCount, objectLimit: objectLimit } = currentState;
        const threshold = (0, $lKvGx.determineThreshold)({
            objectCount: objectCount,
            objectLimit: objectLimit
        });
        const isDismissed = (0, $5vvVt.LOCAL_STORAGE).get((0, $5vvVt.DISMISSED_FOR_THRESHOLD_TYPE_KEY)) === threshold;
        if (!isDismissed) {
            (0, $5vvVt.LOCAL_STORAGE).set((0, $5vvVt.DISMISSED_FOR_THRESHOLD_TYPE_KEY), threshold);
            setState({
                ...currentState,
                isDismissed: true
            });
        }
    };

});

parcelRegister("kN2r5", function(module, exports) {

$parcel$export(module.exports, "refreshObjectCount", () => $c92dbd207d8fd580$export$457582db067330de);

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");

var $4VpwK = parcelRequire("4VpwK");

var $juXmc = parcelRequire("juXmc");

var $5vvVt = parcelRequire("5vvVt");

var $lKvGx = parcelRequire("lKvGx");
const $c92dbd207d8fd580$export$457582db067330de = ({ createAnalyticsEvent: createAnalyticsEvent })=>async ({ setState: setState, getState: getState })=>{
        try {
            const currentState = getState();
            const { workspaceId: workspaceId } = currentState;
            const response = await (0, $4VpwK.performCmdbGetRequest)((0, $juXmc.getCmdbGlobalConfigUrl)(workspaceId));
            const { limitInfo: limitInfo } = response;
            const { limitState: limitState = 'disabled', objectCount: objectCount, objectLimit: objectLimit } = limitInfo;
            const updatedState = {
                ...currentState,
                limitState: limitState,
                objectCount: objectCount,
                objectLimit: objectLimit
            };
            if ($c92dbd207d8fd580$var$isStoredIsDismissedValueStale({
                objectCount: objectCount,
                objectLimit: objectLimit
            })) {
                (0, $5vvVt.LOCAL_STORAGE).remove((0, $5vvVt.DISMISSED_FOR_THRESHOLD_TYPE_KEY));
                setState({
                    ...updatedState,
                    isDismissed: false
                });
            } else setState(updatedState);
            if (createAnalyticsEvent) (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'refreshObjectCount succeeded');
        } catch (untypedError) {
            const error = untypedError instanceof Error ? untypedError : undefined;
            (0, $jcw0u.default)({
                meta: {
                    id: 'refreshObjectCount',
                    packageName: 'jiraServicedeskCmdbObjectUsageMessaging',
                    teamName: 'krispy-krew'
                },
                error: error
            });
        }
    };
const $c92dbd207d8fd580$var$isStoredIsDismissedValueStale = ({ objectCount: objectCount, objectLimit: objectLimit })=>{
    const threshold = (0, $lKvGx.determineThreshold)({
        objectCount: objectCount,
        objectLimit: objectLimit
    });
    const dismissState = (0, $5vvVt.LOCAL_STORAGE).get((0, $5vvVt.DISMISSED_FOR_THRESHOLD_TYPE_KEY));
    return dismissState && dismissState !== threshold && threshold !== 'none';
};

});

parcelRegister("bZQIa", function(module, exports) {

$parcel$export(module.exports, "setInitialData", () => $7c62df8eb847bfd1$export$e493baf433de729b);

var $5vvVt = parcelRequire("5vvVt");

var $lKvGx = parcelRequire("lKvGx");
const $7c62df8eb847bfd1$export$e493baf433de729b = ({ isJiraAdmin: isJiraAdmin, objectCount: objectCount, objectLimit: objectLimit, billingPeriod: billingPeriod, limitState: limitState, workspaceId: workspaceId })=>async ({ setState: setState })=>{
        const threshold = (0, $lKvGx.determineThreshold)({
            objectCount: objectCount,
            objectLimit: objectLimit
        });
        const dismissState = (0, $5vvVt.LOCAL_STORAGE).get((0, $5vvVt.DISMISSED_FOR_THRESHOLD_TYPE_KEY));
        const userRole = isJiraAdmin ? 'admin' : 'agent';
        if (dismissState && dismissState !== threshold && threshold !== 'none' && limitState !== 'disabled') (0, $5vvVt.LOCAL_STORAGE).remove((0, $5vvVt.DISMISSED_FOR_THRESHOLD_TYPE_KEY));
        setState({
            userRole: userRole,
            billingPeriod: billingPeriod,
            objectCount: objectCount,
            objectLimit: objectLimit,
            isDismissed: dismissState === threshold,
            limitState: limitState,
            workspaceId: workspaceId
        });
    };

});



parcelRegister("jvhnv", function(module, exports) {

$parcel$export(module.exports, "messages", () => $40d8afc302cd5904$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $40d8afc302cd5904$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    admin80PercentMonthly: {
        "id": "servicedesk-cmdb-object-usage-messaging.limits-banner.admin-80-percent-monthly",
        "defaultMessage": "<b>You're running out of available Assets objects (< 20%).</b> Delete objects or <a>increase usage limit</a>."
    },
    admin90PercentMonthly: {
        "id": "servicedesk-cmdb-object-usage-messaging.limits-banner.admin-90-percent-monthly",
        "defaultMessage": "<b>You're nearly out of available Assets objects (< 10%).</b> Delete objects or <a>increase usage limit</a>."
    },
    adminLimitReachedMonthly: {
        "id": "servicedesk-cmdb-object-usage-messaging.limits-banner.admin-limit-reached-monthly",
        "defaultMessage": "<b>You're out of available Assets objects.</b> Delete objects or <a>increase usage limit</a> to add more objects."
    },
    admin80PercentYearly: {
        "id": "servicedesk-cmdb-object-usage-messaging.limits-banner.admin-80-percent-yearly",
        "defaultMessage": "<b>You're running out of available Assets objects (< 20%).</b> Delete objects or <a>get extra objects</a>."
    },
    admin90PercentYearly: {
        "id": "servicedesk-cmdb-object-usage-messaging.limits-banner.admin-90-percent-yearly",
        "defaultMessage": "<b>You\u2019re nearly out of available Assets objects (< 10%).</b> Delete objects or <a>get extra objects</a>."
    },
    adminLimitReachedYearly: {
        "id": "servicedesk-cmdb-object-usage-messaging.limits-banner.admin-limit-reached-yearly",
        "defaultMessage": "<b>You\u2019re out of available Assets objects.</b> Delete objects or <a>get extra objects</a> to add more objects."
    },
    agent90PercentMonthly: {
        "id": "servicedesk-cmdb-object-usage-messaging.limits-banner.agent-90-percent-monthly",
        "defaultMessage": "<b>You\u2019re nearly out of available Assets objects (< 10%).</b> Contact your admin to increase the usage limit."
    },
    agentLimitReachedMonthly: {
        "id": "servicedesk-cmdb-object-usage-messaging.limits-banner.agent-limit-reached-monthly",
        "defaultMessage": "<b>You\u2019re out of available Assets objects.</b> Contact your admin to increase the usage limit."
    },
    agent90PercentYearly: {
        "id": "servicedesk-cmdb-object-usage-messaging.limits-banner.agent-90-percent-yearly",
        "defaultMessage": "<b>You\u2019re nearly out of available Assets objects (< 10%).</b> Contact your admin to increase the usage limit."
    },
    agentLimitReachedYearly: {
        "id": "servicedesk-cmdb-object-usage-messaging.limits-banner.agent-limit-reached-yearly",
        "defaultMessage": "<b>You\u2019re out of available Assets objects.</b> Contact your admin to increase the usage limit."
    },
    warningIcon: {
        "id": "servicedesk-cmdb-object-usage-messaging.limits-banner.warning-icon",
        "defaultMessage": "Warning icon"
    },
    errorIcon: {
        "id": "servicedesk-cmdb-object-usage-messaging.limits-banner.error-icon",
        "defaultMessage": "Error icon"
    },
    dismissBanner: {
        "id": "servicedesk-cmdb-object-usage-messaging.limits-banner.dismiss-banner",
        "defaultMessage": "Dismiss banner"
    }
});

});


parcelRegister("hKGUh", function(module, exports) {

$parcel$export(module.exports, "PreReleaseBanner", () => $e748dc960b0cd2b2$export$7995d7f5d5b98c14);

var $5uXOq = parcelRequire("5uXOq");

var $42CjB = parcelRequire("42CjB");

var $84THj = parcelRequire("84THj");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $jhmo0 = parcelRequire("jhmo0");

var $bSSG7 = parcelRequire("bSSG7");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $aITgo = parcelRequire("aITgo");
const $e748dc960b0cd2b2$var$LOCAL_STORAGE = (0, $bSSG7.createLocalStorageProvider)('jsm-cbp-pre-release');
const $e748dc960b0cd2b2$var$DISMISSED_KEY = 'dismissed';
const $e748dc960b0cd2b2$export$7995d7f5d5b98c14 = ({ location: location })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isDismissed, setIsDismissed] = (0, $5uXOq.useState)($e748dc960b0cd2b2$var$LOCAL_STORAGE.get($e748dc960b0cd2b2$var$DISMISSED_KEY) != null);
    const onDismiss = ()=>{
        $e748dc960b0cd2b2$var$LOCAL_STORAGE.set($e748dc960b0cd2b2$var$DISMISSED_KEY, 'true');
        setIsDismissed(true);
    };
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    if (isDismissed) return null;
    // Implementation to match Atlaskit banner, because AK banner wraps the content with multiple elements without full
    // width, so it's not possible to place the dismiss button at the end.
    const banner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        role: "alert",
        xcss: $e748dc960b0cd2b2$var$containerStyles,
        backgroundColor: "color.background.neutral.bold",
        padding: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $e748dc960b0cd2b2$var$textStyles,
        as: "span"
    }, formatMessage((0, $aITgo.messages).infoV2), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jhmo0.default), {
        href: "https://www.atlassian.com/blog/announcements/jsm-cloud-pricing-packaging-update",
        target: "_blank",
        rel: "noopener",
        xcss: $e748dc960b0cd2b2$var$linkStyles,
        onClick: ()=>{
            // https://data-portal.internal.atlassian.com/analytics/registry/71908
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'link'
            }), 'cbpWhatThisMeansClick');
        }
    }, formatMessage((0, $aITgo.messages).whatThisMeans))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($84THj))), {
                ...iconProps,
                spacing: "spacious",
                color: "var(--ds-icon-inverse)"
            }),
        label: formatMessage((0, $aITgo.messages).dismiss),
        onClick: onDismiss
    }));
    if (location === 'assets') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $e748dc960b0cd2b2$var$negateMarginStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $e748dc960b0cd2b2$var$negateMarginInnerStyles
    }, banner));
    // Add any custom wrapper styles for location === 'virtual-agent' if required
    return banner;
};
const $e748dc960b0cd2b2$var$containerStyles = (0, $8CUq3.xcss)({
    height: '3rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
});
const $e748dc960b0cd2b2$var$textStyles = (0, $8CUq3.xcss)({
    color: 'color.text.inverse',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
const $e748dc960b0cd2b2$var$linkStyles = (0, $8CUq3.xcss)({
    color: 'color.text.inverse',
    textDecoration: 'underline',
    ':hover': {
        color: 'color.text.inverse'
    },
    ':focus': {
        color: 'color.text.inverse'
    },
    ':active': {
        color: 'color.text.inverse'
    }
});
// nested wrappers due to no space.negative.500, maximum 400.
const $e748dc960b0cd2b2$var$negateMarginStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.0',
    marginLeft: 'space.negative.400',
    marginRight: 'space.negative.400'
});
const $e748dc960b0cd2b2$var$negateMarginInnerStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.negative.100',
    marginRight: 'space.negative.100'
});

});
parcelRegister("aITgo", function(module, exports) {

$parcel$export(module.exports, "messages", () => $07d85fcbfc471381$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $07d85fcbfc471381$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    infoV2: {
        "id": "servicedesk-feature-usage-common.pre-release-banner.info-v-2",
        "defaultMessage": "Assets and the virtual service agent are moving to consumption-based pricing."
    },
    whatThisMeans: {
        "id": "servicedesk-feature-usage-common.pre-release-banner.what-this-means",
        "defaultMessage": "What this means for your site."
    },
    dismiss: {
        "id": "servicedesk-feature-usage-common.pre-release-banner.dismiss",
        "defaultMessage": "Dismiss"
    }
});

});


parcelRegister("duHa2", function(module, exports) {

$parcel$export(module.exports, "ObjectContainer", () => $88fa1399f8bc82f7$export$58ea959b0b68b9ee);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $l1N8i = parcelRequire("l1N8i");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $gd5Xi = parcelRequire("gd5Xi");

var $l3q9P = parcelRequire("l3q9P");

var $9Nam0 = parcelRequire("9Nam0");

var $4FFUT = parcelRequire("4FFUT");

var $21gb6 = parcelRequire("21gb6");
const $88fa1399f8bc82f7$var$ObjectList = (props)=>{
    const { referencedObjects: referencedObjects } = props;
    const { numberOfObjectsDisplayed: numberOfObjectsDisplayed } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onRecentObjectClick = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'insightRecentObjectLozenge');
    }, [
        createAnalyticsEvent
    ]);
    if (referencedObjects.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($88fa1399f8bc82f7$var$NoObjectsText, null, formatMessage((0, $21gb6.messages).noObjectsToShow));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, referencedObjects.slice(0, numberOfObjectsDisplayed).map((object)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gd5Xi.ReferencedObjectReadView), {
            key: object.id,
            id: object.id,
            objectKey: object.objectKey,
            label: object.label,
            avatar: object.avatar,
            onClick: onRecentObjectClick
        })));
};
const $88fa1399f8bc82f7$export$58ea959b0b68b9ee = ()=>{
    const [numberOfObjectsDisplayed, setNumberOfObjectsDisplayed] = (0, $5uXOq.useState)(5);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ recentObjectState: recentObjectState }] = (0, $l3q9P.useLandingPageState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onViewMoreClick = (0, $5uXOq.useCallback)(()=>{
        setNumberOfObjectsDisplayed(numberOfObjectsDisplayed + 5);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'insightRecentObjectsViewMore');
    }, [
        numberOfObjectsDisplayed,
        createAnalyticsEvent
    ]);
    const displayFooter = recentObjectState.type === 'success' && recentObjectState.recentObjects.length > numberOfObjectsDisplayed;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, recentObjectState.type === 'loading' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9Nam0.InsightRecentObjectContainerSkeleton), null), recentObjectState.type === 'error' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4FFUT.ErrorContent), null), recentObjectState.type === 'success' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $88fa1399f8bc82f7$var$listHeaderStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h2",
        size: "xsmall"
    }, formatMessage((0, $21gb6.messages).objectSchemas))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($88fa1399f8bc82f7$var$ListWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($88fa1399f8bc82f7$var$ObjectList, {
        referencedObjects: recentObjectState.recentObjects,
        numberOfObjectsDisplayed: numberOfObjectsDisplayed
    }))), displayFooter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $88fa1399f8bc82f7$var$listFooterStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "link",
        spacing: "none",
        onClick: onViewMoreClick
    }, formatMessage((0, $21gb6.messages).viewMore))));
};
const $88fa1399f8bc82f7$var$listHeaderStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.200'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $88fa1399f8bc82f7$var$ListWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1p57u2gc _1e0c1txw _2lx21bp4 _4cvr1y6m",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $88fa1399f8bc82f7$var$NoObjectsText = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8qk37 _syaz1n3s _1p57idpf",
            __cmplp.className
        ])
    });
});
const $88fa1399f8bc82f7$var$listFooterStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.150'
});

});
parcelRegister("gd5Xi", function(module, exports) {

$parcel$export(module.exports, "ReferencedObjectCreateView", () => $8ca12b6e5f53dda8$export$ea78f3bd97835b9f);
$parcel$export(module.exports, "ReferencedObjectReadView", () => $8ca12b6e5f53dda8$export$ae3e6ca9eba42ca);
$parcel$export(module.exports, "ReferencedObjectsReadView", () => $8ca12b6e5f53dda8$export$a03416ddf396563c);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $47bDC = parcelRequire("47bDC");

var $8Rkzz = parcelRequire("8Rkzz");


var $3bDjY = parcelRequire("3bDjY");

var $gwIPs = parcelRequire("gwIPs");

var $koVbs = parcelRequire("koVbs");

var $djSMm = parcelRequire("djSMm");

var $bUUmN = parcelRequire("bUUmN");

var $blEB6 = parcelRequire("blEB6");

var $hDzhb = parcelRequire("hDzhb");

var $7hDf3 = parcelRequire("7hDf3");

var $j8mgt = parcelRequire("j8mgt");
const $8ca12b6e5f53dda8$var$TooltipTag = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8ca12b6e5f53dda8$var$StyledTooltipTag, {
        ref: ref,
        ...props
    }));
const $8ca12b6e5f53dda8$export$25bd2ea9110ffe38 = ({ label: label, avatar: avatar, icon: icon })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUUmN.UnstyledInsightIcon), {
        iconUrl: (0, $djSMm.getUniqueIconUrl)(icon),
        size: "xsmall",
        label: label
    }), avatar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUUmN.UnstyledInsightIcon), {
        mediaClientConfig: avatar.mediaClientConfig,
        iconUrl: avatar.url48,
        size: "xsmall",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: label,
        tag: $8ca12b6e5f53dda8$var$TooltipTag,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8ca12b6e5f53dda8$var$ReferencedObjectLabel, null, label)));
const $8ca12b6e5f53dda8$export$ea78f3bd97835b9f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8ca12b6e5f53dda8$var$PlainText, {
        forceMaxWidth: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8ca12b6e5f53dda8$export$25bd2ea9110ffe38, {
        label: props.label,
        icon: props.icon
    }));
const $8ca12b6e5f53dda8$var$DEFAULT_APPEARANCE = 'card';
const $8ca12b6e5f53dda8$export$ae3e6ca9eba42ca = ({ appearance: appearance = $8ca12b6e5f53dda8$var$DEFAULT_APPEARANCE, includeLink: includeLink = true, onClick: onClick = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), forceMaxWidth: forceMaxWidth = true, ...referencedObject })=>{
    const { id: id, label: label, avatar: avatar } = referencedObject;
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8ca12b6e5f53dda8$export$25bd2ea9110ffe38, {
        label: label,
        avatar: avatar
    });
    if (appearance === 'card') return includeLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8ca12b6e5f53dda8$var$LozengeLink, {
        to: (0, $blEB6.createObjectDetailUrl)(id),
        onClick: onClick,
        forceMaxWidth: forceMaxWidth
    }, content) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8ca12b6e5f53dda8$var$LozengeText, {
        forceMaxWidth: forceMaxWidth
    }, content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8ca12b6e5f53dda8$var$PlainText, {
        forceMaxWidth: forceMaxWidth
    }, content);
};
const $8ca12b6e5f53dda8$export$a03416ddf396563c = ({ referencedObjects: referencedObjects, appearance: appearance = $8ca12b6e5f53dda8$var$DEFAULT_APPEARANCE, includeLink: includeLink = true, showPlaceholderIfEmpty: showPlaceholderIfEmpty = true })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const hasValues = referencedObjects.length > 0;
    const placeholderText = showPlaceholderIfEmpty ? formatMessage((0, $7hDf3.default).placeholderNoneSelected) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8mgt.ReadViewContainer), {
        isPlaceholder: !hasValues
    }, hasValues ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8ca12b6e5f53dda8$var$ReferencedObjectsContainer, null, referencedObjects.map((referencedObject)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8ca12b6e5f53dda8$export$ae3e6ca9eba42ca // This needs to be ID because when creating a new object the key is a blank string breaking the map
        , {
            key: referencedObject.id,
            ...referencedObject,
            includeLink: includeLink,
            appearance: appearance
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8mgt.PlaceholderSpacer), null, placeholderText));
};
const $8ca12b6e5f53dda8$var$ReferencedObjectsContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulp1b66 _1e0c1txw _1n261g80 _p12f1osq",
            __cmplp.className
        ])
    });
});
const $8ca12b6e5f53dda8$var$ellipsesTruncation = /*#__PURE__*/ (0, $47bDC.css)({
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
const $8ca12b6e5f53dda8$var$maxWidth = /*#__PURE__*/ (0, $47bDC.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${(0, $gwIPs.gridSize) * 19}px`
});
const $8ca12b6e5f53dda8$var$lozengeStyles = /*#__PURE__*/ (0, $47bDC.css)({
    display: 'inline-flex',
    alignItems: 'center',
    padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-100, 8px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    backgroundColor: `var(--ds-surface-raised, ${(0, $829f609a65d26a98$exports).N0})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: `var(--ds-text, ${(0, $829f609a65d26a98$exports).N800})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `${(0, $gwIPs.borderRadius)}px`,
    marginRight: "var(--ds-space-050, 4px)"
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.forceMaxWidth ? $8ca12b6e5f53dda8$var$maxWidth : null, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
$8ca12b6e5f53dda8$var$ellipsesTruncation, {
    boxShadow: "var(--ds-shadow-raised, 0 1px 1px rgba(9,30,66,0.25),0 0 1px 1px rgba(9,30,66,0.13))"
}); // FIXME: type error passing result of `css` to `styled`
// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8ca12b6e5f53dda8$var$LozengeText = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "gcmv2o-0"
})`${$8ca12b6e5f53dda8$var$lozengeStyles};`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8ca12b6e5f53dda8$var$ReferencedObjectLabel = /*#__PURE__*/ (0, $47bDC.default).span.withConfig({
    componentId: "gcmv2o-1"
})({
    marginLeft: "var(--ds-space-050, 4px)"
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
$8ca12b6e5f53dda8$var$ellipsesTruncation); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8ca12b6e5f53dda8$var$PlainText = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "gcmv2o-2"
})({
    display: 'flex',
    alignItems: 'center',
    padding: `${"var(--ds-space-025, 2px)"} 0`,
    marginRight: "var(--ds-space-050, 4px)",
    backgroundColor: 'inherit',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: `var(--ds-text, ${(0, $829f609a65d26a98$exports).N800})`
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.forceMaxWidth ? $8ca12b6e5f53dda8$var$maxWidth : null);
const $8ca12b6e5f53dda8$var$LozengeLink = /*#__PURE__*/ (0, $47bDC.default)((0, $hDzhb.default)).withConfig({
    componentId: "gcmv2o-3"
})`${$8ca12b6e5f53dda8$var$lozengeStyles};&:focus,&:hover{background-color:${`var(--ds-background-neutral-subtle-hovered, ${(0, $829f609a65d26a98$exports).N20})`};color:${`var(--ds-text, ${(0, $829f609a65d26a98$exports).N800})`};text-decoration:none;}&:active{background-color:${`var(--ds-background-neutral-subtle-pressed, ${(0, $829f609a65d26a98$exports).N30})`};}`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8ca12b6e5f53dda8$var$StyledTooltipTag = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1ul9idpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("djSMm", function(module, exports) {

$parcel$export(module.exports, "getUniqueIconUrl", () => $9d0363100cfab431$export$85a1f43e7ff44c3f);

var $xJtdX = parcelRequire("xJtdX");
const $9d0363100cfab431$export$85a1f43e7ff44c3f = (icon, options = {
    size: '48'
})=>{
    const sizeUrl = options.size === '48' ? icon.url48 : icon.url16;
    try {
        const url = new URL(sizeUrl);
        // Give each icon a unique URL by appending the iconId query param
        url.searchParams.append('iconId', icon.id);
        return url.toString();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $xJtdX.fireCmdbErrorAnalytics)({
            error: error,
            meta: {
                id: 'getUniqueIconUrl',
                packageName: 'jiraServicedeskInsightIcon',
                teamName: 'falcons'
            }
        });
        return sizeUrl;
    }
};

});

parcelRegister("bUUmN", function(module, exports) {

$parcel$export(module.exports, "InsightIcon", () => $91b4a14cfc200b23$export$4f72cced31fa9b94);
$parcel$export(module.exports, "MemoizedInsightIcon", () => $91b4a14cfc200b23$export$55641517b59933d7);
$parcel$export(module.exports, "UnstyledInsightIcon", () => $91b4a14cfc200b23$export$30c7947f25987be2);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $vIiRg = parcelRequire("vIiRg");
var $ujWmd = parcelRequire("ujWmd");
var $iDZjq = parcelRequire("iDZjq");

var $kOLg6 = parcelRequire("kOLg6");

var $xJtdX = parcelRequire("xJtdX");

var $cSD7y = parcelRequire("cSD7y");

var $4R6GH = parcelRequire("4R6GH");
const $91b4a14cfc200b23$export$cc575ace31787a4e = (mediaClientConfig)=>Boolean(mediaClientConfig.mediaBaseUrl) && Boolean(mediaClientConfig.mediaJwtToken) && Boolean(mediaClientConfig.issuer) && Boolean(mediaClientConfig.fileId);
const $91b4a14cfc200b23$export$d80733771196ad02 = (mediaClientConfig)=>Boolean(mediaClientConfig.mediaBaseUrl) && Boolean(mediaClientConfig.mediaJwtToken) && Boolean(mediaClientConfig.clientId) && Boolean(mediaClientConfig.fileId);
const $91b4a14cfc200b23$var$DefaultIcon = ({ size: size, label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        appearance: "square",
        size: size,
        name: label
    });
const $91b4a14cfc200b23$export$a39db5532f57c7c2 = (clientAuth)=>Promise.resolve({
        clientId: clientAuth.clientId,
        token: clientAuth.mediaJwtToken,
        baseUrl: clientAuth.mediaBaseUrl
    });
const $91b4a14cfc200b23$export$a5f760203816608a = (asapAuth)=>Promise.resolve({
        asapIssuer: asapAuth.issuer,
        token: asapAuth.mediaJwtToken,
        baseUrl: asapAuth.mediaBaseUrl
    });
const $91b4a14cfc200b23$export$3cac96b307c02149 = (props)=>{
    const { iconUrl: iconUrl, size: size, label: label, mediaClientConfig: mediaClientConfig } = props;
    if ((0, $4R6GH.fg)('assets_rearch_media_client_auth')) {
        if (!mediaClientConfig || $91b4a14cfc200b23$export$d80733771196ad02(mediaClientConfig) === false) {
            if (iconUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
                src: iconUrl,
                appearance: "square",
                size: size,
                name: label
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($91b4a14cfc200b23$var$DefaultIcon, {
                size: size,
                label: label
            });
        }
    } else if (!mediaClientConfig || $91b4a14cfc200b23$export$cc575ace31787a4e(mediaClientConfig) === false) {
        if (iconUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
            src: iconUrl,
            appearance: "square",
            size: size,
            name: label
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($91b4a14cfc200b23$var$DefaultIcon, {
            size: size,
            label: label
        });
    }
    if (!mediaClientConfig) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($91b4a14cfc200b23$var$DefaultIcon, {
        size: size,
        label: label
    });
    const fileIdentifier = {
        id: mediaClientConfig.fileId,
        mediaItemType: 'file'
    };
    const imageSize = {
        width: (0, $vIiRg.AVATAR_SIZES)[size],
        height: (0, $vIiRg.AVATAR_SIZES)[size]
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kOLg6.MediaImageWithErrorBoundary), {
        identifier: fileIdentifier,
        mediaClientConfig: {
            authProvider: ()=>(0, $4R6GH.fg)('assets_rearch_media_client_auth') ? $91b4a14cfc200b23$export$a39db5532f57c7c2(mediaClientConfig) : $91b4a14cfc200b23$export$a5f760203816608a(mediaClientConfig)
        },
        apiConfig: imageSize
    }, ({ loading: loading, error: error, data: data })=>{
        if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iDZjq.default), {
            appearance: "square",
            size: size
        });
        if (error) {
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                error: // @ts-expect-error - TS2322 - Type 'true' is not assignable to type 'Error | undefined'.
                error,
                meta: {
                    id: 'insightIcon',
                    packageName: 'jiraServicedeskInsightIcon',
                    teamName: 'falcons'
                }
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($91b4a14cfc200b23$var$DefaultIcon, {
                size: size,
                label: label
            });
        }
        if (!data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($91b4a14cfc200b23$var$DefaultIcon, {
            size: size,
            label: label
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
            src: data.src,
            appearance: "square",
            size: size,
            name: label
        });
    });
};
const $91b4a14cfc200b23$export$c9cbd60c1615f1b8 = (props)=>{
    const { iconUrl: iconUrl, size: size, label: label, mediaClientConfig: mediaClientConfig } = props;
    const sizeInPx = (0, $vIiRg.AVATAR_SIZES)[size];
    const renderAvatar = (src)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
            loading: "lazy",
            src: src,
            width: sizeInPx,
            height: sizeInPx,
            alt: ""
        });
    if ((0, $4R6GH.fg)('assets_rearch_media_client_auth')) {
        if (!mediaClientConfig || $91b4a14cfc200b23$export$d80733771196ad02(mediaClientConfig) === false) {
            if (iconUrl) return renderAvatar(iconUrl);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($91b4a14cfc200b23$var$DefaultIcon, {
                size: size,
                label: label
            });
        }
    } else if (!mediaClientConfig || $91b4a14cfc200b23$export$cc575ace31787a4e(mediaClientConfig) === false) {
        if (iconUrl) return renderAvatar(iconUrl);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($91b4a14cfc200b23$var$DefaultIcon, {
            size: size,
            label: label
        });
    }
    if (!mediaClientConfig) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($91b4a14cfc200b23$var$DefaultIcon, {
        size: size,
        label: label
    });
    const fileIdentifier = {
        id: mediaClientConfig.fileId,
        mediaItemType: 'file'
    };
    const imageSize = {
        width: (0, $vIiRg.AVATAR_SIZES)[size],
        height: (0, $vIiRg.AVATAR_SIZES)[size]
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kOLg6.MediaImageWithErrorBoundary), {
        identifier: fileIdentifier,
        mediaClientConfig: {
            authProvider: ()=>(0, $4R6GH.fg)('assets_rearch_media_client_auth') ? $91b4a14cfc200b23$export$a39db5532f57c7c2(mediaClientConfig) : $91b4a14cfc200b23$export$a5f760203816608a(mediaClientConfig)
        },
        apiConfig: imageSize
    }, ({ loading: loading, error: error, data: data })=>{
        if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iDZjq.default), {
            appearance: "square",
            size: size
        });
        if (error) {
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                error: // @ts-expect-error - TS2322 - Type 'true' is not assignable to type 'Error | undefined'.
                error,
                meta: {
                    id: 'insightIcon',
                    packageName: 'jiraServicedeskInsightIcon',
                    teamName: 'falcons'
                }
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($91b4a14cfc200b23$var$DefaultIcon, {
                size: size,
                label: label
            });
        }
        if (!data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($91b4a14cfc200b23$var$DefaultIcon, {
            size: size,
            label: label
        });
        return renderAvatar(data.src);
    });
};
const $91b4a14cfc200b23$export$4f72cced31fa9b94 = (0, $cSD7y.componentWithFG)('jsdcloud-14092-lazy-load-img', $91b4a14cfc200b23$export$c9cbd60c1615f1b8, $91b4a14cfc200b23$export$3cac96b307c02149);
const $91b4a14cfc200b23$export$55641517b59933d7 = /*#__PURE__*/ (0, $5uXOq.memo)($91b4a14cfc200b23$export$4f72cced31fa9b94);
const $91b4a14cfc200b23$export$30c7947f25987be2 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($91b4a14cfc200b23$var$UnstyledInsightIconWrapper, {
        isFGEnabled: (0, $4R6GH.fg)('jsdcloud-14092-lazy-load-img')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($91b4a14cfc200b23$export$55641517b59933d7, props));
/**
 * The reason for calling !important on display block is to ovveride the inherited
 * CSS from Avatar atlaskit component in order to centre the icon within the reference
 * object container.
 */ // Double check the shadow !
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $91b4a14cfc200b23$var$UnstyledInsightIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFGEnabled: isFGEnabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pk1i6y _2hwx1i6y _otyr1i6y _18u01i6y _p7r1tcjq _1ugpglyw",
            __cmplp.isFGEnabled && "_1e0c1txw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iDZjq", function(module, exports) {

$parcel$export(module.exports, "default", () => $31b6b09c530db49a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $vIiRg = parcelRequire("vIiRg");
function $31b6b09c530db49a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $31b6b09c530db49a$var$skeletonStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'inline-block',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    backgroundColor: `var(${(0, $vIiRg.CSS_VAR_AVATAR_BGCOLOR)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    border: `${(0, $vIiRg.BORDER_WIDTH)}px solid transparent`
});
const $31b6b09c530db49a$var$sizeStyles = Object.entries((0, $vIiRg.AVATAR_SIZES)).reduce((styles, [key, size])=>{
    return {
        ...styles,
        [key]: /*#__PURE__*/ (0, $f8Sb3.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width: `${size}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: `${size}px`
        })
    };
}, {});
const $31b6b09c530db49a$var$radiusStyles = Object.entries((0, $vIiRg.AVATAR_RADIUS)).reduce((styles, [key, size])=>{
    return {
        ...styles,
        [key]: /*#__PURE__*/ (0, $f8Sb3.css)({
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderRadius: `${size}px`
        })
    };
}, {});
const $31b6b09c530db49a$var$defaultRadiusStyles = {
    name: "1by8p7f",
    styles: "border-radius:var(--ds-border-radius-circle, 50%)"
};
const $31b6b09c530db49a$var$strongOpacityStyles = {
    name: "19sqbed",
    styles: "opacity:0.3"
};
const $31b6b09c530db49a$var$defaultOpacityStyles = {
    name: "1rz7oiv",
    styles: "opacity:0.15"
};
/**
 * __Skeleton__
 *
 * A skeleton is the loading state for the avatar component.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-skeleton/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-skeleton/code)
 */ const $31b6b09c530db49a$var$Skeleton = ({ size: size, appearance: appearance, color: color, weight: weight })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $31b6b09c530db49a$var$skeletonStyles,
            $31b6b09c530db49a$var$sizeStyles[size ?? 'medium'],
            appearance === 'square' ? $31b6b09c530db49a$var$radiusStyles[size ?? 'medium'] : $31b6b09c530db49a$var$defaultRadiusStyles,
            weight === 'strong' ? $31b6b09c530db49a$var$strongOpacityStyles : $31b6b09c530db49a$var$defaultOpacityStyles
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $vIiRg.CSS_VAR_AVATAR_BGCOLOR)]: color ?? 'currentColor'
        }
    });
var $31b6b09c530db49a$export$2e2bcd8739ae039 = $31b6b09c530db49a$var$Skeleton;

});

parcelRegister("kOLg6", function(module, exports) {

$parcel$export(module.exports, "MediaImageWithErrorBoundary", () => $27dd12b02502711d$export$758a2fef95a29ad0);

var $5uXOq = parcelRequire("5uXOq");

var $f4cXA = parcelRequire("f4cXA");

var $eYKm8 = parcelRequire("eYKm8");
const $27dd12b02502711d$export$758a2fef95a29ad0 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f4cXA.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.children({
            loading: false,
            error: true
        }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eYKm8.MediaImageWithMediaClient), props));

});
parcelRegister("eYKm8", function(module, exports) {

$parcel$export(module.exports, "MediaImageWithMediaClient", () => $eecef2c1b93fb3db$export$8acd7eecc88dfeb5);
/* mediaImage.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $iArlU = parcelRequire("iArlU");

var $10b0h = parcelRequire("10b0h");

var $VSDnB = parcelRequire("VSDnB");
const $eecef2c1b93fb3db$var$copyDivStyles = null;
const $eecef2c1b93fb3db$var$MediaImageBase = ({ identifier: identifier, apiConfig: apiConfig = {}, children: children, ssr: ssr })=>{
    const { width: width, height: height, mode: mode, allowAnimated: allowAnimated, upscale: upscale, 'max-age': maxAge } = apiConfig;
    const dimensions = {
        width: width,
        height: height
    };
    const { preview: preview, error: error, copyNodeRef: copyNodeRef, getSsrScriptProps: getSsrScriptProps } = (0, $10b0h.useFilePreview)({
        identifier: identifier,
        dimensions: dimensions,
        ssr: ssr,
        resizeMode: mode,
        allowAnimated: allowAnimated,
        upscale: upscale,
        maxAge: maxAge
    });
    //----------------------------------------------------------------
    // RENDER
    //----------------------------------------------------------------
    let status = 'loading';
    if (preview?.dataURI) status = 'succeeded';
    else if (error) status = 'error';
    return /*#__PURE__*/ $5uXOq.createElement($5uXOq.Fragment, null, children({
        loading: status === 'loading',
        error: status === 'error',
        data: status === 'succeeded' ? {
            status: status,
            src: preview?.dataURI
        } : undefined
    }), (0, $VSDnB.fg)('platform_media_cross_client_copy') && /*#__PURE__*/ $5uXOq.createElement("div", {
        ref: copyNodeRef,
        className: (0, $bwpsq.default)([
            "_1e0cglyw"
        ])
    }), getSsrScriptProps && /*#__PURE__*/ $5uXOq.createElement("script", getSsrScriptProps()));
};
const $eecef2c1b93fb3db$export$8acd7eecc88dfeb5 = (props)=>{
    const MediaImageComponent = (0, $5uXOq.useMemo)(()=>(0, $iArlU.withMediaClient)($eecef2c1b93fb3db$var$MediaImageBase), []);
    return /*#__PURE__*/ $5uXOq.createElement(MediaImageComponent, props);
};

});
parcelRegister("iArlU", function(module, exports) {

$parcel$export(module.exports, "withMediaClient", () => $104af301cec809a6$export$9f7977d4a2561bee);

var $5uXOq = parcelRequire("5uXOq");

var $cEHh7 = parcelRequire("cEHh7");
const $104af301cec809a6$export$9f7977d4a2561bee = (Component)=>({ mediaClientConfig: mediaClientConfig, ...otherProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cEHh7.MediaClientContext).Consumer, null, (value)=>value ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
                ...otherProps,
                mediaClient: value
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cEHh7.MediaClientProvider), {
                clientConfig: mediaClientConfig
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cEHh7.MediaClientContext).Consumer, null, (client)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
                    ...otherProps,
                    mediaClient: client
                }))));

});

parcelRegister("10b0h", function(module, exports) {

$parcel$export(module.exports, "useFilePreview", () => $baceb2843b357d39$export$4eaebdef02112fe4);

var $5uXOq = parcelRequire("5uXOq");

var $1Pp1U = parcelRequire("1Pp1U");
var $gFZHi = parcelRequire("gFZHi");

var $93kaw = parcelRequire("93kaw");
var $24tOd = parcelRequire("24tOd");
var $cEHh7 = parcelRequire("cEHh7");

var $8GKRF = parcelRequire("8GKRF");

var $kGpuq = parcelRequire("kGpuq");

var $01sWe = parcelRequire("01sWe");

var $3JWNV = parcelRequire("3JWNV");
var $4n1NZ = parcelRequire("4n1NZ");
var $7xRaJ = parcelRequire("7xRaJ");

var $3JZCV = parcelRequire("3JZCV");
var $jR4hE = parcelRequire("jR4hE");

var $8Kbwv = parcelRequire("8Kbwv");
const $baceb2843b357d39$export$4eaebdef02112fe4 = ({ resizeMode: resizeMode = 'crop', identifier: identifier, ssr: ssr, dimensions: dimensions, traceContext: traceContext, skipRemote: skipRemote, mediaBlobUrlAttrs: mediaBlobUrlAttrs, allowAnimated: allowAnimated = true, upscale: upscale, maxAge: maxAge, source: source })=>{
    const mediaClient = (0, $cEHh7.useMediaClient)();
    const [status, setStatus] = (0, $5uXOq.useState)('loading');
    const [error, setError] = (0, $5uXOq.useState)();
    const [nonCriticalError, setNonCriticalError] = (0, $5uXOq.useState)();
    const [isBannedLocalPreview, setIsBannedLocalPreview] = (0, $5uXOq.useState)(false);
    const [upfrontPreviewStatus, setUpfrontPreviewStatus] = (0, $5uXOq.useState)('not-resolved');
    const ssrReliabilityRef = (0, $5uXOq.useRef)({
        server: {
            status: 'unknown'
        },
        client: {
            status: 'unknown'
        }
    });
    const requestDimensions = (0, $5uXOq.useMemo)(()=>dimensions ? (0, $8Kbwv.createRequestDimensions)(dimensions) : undefined, [
        dimensions
    ]);
    const requestDimensionsRef = (0, $8Kbwv.useCurrentValueRef)(requestDimensions);
    let imageURLParams = {
        collection: identifier.collectionName,
        mode: resizeMode,
        ...requestDimensions,
        allowAnimated: allowAnimated,
        upscale: upscale,
        'max-age': maxAge
    };
    imageURLParams = {
        ...imageURLParams,
        source: source
    };
    const previewInitializer = ()=>{
        const preview = (0, $7xRaJ.mediaFilePreviewCache).get(identifier.id, resizeMode);
        if (preview) return preview;
        if (ssr) {
            const ssrData = (0, $jR4hE.getSSRData)(identifier);
            if (ssrData?.error) ssrReliabilityRef.current.server = {
                status: 'fail',
                ...ssrData.error
            };
            if (!ssrData?.dataURI) try {
                return (0, $3JWNV.getSSRPreview)(ssr, mediaClient, identifier.id, imageURLParams, mediaBlobUrlAttrs);
            } catch (e) {
                ssrReliabilityRef.current[ssr] = {
                    status: 'fail',
                    ...(0, $kGpuq.extractErrorInfo)(e, traceContext)
                };
            }
            else {
                const { dimensions: dimensions, dataURI: dataURI } = ssrData;
                return {
                    dataURI: dataURI,
                    dimensions: dimensions,
                    source: 'ssr-data'
                };
            }
        }
    };
    const [preview, setPreview] = (0, $5uXOq.useState)(previewInitializer);
    //----------------------------------------------------------------
    // FILE STATE
    //----------------------------------------------------------------
    const { fileState: fileState } = (0, $24tOd.useFileState)(identifier.id, {
        skipRemote: skipRemote,
        collectionName: identifier.collectionName,
        occurrenceKey: identifier.occurrenceKey
    });
    // Derived from File State
    const isBackendPreviewReady = !!fileState && (0, $1Pp1U.isImageRepresentationReady)(fileState);
    const fileStateErrorMessage = fileState?.status === 'error' ? fileState.message : undefined;
    const { preview: localBinary, mediaType: mediaType, mimeType: mimeType } = fileState && fileState?.status !== 'error' ? fileState : {};
    //----------------------------------------------------------------
    // Update status
    //----------------------------------------------------------------
    // TOOD: make a full hook reset (remount) on New identifier or client
    (0, $5uXOq.useEffect)(()=>{
        setStatus('loading');
    }, [
        identifier
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (status !== 'error') {
            if (preview || fileState?.status === 'processed' && !isBackendPreviewReady) setStatus('complete');
            else if (!preview && fileState?.status === 'failed-processing' && !isBackendPreviewReady) {
                setStatus('error');
                setError(new (0, $01sWe.MediaFilePreviewError)('failed-processing'));
            } else if (!preview && fileState?.status === 'error' && upfrontPreviewStatus === 'resolved') {
                setStatus('error');
                setError(new (0, $01sWe.MediaFilePreviewError)('metadata-fetch', (0, $gFZHi.toCommonMediaClientError)(fileState)));
            } else setStatus('loading');
        }
    }, [
        preview,
        status,
        fileState,
        isBackendPreviewReady,
        fileStateErrorMessage,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // Preview Fetch Helper
    //----------------------------------------------------------------
    const getAndCacheRemotePreviewRef = (0, $8Kbwv.useCurrentValueRef)(()=>{
        return (0, $3JWNV.getAndCacheRemotePreview)(mediaClient, identifier.id, requestDimensions || {}, imageURLParams, mediaBlobUrlAttrs, traceContext);
    });
    //----------------------------------------------------------------
    // Upfront Preview
    //----------------------------------------------------------------
    (0, $5uXOq.useEffect)(()=>{
        // Only fetch upfront (no file state) if there is no preview in the state already
        if (preview) setUpfrontPreviewStatus('resolved');
        else if (!preview && upfrontPreviewStatus === 'not-resolved' && !skipRemote) {
            // We block any possible future call to this method regardless of the outcome (success or fail)
            // If it fails, the normal preview fetch should occur after the file state is fetched anyways
            setUpfrontPreviewStatus('resolving');
            const fetchedDimensions = {
                ...requestDimensions
            };
            getAndCacheRemotePreviewRef.current().then((newPreview)=>{
                // If there are new and bigger dimensions in the props, and the upfront preview is still resolving,
                // the fetched preview is no longer valid, and thus, we dismiss it
                if (!(0, $8Kbwv.isBigger)(fetchedDimensions, requestDimensionsRef.current)) setPreview(newPreview);
            }).catch(()=>{
            // NO need to log error. If this call fails, a refetch will happen after
            }).finally(()=>{
                setUpfrontPreviewStatus('resolved');
            });
        }
    }, [
        getAndCacheRemotePreviewRef,
        preview,
        requestDimensions,
        requestDimensionsRef,
        skipRemote,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // Cache, Local & Remote Preview
    //----------------------------------------------------------------
    const mediaBlobUrlAttrsRef = (0, $8Kbwv.useCurrentValueRef)(mediaBlobUrlAttrs);
    (0, $5uXOq.useEffect)(()=>{
        const cachedPreview = (0, $7xRaJ.mediaFilePreviewCache).get(identifier.id, resizeMode);
        // Cached Preview ----------------------------------------------------------------
        if (!preview && cachedPreview && !(0, $8Kbwv.isBigger)(cachedPreview?.dimensions, requestDimensions)) setPreview(cachedPreview);
        else if (!preview && !isBannedLocalPreview && localBinary && (0, $4n1NZ.isSupportedLocalPreview)(mediaType) && (0, $8GKRF.isMimeTypeSupportedByBrowser)(mimeType || '')) // Local preview is available only if it's supported by browser and supported by Media Card (isSupportedLocalPreview)
        // For example, SVGs are mime type NOT supported by browser but media type supported by Media Card (image)
        // Then, local Preview NOT available
        (0, $3JWNV.getAndCacheLocalPreview)(identifier.id, localBinary, requestDimensions || {}, resizeMode, mediaBlobUrlAttrsRef.current).then(setPreview).catch((e)=>{
            setIsBannedLocalPreview(true);
            // CXP-2723 TODO: We might have to wrap this error in MediaCardError
            setNonCriticalError(e);
        });
        else if (!error && !nonCriticalError && (!preview || (0, $8Kbwv.isBigger)(preview.dimensions, requestDimensions) || // We always refetch SSR preview to be able to browser-cache a version without the token in the query parameters
        (0, $3JWNV.isSSRPreview)(preview)) && !skipRemote && upfrontPreviewStatus === 'resolved' && isBackendPreviewReady) getAndCacheRemotePreviewRef.current().then(setPreview).catch((e)=>{
            const wrappedError = (0, $01sWe.ensureMediaFilePreviewError)('preview-fetch', e);
            if (!preview) {
                setStatus('error');
                setError(wrappedError);
            } else // If there is already a preview, we consider it a non-critical error
            setNonCriticalError(wrappedError);
        });
    }, [
        error,
        nonCriticalError,
        getAndCacheRemotePreviewRef,
        identifier.id,
        resizeMode,
        isBannedLocalPreview,
        mediaBlobUrlAttrsRef,
        preview,
        requestDimensions,
        skipRemote,
        isBackendPreviewReady,
        localBinary,
        mediaType,
        mimeType,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // RETURN
    //----------------------------------------------------------------
    const onImageError = (0, $5uXOq.useCallback)((failedPreview)=>{
        if (!failedPreview) return;
        if ((0, $3JWNV.isSSRClientPreview)(failedPreview)) ssrReliabilityRef.current.client = (0, $kGpuq.createFailedSSRObject)(failedPreview, traceContext);
        // If the preview failed and it comes from server (global scope / ssrData), it means that we have reused it in client and the error counts for both: server & client.
        if ((0, $3JWNV.isSSRDataPreview)(failedPreview)) {
            ssrReliabilityRef.current.server = (0, $kGpuq.createFailedSSRObject)(failedPreview, traceContext);
            ssrReliabilityRef.current.client = (0, $kGpuq.createFailedSSRObject)(failedPreview, traceContext);
        }
        // If the dataURI has been replaced, we can dismiss this error
        if (failedPreview.dataURI !== preview?.dataURI) return;
        const isLocal = (0, $3JWNV.isLocalPreview)(failedPreview);
        const isRemote = (0, $3JWNV.isRemotePreview)(failedPreview);
        if (isLocal || isRemote) {
            const error = new (0, $01sWe.ImageLoadError)(failedPreview?.source);
            (0, $7xRaJ.mediaFilePreviewCache).remove(identifier.id, resizeMode);
            if (isLocal) setIsBannedLocalPreview(true);
            if (isRemote) {
                setStatus('error');
                setError(error);
            }
            setPreview(undefined);
        }
    }, [
        identifier.id,
        preview?.dataURI,
        resizeMode,
        traceContext
    ]);
    const onImageLoad = (0, $5uXOq.useCallback)((newPreview)=>{
        if (newPreview) {
            if ((0, $3JWNV.isSSRClientPreview)(newPreview) && ssrReliabilityRef.current.client.status === 'unknown') ssrReliabilityRef.current.client = {
                status: 'success'
            };
            /*
        If the image loads successfully and it comes from server (global scope / ssrData), it means that we have reused it in client and the success counts for both: server & client.
      */ if ((0, $3JWNV.isSSRDataPreview)(newPreview) && ssrReliabilityRef.current.server.status === 'unknown') {
                ssrReliabilityRef.current.server = {
                    status: 'success'
                };
                ssrReliabilityRef.current.client = {
                    status: 'success'
                };
            }
        }
        // If the dataURI has been replaced, we can dismiss this callback
        if (newPreview?.dataURI !== preview?.dataURI) return;
    }, [
        preview?.dataURI
    ]);
    // FOR SSR
    const getSsrScriptProps = ssr === 'server' ? ()=>(0, $3JZCV.generateScriptProps)(identifier, preview?.dataURI, requestDimensions, ssrReliabilityRef.current.server?.status === 'fail' ? ssrReliabilityRef.current.server : undefined) : undefined;
    const { copyNodeRef: copyNodeRef } = (0, $93kaw.useCopyIntent)(identifier.id, {
        collectionName: identifier.collectionName
    });
    // CXP-2723 TODO: should consider simplifying our analytics, and how
    // we might get rid of ssrReliabiltyRef from our hook
    return {
        preview: preview,
        status: status,
        error: error,
        nonCriticalError: nonCriticalError,
        ssrReliability: ssrReliabilityRef.current,
        onImageError: onImageError,
        onImageLoad: onImageLoad,
        getSsrScriptProps: getSsrScriptProps,
        copyNodeRef: copyNodeRef
    };
};

});
parcelRegister("93kaw", function(module, exports) {

$parcel$export(module.exports, "useCopyIntent", () => $d123d92fa0d5c1a9$export$46fd859414de9d62);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $VSDnB = parcelRequire("VSDnB");

var $cEHh7 = parcelRequire("cEHh7");

var $7wsJE = parcelRequire("7wsJE");

var $eaxUQ = parcelRequire("eaxUQ");
function $d123d92fa0d5c1a9$var$useCurrentValueRef(value) {
    const ref = (0, $5uXOq.useRef)(value);
    ref.current = value;
    return ref;
}
const $d123d92fa0d5c1a9$export$46fd859414de9d62 = (id, options = {})=>{
    const mediaClient = (0, $cEHh7.useMediaClient)();
    const innerRef = (0, $5uXOq.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const registerCopyIntentRef = $d123d92fa0d5c1a9$var$useCurrentValueRef(async ()=>{
        try {
            await mediaClient.file.registerCopyIntent(id, options.collectionName);
            createAnalyticsEvent((0, $7wsJE.getCopyIntentSuccessPayload)(id));
        } catch (err) {
            createAnalyticsEvent((0, $7wsJE.getCopyIntentErrorPayload)(err, id));
        }
    });
    const copyNodeRef = (0, $5uXOq.useCallback)((elem)=>{
        innerRef.current = elem;
        if ((0, $VSDnB.fg)('platform_media_cross_client_copy')) elem?.addEventListener('contextmenu', ()=>{
            registerCopyIntentRef.current();
        });
    }, [
        registerCopyIntentRef
    ]);
    const onGlobalCopy = (0, $5uXOq.useCallback)(async ()=>{
        const currentCopyTarget = innerRef.current;
        const currentSelectionContainsNode = currentCopyTarget && getSelection()?.containsNode(currentCopyTarget, true);
        if (currentSelectionContainsNode) registerCopyIntentRef.current();
    }, [
        registerCopyIntentRef
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $VSDnB.fg)('platform_media_cross_client_copy')) (0, $eaxUQ.getDocument)()?.addEventListener('copy', onGlobalCopy);
        return ()=>(0, $eaxUQ.getDocument)()?.removeEventListener('copy', onGlobalCopy);
    }, [
        onGlobalCopy
    ]);
    return {
        copyNodeRef: copyNodeRef
    };
};

});
parcelRegister("7wsJE", function(module, exports) {

$parcel$export(module.exports, "getCopyIntentErrorPayload", () => $9a6af4835a9857e5$export$3ab52330b662b987);
$parcel$export(module.exports, "getCopyIntentSuccessPayload", () => $9a6af4835a9857e5$export$aacb463551da2e8f);

var $1As4I = parcelRequire("1As4I");
const $9a6af4835a9857e5$var$getRequestErrorDetails = (err)=>{
    if ((0, $1As4I.isRequestError)(err)) return {
        request: {
            statusCode: err.metadata?.statusCode,
            traceContext: err.metadata?.traceContext,
            mediaEnv: err.metadata?.mediaEnv,
            mediaRegion: err.metadata?.mediaRegion
        }
    };
};
const $9a6af4835a9857e5$export$3ab52330b662b987 = (error, fileId = '')=>{
    return {
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCopyIntent',
        failReason: (0, $1As4I.isRequestError)(error) ? error.reason : 'nativeError',
        attributes: {
            status: 'fail',
            fileAttributes: {
                fileId: fileId
            },
            ...$9a6af4835a9857e5$var$getRequestErrorDetails(error)
        }
    };
};
const $9a6af4835a9857e5$export$aacb463551da2e8f = (fileId = '')=>{
    return {
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaCopyIntent',
        attributes: {
            fileAttributes: {
                fileId: fileId
            }
        }
    };
};

});

parcelRegister("eaxUQ", function(module, exports) {

$parcel$export(module.exports, "getDocument", () => $9ea95d3f3a6b1d04$export$f65ca476c09acec0);
const $9ea95d3f3a6b1d04$export$f65ca476c09acec0 = ()=>{
    if (typeof window === 'undefined') return;
    if (typeof window.document === 'undefined') return;
    return window.document;
};

});


parcelRegister("24tOd", function(module, exports) {

$parcel$export(module.exports, "useFileState", () => $768d10f5fd62ab89$export$90ff537b0999afb);

var $5uXOq = parcelRequire("5uXOq");

var $cEHh7 = parcelRequire("cEHh7");

var $k4CmR = parcelRequire("k4CmR");
function $768d10f5fd62ab89$export$90ff537b0999afb(id, options = {}) {
    const { collectionName: collectionName, occurrenceKey: occurrenceKey, skipRemote: skipRemote = false, includeHashForDuplicateFiles: includeHashForDuplicateFiles } = options;
    const mediaClient = (0, $cEHh7.useMediaClient)();
    const fileState = (0, $k4CmR.useMediaStore)((state)=>state.files[id]);
    (0, $5uXOq.useEffect)(()=>{
        // No need to resubscribe if there is a fileState already
        if (!fileState && !skipRemote) mediaClient.file.getFileState(id, {
            collectionName: collectionName,
            occurrenceKey: occurrenceKey,
            includeHashForDuplicateFiles: includeHashForDuplicateFiles
        });
    }, [
        id,
        mediaClient,
        collectionName,
        occurrenceKey,
        skipRemote,
        fileState,
        includeHashForDuplicateFiles
    ]);
    return {
        fileState: fileState
    };
}

});
parcelRegister("k4CmR", function(module, exports) {

$parcel$export(module.exports, "useMediaStore", () => $a907ffa2ecfaf54d$export$8a9cc8c330400af8);

var $6esDR = parcelRequire("6esDR");

var $cEHh7 = parcelRequire("cEHh7");
const $a907ffa2ecfaf54d$var$createBoundedUseStore = (store)=>(selector, equals)=>(0, $6esDR.useStore)(store, selector, equals);
function $a907ffa2ecfaf54d$export$8a9cc8c330400af8(selector, equals) {
    const mediaClient = (0, $cEHh7.useMediaClient)();
    const store = mediaClient.__DO_NOT_USE__getMediaStore();
    const useBoundStore = $a907ffa2ecfaf54d$var$createBoundedUseStore(store);
    return useBoundStore(selector, equals);
}

});
parcelRegister("6esDR", function(module, exports) {

$parcel$export(module.exports, "useStore", () => $489a4492a45245b1$export$6ccbb43953eebf8);

var $ee7sp = parcelRequire("ee7sp");

var $5uXOq = parcelRequire("5uXOq");

var $lNQti = parcelRequire("lNQti");
var $489a4492a45245b1$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/index.mjs"
});
const { useDebugValue: $489a4492a45245b1$var$useDebugValue } = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq)));
const { useSyncExternalStoreWithSelector: $489a4492a45245b1$var$useSyncExternalStoreWithSelector } = (0, (/*@__PURE__*/$parcel$interopDefault($lNQti)));
let $489a4492a45245b1$var$didWarnAboutEqualityFn = false;
const $489a4492a45245b1$var$identity = (arg)=>arg;
function $489a4492a45245b1$export$6ccbb43953eebf8(api, selector = $489a4492a45245b1$var$identity, equalityFn) {
    if (($489a4492a45245b1$import_meta.env ? $489a4492a45245b1$import_meta.env.MODE : void 0) !== "production" && equalityFn && !$489a4492a45245b1$var$didWarnAboutEqualityFn) {
        console.warn("[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937");
        $489a4492a45245b1$var$didWarnAboutEqualityFn = true;
    }
    const slice = $489a4492a45245b1$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $489a4492a45245b1$var$useDebugValue(slice);
    return slice;
}
const $489a4492a45245b1$var$createImpl = (createState)=>{
    if (($489a4492a45245b1$import_meta.env ? $489a4492a45245b1$import_meta.env.MODE : void 0) !== "production" && typeof createState !== "function") console.warn("[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`.");
    const api = typeof createState === "function" ? (0, $ee7sp.createStore)(createState) : createState;
    const useBoundStore = (selector, equalityFn)=>$489a4492a45245b1$export$6ccbb43953eebf8(api, selector, equalityFn);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const $489a4492a45245b1$export$185802fd694ee1f5 = (createState)=>createState ? $489a4492a45245b1$var$createImpl(createState) : $489a4492a45245b1$var$createImpl;
var $489a4492a45245b1$export$2e2bcd8739ae039 = (createState)=>{
    if (($489a4492a45245b1$import_meta.env ? $489a4492a45245b1$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`.");
    return $489a4492a45245b1$export$185802fd694ee1f5(createState);
};

});
parcelRegister("lNQti", function(module, exports) {
'use strict';

module.exports = (parcelRequire("hUiTL"));

});
parcelRegister("hUiTL", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $d096537a1780f6c5$export$bf730a2d8bf68b42, (v) => $d096537a1780f6c5$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d096537a1780f6c5$export$bf730a2d8bf68b42;
'use strict';

var $5uXOq = parcelRequire("5uXOq");

var $goz36 = parcelRequire("goz36");
function $d096537a1780f6c5$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $d096537a1780f6c5$var$q = "function" === typeof Object.is ? Object.is : $d096537a1780f6c5$var$p, $d096537a1780f6c5$var$r = $goz36.useSyncExternalStore, $d096537a1780f6c5$var$t = $5uXOq.useRef, $d096537a1780f6c5$var$u = $5uXOq.useEffect, $d096537a1780f6c5$var$v = $5uXOq.useMemo, $d096537a1780f6c5$var$w = $5uXOq.useDebugValue;
$d096537a1780f6c5$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $d096537a1780f6c5$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $d096537a1780f6c5$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($d096537a1780f6c5$var$q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $d096537a1780f6c5$var$r(a, c[0], c[1]);
    $d096537a1780f6c5$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $d096537a1780f6c5$var$w(d);
    return d;
};

});
parcelRegister("goz36", function(module, exports) {
'use strict';

module.exports = (parcelRequire("jcmQl"));

});
parcelRegister("jcmQl", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $dfa0db7ec3fca60b$export$306c0aa65ff9ec16, (v) => $dfa0db7ec3fca60b$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $dfa0db7ec3fca60b$export$306c0aa65ff9ec16;
'use strict';

var $5uXOq = parcelRequire("5uXOq");
function $dfa0db7ec3fca60b$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $dfa0db7ec3fca60b$var$k = "function" === typeof Object.is ? Object.is : $dfa0db7ec3fca60b$var$h, $dfa0db7ec3fca60b$var$l = $5uXOq.useState, $dfa0db7ec3fca60b$var$m = $5uXOq.useEffect, $dfa0db7ec3fca60b$var$n = $5uXOq.useLayoutEffect, $dfa0db7ec3fca60b$var$p = $5uXOq.useDebugValue;
function $dfa0db7ec3fca60b$var$q(a, b) {
    var d = b(), f = $dfa0db7ec3fca60b$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $dfa0db7ec3fca60b$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $dfa0db7ec3fca60b$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $dfa0db7ec3fca60b$var$m(function() {
        $dfa0db7ec3fca60b$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $dfa0db7ec3fca60b$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $dfa0db7ec3fca60b$var$p(d);
    return d;
}
function $dfa0db7ec3fca60b$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$dfa0db7ec3fca60b$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $dfa0db7ec3fca60b$var$t(a, b) {
    return b();
}
var $dfa0db7ec3fca60b$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $dfa0db7ec3fca60b$var$t : $dfa0db7ec3fca60b$var$q;
$dfa0db7ec3fca60b$export$306c0aa65ff9ec16 = void 0 !== $5uXOq.useSyncExternalStore ? $5uXOq.useSyncExternalStore : $dfa0db7ec3fca60b$var$u;

});







parcelRegister("kGpuq", function(module, exports) {

$parcel$export(module.exports, "extractErrorInfo", () => $d93d75d54376e990$export$74aaf4784c2edb2c);
$parcel$export(module.exports, "createFailedSSRObject", () => $d93d75d54376e990$export$768c370ed0dbaeb3);

var $gFZHi = parcelRequire("gFZHi");

var $01sWe = parcelRequire("01sWe");
const $d93d75d54376e990$export$29aa614726672b2e = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $gFZHi.isCommonMediaClientError)(secondaryError)) return secondaryError.metadata?.traceContext;
};
const $d93d75d54376e990$export$4af9d71992e89714 = (error)=>{
    return error.primaryReason || 'nativeError';
};
const $d93d75d54376e990$export$88c61dcad53762da = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $gFZHi.isCommonMediaClientError)(secondaryError)) return secondaryError.reason;
    return 'nativeError';
};
const $d93d75d54376e990$export$9ccc5365d056da4b = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $gFZHi.isCommonMediaClientError)(secondaryError)) return secondaryError.message;
    return error.message;
};
const $d93d75d54376e990$export$74aaf4784c2edb2c = (error, metadataTraceContext)=>{
    return {
        failReason: $d93d75d54376e990$export$4af9d71992e89714(error),
        error: $d93d75d54376e990$export$88c61dcad53762da(error),
        errorDetail: $d93d75d54376e990$export$9ccc5365d056da4b(error),
        metadataTraceContext: metadataTraceContext ?? $d93d75d54376e990$export$29aa614726672b2e(error)
    };
};
const $d93d75d54376e990$export$768c370ed0dbaeb3 = (preview, metadataTraceContext)=>({
        status: 'fail',
        ...$d93d75d54376e990$export$74aaf4784c2edb2c(new (0, $01sWe.ImageLoadError)(preview.source), metadataTraceContext)
    });

});
parcelRegister("01sWe", function(module, exports) {

$parcel$export(module.exports, "MediaFilePreviewError", () => $fcceba16863dd854$export$96e559194c287cf4);
$parcel$export(module.exports, "LocalPreviewError", () => $fcceba16863dd854$export$2c035820a31723e);
$parcel$export(module.exports, "RemotePreviewError", () => $fcceba16863dd854$export$10ab445310d30114);
$parcel$export(module.exports, "SsrPreviewError", () => $fcceba16863dd854$export$18e89b7e50818288);
$parcel$export(module.exports, "ImageLoadError", () => $fcceba16863dd854$export$d0a45ab59b4606b);
$parcel$export(module.exports, "ensureMediaFilePreviewError", () => $fcceba16863dd854$export$7156ce7b78b49bd7);
class $fcceba16863dd854$export$96e559194c287cf4 extends Error {
    constructor(primaryReason, secondaryError){
        super(primaryReason), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
class $fcceba16863dd854$export$2c035820a31723e extends $fcceba16863dd854$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $fcceba16863dd854$export$10ab445310d30114 extends $fcceba16863dd854$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $fcceba16863dd854$export$18e89b7e50818288 extends $fcceba16863dd854$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
const $fcceba16863dd854$var$getImageLoadPrimaryReason = (source)=>{
    switch(source){
        case 'cache-remote':
            return 'cache-remote-uri';
        case 'cache-local':
            return 'cache-local-uri';
        case 'external':
            return 'external-uri';
        case 'local':
            return 'local-uri';
        case 'remote':
            return 'remote-uri';
        case 'ssr-client':
            return 'ssr-client-uri';
        case 'ssr-server':
        case 'ssr-data':
            return 'ssr-server-uri';
        // This fail reason will come from a bug, most likely.
        default:
            return `unknown-uri`;
    }
};
class $fcceba16863dd854$export$d0a45ab59b4606b extends $fcceba16863dd854$export$96e559194c287cf4 {
    constructor(source){
        super($fcceba16863dd854$var$getImageLoadPrimaryReason(source));
    }
}
function $fcceba16863dd854$export$553696a6e769784c(err) {
    return err instanceof $fcceba16863dd854$export$96e559194c287cf4;
}
const $fcceba16863dd854$export$b380593ba3516c6f = (err)=>err instanceof $fcceba16863dd854$export$2c035820a31723e;
const $fcceba16863dd854$export$e1d87830b3784f94 = (err)=>err instanceof $fcceba16863dd854$export$10ab445310d30114;
const $fcceba16863dd854$export$443aeb298d35d79d = (err)=>$fcceba16863dd854$export$553696a6e769784c(err) && err.primaryReason === 'local-preview-unsupported';
const $fcceba16863dd854$export$7156ce7b78b49bd7 = (primaryReason, error, updatePrimaryReason)=>{
    if ($fcceba16863dd854$export$553696a6e769784c(error)) {
        if (updatePrimaryReason && error.primaryReason !== primaryReason) return new $fcceba16863dd854$export$96e559194c287cf4(primaryReason, error.secondaryError);
        return error;
    }
    return new $fcceba16863dd854$export$96e559194c287cf4(primaryReason, error);
};

});


parcelRegister("3JWNV", function(module, exports) {

$parcel$export(module.exports, "getSSRPreview", () => $609060e8f7210c63$export$faf1c301c59a1bdc);
$parcel$export(module.exports, "isLocalPreview", () => $609060e8f7210c63$export$78ad02c5efc361c9);
$parcel$export(module.exports, "isRemotePreview", () => $609060e8f7210c63$export$87442a14a8a19e0);
$parcel$export(module.exports, "isSSRClientPreview", () => $609060e8f7210c63$export$36aae1afbc0a9661);
$parcel$export(module.exports, "isSSRDataPreview", () => $609060e8f7210c63$export$f366c2c8a792cce6);
$parcel$export(module.exports, "isSSRPreview", () => $609060e8f7210c63$export$dea79d05143ccf4);
$parcel$export(module.exports, "getAndCacheRemotePreview", () => $609060e8f7210c63$export$49721bcc26fb9388);
$parcel$export(module.exports, "getAndCacheLocalPreview", () => $609060e8f7210c63$export$98e935d981c884d);

var $9KG2L = parcelRequire("9KG2L");

var $01sWe = parcelRequire("01sWe");

var $7xRaJ = parcelRequire("7xRaJ");

var $4n1NZ = parcelRequire("4n1NZ");
const $609060e8f7210c63$var$extendAndCachePreview = (id, mode, preview, mediaBlobUrlAttrs)=>{
    let source;
    switch(preview.source){
        case 'local':
            source = 'cache-local';
            break;
        case 'remote':
            source = 'cache-remote';
            break;
        default:
            source = preview.source;
    }
    // We want to embed some meta context into dataURI for Copy/Paste to work.
    const dataURI = mediaBlobUrlAttrs ? (0, $9KG2L.addFileAttrsToUrl)(preview.dataURI, mediaBlobUrlAttrs) : preview.dataURI;
    // We store new cardPreview into cache
    (0, $7xRaJ.mediaFilePreviewCache).set(id, mode, {
        ...preview,
        source: source,
        dataURI: dataURI
    });
    return {
        ...preview,
        dataURI: dataURI
    };
};
const $609060e8f7210c63$export$faf1c301c59a1bdc = (ssr, mediaClient, id, params, mediaBlobUrlAttrs)=>{
    let dataURI;
    try {
        const rawDataURI = mediaClient.getImageUrlSync(id, params);
        // We want to embed some meta context into dataURI for Copy/Paste to work.
        dataURI = mediaBlobUrlAttrs ? (0, $9KG2L.addFileAttrsToUrl)(rawDataURI, mediaBlobUrlAttrs) : rawDataURI;
        const source = ssr === 'client' ? 'ssr-client' : 'ssr-server';
        return {
            dataURI: dataURI,
            source: source,
            orientation: 1
        };
    } catch (e) {
        const reason = ssr === 'server' ? 'ssr-server-uri' : 'ssr-client-uri';
        throw new (0, $01sWe.SsrPreviewError)(reason, e instanceof Error ? e : undefined);
    }
};
const $609060e8f7210c63$export$78ad02c5efc361c9 = (preview)=>{
    const localSources = [
        'local',
        'cache-local'
    ];
    return localSources.includes(preview.source);
};
const $609060e8f7210c63$export$87442a14a8a19e0 = (preview)=>{
    const remoteSources = [
        'remote',
        'cache-remote'
    ];
    return remoteSources.includes(preview.source);
};
const $609060e8f7210c63$export$36aae1afbc0a9661 = (preview)=>preview.source === 'ssr-client';
const $609060e8f7210c63$export$f366c2c8a792cce6 = (preview)=>preview.source === 'ssr-data';
const $609060e8f7210c63$export$dea79d05143ccf4 = (preview)=>{
    const ssrClientSources = [
        'ssr-client',
        'ssr-server',
        'ssr-data'
    ];
    return ssrClientSources.includes(preview.source);
};
const $609060e8f7210c63$export$49721bcc26fb9388 = async (mediaClient, id, dimensions, params, mediaBlobUrlAttrs, traceContext)=>{
    const remotePreview = await (0, $4n1NZ.getRemotePreview)(mediaClient, id, params, traceContext);
    return $609060e8f7210c63$var$extendAndCachePreview(id, params.mode, {
        ...remotePreview,
        dimensions: dimensions
    }, mediaBlobUrlAttrs);
};
const $609060e8f7210c63$export$98e935d981c884d = async (id, filePreview, dimensions, mode, mediaBlobUrlAttrs)=>{
    const localPreview = await (0, $4n1NZ.getLocalPreview)(filePreview);
    return $609060e8f7210c63$var$extendAndCachePreview(id, mode, {
        ...localPreview,
        dimensions: dimensions
    }, mediaBlobUrlAttrs);
};

});
parcelRegister("9KG2L", function(module, exports) {

$parcel$export(module.exports, "isMediaBlobUrl", () => $3193ea5c2295e37f$export$e1e8ad57ada2d90);
$parcel$export(module.exports, "getAttrsFromUrl", () => $3193ea5c2295e37f$export$b91a9e94ff0cbb29);
$parcel$export(module.exports, "addFileAttrsToUrl", () => $3193ea5c2295e37f$export$e51a8146182600b8);
const $3193ea5c2295e37f$var$mediaBlobUrlIdentifier = 'media-blob-url';
const $3193ea5c2295e37f$export$e1e8ad57ada2d90 = (url)=>{
    return url.indexOf(`${$3193ea5c2295e37f$var$mediaBlobUrlIdentifier}=true`) > -1;
};
const $3193ea5c2295e37f$var$getNumberFromParams = (params, name)=>{
    const value = params.get(name);
    return typeof value === 'string' && !isNaN(parseInt(value)) ? parseInt(value) : undefined;
};
const $3193ea5c2295e37f$var$getStringFromParams = (params, name)=>{
    const value = params.get(name);
    if (!value) return;
    return decodeURIComponent(value);
};
const $3193ea5c2295e37f$export$b91a9e94ff0cbb29 = (blobUrl)=>{
    const url = new URL(blobUrl);
    const hash = url.hash.replace('#', '');
    const params = new URLSearchParams(hash);
    const id = params.get('id');
    const contextId = params.get('contextId');
    // check if we have the required params
    if (!id || !contextId) return;
    return {
        id: id,
        contextId: contextId,
        collection: $3193ea5c2295e37f$var$getStringFromParams(params, 'collection'),
        alt: $3193ea5c2295e37f$var$getStringFromParams(params, 'alt'),
        height: $3193ea5c2295e37f$var$getNumberFromParams(params, 'height'),
        width: $3193ea5c2295e37f$var$getNumberFromParams(params, 'width'),
        size: $3193ea5c2295e37f$var$getNumberFromParams(params, 'size'),
        name: $3193ea5c2295e37f$var$getStringFromParams(params, 'name'),
        mimeType: $3193ea5c2295e37f$var$getStringFromParams(params, 'mimeType')
    };
};
const $3193ea5c2295e37f$export$89a7e74069fbb7af = (json)=>{
    return Object.keys(json).filter((attrName)=>typeof json[attrName] !== 'undefined' && json[attrName] !== null).map((key)=>{
        const value = json[key];
        if (typeof value === 'undefined' || value === null) return;
        return `${encodeURIComponent(key)}=${encodeURIComponent(value.toString())}`;
    }).join('&');
};
const $3193ea5c2295e37f$export$e51a8146182600b8 = (url, fileAttrs)=>{
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) return url;
    const mediaIdentifierAttr = {
        [$3193ea5c2295e37f$var$mediaBlobUrlIdentifier]: 'true'
    };
    const mergedAttrs = {
        ...mediaIdentifierAttr,
        ...fileAttrs
    };
    const queryAttrs = $3193ea5c2295e37f$export$89a7e74069fbb7af(mergedAttrs);
    // we can't use '?' separator for blob url params
    return `${url}#${queryAttrs}`;
};

});

parcelRegister("7xRaJ", function(module, exports) {

$parcel$export(module.exports, "mediaFilePreviewCache", () => $abbc266dbfedc514$export$b7e8ee3f7a41459);

var $aAIop = parcelRequire("aAIop");
const $abbc266dbfedc514$export$611736262b635f8d = (id, mode)=>{
    const resizeMode = mode || 'crop';
    return [
        id,
        resizeMode
    ].join('-');
};
class $abbc266dbfedc514$export$7b50526c091bb915 {
    constructor(previewCache){
        this.previewCache = previewCache;
        this.get = (id, mode)=>{
            const cacheKey = $abbc266dbfedc514$export$611736262b635f8d(id, mode);
            return this.previewCache.get(cacheKey);
        };
        this.set = (id, mode, cardPreview)=>{
            const cacheKey = $abbc266dbfedc514$export$611736262b635f8d(id, mode);
            this.previewCache.set(cacheKey, cardPreview);
        };
        this.remove = (id, mode)=>{
            const cacheKey = $abbc266dbfedc514$export$611736262b635f8d(id, mode);
            this.previewCache.remove(cacheKey);
        };
        this.clear = ()=>{
            this.previewCache.clear();
        };
    }
}
const $abbc266dbfedc514$export$b7e8ee3f7a41459 = new $abbc266dbfedc514$export$7b50526c091bb915((0, $aAIop.createObjectURLCache)());

});
parcelRegister("aAIop", function(module, exports) {

$parcel$export(module.exports, "createObjectURLCache", () => $0cfc22aea6c15367$export$ba71be67d5c32535);

var $7n9mn = parcelRequire("7n9mn");

var $iwKVT = parcelRequire("iwKVT");
const $0cfc22aea6c15367$export$36d0f9859761643d = 50;
class $0cfc22aea6c15367$var$ExtendedLRUCache extends (0, $iwKVT.LRUMap) {
    constructor(limit){
        super(limit);
        this.eventEmitter = new (0, $7n9mn.EventEmitter2)();
    }
    shift() {
        const entry = super.shift();
        this.eventEmitter.emit('shift', entry);
        return entry;
    }
    on(event, callback) {
        this.eventEmitter.on(event, callback);
    }
}
class $0cfc22aea6c15367$export$75d1c8c9ba1d0773 {
    constructor(size){
        this.cache = new $0cfc22aea6c15367$var$ExtendedLRUCache(size);
        this.cache.on('shift', (entry)=>{
            if (entry && entry[1].dataURI) URL.revokeObjectURL(entry[1].dataURI);
        });
    }
    has(key) {
        return !!this.cache.find(key);
    }
    get(key) {
        return this.cache.get(key);
    }
    set(key, value) {
        this.cache.set(key, value);
    }
    remove(key) {
        const removed = this.cache.delete(key);
        removed && URL.revokeObjectURL(removed.dataURI);
    }
    clear() {
        this.cache.clear();
    }
}
const $0cfc22aea6c15367$export$ba71be67d5c32535 = ()=>new $0cfc22aea6c15367$export$75d1c8c9ba1d0773($0cfc22aea6c15367$export$36d0f9859761643d);

});


parcelRegister("4n1NZ", function(module, exports) {

$parcel$export(module.exports, "isSupportedLocalPreview", () => $3b75ec6170865ae7$export$1fa85b75e8662d54);
$parcel$export(module.exports, "getLocalPreview", () => $3b75ec6170865ae7$export$3d6ed68e437b8c99);
$parcel$export(module.exports, "getRemotePreview", () => $3b75ec6170865ae7$export$bfe20bd01db02b3);

var $jzW7G = parcelRequire("jzW7G");

var $48aIR = parcelRequire("48aIR");

var $01sWe = parcelRequire("01sWe");

var $Nl5sY = parcelRequire("Nl5sY");
const $3b75ec6170865ae7$export$1fa85b75e8662d54 = (mediaType)=>mediaType === 'image' || mediaType === 'video';
const $3b75ec6170865ae7$var$getImageLocalPreview = async (value)=>{
    try {
        const orientation = await (0, $48aIR.getOrientation)(value);
        const dataURI = URL.createObjectURL(value);
        return {
            dataURI: dataURI,
            orientation: orientation,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $01sWe.LocalPreviewError)('local-preview-image', e instanceof Error ? e : undefined);
    }
};
const $3b75ec6170865ae7$var$getVideoLocalPreview = async (value)=>{
    try {
        const dataURI = await (0, $Nl5sY.takeSnapshot)(value);
        return {
            dataURI: dataURI,
            orientation: 1,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $01sWe.LocalPreviewError)('local-preview-video', e instanceof Error ? e : undefined);
    }
};
const $3b75ec6170865ae7$export$3d6ed68e437b8c99 = async (filePreview)=>{
    let value;
    try {
        const resolvedFilePreview = await filePreview;
        value = resolvedFilePreview.value;
    } catch (e) {
        throw new (0, $01sWe.LocalPreviewError)('local-preview-rejected', e instanceof Error ? e : undefined);
    }
    if (typeof value === 'string') return {
        dataURI: value,
        orientation: 1,
        source: 'local'
    };
    else if (value instanceof Blob) {
        const { type: type } = value;
        const mediaType = (0, $jzW7G.getMediaTypeFromMimeType)(type);
        switch(mediaType){
            case 'image':
                return $3b75ec6170865ae7$var$getImageLocalPreview(value);
            case 'video':
                return $3b75ec6170865ae7$var$getVideoLocalPreview(value);
            default:
                throw new (0, $01sWe.LocalPreviewError)('local-preview-unsupported');
        }
    }
    throw new (0, $01sWe.LocalPreviewError)('local-preview-unsupported');
};
const $3b75ec6170865ae7$export$bfe20bd01db02b3 = async (mediaClient, id, params, traceContext)=>{
    try {
        const blob = await mediaClient.getImage(id, params, undefined, undefined, traceContext);
        return {
            dataURI: URL.createObjectURL(blob),
            orientation: 1,
            source: 'remote'
        };
    } catch (e) {
        throw new (0, $01sWe.RemotePreviewError)('remote-preview-fetch', e instanceof Error ? e : undefined);
    }
};

});
parcelRegister("48aIR", function(module, exports) {

$parcel$export(module.exports, "getImageInfo", () => $93f6c931eebc2be3$export$2176b0e68c10508f);
$parcel$export(module.exports, "getOrientation", () => $93f6c931eebc2be3$export$67689507e8404821);

var $k9Ch0 = parcelRequire("k9Ch0");

var $5m9mt = parcelRequire("5m9mt");

var $1xbJn = parcelRequire("1xbJn");

var $hNjKA = parcelRequire("hNjKA");
const { Orientation: $93f6c931eebc2be3$var$Orientation, XResolution: $93f6c931eebc2be3$var$XResolution } = (0, $k9Ch0.SupportedImageMetaTag);
// http://bonfx.com/why-is-the-web-72-dpi-and-print-300-dpi/
const $93f6c931eebc2be3$var$DPI_WEB_BASELINE = 72;
async function $93f6c931eebc2be3$export$2176b0e68c10508f(fileInfo) {
    const metadata = await $93f6c931eebc2be3$export$c142eb1c8c5c79c(fileInfo);
    if (!metadata) return null;
    const { width: width, height: height, tags: tags } = metadata;
    const scaleFactor = $93f6c931eebc2be3$export$dd08dbbf61041ccd(fileInfo.file, tags);
    return {
        scaleFactor: scaleFactor,
        width: width,
        height: height
    };
}
function $93f6c931eebc2be3$export$dd08dbbf61041ccd(file, tags) {
    const scaleFactorFromFilename = $93f6c931eebc2be3$export$11cb6a214555dd36(file);
    if (scaleFactorFromFilename !== null) return scaleFactorFromFilename;
    else if (tags) {
        /**
		 * Scale Factor is actually a 2D thing, but in practice X & Y are same in 99% cases.
		 * So we are only relying on X axis.
		 */ if (typeof tags['PixelPerUnitX'] === 'number') // 1 inch = 0.0254 meters
        return Math.round(tags['PixelPerUnitX'] * 0.0254) / $93f6c931eebc2be3$var$DPI_WEB_BASELINE;
        else return $93f6c931eebc2be3$export$268f92356524130b(tags, $93f6c931eebc2be3$var$XResolution, $93f6c931eebc2be3$var$DPI_WEB_BASELINE) / $93f6c931eebc2be3$var$DPI_WEB_BASELINE;
    } else return 1;
}
const $93f6c931eebc2be3$var$getOrientationFromTags = (tags)=>{
    if (tags && tags[$93f6c931eebc2be3$var$Orientation]) {
        const tagValue = tags[$93f6c931eebc2be3$var$Orientation];
        if (tagValue) {
            const numericValue = parseInt(tagValue, 10);
            if (isNaN(numericValue)) return (0, $k9Ch0.ExifOrientation)[tagValue];
            return numericValue;
        }
    }
    return 1;
};
async function $93f6c931eebc2be3$export$67689507e8404821(file) {
    const tags = await (0, $5m9mt.readImageMetaTags)(file);
    return $93f6c931eebc2be3$var$getOrientationFromTags(tags);
}
function $93f6c931eebc2be3$export$268f92356524130b(tags, key, defaultValue) {
    try {
        const num = parseFloat(`${tags[key]}`);
        if (!isNaN(num)) return num;
    } catch (e) {
    //
    }
    return defaultValue;
}
function $93f6c931eebc2be3$export$11cb6a214555dd36(file) {
    try {
        // filenames with scale ratio in name take precedence - eg. filename@2x.png
        const match = file.name.trim().match(/@([0-9\.]+)x\.[a-z]{3}$/);
        if (match) return parseFloat(match[1]);
    } catch (e) {
    // parse problem, return null
    }
    return null;
}
async function $93f6c931eebc2be3$export$c142eb1c8c5c79c(fileInfo) {
    const { file: file, src: src } = fileInfo;
    const type = file.type;
    let width = 0;
    let height = 0;
    const tags = await (0, $5m9mt.readImageMetaTags)(file);
    // since we're reading metadata anyway, try to get dimensions from there...
    if (tags && tags.PixelXDimension) width = $93f6c931eebc2be3$export$268f92356524130b(tags, 'PixelXDimension', 0);
    if (tags && tags.PixelXDimension) height = $93f6c931eebc2be3$export$268f92356524130b(tags, 'PixelYDimension', 0);
    const data = {
        type: type,
        width: width,
        height: height,
        naturalWidth: width,
        naturalHeight: height,
        tags: tags
    };
    /*
	 * The PixelXDimension and PixelYDimension of image tags can mean something different than just width and height, especially when images are compressed or for other reasons.
	 * https://imagemagick.org/discourse-server/viewtopic.php?t=27037
	 * We've also received JAC tickets reporting incorrect dimensions because of this
	 * https://jira.atlassian.com/browse/CONFCLOUD-78275
	 * The best way to get accurate dimensions is by loading images into the HTML, which reflects the actual dimensions the browser will render
	 */ try {
        const img = await (0, $1xbJn.loadImage)(src);
        const { width: width, height: height } = (0, $1xbJn.readImageNaturalOrientationFromDOM)(img);
        data.width = width;
        data.height = height;
        data.naturalWidth = img.naturalWidth;
        data.naturalHeight = img.naturalHeight;
    } catch (e) {
        return null;
    }
    return data;
}

});
parcelRegister("k9Ch0", function(module, exports) {

$parcel$export(module.exports, "ImageType", () => $8ba626f637ae3df3$export$48c85e6e32ef0825);
$parcel$export(module.exports, "SupportedImageMetaTag", () => $8ba626f637ae3df3$export$e369bb48cf33e564);
$parcel$export(module.exports, "ExifOrientation", () => $8ba626f637ae3df3$export$f6ea0c89fd7d156);
var $8ba626f637ae3df3$export$48c85e6e32ef0825 = /*#__PURE__*/ function(ImageType) {
    ImageType["JPEG"] = "image/jpeg";
    ImageType["PNG"] = "image/png";
    return ImageType;
}({});
var $8ba626f637ae3df3$export$e369bb48cf33e564 = /*#__PURE__*/ function(SupportedImageMetaTag) {
    SupportedImageMetaTag["XResolution"] = "XResolution";
    SupportedImageMetaTag["YResolution"] = "YResolution";
    SupportedImageMetaTag["Orientation"] = "Orientation";
    return SupportedImageMetaTag;
}({});
const $8ba626f637ae3df3$export$f6ea0c89fd7d156 = {
    'top-left': 1,
    'top-right': 2,
    'bottom-right': 3,
    'bottom-left': 4,
    'left-top': 5,
    'right-top': 6,
    'right-bottom': 7,
    'left-bottom': 8
};

});

parcelRegister("5m9mt", function(module, exports) {

$parcel$export(module.exports, "readImageMetaTags", () => $6da5c9a89db4de84$export$41982b5c7acb23c4);

var $k9Ch0 = parcelRequire("k9Ch0");

var $jkveD = parcelRequire("jkveD");

var $kINoG = parcelRequire("kINoG");

var $2edT6 = parcelRequire("2edT6");
async function $6da5c9a89db4de84$export$41982b5c7acb23c4(file) {
    const type = file.type;
    try {
        if (type === (0, $k9Ch0.ImageType).PNG) {
            // http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
            // iTXt = XML text with metadata
            // pHYs = Physical pixel dimensions
            const { iTXt: iTXt, pHYs: pHYs } = await (0, $kINoG.readPNGXMPMetaData)(file);
            const xmpMetaData = {
                ...(0, $2edT6.parseXMPMetaData)(iTXt),
                ...pHYs
            };
            return xmpMetaData;
        } else if (file.type === (0, $k9Ch0.ImageType).JPEG) return await (0, $jkveD.readJPEGExifMetaData)(file);
    } catch (e) {
    // problem parsing metadata
    }
    return null;
}

});
parcelRegister("jkveD", function(module, exports) {

$parcel$export(module.exports, "readJPEGExifMetaData", () => $537aa8dc852a8555$export$556b2ccec62d7f2a);

var $k9Ch0 = parcelRequire("k9Ch0");
const { XResolution: $537aa8dc852a8555$var$XResolution, YResolution: $537aa8dc852a8555$var$YResolution } = (0, $k9Ch0.SupportedImageMetaTag);
let $537aa8dc852a8555$var$loadImage;

function $537aa8dc852a8555$export$556b2ccec62d7f2a(file) {
    return new Promise(async (resolve, reject)=>{
        if (!$537aa8dc852a8555$var$loadImage) {
            const module = await (parcelRequire("8iz07"));
            $537aa8dc852a8555$var$loadImage = module.default || module;
        }
        $537aa8dc852a8555$var$loadImage.parseMetaData(file, (data)=>{
            try {
                const tags = data && data.exif ? data.exif.getAll() : {};
                Object.keys(tags).forEach((key)=>{
                    const value = tags[key];
                    if (typeof value === 'object' && (key === $537aa8dc852a8555$var$XResolution || key === $537aa8dc852a8555$var$YResolution) && 'numerator' in value) // some test images had this structure, so just take the numerator value to simplify returned value
                    tags[key] = value.numerator;
                    if (typeof tags[key] === 'number') // in case numbers types were auto-converted, keep everything the same between jpeg & png we keep as strings
                    tags[key] = `${tags[key]}`;
                });
                resolve(tags);
            } catch (e) {
                reject(e);
            }
        });
    });
}

});
parcelRegister("8iz07", function(module, exports) {

let $60ab27a2818ad2da$var$load = (parcelRequire("28QjX"))(4);
module.exports = $60ab27a2818ad2da$var$load("7lJbN").then(()=>parcelRequire('8aLn9'));

});


parcelRegister("kINoG", function(module, exports) {

$parcel$export(module.exports, "readPNGXMPMetaData", () => $013315ab2d0cc3cf$export$5fb37736440fca6f);

var $1xbJn = parcelRequire("1xbJn");
let $013315ab2d0cc3cf$var$pngChunksExtract;

async function $013315ab2d0cc3cf$export$5fb37736440fca6f(file) {
    if (!$013315ab2d0cc3cf$var$pngChunksExtract) {
        const module = await (parcelRequire("8u6C4"));
        $013315ab2d0cc3cf$var$pngChunksExtract = module.default || module;
    }
    const buffer = await (0, $1xbJn.fileToArrayBuffer)(file);
    const chunks = $013315ab2d0cc3cf$var$pngChunksExtract(buffer);
    return await $013315ab2d0cc3cf$export$9185743fdd58ce45(chunks);
}
async function $013315ab2d0cc3cf$export$9185743fdd58ce45(chunks) {
    let iTXt = '';
    let pHYs = {};
    /**
	 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
	 * Order of every chunk is not guaranteed.
	 * And both iTXt and pHYs are Ancillary chunks.
	 */ for(let i = 0; i < chunks.length; ++i){
        const chunk = chunks[i];
        // Must be last
        if (chunk.name === 'IEND') break;
        /**
		 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Anc-text
		 * iTXt contains the useful XMP/XML string data of meta tags
		 */ if (chunk.name === 'iTXt') iTXt = String.fromCharCode.apply(null, Array.from(chunk.data));
        /**
		 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.pHYs
		 * Pixels per unit, X axis: 4 bytes (unsigned integer)
		 * Pixels per unit, Y axis: 4 bytes (unsigned integer)
		 * Unit specifier:          1 byte  (0: unit is unknown 1: unit is the meter)
		 */ if (chunk.name === 'pHYs') {
            const dv = new DataView(chunk.data.buffer);
            const unitSpecifier = dv.getUint8(8);
            // meter
            if (unitSpecifier === 1) {
                const PixelPerUnitX = dv.getUint32(0);
                const PixelPerUnitY = dv.getUint32(4);
                pHYs = {
                    PixelPerUnitX: PixelPerUnitX,
                    PixelPerUnitY: PixelPerUnitY
                };
            }
        }
    }
    return {
        iTXt: iTXt,
        pHYs: pHYs
    };
}

});
parcelRegister("1xbJn", function(module, exports) {

$parcel$export(module.exports, "dataURItoFile", () => $3c9a3ebb8ee397f0$export$80d19edb7b1ae293);
$parcel$export(module.exports, "fileToDataURI", () => $3c9a3ebb8ee397f0$export$849633012686f7ee);
$parcel$export(module.exports, "getFileInfo", () => $3c9a3ebb8ee397f0$export$ca39f27fe4f7d9b4);
$parcel$export(module.exports, "fileToArrayBuffer", () => $3c9a3ebb8ee397f0$export$956310555b96755a);
$parcel$export(module.exports, "loadImage", () => $3c9a3ebb8ee397f0$export$fe58198efe02b173);
$parcel$export(module.exports, "readImageNaturalOrientationFromDOM", () => $3c9a3ebb8ee397f0$export$325d46491952db2d);
$parcel$export(module.exports, "findParentByClassname", () => $3c9a3ebb8ee397f0$export$89ff65f1d45dfb03);
$parcel$export(module.exports, "getMimeIcon", () => $3c9a3ebb8ee397f0$export$61a1de0822e2820);

var $2tm8x = parcelRequire("2tm8x");

var $RiK2l = parcelRequire("RiK2l");

var $cHwqN = parcelRequire("cHwqN");

var $2sfBf = parcelRequire("2sfBf");

var $iABw2 = parcelRequire("iABw2");

var $7hpMa = parcelRequire("7hpMa");

var $dGYEZ = parcelRequire("dGYEZ");

var $iBOon = parcelRequire("iBOon");

var $jdlqN = parcelRequire("jdlqN");

var $c70Lr = parcelRequire("c70Lr");

var $2osAJ = parcelRequire("2osAJ");

var $7zjHG = parcelRequire("7zjHG");

var $8SPcB = parcelRequire("8SPcB");

var $es8mD = parcelRequire("es8mD");

var $gYsK7 = parcelRequire("gYsK7");

var $8RqHP = parcelRequire("8RqHP");
function $3c9a3ebb8ee397f0$export$80d19edb7b1ae293(dataURI, filename = 'untitled') {
    if (dataURI.length === 0) throw new Error('dataURI not found');
    // convert base64/URLEncoded data component to raw binary data held in a string
    const dataURIParts = dataURI.split(',');
    const byteString = dataURIParts[0].indexOf('base64') >= 0 ? atob(dataURIParts[1]) : decodeURIComponent(dataURIParts[1]);
    // separate out the mime component
    let mimeString;
    try {
        mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    } catch (e) {
        // https://stackoverflow.com/questions/1176022/unknown-file-type-mime
        mimeString = 'application/octet-stream';
    }
    // write the bytes of the string to a typed array
    const intArray = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)intArray[i] = byteString.charCodeAt(i);
    const blob = new Blob([
        intArray
    ], {
        type: mimeString
    });
    try {
        return new File([
            blob
        ], filename, {
            type: mimeString
        });
    } catch (e) {
        // IE11 does not allow the File constructor (yay!)
        // we get around this by decorating the blob instance with File properties
        // effectively casting up from Blob to File.
        const ie11File = blob;
        const date = new Date();
        ie11File.lastModified = date.getTime();
        ie11File.lastModifiedDate = date;
        ie11File.name = filename;
        ie11File.webkitRelativePath = '';
        return ie11File;
    }
}
function $3c9a3ebb8ee397f0$export$849633012686f7ee(blob) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const result = reader.result;
            if (typeof result === 'string') resolve(result);
            else if (result === null) reject();
        });
        reader.addEventListener('error', reject);
        reader.readAsDataURL(blob);
    });
}
async function $3c9a3ebb8ee397f0$export$ca39f27fe4f7d9b4(file, src) {
    return {
        file: file,
        src: src || await $3c9a3ebb8ee397f0$export$849633012686f7ee(file)
    };
}
async function $3c9a3ebb8ee397f0$export$d727e14d7168c14(src, file) {
    return {
        file: file || await $3c9a3ebb8ee397f0$export$80d19edb7b1ae293(src),
        src: src
    };
}
function $3c9a3ebb8ee397f0$export$956310555b96755a(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const array = new Uint8Array(reader.result);
            resolve(array);
        });
        reader.addEventListener('error', reject);
        reader.readAsArrayBuffer(file);
    });
}
function $3c9a3ebb8ee397f0$export$fe58198efe02b173(src) {
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.src = src;
        img.onload = ()=>{
            resolve(img);
        };
        img.onerror = reject;
    });
}
function $3c9a3ebb8ee397f0$export$325d46491952db2d(img) {
    img.style.position = 'absolute';
    img.style.visibility = 'hidden';
    document.body.appendChild(img);
    const { width: width, height: height } = img.getBoundingClientRect();
    document.body.removeChild(img);
    return {
        width: width,
        height: height
    };
}
const $3c9a3ebb8ee397f0$export$89ff65f1d45dfb03 = (element, className, maxParentElement = document.body)=>{
    if (element.classList.contains(className)) return element;
    let currentElement = element;
    while(currentElement.parentElement !== maxParentElement){
        if (currentElement.parentElement) {
            currentElement = currentElement.parentElement;
            if (currentElement.classList.contains(className)) return currentElement;
        } else return undefined;
    }
    return undefined;
};
const $3c9a3ebb8ee397f0$var$mimeTypes = [
    {
        label: 'pdf',
        mimeTypes: [
            'application/pdf'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2tm8x)))
    },
    {
        label: 'google-form',
        mimeTypes: [
            'application/vnd.google-apps.form'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jdlqN)))
    },
    {
        label: 'google-slides',
        mimeTypes: [
            'application/vnd.google-apps.presentation'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2osAJ)))
    },
    {
        label: 'google-form',
        mimeTypes: [
            'application/vnd.google-apps.form'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jdlqN)))
    },
    {
        label: 'google-sheets',
        mimeTypes: [
            'application/vnd.google-apps.spreadsheet'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($c70Lr)))
    },
    {
        label: 'google-docs',
        mimeTypes: [
            'application/vnd.google-apps.document',
            'application/vnd.google-apps.kix'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iBOon)))
    },
    {
        label: 'microsoft-word',
        mimeTypes: [
            'application/msword',
            'application/vnd.openxmlformats-officedocument.word'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2sfBf)))
    },
    {
        label: 'presentation',
        mimeTypes: [
            'application/x-iwork-keynote-sffkey',
            'application/vnd.oasis.opendocument.presentation'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($es8mD)))
    },
    {
        label: 'powerpoint-presentation',
        mimeTypes: [
            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'application/vnd.ms-powerpoint'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cHwqN)))
    },
    {
        label: 'giphy',
        mimeTypes: [
            'image/gif'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($RiK2l)))
    },
    {
        label: 'spreadsheet',
        mimeTypes: [
            'text/csv'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8SPcB)))
    },
    {
        label: 'excel-spreadsheet',
        mimeTypes: [
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.ms-excel',
            'application/x-iwork-keynote-sffnumbers'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7zjHG)))
    }
];
function $3c9a3ebb8ee397f0$export$61a1de0822e2820(mimeType, fileName) {
    // based on the mimeType, determine the corresponding icon and label
    const iconInfo = $3c9a3ebb8ee397f0$var$mimeTypes.find((file)=>file.mimeTypes.indexOf(mimeType) > -1);
    //return the appropriate icon and its label if we have it
    if (iconInfo) return iconInfo;
    if ((0, $8RqHP.isCodeViewerItem)(fileName, mimeType)) return {
        label: 'source-code',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gYsK7)))
    };
    // we are not able to determine what icon to render based on the mimeType
    // hence we render the icon based on the filename
    if (fileName.match(/.*\.sketch$/)) return {
        label: 'sketch',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iABw2)))
    };
    if (fileName.match(/.*\.fig$/)) return {
        label: 'figma',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7hpMa)))
    };
    if (fileName.match(/.*\.exe$/) || fileName.match(/.*\.dmg$/)) return {
        label: 'executable',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dGYEZ)))
    };
    // cannot find a corresponding mimeType icon.
    return undefined;
}

});
parcelRegister("2tm8x", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $1ccf7616b127308b$var$_react = $1ccf7616b127308b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $1ccf7616b127308b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1ccf7616b127308b$var$PdfDocument24Icon = (props)=>/*#__PURE__*/ $1ccf7616b127308b$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.846 12.17h.483c1.116 0 1.203-.322 1.203-.776 0-.518-.268-.771-.817-.771h-.869zm6.29 2.183h.664c.742 0 1.501-.22 1.501-1.855 0-1.65-.802-1.86-1.501-1.86h-.665zM4.462 15.99h-1.08A.384.384 0 0 1 3 15.606V9.383c0-.21.171-.383.383-.383h2.494c1.483 0 2.52.984 2.52 2.394 0 1.43-1.015 2.39-2.525 2.39H4.846v1.822a.384.384 0 0 1-.383.384m7.45 0h-2.24a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h2.242c2.107 0 3.268 1.237 3.268 3.484 0 2.26-1.16 3.506-3.268 3.506m5.776 0h-1.08a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h4.009c.21 0 .383.172.383.383v.88a.383.383 0 0 1-.383.383h-2.545v1.14h2.292c.212 0 .383.172.383.383v.867c0 .21-.171.383-.383.383h-2.292v2.187a.384.384 0 0 1-.383.384"/></svg>`
    }, props, {
        size: 'medium'
    }));
$1ccf7616b127308b$var$PdfDocument24Icon.displayName = 'PdfDocument24Icon';
var $1ccf7616b127308b$var$_default = module.exports.default = $1ccf7616b127308b$var$PdfDocument24Icon;

});

parcelRegister("RiK2l", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $0a037d07967bfa4f$var$_react = $0a037d07967bfa4f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $0a037d07967bfa4f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0a037d07967bfa4f$var$Gif24Icon = (props)=>/*#__PURE__*/ $0a037d07967bfa4f$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m10.564 16.636h-1.93a.243.243 0 0 1-.244-.243V8.384c0-.135.108-.243.243-.243h1.93c.135 0 .244.108.244.243v8.009a.243.243 0 0 1-.243.243m3.79 0h-1.931a.243.243 0 0 1-.243-.243V8.384c0-.135.109-.243.243-.243h5.334c.133 0 .243.108.243.243v1.573c0 .134-.11.243-.243.243h-3.16v1.42h2.848c.135 0 .244.11.244.244v1.518a.243.243 0 0 1-.244.244h-2.847v2.767c0 .134-.11.243-.244.243m-10.567.146C4.416 16.782 3 15.31 3 12.843v-.962C3 9.487 4.453 8 6.793 8c2.314 0 3.436 1.467 3.522 2.922a.24.24 0 0 1-.242.258H8.195a.24.24 0 0 1-.24-.2c-.1-.55-.552-.892-1.18-.892-1.108 0-1.34.985-1.34 1.81v.94c0 1.231.467 1.856 1.393 1.856.885 0 1.2-.538 1.2-1v-.092H6.874a.243.243 0 0 1-.243-.243v-1.373c0-.134.11-.243.243-.243h3.216c.134 0 .243.109.243.243v1.555c0 1.496-.929 3.241-3.546 3.241"/></svg>`
    }, props, {
        size: 'medium'
    }));
$0a037d07967bfa4f$var$Gif24Icon.displayName = 'Gif24Icon';
var $0a037d07967bfa4f$var$_default = module.exports.default = $0a037d07967bfa4f$var$Gif24Icon;

});

parcelRegister("cHwqN", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $93f2a85309224bbe$var$_react = $93f2a85309224bbe$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $93f2a85309224bbe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $93f2a85309224bbe$var$PowerpointPresentation24Icon = (props)=>/*#__PURE__*/ $93f2a85309224bbe$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ca5010" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM7.854 8.454h2.94c1.45 0 2.441.972 2.441 2.437 0 1.45-1.03 2.422-2.514 2.422H9.329V15.5H7.854zM9.33 9.665v2.451h1.07c.844 0 1.337-.43 1.337-1.22 0-.801-.483-1.231-1.333-1.231z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$93f2a85309224bbe$var$PowerpointPresentation24Icon.displayName = 'PowerpointPresentation24Icon';
var $93f2a85309224bbe$var$_default = module.exports.default = $93f2a85309224bbe$var$PowerpointPresentation24Icon;

});

parcelRegister("2sfBf", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $1c9a4c12d2fc4227$var$_react = $1c9a4c12d2fc4227$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $1c9a4c12d2fc4227$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1c9a4c12d2fc4227$var$WordDocument24Icon = (props)=>/*#__PURE__*/ $1c9a4c12d2fc4227$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#1d7afc" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zm5.629 5.324L8.687 16H7.295L5.43 8.954h1.533l1.099 4.966h.078l1.284-4.966h1.245l1.309 4.966h.078l1.089-4.966h1.523L12.798 16h-1.382l-1.333-4.663zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$1c9a4c12d2fc4227$var$WordDocument24Icon.displayName = 'WordDocument24Icon';
var $1c9a4c12d2fc4227$var$_default = module.exports.default = $1c9a4c12d2fc4227$var$WordDocument24Icon;

});

parcelRegister("iABw2", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d888b0a1557aa645$var$_react = $d888b0a1557aa645$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $d888b0a1557aa645$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d888b0a1557aa645$var$Sketch24Icon = (props)=>/*#__PURE__*/ $d888b0a1557aa645$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff8b00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m9.03 20c.29-.001.562-.126.752-.343l6.971-8a1 1 0 0 0 .095-1.185l-2.485-4a1 1 0 0 0-.85-.472h-8.84c-.334 0-.646.167-.832.444l-2.674 4a1 1 0 0 0 .081 1.216l7.03 8c.188.216.462.34.75.34"/></svg>`
    }, props, {
        size: 'medium'
    }));
$d888b0a1557aa645$var$Sketch24Icon.displayName = 'Sketch24Icon';
var $d888b0a1557aa645$var$_default = module.exports.default = $d888b0a1557aa645$var$Sketch24Icon;

});

parcelRegister("7hpMa", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $54ce1d7bd56eb231$var$_react = $54ce1d7bd56eb231$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $54ce1d7bd56eb231$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $54ce1d7bd56eb231$var$Figma24Icon = (props)=>/*#__PURE__*/ $54ce1d7bd56eb231$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3.248 0A3.25 3.25 0 0 0 0 3.248v17.504A3.25 3.25 0 0 0 3.248 24h17.504A3.25 3.25 0 0 0 24 20.752V3.248A3.25 3.25 0 0 0 20.752 0zm8.755 17.013a2.506 2.506 0 0 1-2.505 2.506 2.506 2.506 0 0 1 0-5.013 2.506 2.506 0 0 1 0-5.012 2.506 2.506 0 0 1 0-5.013h5.009a2.506 2.506 0 0 1 0 5.013h-2.504v2.5a2.506 2.506 0 0 1 2.504-2.5 2.506 2.506 0 0 1 0 5.012 2.506 2.506 0 0 1-2.504-2.5z" clip-rule="evenodd"/></svg>`
    }, props, {
        size: 'medium'
    }));
$54ce1d7bd56eb231$var$Figma24Icon.displayName = 'Figma24Icon';
var $54ce1d7bd56eb231$var$_default = module.exports.default = $54ce1d7bd56eb231$var$Figma24Icon;

});

parcelRegister("dGYEZ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $9f7e406d5bea49df$var$_react = $9f7e406d5bea49df$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $9f7e406d5bea49df$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9f7e406d5bea49df$var$Executable24Icon = (props)=>/*#__PURE__*/ $9f7e406d5bea49df$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 13v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5zm1.883-8a1 1 0 0 0-.992.876L5 13h14l-.89-7.124A1 1 0 0 0 17.116 5zM8 15h8a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2"/></svg>`
    }, props, {
        size: 'medium'
    }));
$9f7e406d5bea49df$var$Executable24Icon.displayName = 'Executable24Icon';
var $9f7e406d5bea49df$var$_default = module.exports.default = $9f7e406d5bea49df$var$Executable24Icon;

});

parcelRegister("iBOon", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d8c2c58dddf5fcc0$var$_react = $d8c2c58dddf5fcc0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $d8c2c58dddf5fcc0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d8c2c58dddf5fcc0$var$GoogleDoc24Icon = (props)=>/*#__PURE__*/ $d8c2c58dddf5fcc0$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2196f3" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$d8c2c58dddf5fcc0$var$GoogleDoc24Icon.displayName = 'GoogleDoc24Icon';
var $d8c2c58dddf5fcc0$var$_default = module.exports.default = $d8c2c58dddf5fcc0$var$GoogleDoc24Icon;

});

parcelRegister("jdlqN", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $dfcfdb061c664b77$var$_react = $dfcfdb061c664b77$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $dfcfdb061c664b77$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $dfcfdb061c664b77$var$GoogleForm24Icon = (props)=>/*#__PURE__*/ $dfcfdb061c664b77$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$dfcfdb061c664b77$var$GoogleForm24Icon.displayName = 'GoogleForm24Icon';
var $dfcfdb061c664b77$var$_default = module.exports.default = $dfcfdb061c664b77$var$GoogleForm24Icon;

});

parcelRegister("c70Lr", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $8d16bb363c31083e$var$_react = $8d16bb363c31083e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $8d16bb363c31083e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8d16bb363c31083e$var$GoogleSheet24Icon = (props)=>/*#__PURE__*/ $8d16bb363c31083e$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#0a9d58" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$8d16bb363c31083e$var$GoogleSheet24Icon.displayName = 'GoogleSheet24Icon';
var $8d16bb363c31083e$var$_default = module.exports.default = $8d16bb363c31083e$var$GoogleSheet24Icon;

});

parcelRegister("2osAJ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $1be4005185ae78d9$var$_react = $1be4005185ae78d9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $1be4005185ae78d9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1be4005185ae78d9$var$GoogleSlide24Icon = (props)=>/*#__PURE__*/ $1be4005185ae78d9$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffc107" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$1be4005185ae78d9$var$GoogleSlide24Icon.displayName = 'GoogleSlide24Icon';
var $1be4005185ae78d9$var$_default = module.exports.default = $1be4005185ae78d9$var$GoogleSlide24Icon;

});

parcelRegister("7zjHG", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $582b1603b710ea90$var$_react = $582b1603b710ea90$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $582b1603b710ea90$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $582b1603b710ea90$var$ExcelSpreadsheet24Icon = (props)=>/*#__PURE__*/ $582b1603b710ea90$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#22a06b" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM6.93 15.5l2.25-3.55-2.236-3.496h1.734l1.47 2.466h.087l1.485-2.466h1.65l-2.32 3.52 2.286 3.526h-1.68l-1.513-2.388h-.088L8.52 15.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$582b1603b710ea90$var$ExcelSpreadsheet24Icon.displayName = 'ExcelSpreadsheet24Icon';
var $582b1603b710ea90$var$_default = module.exports.default = $582b1603b710ea90$var$ExcelSpreadsheet24Icon;

});

parcelRegister("8SPcB", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $677b15938c7d624c$var$_react = $677b15938c7d624c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $677b15938c7d624c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $677b15938c7d624c$var$Spreadsheet24Icon = (props)=>/*#__PURE__*/ $677b15938c7d624c$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 5a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm7-12a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$677b15938c7d624c$var$Spreadsheet24Icon.displayName = 'Spreadsheet24Icon';
var $677b15938c7d624c$var$_default = module.exports.default = $677b15938c7d624c$var$Spreadsheet24Icon;

});

parcelRegister("es8mD", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $a85a2b23143ceb75$var$_react = $a85a2b23143ceb75$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $a85a2b23143ceb75$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a85a2b23143ceb75$var$Presentation24Icon = (props)=>/*#__PURE__*/ $a85a2b23143ceb75$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m3 14a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1m8-6a1 1 0 0 0-1 1v9a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1m-4 4a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0v-5a1 1 0 0 0-1-1m8-7a1 1 0 0 0-1 1v12a1 1 0 0 0 2 0V6a1 1 0 0 0-1-1"/></svg>`
    }, props, {
        size: 'medium'
    }));
$a85a2b23143ceb75$var$Presentation24Icon.displayName = 'Presentation24Icon';
var $a85a2b23143ceb75$var$_default = module.exports.default = $a85a2b23143ceb75$var$Presentation24Icon;

});

parcelRegister("gYsK7", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c5b88baa981b1084$var$_react = $c5b88baa981b1084$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $c5b88baa981b1084$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c5b88baa981b1084$var$SourceCode24Icon = (props)=>/*#__PURE__*/ $c5b88baa981b1084$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#00b8d9" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m5.017 12.265-2.58-2.501L8.236 7.05a.999.999 0 1 0-1.392-1.436l-3.54 3.432a1 1 0 0 0 0 1.436l3.32 3.219a1 1 0 1 0 1.393-1.436m6.638-8.21a1 1 0 0 0-1.271.62l-4.83 14.046a1 1 0 0 0 1.892.65l4.829-14.045a1 1 0 0 0-.62-1.271m6.081 9.776-3.32-3.219a.999.999 0 1 0-1.393 1.436l2.58 2.501-2.799 2.714a.999.999 0 1 0 1.392 1.436l3.54-3.432a1 1 0 0 0 0-1.436"/></svg>`
    }, props, {
        size: 'medium'
    }));
$c5b88baa981b1084$var$SourceCode24Icon.displayName = 'SourceCode24Icon';
var $c5b88baa981b1084$var$_default = module.exports.default = $c5b88baa981b1084$var$SourceCode24Icon;

});

parcelRegister("8RqHP", function(module, exports) {

$parcel$export(module.exports, "getExtension", () => $60b93921782d6d1e$export$78d71f9ed5534abe);
$parcel$export(module.exports, "isCodeViewerItem", () => $60b93921782d6d1e$export$bb139b46f345ca28);
$parcel$export(module.exports, "getLanguageType", () => $60b93921782d6d1e$export$ba4368c844580f9e);
function $60b93921782d6d1e$export$78d71f9ed5534abe(filename) {
    if (filename.indexOf('.') > -1) return filename.split('.').pop();
    return '';
}
const $60b93921782d6d1e$var$codeViewerMimeTypes = [
    {
        mimetype: 'application/json',
        language: 'json'
    },
    {
        mimetype: 'text/html',
        language: 'html'
    }
];
function $60b93921782d6d1e$export$bb139b46f345ca28(name, mimetype = 'unknown') {
    return $60b93921782d6d1e$export$ba4368c844580f9e(name, mimetype) !== null;
}
function $60b93921782d6d1e$export$ba4368c844580f9e(name, mimetype) {
    if (mimetype) {
        const languageForMimeType = $60b93921782d6d1e$var$codeViewerMimeTypes.find((x)=>x.mimetype === mimetype);
        if (languageForMimeType) return languageForMimeType.language;
    }
    const ext = $60b93921782d6d1e$export$78d71f9ed5534abe(name);
    switch(ext){
        case 'abap':
        case 'ada':
        case 'c':
        case 'css':
        case 'd':
        case 'dart':
        case 'go':
        case 'graphql':
        case 'groovy':
        case 'html':
        case 'java':
        case 'json':
        case 'matlab':
        case 'xml':
        case 'lua':
        case 'puppet':
        case 'qml':
        case 'sass':
        case 'sql':
        case 'php':
        case 'r':
        case 'swift':
        case 'tcl':
        case 'vala':
        case 'vhdl':
        case 'xquery':
            return ext;
        case 'as':
        case 'asc':
            return 'actionscript';
        case 'ino':
            return 'arduino';
        case 'au3':
            return 'autoit';
        case 'cpp':
        case 'h':
        case 'c++':
            return 'c++';
        case 'coffee':
            return 'coffeescript';
        case 'cs':
            return 'csharp';
        case 'cu':
            return 'cuda';
        case 'pas':
        case 'dpr':
        case 'dproj':
        case 'dpk':
            return 'delphi';
        case 'ex':
        case 'exs':
            return 'elixir';
        case 'erl':
        case 'hrl':
            return 'erlang';
        case 'f90':
        case 'for':
        case 'f':
        case 'fpp':
        case 'i':
        case 'i90':
        case 'ftn':
            return 'fortran';
        case 'dbc':
            return 'foxpro';
        case 'hs':
        case 'has':
            return 'haskell';
        case 'hx':
            return 'haxe';
        case 'js':
        case 'jsx':
            return 'javascript';
        case 'jl':
            return 'julia';
        case 'kt':
            return 'kotlin';
        case 'm':
        case 'mm':
            return 'objective-c';
        case 'j':
            return 'objective-j';
        case 'tex':
            return 'latex';
        case 'nb':
        case 'cdf':
            return 'mathematica';
        case 'cma':
            return 'ocaml';
        case 'pl':
            return 'perl';
        case 'py':
            return 'python';
        case 'ps1':
        case 'psd1':
        case 'psm1':
            return 'powershell';
        case 'rb':
            return 'ruby';
        case 'rst':
            return 'restructuredtext';
        case 'rs':
            return 'rust';
        case 'rkt':
            return 'racket';
        case 'sh':
            return 'shell';
        case 'sc':
        case 'sch':
            return 'scheme';
        case 'txt':
        case 'msg':
        case 'log':
        case 'csv':
        case 'md':
            return 'text';
        case 'ts':
        case 'tsx':
            return 'typescript';
        case 'v':
            return 'verilog';
        case 'xq':
        case 'xql':
        case 'xqm':
        case 'xqy':
            return 'xquery';
        case 'lock':
        case 'yaml':
        case 'yml':
            return 'yaml';
        default:
            return null;
    }
}

});


parcelRegister("8u6C4", function(module, exports) {

let $019819d3d04dcea8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $019819d3d04dcea8$var$load("jODAF").then(()=>parcelRequire('eYIux'));

});


parcelRegister("2edT6", function(module, exports) {

$parcel$export(module.exports, "parseXMPMetaData", () => $1cac606283e05089$export$55c3bc9841b19de2);
function $1cac606283e05089$export$55c3bc9841b19de2(xmpMetaData) {
    const metadata = {};
    const tags = xmpMetaData.match(/<(tiff|exif):.+>/gi);
    if (tags) tags.forEach((tag)=>{
        const match = tag.match(/<(tiff|exif):([^>]+)>([^<]+)/i);
        if (match) {
            const name = match[2];
            metadata[name] = match[3];
        }
    });
    return metadata;
}

});


parcelRegister("hNjKA", function(module, exports) {

$parcel$export(module.exports, "isRotated", () => $81d3fceca65be0fc$export$8af433705f41088f);
$parcel$export(module.exports, "getCssFromImageOrientation", () => $81d3fceca65be0fc$export$43142f95b8de7a91);
const $81d3fceca65be0fc$var$ORIENT_TRANSFORMS = {
    1: 'none',
    2: 'rotateY(180deg)',
    3: 'rotate(180deg)',
    4: 'rotate(180deg) rotateY(180deg)',
    5: 'rotate(270deg) rotateY(180deg)',
    6: 'rotate(90deg)',
    7: 'rotate(90deg) rotateY(180deg)',
    8: 'rotate(270deg)'
};
const $81d3fceca65be0fc$export$8af433705f41088f = (orientation)=>orientation >= 5;
const $81d3fceca65be0fc$export$43142f95b8de7a91 = (orientation)=>{
    return $81d3fceca65be0fc$var$ORIENT_TRANSFORMS[orientation];
};

});


parcelRegister("Nl5sY", function(module, exports) {

$parcel$export(module.exports, "takeSnapshot", () => $33ec34d1173165de$export$4269d30173168e5c);
const $33ec34d1173165de$export$4269d30173168e5c = async (blob)=>{
    return new Promise((resolve, reject)=>{
        const url = URL.createObjectURL(blob);
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.src = url;
        video.muted = true;
        video.play().catch(()=>{
            return reject(new Error('failed to play video'));
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('timeupdate', function timeUpdateHandler() {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            video.removeEventListener('timeupdate', timeUpdateHandler);
            video.pause();
            URL.revokeObjectURL(url);
            //create canvas to draw our first frame on.
            if (!video.videoWidth && !video.videoHeight) return reject(new Error('error retrieving video dimensions'));
            const canvas = document.createElement('canvas');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            const context = canvas.getContext('2d');
            if (!context) return reject(new Error('error creating canvas context'));
            context.drawImage(video, 0, 0, canvas.width, canvas.height);
            const dataURL = canvas.toDataURL('image/jpeg', 0.85);
            resolve(dataURL);
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('error', ()=>{
            reject(new Error('failed to load video'));
            URL.revokeObjectURL(url);
        });
    });
};

});



parcelRegister("3JZCV", function(module, exports) {

$parcel$export(module.exports, "getMediaCardSSR", () => $293d53ca8ea6912a$export$ede93d4564eaa8da);
$parcel$export(module.exports, "getKey", () => $293d53ca8ea6912a$export$a47fb462a08de82f);
$parcel$export(module.exports, "generateScriptProps", () => $293d53ca8ea6912a$export$de7c49925e44d75d);

var $1QRxp = parcelRequire("1QRxp");
const $293d53ca8ea6912a$export$21c2ece80f3e3137 = 'mediaCardSsr';
const $293d53ca8ea6912a$export$5b1a163e413609f8 = '__MEDIA_INTERNAL';
function $293d53ca8ea6912a$export$96a3cfb3a41e9bb2(globalScope = window) {
    // Must match GLOBAL_MEDIA_NAMESPACE. Can't reference the constant from here.
    const namespace = '__MEDIA_INTERNAL';
    if (!globalScope[namespace]) globalScope[namespace] = {};
    return globalScope[namespace];
}
function $293d53ca8ea6912a$export$ede93d4564eaa8da(globalScope = window) {
    const globalMedia = $293d53ca8ea6912a$export$96a3cfb3a41e9bb2(globalScope);
    // Must match GLOBAL_MEDIA_CARD_SSR. Can't reference the constant from here.
    const key = 'mediaCardSsr';
    if (!globalMedia[key]) globalMedia[key] = {};
    return globalMedia[key];
}
const $293d53ca8ea6912a$var$dashed = (param)=>param ? `-${param}` : '';
const $293d53ca8ea6912a$export$a47fb462a08de82f = ({ id: id, collectionName: collectionName, occurrenceKey: occurrenceKey })=>`${id}${$293d53ca8ea6912a$var$dashed(collectionName)}${$293d53ca8ea6912a$var$dashed(occurrenceKey)}`;
const $293d53ca8ea6912a$export$4310981e0aa4ce67 = (key, dataURI, dimensions, error, globalScope = window)=>{
    const mediaCardSsr = $293d53ca8ea6912a$export$ede93d4564eaa8da(globalScope);
    mediaCardSsr[key] = {
        dataURI: dataURI,
        dimensions: dimensions,
        error: error
    };
};
const $293d53ca8ea6912a$var$generateScript = (identifier, dataURI, dimensions, error)=>{
    const functionCall = (0, $1QRxp.printFunctionCall)($293d53ca8ea6912a$export$4310981e0aa4ce67, $293d53ca8ea6912a$export$a47fb462a08de82f(identifier), dataURI, dimensions, error);
    return (0, $1QRxp.printScript)([
        $293d53ca8ea6912a$export$ede93d4564eaa8da.toString(),
        $293d53ca8ea6912a$export$96a3cfb3a41e9bb2.toString(),
        functionCall
    ]);
};
const $293d53ca8ea6912a$export$de7c49925e44d75d = (identifier, dataURI, dimensions, error)=>({
        dangerouslySetInnerHTML: {
            __html: $293d53ca8ea6912a$var$generateScript(identifier, dataURI, dimensions, error)
        }
    });

});
parcelRegister("1QRxp", function(module, exports) {

$parcel$export(module.exports, "printFunctionCall", () => $56ce1649d25a132b$export$3742967cc82ac85a);
$parcel$export(module.exports, "printScript", () => $56ce1649d25a132b$export$8b902fb69a2f17c1);
const $56ce1649d25a132b$var$printParam = (param)=>{
    if (typeof param === 'string') return `'${param}'`;
    else if (typeof param === 'object') return JSON.stringify(param);
    else if (param === undefined) return 'undefined';
    return param;
};
const $56ce1649d25a132b$var$printParams = (args)=>args.map((arg)=>$56ce1649d25a132b$var$printParam(arg)).join(',');
const $56ce1649d25a132b$export$3742967cc82ac85a = (fn, ...args)=>`(${fn.toString()})(${$56ce1649d25a132b$var$printParams(args)});`;
const $56ce1649d25a132b$export$8b902fb69a2f17c1 = (statements)=>`(function(){
  ${statements.join(';')}
})();
`;

});


parcelRegister("jR4hE", function(module, exports) {

$parcel$export(module.exports, "getSSRData", () => $815e3e27cebcb154$export$d3a890b0f7844b6f);

var $3JZCV = parcelRequire("3JZCV");
const $815e3e27cebcb154$export$d3a890b0f7844b6f = (identifier)=>{
    const mediaCardSsr = (0, $3JZCV.getMediaCardSSR)();
    if (!mediaCardSsr) return;
    return mediaCardSsr[(0, $3JZCV.getKey)(identifier)];
};

});

parcelRegister("8Kbwv", function(module, exports) {

$parcel$export(module.exports, "isBigger", () => $7b6d905fc3b6f0e9$export$912a00e9a5470d9a);
$parcel$export(module.exports, "createRequestDimensions", () => $7b6d905fc3b6f0e9$export$3063221e86a58f9);
$parcel$export(module.exports, "useCurrentValueRef", () => $7b6d905fc3b6f0e9$export$b3e10e1f0fbb71db);

var $5uXOq = parcelRequire("5uXOq");
const $7b6d905fc3b6f0e9$export$912a00e9a5470d9a = (current, next)=>{
    const { width: currentWidth, height: currentHeight } = current || {};
    const { width: nextWidth, height: nextHeight } = next || {};
    if (!!currentWidth && !!currentHeight && !!nextWidth && !!nextHeight) {
        const nextIsWider = currentWidth < nextWidth;
        const nextIsHigher = currentHeight < nextHeight;
        return nextIsHigher || nextIsWider;
    } else return false;
};
/** Verifies if the current screen is retina display */ function $7b6d905fc3b6f0e9$var$isRetina() {
    const mediaQuery = '(-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5), (-o-min-device-pixel-ratio: 3/2), (min-resolution: 1.5dppx)';
    return window.devicePixelRatio > 1 || window.matchMedia && window.matchMedia(mediaQuery).matches;
}
const $7b6d905fc3b6f0e9$export$3063221e86a58f9 = (dimensions)=>{
    if (!dimensions) return;
    const retinaFactor = $7b6d905fc3b6f0e9$var$isRetina() ? 2 : 1;
    const { width: width, height: height } = dimensions;
    const result = {};
    if (width) result.width = width * retinaFactor;
    if (height) result.height = height * retinaFactor;
    return result;
};
function $7b6d905fc3b6f0e9$export$b3e10e1f0fbb71db(value) {
    const ref = (0, $5uXOq.useRef)(value);
    ref.current = value;
    return ref;
}

});





parcelRegister("7hDf3", function(module, exports) {

$parcel$export(module.exports, "default", () => $6dfc7542ad737334$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6dfc7542ad737334$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    placeholderNoneEntered: {
        "id": "servicedesk-insight-attribute-views.common.placeholder-none-entered",
        "defaultMessage": "None entered"
    },
    placeholderNoneSelected: {
        "id": "servicedesk-insight-attribute-views.common.placeholder-none-selected",
        "defaultMessage": "None selected"
    }
});

});

parcelRegister("j8mgt", function(module, exports) {

$parcel$export(module.exports, "ObjectDetailsSpacer", () => $410f96bc2353d4f7$export$b8f1b5c1e5f43c5c);
$parcel$export(module.exports, "ReadViewContainer", () => $410f96bc2353d4f7$export$ebb3489b83262b26);
$parcel$export(module.exports, "RoleList", () => $410f96bc2353d4f7$export$f28593264fbf36da);
$parcel$export(module.exports, "RoleContainer", () => $410f96bc2353d4f7$export$e5989493d486ab26);
$parcel$export(module.exports, "RoleDisplayName", () => $410f96bc2353d4f7$export$a57fa052c6fb1799);
$parcel$export(module.exports, "AvatarWrapper", () => $410f96bc2353d4f7$export$f7513421c53ce141);
$parcel$export(module.exports, "PlaceholderSpacer", () => $410f96bc2353d4f7$export$e5d47ed31c76a9c0);
/* styled.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $gwIPs = parcelRequire("gwIPs");
const $410f96bc2353d4f7$export$b8f1b5c1e5f43c5c = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qu2gc _u5f312x7 _n3tdu2gc _19bv12x7",
            __cmplp.className
        ])
    });
});
const $410f96bc2353d4f7$var$readViewContainerStyles = (0, $8CUq3.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    lineHeight: `${(0, $gwIPs.gridSize) * 2.5}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    minHeight: `${(0, $gwIPs.gridSize) * 2.25}px`,
    whiteSpace: 'pre-wrap',
    wordWrap: 'break-word',
    flexFlow: 'wrap'
});
const $410f96bc2353d4f7$var$readViewContainerPlaceholderStyles = (0, $8CUq3.xcss)({
    color: 'color.text.subtlest',
    wordBreak: 'break-word',
    overflowWrap: 'break-word'
});
const $410f96bc2353d4f7$var$readViewContainerNonPlaceholderStyles = (0, $8CUq3.xcss)({
    wordBreak: 'break-all'
});
const $410f96bc2353d4f7$export$ebb3489b83262b26 = ({ children: children, isPlaceholder: isPlaceholder })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center",
        xcss: [
            $410f96bc2353d4f7$var$readViewContainerStyles,
            isPlaceholder ? $410f96bc2353d4f7$var$readViewContainerPlaceholderStyles : $410f96bc2353d4f7$var$readViewContainerNonPlaceholderStyles
        ]
    }, children);
const $410f96bc2353d4f7$export$f28593264fbf36da = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _1e0c1txw _1n261g80",
            __cmplp.className
        ])
    });
});
const $410f96bc2353d4f7$export$e5989493d486ab26 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko7vkz _1e0c1txw _4cvr1h6o _bfhk1s4m _ca0qv77o _u5f3u2gc _n3tdv77o _19bvu2gc",
            __cmplp.className
        ])
    });
});
const $410f96bc2353d4f7$export$a57fa052c6fb1799 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u01b66",
            __cmplp.className
        ])
    });
});
const $410f96bc2353d4f7$export$f7513421c53ce141 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0r5cr _1aayyfq0",
            __cmplp.className
        ])
    });
});
const $410f96bc2353d4f7$export$e5d47ed31c76a9c0 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qv77o _u5f3idpf _n3tdv77o _19bvidpf",
            __cmplp.className
        ])
    });
});

});


parcelRegister("9Nam0", function(module, exports) {

$parcel$export(module.exports, "InsightSchemaContainerSkeleton", () => $0fb5248eae5f5494$export$b0724c56a3d557df);
$parcel$export(module.exports, "InsightRecentObjectContainerSkeleton", () => $0fb5248eae5f5494$export$da0d7917b3d96c87);
/* InsightSchemaContainerSkeleton.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $boEew = parcelRequire("boEew");

var $djqo0 = parcelRequire("djqo0");
const $0fb5248eae5f5494$var$skeletonCssStyles = null;
const $0fb5248eae5f5494$export$b0724c56a3d557df = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($djqo0))),
        containerStyles: {
            maxHeight: '30em'
        },
        className: (0, $bwpsq.default)([
            "_1wgmglyw"
        ])
    });
const $0fb5248eae5f5494$export$da0d7917b3d96c87 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($boEew))),
        className: (0, $bwpsq.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("boEew", function(module, exports) {
module.exports = new URL("insight-recent-object-container-skeleton.tpl.1a59f7d0.svg", import.meta.url).toString();

});

parcelRegister("djqo0", function(module, exports) {
module.exports = new URL("insight-schema-container-skeleton.tpl.33f9a64b.svg", import.meta.url).toString();

});


parcelRegister("4FFUT", function(module, exports) {

$parcel$export(module.exports, "ErrorContent", () => $4262c0cc3628f02a$export$a9f602ed820d9782);

var $5uXOq = parcelRequire("5uXOq");

var $hTEpF = parcelRequire("hTEpF");

var $hfT4g = parcelRequire("hfT4g");

var $iVgQf = parcelRequire("iVgQf");

var $koVbs = parcelRequire("koVbs");

var $6uypP = parcelRequire("6uypP");
const $4262c0cc3628f02a$export$a9f602ed820d9782 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const renderImage = ()=>(0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $hfT4g.default))({
            imageWidth: 164,
            maxImageWidth: 164,
            maxImageHeight: 212
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        size: "wide",
        renderImage: renderImage,
        header: formatMessage((0, $6uypP.messages).errorTitle),
        description: formatMessage((0, $6uypP.messages).errorDescription)
    });
};

});
parcelRegister("hfT4g", function(module, exports) {

$parcel$export(module.exports, "default", () => $3698a552de39dca3$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $4oxyh = parcelRequire("4oxyh");
const $3698a552de39dca3$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($4oxyh)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($4oxyh))
});
var $3698a552de39dca3$export$2e2bcd8739ae039 = $3698a552de39dca3$var$Illustration;
const $3698a552de39dca3$export$a179c88182cb9d56 = [
    0,
    0,
    164,
    212
];

});
parcelRegister("4oxyh", function(module, exports) {
module.exports = new URL("error-white.e2723ea8.svg", import.meta.url).toString();

});


parcelRegister("6uypP", function(module, exports) {

$parcel$export(module.exports, "messages", () => $959b21b3da71d39c$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $959b21b3da71d39c$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    errorTitle: {
        "id": "servicedesk-insight-object-container.error.error-title",
        "defaultMessage": "There\u2019s been a problem loading the recent objects"
    },
    errorDescription: {
        "id": "servicedesk-insight-object-container.error.error-description",
        "defaultMessage": "Try refreshing the page."
    }
});

});


parcelRegister("21gb6", function(module, exports) {

$parcel$export(module.exports, "messages", () => $9a347db436046e0f$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $9a347db436046e0f$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    objectSchemas: {
        "id": "servicedesk-insight-object-container.object-schemas",
        "defaultMessage": "Recent objects"
    },
    viewMore: {
        "id": "servicedesk-insight-object-container.view-more",
        "defaultMessage": "View more"
    },
    noObjectsToShow: {
        "id": "servicedesk-insight-object-container.no-objects-to-show",
        "defaultMessage": "No recent objects to show"
    }
});

});


parcelRegister("9O52b", function(module, exports) {

$parcel$export(module.exports, "RapidSearchBar", () => $aca8ce10a01a877b$export$40bc8f1aee723991);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $1I7E8 = parcelRequire("1I7E8");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $2NMNM = parcelRequire("2NMNM");

var $kEqrP = parcelRequire("kEqrP");

var $5Ny9E = parcelRequire("5Ny9E");

var $blEB6 = parcelRequire("blEB6");

var $lVJAU = parcelRequire("lVJAU");


var $luBKp = parcelRequire("luBKp");

var $fENDF = parcelRequire("fENDF");

var $8ALjh = parcelRequire("8ALjh");

var $lnJdf = parcelRequire("lnJdf");
const $aca8ce10a01a877b$var$isNotBlank = (value)=>value.trim().length > 0;
const $aca8ce10a01a877b$export$40bc8f1aee723991 = ({ workspaceId: workspaceId, restrictedObjectSchemaIds: restrictedObjectSchemaIds, renderSearchTextfield: renderSearchTextfield })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const [popupWidth, setPopupWidth] = (0, $5uXOq.useState)(400);
    const { query: query, setQuery: setQuery, searchState: searchState } = (0, $fENDF.useRapidSearch)(workspaceId);
    const [selectedIndex, setSelectedIndex] = (0, $5uXOq.useState)(null);
    (0, $5uXOq.useEffect)(()=>{
        // Clear selection after search changes
        setSelectedIndex(null);
    }, [
        searchState,
        setSelectedIndex
    ]);
    const onNavigateToResult = ()=>{
        setIsOpen(false);
        setQuery('');
        setSelectedIndex(null);
    };
    const onKeyDown = (event)=>{
        switch(event.key){
            case 'ArrowDown':
                if (searchState.type === 'success') {
                    const { objects: objects, objectTypes: objectTypes } = searchState.searchResult;
                    event.preventDefault();
                    if (selectedIndex !== null) setSelectedIndex(Math.min(selectedIndex + 1, objects.length + objectTypes.length - 1));
                    else setSelectedIndex(0);
                }
                break;
            case 'ArrowUp':
                event.preventDefault();
                if (selectedIndex !== null) setSelectedIndex(Math.max(0, selectedIndex - 1));
                else setSelectedIndex(0);
                break;
            case 'Enter':
                if (searchState.type === 'success' && selectedIndex !== null) {
                    const { objects: objects, objectTypes: objectTypes } = searchState.searchResult;
                    if (selectedIndex < objects.length) {
                        const object = objects[selectedIndex];
                        (0, $luBKp.fireObjectClickedUiEvent)({
                            analyticsEvent: createAnalyticsEvent({}),
                            objectId: (0, $5Ny9E.toCmdbObjectId)(object.id),
                            schemaId: (0, $5Ny9E.toSchemaId)(object.objectSchemaId),
                            restrictedObjectSchemaIds: restrictedObjectSchemaIds
                        });
                        push((0, $blEB6.createObjectDetailUrl)((0, $5Ny9E.toCmdbObjectId)(object.id)));
                        onNavigateToResult();
                    } else {
                        const objectType = objectTypes[selectedIndex - objects.length];
                        (0, $luBKp.fireObjectTypeClickedUiEvent)({
                            analyticsEvent: createAnalyticsEvent({}),
                            objectTypeId: (0, $5Ny9E.toCmdbObjectTypeId)(objectType.id),
                            schemaId: (0, $5Ny9E.toSchemaId)(objectType.objectSchemaId),
                            restrictedObjectSchemaIds: restrictedObjectSchemaIds
                        });
                        push((0, $blEB6.createObjectTypeUrl)((0, $5Ny9E.toSchemaId)(objectType.objectSchemaId), (0, $5Ny9E.toCmdbObjectTypeId)(objectType.id)));
                        onNavigateToResult();
                    }
                }
                break;
            case 'Esc':
            case 'Escape':
                setQuery('');
                setSelectedIndex(null);
                break;
            default:
        }
    };
    const onKeyUp = (event)=>{
        switch(event.key){
            case 'Esc':
            case 'Escape':
                // Prevents input from losing focus when hitting ESC to close the popup
                event.stopPropagation();
                event.nativeEvent.stopImmediatePropagation();
                break;
            default:
        }
    };
    const onChange = (event)=>{
        const userInput = event.target.value;
        if (userInput.trim().length >= (0, $3c8276963f7bf891$export$16d80a8e6849f8af)) (0, $kEqrP.rapidSearchExperience).start();
        setIsOpen($aca8ce10a01a877b$var$isNotBlank(userInput));
        setQuery(userInput);
        setSelectedIndex(null);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.default), {
        isOpen: isOpen,
        autoFocus: false,
        shouldRenderToParent: true,
        onClose: ()=>setIsOpen(false),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: [
                    $aca8ce10a01a877b$var$popupWrapperStyles,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                    (0, $8CUq3.xcss)({
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                        width: `${popupWidth}px`
                    })
                ]
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8ALjh.PopupContent), {
                query: query,
                searchState: searchState,
                selectedIndex: selectedIndex,
                restrictedObjectSchemaIds: restrictedObjectSchemaIds,
                onResultClick: onNavigateToResult
            })),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lnJdf.TextfieldTrigger), {
                ...triggerProps,
                isOpen: isOpen,
                onClick: ()=>setIsOpen($aca8ce10a01a877b$var$isNotBlank(query)),
                onChange: onChange,
                onKeyDown: onKeyDown,
                onKeyUp: onKeyUp,
                value: query,
                setPopupWidth: setPopupWidth,
                renderSearchTextfield: renderSearchTextfield
            }),
        placement: "bottom-start",
        testId: "servicedesk-insight-rapid-search-bar.ui.popup"
    });
};
const $aca8ce10a01a877b$var$popupWrapperStyles = (0, $8CUq3.xcss)({
    overflow: 'auto'
});

});
parcelRegister("kEqrP", function(module, exports) {

$parcel$export(module.exports, "graphModalExperience", () => $92ce1ce82a42bb8a$export$1b179afadba799dc);
$parcel$export(module.exports, "rapidSearchExperience", () => $92ce1ce82a42bb8a$export$1a90deecc86e78f8);
$parcel$export(module.exports, "autocompleteInsightFieldExperience", () => $92ce1ce82a42bb8a$export$94337fa170a193d2);
$parcel$export(module.exports, "fetchAffectedServicesExperience", () => $92ce1ce82a42bb8a$export$ce8d2a860f4e0316);
$parcel$export(module.exports, "objectDetailsViewExperience", () => $92ce1ce82a42bb8a$export$8e0a16d0fc0feba3);
$parcel$export(module.exports, "objectViewInlineEditSwitchFromReadToEditModeExperience", () => $92ce1ce82a42bb8a$export$5ae0e1bbe443c52b);
$parcel$export(module.exports, "objectViewInlineEditSwitchFromEditToReadModeExperience", () => $92ce1ce82a42bb8a$export$b9c9c5e92fa6a3a4);
$parcel$export(module.exports, "createObjectTypeExperience", () => $92ce1ce82a42bb8a$export$15a29f6e079c9b3d);
$parcel$export(module.exports, "createObjectExperience", () => $92ce1ce82a42bb8a$export$aaf507c87c29ab22);
$parcel$export(module.exports, "loadSchemaObjectListExperience", () => $92ce1ce82a42bb8a$export$6f02ba4c2b1e3f5f);
$parcel$export(module.exports, "loadAttributesConfigurationExperience", () => $92ce1ce82a42bb8a$export$8f63f06b0486e498);
$parcel$export(module.exports, "updateObjectFilterExperience", () => $92ce1ce82a42bb8a$export$967859e6be8e6f4b);
$parcel$export(module.exports, "getUpdateGlobalConfigInlineEditExperience", () => $92ce1ce82a42bb8a$export$e4deb66475dfa46b);
$parcel$export(module.exports, "loadObjectDetailExperience", () => $92ce1ce82a42bb8a$export$3f1da23c065671d2);

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");
const $92ce1ce82a42bb8a$export$1b179afadba799dc = new (0, $duUGa.UFOExperience)('service-management.insight-cmdb.display-graph-modal', {
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).InlineResult,
    type: (0, $atdLB.ExperienceTypes).Experience
});
const $92ce1ce82a42bb8a$export$1a90deecc86e78f8 = new (0, $duUGa.UFOExperience)('service-management.insight-cmdb.display-rapid-search-results', {
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).InlineResult,
    type: (0, $atdLB.ExperienceTypes).Experience
});
const $92ce1ce82a42bb8a$export$94337fa170a193d2 = new (0, $duUGa.UFOExperience)('service-management.insight-cmdb.autocomplete-search-insight-field', {
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).InlineResult,
    type: (0, $atdLB.ExperienceTypes).Experience,
    featureFlags: [
        'jsm-insight-field-performance-improvements_fplgq'
    ]
});
const $92ce1ce82a42bb8a$export$ce8d2a860f4e0316 = new (0, $duUGa.UFOExperience)('service-management.insight-cmdb.fetch-affected-services', {
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).InlineResult,
    type: (0, $atdLB.ExperienceTypes).Experience
});
const $92ce1ce82a42bb8a$export$8e0a16d0fc0feba3 = new (0, $duUGa.UFOExperience)('jsm-cmdb-object-details-view', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).PageSegmentLoad
});
const $92ce1ce82a42bb8a$export$5ae0e1bbe443c52b = new (0, $duUGa.UFOExperience)('service-management.insight-cmdb.object-view-inline-edit.switch-from-read-to-edit-mode', {
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).InlineResult,
    type: (0, $atdLB.ExperienceTypes).Experience
});
const $92ce1ce82a42bb8a$export$b9c9c5e92fa6a3a4 = new (0, $duUGa.UFOExperience)('service-management.insight-cmdb.object-view-inline-edit.switch-from-edit-to-read-mode', {
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).InlineResult,
    type: (0, $atdLB.ExperienceTypes).Experience
});
const $92ce1ce82a42bb8a$export$15a29f6e079c9b3d = new (0, $duUGa.UFOExperience)('jsm-cmdb-create-object-type', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom,
    timings: [
        {
            key: 'created-on-server',
            endMark: 'object-type-created-on-server'
        }
    ]
});
const $92ce1ce82a42bb8a$export$aaf507c87c29ab22 = new (0, $duUGa.UFOExperience)('service-management.insight-cmdb.create-object', {
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).InlineResult,
    type: (0, $atdLB.ExperienceTypes).Experience
});
const $92ce1ce82a42bb8a$export$6f02ba4c2b1e3f5f = new (0, $duUGa.UFOExperience)('jsm-cmdb-load-object-list', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).PageSegmentLoad
});
const $92ce1ce82a42bb8a$export$8f63f06b0486e498 = new (0, $duUGa.UFOExperience)('jsm-cmdb-load-attributes-tab', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).PageSegmentLoad
});
const $92ce1ce82a42bb8a$export$967859e6be8e6f4b = new (0, $duUGa.UFOExperience)('jsm-cmdb-object-filter', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom,
    timings: [
        {
            key: 'response-received',
            endMark: 'server-response-received'
        },
        {
            key: 'object-table-rendered',
            endMark: 'object-table-rendered'
        },
        {
            key: 'object-list-rendered',
            endMark: 'object-list-rendered'
        },
        {
            key: 'no-filter-results-rendered',
            endMark: 'no-filter-results-rendered'
        }
    ]
});
const $92ce1ce82a42bb8a$export$e4deb66475dfa46b = ()=>new (0, $duUGa.UFOExperience)('service-management.insight-cmdb.global-config-inline-edit.update', {
        performanceType: (0, $atdLB.ExperiencePerformanceTypes).InlineResult,
        type: (0, $atdLB.ExperienceTypes).Experience
    });
const $92ce1ce82a42bb8a$export$3f1da23c065671d2 = new (0, $duUGa.UFOExperience)('service-management.insight-cmdb.embedded-object-details-view', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).PageSegmentLoad
});

});

const $3c8276963f7bf891$export$16d80a8e6849f8af = 2;

parcelRegister("luBKp", function(module, exports) {

$parcel$export(module.exports, "fireObjectClickedUiEvent", () => $9212a36f4496b3ae$export$8a87e5c0106fedb4);
$parcel$export(module.exports, "fireObjectTypeClickedUiEvent", () => $9212a36f4496b3ae$export$8faac28956ce929a);

var $8zOmE = parcelRequire("8zOmE");

var $6u2pX = parcelRequire("6u2pX");
const $9212a36f4496b3ae$export$8a87e5c0106fedb4 = ({ analyticsEvent: analyticsEvent, objectId: objectId, schemaId: schemaId, restrictedObjectSchemaIds: restrictedObjectSchemaIds })=>{
    (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'link clicked', 'insightRapidSearchResult', {
        searchResultType: 'object',
        objectId: objectId,
        ...(0, $6u2pX.getCmdbAnalyticAttributesFromRestrictedSchemaIds)(restrictedObjectSchemaIds, schemaId)
    });
};
const $9212a36f4496b3ae$export$8faac28956ce929a = ({ analyticsEvent: analyticsEvent, objectTypeId: objectTypeId, schemaId: schemaId, restrictedObjectSchemaIds: restrictedObjectSchemaIds })=>{
    (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'link clicked', 'insightRapidSearchResult', {
        searchResultType: 'objectType',
        objectTypeId: objectTypeId,
        ...(0, $6u2pX.getCmdbAnalyticAttributesFromRestrictedSchemaIds)(restrictedObjectSchemaIds, schemaId)
    });
};

});

parcelRegister("fENDF", function(module, exports) {

$parcel$export(module.exports, "useRapidSearch", () => $1ee99698fa1ea1fb$export$3a0917c306e9b95b);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");


var $c4Tkw = parcelRequire("c4Tkw");
const $1ee99698fa1ea1fb$var$EMPTY_SEARCH_RESULT = {
    objects: [],
    objectTypes: []
};
const $1ee99698fa1ea1fb$var$DEBOUNCE_MILLIS = 300;
const $1ee99698fa1ea1fb$var$queriesAreEquivalent = (firstQuery, secondQuery)=>firstQuery.trim() === secondQuery.trim();
const $1ee99698fa1ea1fb$export$3a0917c306e9b95b = (workspaceId)=>{
    const [state, setState] = (0, $5uXOq.useState)({
        query: '',
        searchState: {
            type: 'loading'
        }
    });
    const search = (0, $5uXOq.useCallback)(async (newQuery)=>{
        const updateSearchState = (newSearchState)=>{
            setState((prevState)=>{
                if (!$1ee99698fa1ea1fb$var$queriesAreEquivalent(prevState.query, newQuery)) // The query has changed since this search was kicked off, discard the current (stale) results
                return prevState;
                return {
                    query: prevState.query,
                    searchState: newSearchState
                };
            });
        };
        try {
            const objectsPromise = (0, $c4Tkw.fetchRapidSearchObjects)({
                workspaceId: workspaceId,
                query: newQuery.trim()
            });
            const objectTypesPromise = (0, $c4Tkw.fetchRapidSearchObjectTypes)({
                workspaceId: workspaceId,
                query: newQuery.trim()
            });
            const [objectsResponse, objectTypesResponse] = await Promise.all([
                objectsPromise,
                objectTypesPromise
            ]);
            const searchResult = {
                objects: objectsResponse.values,
                objectTypes: objectTypesResponse.values
            };
            updateSearchState({
                type: 'success',
                searchResult: searchResult
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            updateSearchState({
                type: 'error',
                error: error
            });
        }
    }, [
        workspaceId,
        setState
    ]);
    const debouncedSearch = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(search, $1ee99698fa1ea1fb$var$DEBOUNCE_MILLIS), [
        search
    ]);
    const setQuery = (newQuery)=>{
        if (newQuery.trim().length < (0, $3c8276963f7bf891$export$16d80a8e6849f8af)) {
            // Skip searching if query is too short
            setState({
                query: newQuery,
                searchState: {
                    type: 'success',
                    searchResult: $1ee99698fa1ea1fb$var$EMPTY_SEARCH_RESULT
                }
            });
            return;
        }
        if ($1ee99698fa1ea1fb$var$queriesAreEquivalent(state.query, newQuery)) {
            setState({
                query: newQuery,
                searchState: state.searchState
            });
            return;
        }
        setState({
            query: newQuery,
            searchState: {
                type: 'loading'
            }
        });
        debouncedSearch(newQuery);
    };
    return {
        query: state.query,
        setQuery: setQuery,
        searchState: state.searchState
    };
};

});
parcelRegister("c4Tkw", function(module, exports) {

$parcel$export(module.exports, "fetchRapidSearchObjects", () => $6b764d07290db462$export$3ded75e27074b785);
$parcel$export(module.exports, "fetchRapidSearchObjectTypes", () => $6b764d07290db462$export$b1de10c4478ba28d);

var $eusud = parcelRequire("eusud");

var $hj0o3 = parcelRequire("hj0o3");
const $6b764d07290db462$export$3ded75e27074b785 = async ({ workspaceId: workspaceId, query: query })=>(0, $eusud.performGetRequest)((0, $hj0o3.getCmdbRapidSearchObjectUrl)(workspaceId, {
        searchTerm: query
    }));
const $6b764d07290db462$export$b1de10c4478ba28d = async ({ workspaceId: workspaceId, query: query })=>(0, $eusud.performGetRequest)((0, $hj0o3.getCmdbRapidSearchObjectTypeUrl)(workspaceId, {
        searchTerm: query
    }));

});
parcelRegister("hj0o3", function(module, exports) {

$parcel$export(module.exports, "getCmdbRapidSearchObjectUrl", () => $982af59f735d496d$export$67454f0a1a714bb4);
$parcel$export(module.exports, "getCmdbRapidSearchObjectTypeUrl", () => $982af59f735d496d$export$624b1a84b14ec612);

var $ebyGx = parcelRequire("ebyGx");

var $klJ8b = parcelRequire("klJ8b");
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/rapidsearch
 */ const $982af59f735d496d$var$getCmdbRapidSearchUrl = (workspaceId)=>`${(0, $klJ8b.getCmdbRestBaseUrl)(workspaceId)}/rapidsearch`;
const $982af59f735d496d$export$67454f0a1a714bb4 = (workspaceId, queryParams)=>`${$982af59f735d496d$var$getCmdbRapidSearchUrl(workspaceId)}/object?${(0, $ebyGx.stringify)(queryParams)}`;
const $982af59f735d496d$export$624b1a84b14ec612 = (workspaceId, queryParams)=>`${$982af59f735d496d$var$getCmdbRapidSearchUrl(workspaceId)}/objecttype?${(0, $ebyGx.stringify)(queryParams)}`;

});



parcelRegister("8ALjh", function(module, exports) {

$parcel$export(module.exports, "PopupContent", () => $df90b616d29c986a$export$2a2c7ba12d3231e3);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hTEpF = parcelRequire("hTEpF");

var $eZJjh = parcelRequire("eZJjh");

var $jldZL = parcelRequire("jldZL");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $MKbfF = parcelRequire("MKbfF");

var $iVgQf = parcelRequire("iVgQf");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $kEqrP = parcelRequire("kEqrP");

var $blEB6 = parcelRequire("blEB6");


var $luBKp = parcelRequire("luBKp");

var $2mwKY = parcelRequire("2mwKY");

var $7MgOk = parcelRequire("7MgOk");

var $hXj8U = parcelRequire("hXj8U");
const $df90b616d29c986a$var$NoOptionsMessage = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const renderImage = ()=>(0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $MKbfF.default))({
            imageWidth: 208,
            imageHeight: 190,
            maxImageWidth: 208,
            maxImageHeight: 190
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        header: formatMessage((0, $hXj8U.default).noResultsFoundMessage),
        renderImage: renderImage,
        testId: "servicedesk-insight-rapid-search-bar.ui.popup-content.empty-state"
    });
};
const $df90b616d29c986a$var$INITIAL_DISPLAYED_OBJECTS = 10;
const $df90b616d29c986a$var$INITIAL_DISPLAYED_OBJECT_TYPES = 5;
const $df90b616d29c986a$export$a6541fefb32bf661 = ({ selectedIndex: selectedIndex, numObjects: numObjects })=>{
    if (selectedIndex === null) return null;
    if (selectedIndex >= numObjects + $df90b616d29c986a$var$INITIAL_DISPLAYED_OBJECT_TYPES) return 'object-types';
    if (selectedIndex >= $df90b616d29c986a$var$INITIAL_DISPLAYED_OBJECTS && selectedIndex < numObjects) return 'objects';
    return null;
};
const $df90b616d29c986a$export$70b3420806bcb550 = ({ searchResult: searchResult, selectedIndex: selectedIndex, restrictedObjectSchemaIds: restrictedObjectSchemaIds, onResultClick: onResultClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { objects: objects, objectTypes: objectTypes } = searchResult;
    const [displayAllObjects, setDisplayAllObjects] = (0, $5uXOq.useState)(objects.length <= $df90b616d29c986a$var$INITIAL_DISPLAYED_OBJECTS);
    const [displayAllObjectTypes, setDisplayAllObjectTypes] = (0, $5uXOq.useState)(objectTypes.length <= $df90b616d29c986a$var$INITIAL_DISPLAYED_OBJECT_TYPES);
    (0, $5uXOq.useEffect)(()=>{
        // Any time the selected index moves, potentially expand the objects or object types
        const listToExpand = $df90b616d29c986a$export$a6541fefb32bf661({
            selectedIndex: selectedIndex,
            numObjects: objects.length
        });
        if (listToExpand === 'objects') setDisplayAllObjects(true);
        else if (listToExpand === 'object-types') setDisplayAllObjectTypes(true);
    }, [
        selectedIndex,
        objects.length,
        setDisplayAllObjects,
        setDisplayAllObjectTypes
    ]);
    const displayedObjects = displayAllObjects ? objects : objects.slice(0, $df90b616d29c986a$var$INITIAL_DISPLAYED_OBJECTS);
    const displayedObjectTypes = displayAllObjectTypes ? objectTypes : objectTypes.slice(0, $df90b616d29c986a$var$INITIAL_DISPLAYED_OBJECT_TYPES);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($df90b616d29c986a$var$DropdownWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2mwKY.DropdownContainer), {
        groupTitle: formatMessage((0, $hXj8U.default).objects),
        items: displayedObjects.map((object, index)=>{
            const { id: id, label: label, objectKey: objectKey, objectSchemaName: objectSchemaName, objectSchemaId: objectSchemaId } = object;
            const { url48: url48, mediaClientConfig: mediaClientConfig } = object.avatar;
            return {
                url: (0, $blEB6.createObjectDetailUrl)(id),
                id: id,
                label: label,
                objectKey: objectKey,
                iconUrl: url48,
                mediaClientConfig: mediaClientConfig,
                schemaName: objectSchemaName,
                isSelected: selectedIndex === index,
                onClick: ()=>{
                    onResultClick();
                    (0, $luBKp.fireObjectClickedUiEvent)({
                        analyticsEvent: createAnalyticsEvent({}),
                        objectId: id,
                        schemaId: objectSchemaId,
                        restrictedObjectSchemaIds: restrictedObjectSchemaIds
                    });
                }
            };
        }),
        emptyMessage: formatMessage((0, $hXj8U.default).noneFound),
        canShowMore: !displayAllObjects,
        onShowMore: ()=>{
            setDisplayAllObjects(true);
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'insightRapidSearchResultViewMore', {
                searchResultType: 'object'
            });
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2mwKY.DropdownContainer), {
        groupTitle: formatMessage((0, $hXj8U.default).objectTypes),
        items: displayedObjectTypes.map((objectType, index)=>{
            const { id: id, name: name, icon: icon, objectSchemaId: objectSchemaId, objectSchemaName: objectSchemaName } = objectType;
            return {
                url: (0, $blEB6.createObjectTypeUrl)(objectSchemaId, id),
                id: id,
                label: name,
                iconUrl: icon.url48,
                schemaName: objectSchemaName,
                isSelected: selectedIndex === objects.length + index,
                onClick: ()=>{
                    onResultClick();
                    (0, $luBKp.fireObjectTypeClickedUiEvent)({
                        analyticsEvent: createAnalyticsEvent({}),
                        objectTypeId: objectType.id,
                        schemaId: objectSchemaId,
                        restrictedObjectSchemaIds: restrictedObjectSchemaIds
                    });
                }
            };
        }),
        emptyMessage: formatMessage((0, $hXj8U.default).noneFound),
        canShowMore: !displayAllObjectTypes,
        onShowMore: ()=>{
            setDisplayAllObjectTypes(true);
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'insightRapidSearchResultViewMore', {
                searchResultType: 'objectType'
            });
        }
    }));
};
const $df90b616d29c986a$export$ab244b0732907409 = ({ query: query, searchState: searchState, selectedIndex: selectedIndex, restrictedObjectSchemaIds: restrictedObjectSchemaIds, onResultClick: onResultClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (searchState.type === 'loading') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($df90b616d29c986a$var$StyledSpinner, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "large"
    }));
    if (searchState.type === 'error') {
        (0, $kEqrP.rapidSearchExperience).failure();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7MgOk.ErrorContent), null);
    }
    if (query.trim().length < (0, $3c8276963f7bf891$export$16d80a8e6849f8af)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($df90b616d29c986a$var$QueryTooShortMessage, null, formatMessage((0, $hXj8U.default).typeMoreToSeeResults));
    (0, $kEqrP.rapidSearchExperience).success();
    const { searchResult: searchResult } = searchState;
    if (searchResult.objects.length === 0 && searchResult.objectTypes.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($df90b616d29c986a$var$NoOptionsMessage, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($df90b616d29c986a$export$70b3420806bcb550, {
        searchResult: searchState.searchResult,
        selectedIndex: selectedIndex,
        restrictedObjectSchemaIds: restrictedObjectSchemaIds,
        onResultClick: onResultClick
    });
};
const $df90b616d29c986a$export$afd815e950930aa8 = ({ query: query, searchState: searchState, selectedIndex: selectedIndex, restrictedObjectSchemaIds: restrictedObjectSchemaIds, onResultClick: onResultClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    let content;
    let screenReaderMessage = '';
    if (searchState.type === 'loading') content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($df90b616d29c986a$var$StyledSpinner, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "large"
    }));
    else if (searchState.type === 'error') {
        (0, $kEqrP.rapidSearchExperience).failure();
        content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7MgOk.ErrorContent), null);
        screenReaderMessage = formatMessage((0, $hXj8U.default).errorOccurredScreenReaderMessage);
    } else if (query.trim().length < (0, $3c8276963f7bf891$export$16d80a8e6849f8af)) {
        content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($df90b616d29c986a$var$QueryTooShortMessage, null, formatMessage((0, $hXj8U.default).typeMoreToSeeResults));
        screenReaderMessage = formatMessage((0, $hXj8U.default).typeMoreToSeeResults);
    } else {
        (0, $kEqrP.rapidSearchExperience).success();
        const { searchResult: searchResult } = searchState;
        screenReaderMessage = `${formatMessage((0, $hXj8U.default).objectSearchResultsScreenReaderMessage, {
            objectCount: searchResult.objects?.length ?? 0
        })} ${formatMessage((0, $hXj8U.default).objectTypeSearchResultsScreenReaderMessage, {
            objectTypeCount: searchResult.objectTypes?.length ?? 0
        })}`;
        if (searchResult.objects.length === 0 && searchResult.objectTypes.length === 0) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($df90b616d29c986a$var$NoOptionsMessage, null);
        else content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($df90b616d29c986a$export$70b3420806bcb550, {
            searchResult: searchState.searchResult,
            selectedIndex: selectedIndex,
            restrictedObjectSchemaIds: restrictedObjectSchemaIds,
            onResultClick: onResultClick
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jldZL.default), {
        "aria-live": "polite",
        role: "status"
    }, screenReaderMessage), content);
};
const $df90b616d29c986a$export$2a2c7ba12d3231e3 = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('assets-a11y-fix'), $df90b616d29c986a$export$afd815e950930aa8, $df90b616d29c986a$export$ab244b0732907409); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $df90b616d29c986a$var$DropdownWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _1e0c1txw _2lx21bp4 _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _c71lufrr _18m91wug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $df90b616d29c986a$var$StyledSpinner = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qpxbi _1e0c1txw _1bah1h6o _1tke1mjv",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $df90b616d29c986a$var$QueryTooShortMessage = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0q1jfw _u5f3idpf _n3td1jfw _19bvidpf _y3gn1h6o _syaz1n3s",
            __cmplp.className
        ])
    });
});

});
parcelRegister("MKbfF", function(module, exports) {

$parcel$export(module.exports, "default", () => $674b3db7fb55da62$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $dCLgq = parcelRequire("dCLgq");

var $7fzlq = parcelRequire("7fzlq");

var $j6p7e = parcelRequire("j6p7e");
/** @deprecated cf. https://hello.atlassian.net/wiki/spaces/IMKT/pages/743859674/Empty+state+and+Error+state+guidelines */ const $674b3db7fb55da62$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($j6p7e)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($7fzlq))
});
var $674b3db7fb55da62$export$2e2bcd8739ae039 = $674b3db7fb55da62$var$Illustration;
// for advanced use only
const $674b3db7fb55da62$export$a179c88182cb9d56 = [
    0,
    0,
    205,
    199
];

});
parcelRegister("7fzlq", function(module, exports) {
module.exports = new URL("empty-no-search-results-v2-darkmode.fad57704.svg", import.meta.url).toString();

});

parcelRegister("j6p7e", function(module, exports) {
module.exports = new URL("empty-no-search-results-v2.a81f25f1.svg", import.meta.url).toString();

});


parcelRegister("2mwKY", function(module, exports) {

$parcel$export(module.exports, "DropdownContainer", () => $b8e64a44e272470d$export$49166591ec160d97);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $3US9t = parcelRequire("3US9t");

var $ga54K = parcelRequire("ga54K");
const $b8e64a44e272470d$export$49166591ec160d97 = ({ groupTitle: groupTitle, items: items, emptyMessage: emptyMessage, canShowMore: canShowMore, onShowMore: onShowMore })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8e64a44e272470d$var$Title, null, groupTitle), items.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $b8e64a44e272470d$var$emptyMessageStyles
    }, emptyMessage) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8e64a44e272470d$var$OptionsList, null, items.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3US9t.InsightRapidSearchDropdownOption), {
            key: item.id,
            ...item
        }))), canShowMore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $b8e64a44e272470d$var$listFooterStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "link",
        spacing: "none",
        onClick: onShowMore,
        tabIndex: "-1",
        testId: "servicedesk-insight-rapid-search-bar.ui.popup-content.dropdown-container.show-more-button"
    }, formatMessage((0, $ga54K.messages).showMore))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b8e64a44e272470d$var$Title = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "h3", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8qk37 _syaz1thw _1p1dangw _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _k48p1pd9",
            __cmplp.className
        ])
    });
});
const $b8e64a44e272470d$var$emptyMessageStyles = (0, $8CUq3.xcss)({
    padding: 'space.100'
});
const $b8e64a44e272470d$var$listFooterStyles = (0, $8CUq3.xcss)({
    padding: 'space.100'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b8e64a44e272470d$var$OptionsList = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2mzuglyw _1pyaidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3US9t", function(module, exports) {

$parcel$export(module.exports, "InsightRapidSearchDropdownOption", () => $03ca90019ee22934$export$1d307d1846f567a6);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $5EBaG = parcelRequire("5EBaG");

var $bUUmN = parcelRequire("bUUmN");

var $hDzhb = parcelRequire("hDzhb");
const $03ca90019ee22934$export$1d307d1846f567a6 = ({ url: url, mediaClientConfig: mediaClientConfig, label: label, iconUrl: iconUrl, schemaName: schemaName, isSelected: isSelected, onClick: onClick, objectKey: objectKey })=>{
    const selectedElementReference = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (isSelected && selectedElementReference.current) selectedElementReference.current.scrollIntoView?.({
            block: 'center'
        });
    }, [
        isSelected
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", {
        ref: selectedElementReference
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($03ca90019ee22934$var$Row, {
        isSelected: isSelected,
        to: url,
        onClick: onClick,
        /* @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'number | undefined'. */ tabIndex: "-1",
        "data-testid": "servicedesk-insight-rapid-search-bar.ui.popup-content.dropdown-container.dropdown-option.dropdown-option"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($03ca90019ee22934$var$ObjectContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUUmN.MemoizedInsightIcon), {
        mediaClientConfig: mediaClientConfig,
        iconUrl: iconUrl,
        label: label,
        size: "small"
    }), objectKey !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($03ca90019ee22934$var$ObjectKey, null, objectKey), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($03ca90019ee22934$var$Text, null, label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($03ca90019ee22934$var$SchemaContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5EBaG.SchemaIcon), {
        label: schemaName,
        size: "medium"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($03ca90019ee22934$var$Text, null, schemaName))));
};
const $03ca90019ee22934$var$Text = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $03ca90019ee22934$var$textStyles
    }, children);
const $03ca90019ee22934$var$ObjectContainer = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $03ca90019ee22934$var$objectContainerStyles
    }, children);
const $03ca90019ee22934$var$ObjectKey = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $03ca90019ee22934$var$objectKeyStyles
    }, children);
const $03ca90019ee22934$var$SchemaContainer = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $03ca90019ee22934$var$schemaContainerStyles
    }, children);
const $03ca90019ee22934$var$schemaContainerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.100',
    color: 'color.text.subtlest',
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    padding: 'space.100'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $03ca90019ee22934$var$Row = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $hDzhb.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _80omtlke _syaz1fxt _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _p12f1osq _9oik18uv _1bnxglyw _jf4cnqa1 _30l31fxt _irr3q29e",
            __cmplp.isSelected && "_bfhkbal5",
            __cmplp.className
        ])
    });
});
const $03ca90019ee22934$export$7ed12d2a5241e393 = {
    ObjectKey: $03ca90019ee22934$var$ObjectKey
};
const $03ca90019ee22934$var$textStyles = (0, $8CUq3.xcss)({
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
});
const $03ca90019ee22934$var$objectContainerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    alignItems: 'center',
    flexGrow: 1,
    gap: 'space.100',
    overflow: 'auto'
});
const $03ca90019ee22934$var$objectKeyStyles = (0, $8CUq3.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    ...$03ca90019ee22934$var$textStyles,
    paddingRight: 'space.100',
    flexShrink: 0
});

});
parcelRegister("5EBaG", function(module, exports) {

$parcel$export(module.exports, "ObjectSchemasIcon", () => $87a6e7030c6a3200$export$bea30a91ea911ed8);
$parcel$export(module.exports, "ObjectGraphGlyph", () => $87a6e7030c6a3200$export$fd4e4ffca6161634);
$parcel$export(module.exports, "ObjectGraphIcon", () => $87a6e7030c6a3200$export$7fd55e0f2e77172c);
$parcel$export(module.exports, "ShowObjectGraphDetailsIcon", () => $87a6e7030c6a3200$export$a96f5718ff672e9d);
$parcel$export(module.exports, "HideObjectGraphDetailsIcon", () => $87a6e7030c6a3200$export$cf601da3438765d9);
$parcel$export(module.exports, "SchemaIcon", () => $87a6e7030c6a3200$export$fc6a25a0b4021903);
$parcel$export(module.exports, "ColumnsIcon", () => $87a6e7030c6a3200$export$38f001d9cffdd080);
$parcel$export(module.exports, "QrCodeIcon", () => $87a6e7030c6a3200$export$33dd147542b2195b);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $iwxKK = parcelRequire("iwxKK");

var $apaik = parcelRequire("apaik");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $7XYc4 = parcelRequire("7XYc4");

var $dCm1o = parcelRequire("dCm1o");

var $1aBwA = parcelRequire("1aBwA");
const $87a6e7030c6a3200$export$58cebcda192184d0 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16 8C14.8954 8 14 8.89543 14 10V12C14 13.1046 14.8954 14 16 14H18C19.1046 14 20 13.1046 20 12V10C20 8.89543 19.1046 8 18 8H16ZM18 10H16V12H18V10Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16 16C14.8954 16 14 16.8954 14 18V20C14 21.1046 14.8954 22 16 22H18C19.1046 22 20 21.1046 20 20V18C20 16.8954 19.1046 16 18 16H16ZM18 18H16V20H18V18Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6 2C4.89543 2 4 2.89543 4 4V6C4 7.10457 4.89543 8 6 8H8C9.10457 8 10 7.10457 10 6V4C10 2.89543 9.10457 2 8 2H6ZM8 4H6V6H8V4Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        x: "6",
        y: "7",
        width: "2",
        height: "11",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M6 18H15V20H8C6.89543 20 6 19.1046 6 18Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M6 10H15V12H8C6.89543 12 6 11.1046 6 10Z",
        fill: "currentColor"
    }));
const $87a6e7030c6a3200$export$bea30a91ea911ed8 = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), (0, (/*@__PURE__*/$parcel$interopDefault($iwxKK))), (0, $1aBwA.createCustomAKIcon)($87a6e7030c6a3200$export$58cebcda192184d0));
const $87a6e7030c6a3200$export$fd4e4ffca6161634 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("circle", {
        cx: "4",
        cy: "4",
        r: "2",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("circle", {
        cx: "6",
        cy: "18",
        r: "2",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("circle", {
        cx: "20",
        cy: "6",
        r: "2",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("circle", {
        cx: "18",
        cy: "19",
        r: "2",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 15a4 4 0 100-8 4 4 0 000 8zm0-2a2 2 0 100-4 2 2 0 000 4z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M4 4l6 5.5m9.5-3l-5 3m-8 8l4-4.5m8 6.5l-5-6",
        stroke: "currentColor",
        strokeWidth: "1.5"
    }));
const $87a6e7030c6a3200$export$7fd55e0f2e77172c = (0, $1aBwA.createCustomAKIcon)($87a6e7030c6a3200$export$fd4e4ffca6161634);
const $87a6e7030c6a3200$var$ShowObjectGraphDetailsGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M20 2H2V4H9V9H11V4H20V20H11V15H9V20H2V22H20C21.1046 22 22 21.1046 22 20V4C22 2.89543 21.1046 2 20 2Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M2.47 12.8835C2.19 12.7165 2 12.3835 2 11.9995C2 11.6155 2.19 11.2825 2.47 11.1155L5.086 8.49946C5.2746 8.3173 5.5272 8.21651 5.7894 8.21879C6.0516 8.22107 6.30241 8.32623 6.48782 8.51164C6.67323 8.69705 6.7784 8.94786 6.78067 9.21006C6.78295 9.47226 6.68216 9.72486 6.5 9.91346L4.938 10.9995H10.118C10.605 10.9995 11 11.4475 11 11.9995C11 12.5515 10.605 12.9995 10.118 12.9995H4.938L6.5 14.0855C6.68216 14.2741 6.78295 14.5267 6.78067 14.7889C6.7784 15.0511 6.67323 15.3019 6.48782 15.4873C6.30241 15.6727 6.0516 15.7779 5.7894 15.7801C5.5272 15.7824 5.2746 15.6816 5.086 15.4995L2.47 12.8835Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M13 7C13 6.44772 13.4477 6 14 6H17C17.5523 6 18 6.44772 18 7C18 7.55228 17.5523 8 17 8H14C13.4477 8 13 7.55228 13 7Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M13 11C13 10.4477 13.4477 10 14 10H17C17.5523 10 18 10.4477 18 11C18 11.5523 17.5523 12 17 12H14C13.4477 12 13 11.5523 13 11Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M13 15C13 14.4477 13.4477 14 14 14H17C17.5523 14 18 14.4477 18 15C18 15.5523 17.5523 16 17 16H14C13.4477 16 13 15.5523 13 15Z",
        fill: "currentColor"
    }));
const $87a6e7030c6a3200$var$HideObjectGraphDetailsGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M19 2H2V4H14V9H16V4H19V20H16V15H14V20H2V22H19C20.1046 22 21 21.1046 21 20V4C21 2.89543 20.1046 2 19 2Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M12.53 12.8835C12.81 12.7165 13 12.3835 13 11.9995C13 11.6155 12.81 11.2825 12.53 11.1155L9.914 8.49946C9.7254 8.3173 9.4728 8.21651 9.2106 8.21879C8.9484 8.22107 8.69759 8.32623 8.51218 8.51164C8.32677 8.69705 8.2216 8.94786 8.21933 9.21006C8.21705 9.47226 8.31784 9.72486 8.5 9.91346L10.062 10.9995H2.882C2.395 10.9995 2 11.4475 2 11.9995C2 12.5515 2.395 12.9995 2.882 12.9995H10.062L8.5 14.0855C8.31784 14.2741 8.21705 14.5267 8.21933 14.7889C8.2216 15.0511 8.32677 15.3019 8.51218 15.4873C8.69759 15.6727 8.9484 15.7779 9.2106 15.7801C9.4728 15.7824 9.7254 15.6816 9.914 15.4995L12.53 12.8835Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M14 9H16V15H14V9Z",
        fill: "currentColor"
    }));
const $87a6e7030c6a3200$export$a96f5718ff672e9d = (0, $1aBwA.createCustomAKIcon)($87a6e7030c6a3200$var$ShowObjectGraphDetailsGlyph);
const $87a6e7030c6a3200$export$cf601da3438765d9 = (0, $1aBwA.createCustomAKIcon)($87a6e7030c6a3200$var$HideObjectGraphDetailsGlyph);
const $87a6e7030c6a3200$var$SchemaGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        x: "0.5",
        y: "0.5",
        width: "47",
        height: "47",
        rx: "4.5",
        fill: "white",
        stroke: "#C1C7D0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M28.6665 18.6667C27.5619 18.6667 26.6665 19.5621 26.6665 20.6667V24.6667C26.6665 25.7713 27.5619 26.6667 28.6665 26.6667H32.6665C33.7711 26.6667 34.6665 25.7713 34.6665 24.6667V20.6667C34.6665 19.5621 33.7711 18.6667 32.6665 18.6667H28.6665ZM31.9998 21.3334H29.3331V24.0001H31.9998V21.3334Z",
        fill: "#42526E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M28.6665 29.3333C27.5619 29.3333 26.6665 30.2287 26.6665 31.3333V35.3333C26.6665 36.4379 27.5619 37.3333 28.6665 37.3333H32.6665C33.7711 37.3333 34.6665 36.4379 34.6665 35.3333V31.3333C34.6665 30.2287 33.7711 29.3333 32.6665 29.3333H28.6665ZM31.9998 31.9999H29.3331V34.6666H31.9998V31.9999Z",
        fill: "#42526E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.3335 10.6667C14.2289 10.6667 13.3335 11.5621 13.3335 12.6667V16.6667C13.3335 17.7713 14.2289 18.6667 15.3335 18.6667H19.3335C20.4381 18.6667 21.3335 17.7713 21.3335 16.6667V12.6667C21.3335 11.5621 20.4381 10.6667 19.3335 10.6667H15.3335ZM18.6669 13.3334H16.0002V16.0001H18.6669V13.3334Z",
        fill: "#42526E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        x: "16",
        y: "17.3333",
        width: "2.66667",
        height: "14.6667",
        fill: "#42526E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M16 32H28V34.6667H18C16.8954 34.6667 16 33.7712 16 32.6667V32Z",
        fill: "#42526E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M16 21.3333H28V24H18C16.8954 24 16 23.1046 16 22V21.3333Z",
        fill: "#42526E"
    }));
const $87a6e7030c6a3200$export$fc6a25a0b4021903 = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $87a6e7030c6a3200$var$iconBorder
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iwxKK))), props)), (0, $1aBwA.createCustomAKIcon)($87a6e7030c6a3200$var$SchemaGlyph));
const $87a6e7030c6a3200$var$ColumnsGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4 6H2V8V20V22H4H7H9V20V19H7V20H4V8H5V6H4Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20 8H17V20H20V8ZM15 6V22H22V6H15Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 4H9V15H12V4ZM7 2V17H14V2H7Z",
        fill: "currentColor"
    }));
const $87a6e7030c6a3200$export$38f001d9cffdd080 = (0, $1aBwA.createCustomAKIcon)($87a6e7030c6a3200$var$ColumnsGlyph);
const $87a6e7030c6a3200$var$QrCodeGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 4V7H4V4H7V2H4H2V4ZM4 17H2V20V22H4H7V20H4V17ZM22 4V7H20V4H17V2H20H22V4ZM22 17H20V20H17V22H20H22V20V17ZM19 9H13V11H19V9ZM8 13H11V15H8V13ZM11 17H8V19H11V17ZM13 5H15V8H13V5ZM7 13H5V19H7V13ZM17 5H19V8H17V5ZM11 5H5V11H11V5ZM9 7H7V9H9V7ZM13 13H19V19H13V13ZM15 15H17V17H15V15Z",
        fill: "currentColor"
    }));
const $87a6e7030c6a3200$export$33dd147542b2195b = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($apaik))), {
        spacing: "spacious",
        ...props
    }), (0, $1aBwA.createCustomAKIcon)($87a6e7030c6a3200$var$QrCodeGlyph));
const $87a6e7030c6a3200$var$iconBorder = (0, $8CUq3.xcss)({
    width: '24px',
    height: '24px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: 'solid 1px',
    borderRadius: '3px',
    borderColor: 'color.border'
});

});
parcelRegister("iwxKK", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c2cf6d0b083efc7534cda00bbb519961>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d7c565c5cbd5c490$var$_react = $d7c565c5cbd5c490$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $d7c565c5cbd5c490$var$_baseNew = $d7c565c5cbd5c490$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $d7c565c5cbd5c490$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "AssetsSchema".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for JSM Assets.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d7c565c5cbd5c490$var$AssetsSchemaIcon = (props)=>/*#__PURE__*/ $d7c565c5cbd5c490$var$_react.default.createElement($d7c565c5cbd5c490$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M10.25 7.25a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Zm0 0h-6m0-2.625v7c0 .69.56 1.25 1.25 1.25h4.75M5.75 3.25a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm7.5 9.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"/>`
    }, props));
$d7c565c5cbd5c490$var$AssetsSchemaIcon.displayName = 'AssetsSchemaIcon';
var $d7c565c5cbd5c490$var$_default = module.exports.default = $d7c565c5cbd5c490$var$AssetsSchemaIcon;

});

parcelRegister("apaik", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::065bae4da7c9b5223fe8a5a1ed3de3d0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $79343976eae28bb9$var$_react = $79343976eae28bb9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $79343976eae28bb9$var$_baseNew = $79343976eae28bb9$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $79343976eae28bb9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "QrCode".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for QR code experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $79343976eae28bb9$var$QrCodeIcon = (props)=>/*#__PURE__*/ $79343976eae28bb9$var$_react.default.createElement($79343976eae28bb9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M10 10h2v2h-2z"/><path stroke="currentcolor" stroke-width="1.5" d="M1.75 5.25V3c0-.69.56-1.25 1.25-1.25h2.25m9 3.5V3c0-.69-.56-1.25-1.25-1.25h-2.25m-9 9V13c0 .69.56 1.25 1.25 1.25h2.25m9-3.5V13c0 .69-.56 1.25-1.25 1.25h-2.25m-6.75-3h4M11.25 4v4m-6.5-3.25h3.5v3.5h-3.5z"/>`
    }, props));
$79343976eae28bb9$var$QrCodeIcon.displayName = 'QrCodeIcon';
var $79343976eae28bb9$var$_default = module.exports.default = $79343976eae28bb9$var$QrCodeIcon;

});

parcelRegister("1aBwA", function(module, exports) {

$parcel$export(module.exports, "createCustomAKIcon", () => $dfc3adae931a11a1$export$80e74912a0a07a42);

var $5uXOq = parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $dfc3adae931a11a1$export$80e74912a0a07a42 = (glyph)=>(props)=>// @ts-expect-error - TS2769 - No overload matches this call.
        /*#__PURE__*/ (0, $5uXOq.createElement)((0, $5LWLA.default), {
            glyph: glyph,
            ...props
        });

});



parcelRegister("ga54K", function(module, exports) {

$parcel$export(module.exports, "messages", () => $48e6895dc91ab8a0$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $48e6895dc91ab8a0$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    showMore: {
        "id": "servicedesk-insight-rapid-search-bar.popup-content.dropdown-container.show-more",
        "defaultMessage": "Show more"
    }
});

});


parcelRegister("7MgOk", function(module, exports) {

$parcel$export(module.exports, "ErrorContent", () => $307e3efea16d4036$export$a9f602ed820d9782);

var $5uXOq = parcelRequire("5uXOq");

var $hTEpF = parcelRequire("hTEpF");

var $hfT4g = parcelRequire("hfT4g");

var $iVgQf = parcelRequire("iVgQf");

var $koVbs = parcelRequire("koVbs");

var $gXIvE = parcelRequire("gXIvE");
const $307e3efea16d4036$export$a9f602ed820d9782 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const renderImage = ()=>(0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $hfT4g.default))({
            imageWidth: 164,
            maxImageWidth: 164,
            maxImageHeight: 212
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        size: "wide",
        renderImage: renderImage,
        header: formatMessage((0, $gXIvE.messages).errorTitle),
        description: formatMessage((0, $gXIvE.messages).errorDescription)
    });
};

});
parcelRegister("gXIvE", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a2b16bc92db2e1ae$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $a2b16bc92db2e1ae$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    errorTitle: {
        "id": "servicedesk-insight-rapid-search-bar.popup-content.error.error-title",
        "defaultMessage": "We can\u2019t show your results right now"
    },
    errorDescription: {
        "id": "servicedesk-insight-rapid-search-bar.popup-content.error.error-description",
        "defaultMessage": "Give it a minute and try again."
    }
});

});


parcelRegister("hXj8U", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd904138a6acf79a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $cd904138a6acf79a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noResultsFoundMessage: {
        "id": "servicedesk-insight-rapid-search-bar.popup-content.no-results-found-message",
        "defaultMessage": "We couldn't find any results matching your search"
    },
    objects: {
        "id": "servicedesk-insight-rapid-search-bar.popup-content.objects",
        "defaultMessage": "Objects"
    },
    objectTypes: {
        "id": "servicedesk-insight-rapid-search-bar.popup-content.object-types",
        "defaultMessage": "Object types"
    },
    noneFound: {
        "id": "servicedesk-insight-rapid-search-bar.popup-content.none-found",
        "defaultMessage": "None found"
    },
    typeMoreToSeeResults: {
        "id": "servicedesk-insight-rapid-search-bar.popup-content.type-more-to-see-results",
        "defaultMessage": "Keep typing to see search results"
    },
    objectSearchResultsScreenReaderMessage: {
        "id": "servicedesk-insight-rapid-search-bar.popup-content.object-search-results-screen-reader-message",
        "defaultMessage": "{objectCount, plural, =0 {no objects found} one {one object found} other {{objectCount} objects found}}."
    },
    objectTypeSearchResultsScreenReaderMessage: {
        "id": "servicedesk-insight-rapid-search-bar.popup-content.object-type-search-results-screen-reader-message",
        "defaultMessage": "{objectTypeCount, plural, =0 {no object types found} one {one object type found} other {{objectTypeCount} object types found}}."
    },
    errorOccurredScreenReaderMessage: {
        "id": "servicedesk-insight-rapid-search-bar.popup-content.error-occurred-screen-reader-message",
        "defaultMessage": "An error occurred while searching, please try again."
    }
});

});


parcelRegister("lnJdf", function(module, exports) {

$parcel$export(module.exports, "TextfieldTrigger", () => $aae2e0376a1a4755$export$ea52c713ac76896c);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $tvuR8 = parcelRequire("tvuR8");

var $koVbs = parcelRequire("koVbs");

var $a9gep = parcelRequire("a9gep");
const $aae2e0376a1a4755$export$ea52c713ac76896c = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ isOpen: isOpen, setPopupWidth: setPopupWidth, onChange: onChange, onClick: onClick, onKeyDown: onKeyDown, onKeyUp: onKeyUp, value: value, renderSearchTextfield: renderSearchTextfield, ...triggerProps }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const containerRef = (0, $5uXOq.useRef)(null); // @ts-expect-error - Type 'null' is not assignable to type 'HTMLElement'
    (0, $5uXOq.useImperativeHandle)(ref, ()=>containerRef.current);
    (0, $5uXOq.useEffect)(()=>{
        if (containerRef && containerRef.current) setPopupWidth(containerRef.current.clientWidth);
    }, [
        containerRef?.current?.clientWidth,
        setPopupWidth
    ]);
    const searchTextfieldProps = {
        value: value,
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($aae2e0376a1a4755$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($tvuR8))), {
            label: formatMessage((0, $a9gep.default).searchIconLabel)
        })),
        onChange: onChange,
        onClick: onClick,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        maxLength: 256
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: containerRef,
        ...triggerProps
    }, renderSearchTextfield({
        isOpen: isOpen,
        searchTextfieldProps: searchTextfieldProps
    }));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $aae2e0376a1a4755$var$IconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _19bvu2gc _syazqjbk",
            __cmplp.className
        ])
    });
});

});
parcelRegister("a9gep", function(module, exports) {

$parcel$export(module.exports, "default", () => $afe9571e9e67523f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $afe9571e9e67523f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    searchIconLabel: {
        "id": "servicedesk-insight-rapid-search-bar.trigger.search-icon-label",
        "defaultMessage": "Search icon label"
    }
});

});



parcelRegister("i5MrJ", function(module, exports) {

$parcel$export(module.exports, "SchemaContainer", () => $84af6bcbfd201503$export$423976b269b7be7d);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $l1N8i = parcelRequire("l1N8i");

var $9lMrf = parcelRequire("9lMrf");

var $iRH6p = parcelRequire("iRH6p");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $8oYYI = parcelRequire("8oYYI");

var $j8qoE = parcelRequire("j8qoE");

var $l3q9P = parcelRequire("l3q9P");

var $5S3vv = parcelRequire("5S3vv");

var $bOHaD = parcelRequire("bOHaD");

var $9Nam0 = parcelRequire("9Nam0");

var $1AZST = parcelRequire("1AZST");

var $k9CPI = parcelRequire("k9CPI");

var $fZeLi = parcelRequire("fZeLi");
const $84af6bcbfd201503$export$fdcb1fa0b36cbdef = (props)=>{
    const { schemas: schemas } = props;
    const listItems = schemas.map((schema, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84af6bcbfd201503$var$SchemaCardListItem, {
            key: index,
            "data-testid": "servicedesk-insight-schema-container.ui.schema-card-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5S3vv.SchemaCard), {
            schema: schema
        })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84af6bcbfd201503$var$SchemaCardList, null, listItems);
};
const $84af6bcbfd201503$var$InfoTooltip = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: props.content,
        position: "top",
        testId: "servicedesk-insight-schema-container.ui.schema-limit-tooltip"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84af6bcbfd201503$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iRH6p))), {
        size: "small",
        label: ""
    })));
const $84af6bcbfd201503$export$423976b269b7be7d = ({ onSchemaModalStateChange: onSchemaModalStateChange })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ schemaState: schemaState }] = (0, $l3q9P.useLandingPageState)();
    const [isCreateModalOpen, setIsCreateModalOpen] = (0, $5uXOq.useState)(false); // Enrich the schema object with the restricted value
    // (to identify the service schema)
    const [{ config: globalConfigData }] = (0, $j8qoE.useInsightGlobalConfig)();
    const { restrictedObjectSchemaIds: restrictedObjectSchemaIds, insightAdministrator: isAdmin, limitInfo: limitInfo } = globalConfigData ?? {};
    const objectSchemaList = (0, $5uXOq.useMemo)(()=>{
        if (schemaState.type !== 'success') return [];
        if (restrictedObjectSchemaIds) return schemaState.schemas.map((schema)=>({
                ...schema,
                isRestricted: restrictedObjectSchemaIds.includes(Number(schema.id))
            }));
        return schemaState.schemas;
    }, [
        schemaState,
        restrictedObjectSchemaIds
    ]);
    const openCreateSchemaModal = ()=>{
        setIsCreateModalOpen(true);
        onSchemaModalStateChange(true);
    };
    const closeCreateSchemaModal = ()=>{
        setIsCreateModalOpen(false);
        onSchemaModalStateChange(false);
    };
    if (schemaState.type === 'success') (0, $1AZST.GlobalPageLoadExperience).success({
        force: true
    });
    else if (schemaState.type === 'error') {
        if ((0, $bOHaD.isUnexpectedFetchError)(schemaState.error, [
            '5xx'
        ])) (0, $1AZST.GlobalPageLoadExperience).failure({
            force: true
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, schemaState.type === 'loading' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9Nam0.InsightSchemaContainerSkeleton), null), (schemaState.type === 'error' || schemaState.type === 'success') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $84af6bcbfd201503$var$listHeaderStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $84af6bcbfd201503$var$secondaryListHeaderStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h2",
        size: "xsmall"
    }, formatMessage((0, $fZeLi.messages).objectSchemas)), isAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, "\xa0"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84af6bcbfd201503$var$ObjectSchemaCounter, null, `(${limitInfo?.objectSchemaCount}/${limitInfo?.objectSchemaLimit})`))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $84af6bcbfd201503$var$secondaryListHeaderStyles
    }, isAdmin && (limitInfo?.objectSchemaCount && limitInfo?.objectLimit && limitInfo?.objectSchemaCount >= limitInfo?.objectSchemaLimit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $84af6bcbfd201503$var$schemaLimitLabelStyles
    }, formatMessage((0, $fZeLi.messages).schemaLimitReached), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84af6bcbfd201503$var$InfoTooltip, {
        content: formatMessage((0, $fZeLi.messages).schemaLimitErrorMessage, {
            limit: limitInfo.objectSchemaLimit
        })
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "default",
        spacing: "compact",
        onClick: (_event, analyticsEvent)=>{
            openCreateSchemaModal();
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'openCreateSchemaDrawer');
        },
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9lMrf))), {
            label: "",
            size: "medium"
        }),
        testId: "servicedesk-insight-schema-container.ui.create-icon-button",
        interactionName: "servicedesk-insight-schema-container.ui.create"
    }, formatMessage((0, $fZeLi.messages).createSchema)))))), schemaState.type === 'error' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k9CPI.ErrorContent), null), schemaState.type === 'success' && schemaState.schemas.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84af6bcbfd201503$export$fdcb1fa0b36cbdef, {
        schemas: objectSchemaList
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8oYYI.AsyncCmdbGettingStarted), {
        isOpen: isCreateModalOpen,
        onClose: closeCreateSchemaModal
    }));
};
const $84af6bcbfd201503$var$listHeaderStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 'space.300',
    width: '100%',
    marginTop: 'space.200'
});
const $84af6bcbfd201503$var$secondaryListHeaderStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    alignItems: 'center'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $84af6bcbfd201503$var$SchemaCardList = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _2mzuglyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $84af6bcbfd201503$var$SchemaCardListItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_otyru2gc",
            __cmplp.className
        ])
    });
});
const $84af6bcbfd201503$var$schemaLimitLabelStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    height: '24px',
    alignItems: 'center'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $84af6bcbfd201503$var$IconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDisabled: isDisabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _ca0qidpf _u5f31b66 _n3tdidpf _19bv1b66",
            __cmplp.isDisabled ? "_80om13gf" : "_80om1kw7",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $84af6bcbfd201503$var$ObjectSchemaCounter = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81vlj",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iRH6p", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dbbe9c7ad934f1e0$var$_react = $dbbe9c7ad934f1e0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $dbbe9c7ad934f1e0$var$_information = $dbbe9c7ad934f1e0$var$_interopRequireDefault((parcelRequire("2Yv61")));
function $dbbe9c7ad934f1e0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $dbbe9c7ad934f1e0$var$EditorInfoIcon = (props)=>/*#__PURE__*/ $dbbe9c7ad934f1e0$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m0-8.5a1 1 0 0 0-1 1V15a1 1 0 0 0 2 0v-2.5a1 1 0 0 0-1-1m0-1.125a1.375 1.375 0 1 0 0-2.75 1.375 1.375 0 0 0 0 2.75"/></svg>`
    }, props, {
        newIcon: $dbbe9c7ad934f1e0$var$_information.default
    }));
$dbbe9c7ad934f1e0$var$EditorInfoIcon.displayName = 'EditorInfoIcon';
var $dbbe9c7ad934f1e0$var$_default = module.exports.default = $dbbe9c7ad934f1e0$var$EditorInfoIcon;

});

parcelRegister("8oYYI", function(module, exports) {

$parcel$export(module.exports, "AsyncCmdbGettingStarted", () => $836b8cf8e2fe46c7$export$af4e30f085039e49);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $836b8cf8e2fe46c7$var$LazyCmdbGettingStarted = (0, $kxZPA.lazy)(()=>(parcelRequire("8S6V2")).then((module)=>module.CmdbGettingStarted), {
    moduleId: "./src/packages/servicedesk/cmdb-getting-started/src/ui/index.tsx"
});
const $836b8cf8e2fe46c7$export$af4e30f085039e49 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "cmdb-getting-started",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($836b8cf8e2fe46c7$var$LazyCmdbGettingStarted, props));

});
parcelRegister("8S6V2", function(module, exports) {

let $6758bbd942776e06$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6758bbd942776e06$var$load("8xoSQ").then(()=>parcelRequire('8TVYo'));

});


parcelRegister("5S3vv", function(module, exports) {

$parcel$export(module.exports, "SchemaCard", () => $3508260ed6adbe5a$export$eebd315af76f7497);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $6B7KL = parcelRequire("6B7KL");

var $gs7PQ = parcelRequire("gs7PQ");

var $3oUqw = parcelRequire("3oUqw");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $5EBaG = parcelRequire("5EBaG");

var $eEA1w = parcelRequire("eEA1w");

var $6u2pX = parcelRequire("6u2pX");

var $blEB6 = parcelRequire("blEB6");

var $lVJAU = parcelRequire("lVJAU");

var $5ouHq = parcelRequire("5ouHq");

var $eK1SS = parcelRequire("eK1SS");
const $3508260ed6adbe5a$var$IconAndMenu = ({ schema: schema })=>{
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    if (schema.isRestricted === true) {
        const content = formatMessage((0, $eK1SS.messages).tooltipRestrictedSchema);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ouHq.FocusableTooltip), {
            content: content,
            position: "top",
            testId: "servicedesk-insight-schema-card.ui.restricted-tooltip"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3508260ed6adbe5a$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gs7PQ))), {
            size: "medium",
            label: content
        })));
    }
    if (schema.canManage === false) {
        const content = formatMessage((0, $eK1SS.messages).tooltipDisabled);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ouHq.FocusableTooltip), {
            content: content,
            position: "top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3508260ed6adbe5a$var$IconWrapper, {
            isDisabled: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3oUqw))), {
            size: "medium",
            label: content
        })));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eEA1w.MeatballsMenu), {
        testId: `servicedesk-insight-schema-card.ui.meatballs-menu-${schema.id}`,
        moreIconLabel: `${schema.name} ${formatMessage((0, $eK1SS.messages).more)}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        href: (0, $blEB6.createObjectSchemaConfigUrl)(schema.id),
        onClick: (event)=>{
            push((0, $blEB6.createObjectSchemaConfigUrl)(schema.id));
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'configureInsightSchema');
            event.preventDefault();
        }
    }, formatMessage((0, $eK1SS.messages).configuration)));
};
const $3508260ed6adbe5a$var$SchemaTooltipTag = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3508260ed6adbe5a$var$StyledTooltipTag, {
        ref: ref,
        ...props
    }));
const $3508260ed6adbe5a$export$eebd315af76f7497 = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { schema: schema } = props;
    const { id: id } = schema;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3508260ed6adbe5a$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3508260ed6adbe5a$var$StyledLink, {
        "data-testId": "servicedesk-insight-landing-insight-schema-card.styled-link",
        href: (0, $blEB6.createObjectSchemaUrl)(id),
        onClick: (event)=>{
            push((0, $blEB6.createObjectSchemaUrl)(id));
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'card clicked', 'insightObjectSchemaCard', // the service schema will always have isRestricted = true (and isRestricted is always false for Insight schemas)
            (0, $6u2pX.getCmdbAnalyticAttributesFromSchema)(schema));
            event.preventDefault();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5EBaG.SchemaIcon), {
        label: "",
        size: "medium"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3508260ed6adbe5a$var$CardText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3508260ed6adbe5a$var$NameAndKey, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: schema.name,
        tag: $3508260ed6adbe5a$var$SchemaTooltipTag,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3508260ed6adbe5a$var$SchemaName, null, schema.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, "(", schema.objectSchemaKey, ")")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3508260ed6adbe5a$var$ObjectCount, null, formatMessage((0, $eK1SS.messages).objects, {
        objectNumber: schema.objectCount
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3508260ed6adbe5a$var$IconAndMenu, {
        schema: schema
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3508260ed6adbe5a$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _2rko1l7b _16qs1bpa _1e0c1txw _4cvr1h6o _4t3izwfg _bfhkhp5a _ca0q1b66 _u5f3u2gc _n3td1b66 _19bvu2gc _irr31dko",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3508260ed6adbe5a$var$CardText = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _zulp1ejb _1ul9idpf _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3508260ed6adbe5a$var$ObjectCount = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u01wug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3508260ed6adbe5a$var$NameAndKey = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _zulpu2gc _1ul9idpf _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3508260ed6adbe5a$var$StyledTooltipTag = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1ul9idpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3508260ed6adbe5a$var$SchemaName = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _k48p1pd9 _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3508260ed6adbe5a$var$IconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDisabled: isDisabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4cvr1h6o _1e0c1txw _ca0qidpf _u5f31b66 _n3tdidpf _19bv1b66",
            __cmplp.isDisabled ? "_syaz1cf5" : "_syaz1kw7",
            __cmplp.isDisabled ? "_80om13gf" : "_80om1kw7",
            __cmplp.className
        ])
    });
});
const $3508260ed6adbe5a$var$StyledLink = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _zulpu2gc _1ul9idpf _1e0c1txw _4cvr1h6o _80omtlke _syaz1thw _9oik18uv _1bnxglyw _jf4cnqa1 _30l31thw",
            __cmplp.className
        ])
    });
});
$3508260ed6adbe5a$var$StyledLink.displayName = 'StyledLink';

});
parcelRegister("gs7PQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bfa556ca72f8a34c$var$_react = $bfa556ca72f8a34c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $bfa556ca72f8a34c$var$_lockLocked = $bfa556ca72f8a34c$var$_interopRequireDefault((parcelRequire("bwyQI")));
function $bfa556ca72f8a34c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bfa556ca72f8a34c$var$LockFilledIcon = (props)=>/*#__PURE__*/ $bfa556ca72f8a34c$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 10V8.002A4.004 4.004 0 0 1 12 4a4 4 0 0 1 4 4.002V10a2 2 0 0 1 2 2v6c0 1.105-.902 2-2.009 2H8.01A2 2 0 0 1 6 18v-6c0-1.102.897-1.995 2-2m2 0h4V8.002A2 2 0 0 0 12 6c-1.102 0-2 .898-2 2.002zm2 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/></svg>`
    }, props, {
        newIcon: $bfa556ca72f8a34c$var$_lockLocked.default
    }));
$bfa556ca72f8a34c$var$LockFilledIcon.displayName = 'LockFilledIcon';
var $bfa556ca72f8a34c$var$_default = module.exports.default = $bfa556ca72f8a34c$var$LockFilledIcon;

});
parcelRegister("bwyQI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::99280b1ea43458dc827592cb9abe9600>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $863db7350f859785$var$_react = $863db7350f859785$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $863db7350f859785$var$_baseNew = $863db7350f859785$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $863db7350f859785$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "LockLocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $863db7350f859785$var$LockLockedIcon = (props)=>/*#__PURE__*/ $863db7350f859785$var$_react.default.createElement($863db7350f859785$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4.75 7.75H4c-.69 0-1.25.56-1.25 1.25v5c0 .69.56 1.25 1.25 1.25h8c.69 0 1.25-.56 1.25-1.25V9c0-.69-.56-1.25-1.25-1.25h-.75m-6.5 0V4a3.25 3.25 0 1 1 6.5 0v3.75m-6.5 0h6.5M8 10v3"/>`
    }, props));
$863db7350f859785$var$LockLockedIcon.displayName = 'LockLockedIcon';
var $863db7350f859785$var$_default = module.exports.default = $863db7350f859785$var$LockLockedIcon;

});


parcelRegister("eEA1w", function(module, exports) {

$parcel$export(module.exports, "MeatballsMenu", () => $913eeded142cf2a7$export$cdd8c33ef508c851);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $BLPHT = parcelRequire("BLPHT");
var $aRoVz = parcelRequire("aRoVz");

var $3oUqw = parcelRequire("3oUqw");

var $7mPT9 = parcelRequire("7mPT9");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");
const $913eeded142cf2a7$var$MeatballsMenuNoRef = ({ id: id, tabIndex: tabIndex, onKeyDown: onKeyDown, moreIconLabel: moreIconLabel, children: children, isDisabled: isDisabled = false, testId: testId, ...restProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        placement: "bottom-end",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                ...props,
                id: id,
                testId: testId,
                tabIndex: tabIndex,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3oUqw))), {
                    label: moreIconLabel,
                    size: "medium"
                }),
                ref: triggerRef,
                appearance: "subtle",
                isDisabled: isDisabled,
                onKeyDown: onKeyDown
            }),
        ...restProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), null, children));
const $913eeded142cf2a7$var$MeatballsMenuForwardRef = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ id: id, tabIndex: tabIndex, onKeyDown: onKeyDown, moreIconLabel: moreIconLabel, children: children, isDisabled: isDisabled = false, testId: testId, ...restProps }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        placement: "bottom-end",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                ...props,
                id: id,
                testId: testId,
                tabIndex: tabIndex,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3oUqw))), {
                    label: moreIconLabel,
                    size: "medium"
                }),
                ref: (0, $7mPT9.mergeRefs)(triggerRef, ref),
                appearance: "subtle",
                isDisabled: isDisabled,
                onKeyDown: onKeyDown
            }),
        ...restProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), null, children)));
const $913eeded142cf2a7$export$cdd8c33ef508c851 = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('assets-a11y-fix'), $913eeded142cf2a7$var$MeatballsMenuForwardRef, $913eeded142cf2a7$var$MeatballsMenuNoRef);

});

parcelRegister("5ouHq", function(module, exports) {

$parcel$export(module.exports, "FocusableTooltip", () => $b7ac4f977a40b665$export$9a54147e6bad2667);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3bDjY = parcelRequire("3bDjY");
const $b7ac4f977a40b665$export$9a54147e6bad2667 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b7ac4f977a40b665$var$UnstyledButton, null, children));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b7ac4f977a40b665$var$UnstyledButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19itidpf _11q7glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1ule _syaz1kw7",
            __cmplp.className
        ])
    });
});

});

parcelRegister("eK1SS", function(module, exports) {

$parcel$export(module.exports, "messages", () => $20fb642bd4704cc0$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $20fb642bd4704cc0$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    objects: {
        "id": "servicedesk-insight-schema-card.objects",
        "defaultMessage": "{objectNumber} {objectNumber, plural, one {object} other {objects}}"
    },
    configuration: {
        "id": "servicedesk-insight-schema-card.configuration",
        "defaultMessage": "Configuration"
    },
    more: {
        "id": "servicedesk-insight-schema-card.more",
        "defaultMessage": "More"
    },
    locked: {
        "id": "servicedesk-insight-schema-card.locked",
        "defaultMessage": "Locked"
    },
    tooltipDisabled: {
        "id": "servicedesk-insight-schema-card.tooltip-disabled",
        "defaultMessage": "You don't have permission to edit the object schema"
    },
    tooltipRestrictedSchema: {
        "id": "servicedesk-insight-schema-card.tooltip-restricted-schema",
        "defaultMessage": "This system-defined schema is read-only."
    }
});

});


parcelRegister("bOHaD", function(module, exports) {

$parcel$export(module.exports, "isUnexpectedFetchError", () => $d01969acb3765ff6$export$cd70b8b287611e8f);
$parcel$export(module.exports, "isSignal", () => $d01969acb3765ff6$export$a9a36f4641f8c6f0);

var $jcw0u = parcelRequire("jcw0u");

var $jJZqs = parcelRequire("jJZqs");
const $d01969acb3765ff6$export$bc9678df7c38e24d = [
    503
];
const $d01969acb3765ff6$export$cd70b8b287611e8f = (error, errorStatusCodeGroups = [
    '5xx'
], excludeStatusCodes)=>{
    if (!error || !(error instanceof (0, $jJZqs.default))) return false;
    // If excludeStatusCodes defined, check first before proceeding to check group
    if (excludeStatusCodes && excludeStatusCodes.length) {
        const { statusCode: statusCode } = error;
        if (excludeStatusCodes.includes(statusCode)) return false;
    }
    const statusCodeGroup = (0, $jcw0u.getStatusCodeGroup)(error);
    return errorStatusCodeGroups.includes(statusCodeGroup);
};
const $d01969acb3765ff6$export$a9a36f4641f8c6f0 = (error, errorStatusCodeGroups = [
    '4xx',
    '5xx'
])=>$d01969acb3765ff6$export$cd70b8b287611e8f(error, errorStatusCodeGroups, $d01969acb3765ff6$export$bc9678df7c38e24d);

});

parcelRegister("k9CPI", function(module, exports) {

$parcel$export(module.exports, "ErrorContent", () => $a2df1f4b6a5bc318$export$a9f602ed820d9782);

var $5uXOq = parcelRequire("5uXOq");

var $hTEpF = parcelRequire("hTEpF");

var $hfT4g = parcelRequire("hfT4g");

var $iVgQf = parcelRequire("iVgQf");

var $koVbs = parcelRequire("koVbs");

var $bHDdJ = parcelRequire("bHDdJ");
const $a2df1f4b6a5bc318$export$a9f602ed820d9782 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const renderImage = ()=>(0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $hfT4g.default))({
            imageWidth: 164,
            maxImageWidth: 164,
            maxImageHeight: 212
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        size: "wide",
        renderImage: renderImage,
        header: formatMessage((0, $bHDdJ.messages).errorTitle),
        description: formatMessage((0, $bHDdJ.messages).errorDescription),
        testId: "servicedesk-insight-schema-container.ui.error"
    });
};

});
parcelRegister("bHDdJ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $4266b9c4f4e82c9b$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $4266b9c4f4e82c9b$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    errorTitle: {
        "id": "servicedesk-insight-schema-container.error.error-title",
        "defaultMessage": "There\u2019s been a problem loading the object schemas"
    },
    errorDescription: {
        "id": "servicedesk-insight-schema-container.error.error-description",
        "defaultMessage": "Try refreshing the page."
    }
});

});


parcelRegister("fZeLi", function(module, exports) {

$parcel$export(module.exports, "messages", () => $31bf1b91d1b712b4$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $31bf1b91d1b712b4$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    objectSchemas: {
        "id": "servicedesk-insight-schema-container.object-schemas",
        "defaultMessage": "Object schemas"
    },
    addSchema: {
        "id": "servicedesk-insight-schema-container.add-schema",
        "defaultMessage": "Add schema"
    },
    createSchema: {
        "id": "servicedesk-insight-schema-container.create-schema",
        "defaultMessage": "Create schema"
    },
    schemaLimitReached: {
        "id": "servicedesk-insight-schema-container.schema-limit-reached",
        "defaultMessage": "Schema limit reached"
    },
    schemaLimitErrorMessage: {
        "id": "servicedesk-insight-schema-container.schema-limit-error-message",
        "defaultMessage": "You\u2019ve reached your site\u2019s maximum limit of {limit} {limit, plural, one {object schema} other {object schemas}}. Reduce the number of schemas or contact support."
    }
});

});


parcelRegister("iXNW4", function(module, exports) {

$parcel$export(module.exports, "FormattedLinkMessage", () => $5842068a353cecee$export$90d9bea5d5af37e0);

var $5uXOq = parcelRequire("5uXOq");

var $e4yMr = parcelRequire("e4yMr");

var $ousew = parcelRequire("ousew");
const $5842068a353cecee$export$90d9bea5d5af37e0 = ({ message: message, linkProps: linkProps })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...message,
        values: {
            link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), linkProps, chunks)
        }
    });
};

});

parcelRegister("f9Ytl", function(module, exports) {

$parcel$export(module.exports, "DataManagerGAChangeBoardingModal", () => $ced6f64025cadad0$export$a6d366ad2609d7e6);

var $5uXOq = parcelRequire("5uXOq");

var $4mO32 = parcelRequire("4mO32");

var $jVFGQ = parcelRequire("jVFGQ");

var $24OWI = parcelRequire("24OWI");
const $ced6f64025cadad0$export$a6d366ad2609d7e6 = ()=>{
    const [isDataManagerModalLoaded, setDataManagerModalLoaded] = (0, $5uXOq.useState)(false);
    const { entryPointActions: entryPointActions } = (0, $4mO32.useEntryPoint)((0, $jVFGQ.cmdbDataManagerChangeBoardingEntryPoint), {});
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (!isDataManagerModalLoaded) {
            entryPointActions.load();
            setDataManagerModalLoaded(true);
        }
    }, [
        entryPointActions,
        isDataManagerModalLoaded
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $24OWI.CmdbDataManagerChangeBoarding), null);
};

});
parcelRegister("jVFGQ", function(module, exports) {

$parcel$export(module.exports, "cmdbDataManagerChangeBoardingEntryPoint", () => $09a0cb122a9997a5$export$3925cb0b08e1f394);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $09a0cb122a9997a5$export$3925cb0b08e1f394 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("h7QCD")), {
        moduleId: "3740e65a"
    }),
    getPreloadProps: ()=>({
            queries: {}
        })
});

});
parcelRegister("h7QCD", function(module, exports) {

let $c77be8cc96154cb8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c77be8cc96154cb8$var$load("cxXYv").then(()=>parcelRequire('kitdj'));

});


parcelRegister("24OWI", function(module, exports) {

$parcel$export(module.exports, "CmdbDataManagerChangeBoarding", () => $4ad7c0c31af73c11$export$c1e6758d8da69448);

var $5uXOq = parcelRequire("5uXOq");

var $9yOBd = parcelRequire("9yOBd");
var $dkK4L = parcelRequire("dkK4L");

var $5qRwM = parcelRequire("5qRwM");

var $1R1Ge = parcelRequire("1R1Ge");
var $gofOI = parcelRequire("gofOI");
var $i8Qvm = parcelRequire("i8Qvm");

var $lPfex = parcelRequire("lPfex");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $9fuVs = parcelRequire("9fuVs");

var $eGLgs = parcelRequire("eGLgs");

var $7CMCs = parcelRequire("7CMCs");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");


var $jwaui = parcelRequire("jwaui");

var $fHjhV = parcelRequire("fHjhV");
const $4ad7c0c31af73c11$export$1f04342a44ce11ca = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isFinished, setIsFinished] = (0, $5uXOq.useState)(false);
    const finishChangeBoarding = ()=>{
        props.stop?.();
        setIsFinished(true);
    };
    const onDone = ()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.open('https://www.atlassian.com/software/jira/service-management/features/assets-data-manager', '_blank');
        finishChangeBoarding();
    };
    const onClose = ()=>{
        finishChangeBoarding();
    };
    if (isFinished) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dkK4L.default).Provider, {
        value: (0, $lPfex.modalButtonTheme)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1R1Ge.default), {
        width: 600,
        onClose: onClose,
        autoFocus: false,
        testId: "servicedesk-cmdb-data-manager-change-boarding.ui.modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $4ad7c0c31af73c11$var$modalContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $4ad7c0c31af73c11$var$modaImageContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5qRwM.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jwaui))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($jwaui))),
        alt: formatMessage((0, $fHjhV.messages).modalHeroBannerImageAltText),
        testId: "servicedesk-cmdb-data-manager-change-boarding.ui.image"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $4ad7c0c31af73c11$var$noBorderContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $4ad7c0c31af73c11$var$modalTitleWrapper,
        paddingBlockStart: "space.500",
        paddingBlockEnd: "space.200",
        paddingInlineStart: "space.600",
        paddingInlineEnd: "space.600"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gofOI.default), null, formatMessage((0, $fHjhV.messages).modalTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $4ad7c0c31af73c11$var$modalContentWrapper,
        paddingBlockStart: "space.0",
        paddingBlockEnd: "space.0",
        paddingInlineStart: "space.600",
        paddingInlineEnd: "space.600"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $fHjhV.messages).modalContent,
        values: {
            p: (msg)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, msg)
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlockStart: "space.400",
        paddingBlockEnd: "space.500",
        paddingInlineStart: "space.500",
        paddingInlineEnd: "space.500",
        xcss: $4ad7c0c31af73c11$var$noBorderContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        direction: "row",
        justifyContent: "center",
        alignItems: "center",
        gap: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9yOBd.default), {
        appearance: "subtle",
        onClick: onClose,
        testId: "servicedesk-cmdb-data-manager-change-boarding.ui.cancel-button"
    }, formatMessage((0, $fHjhV.messages).cancelButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9yOBd.default), {
        appearance: "primary",
        onClick: onDone,
        testId: "servicedesk-cmdb-data-manager-change-boarding.ui.confirm-button"
    }, formatMessage((0, $fHjhV.messages).confirmButton))))))));
};
const $4ad7c0c31af73c11$export$c1e6758d8da69448 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "CmdbDataManagerChangeBoarding",
        packageName: "jiraServicedeskCmdbDataManagerChangeBoarding",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eGLgs.default), {
        messageId: (0, $9a1c2f0a739f05ff$export$78f2c56846ab905c)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4ad7c0c31af73c11$export$1f04342a44ce11ca, null))));
const $4ad7c0c31af73c11$var$modalTitleWrapper = (0, $8CUq3.xcss)({
    textAlign: 'center',
    fontWeight: 'font.weight.semibold'
});
const $4ad7c0c31af73c11$var$modalContentWrapper = (0, $8CUq3.xcss)({
    textAlign: 'center'
});
const $4ad7c0c31af73c11$var$modalContainer = (0, $8CUq3.xcss)({
    backgroundColor: 'elevation.surface',
    borderRadius: `${"var(--ds-border-radius, 3px)"}`
});
const $4ad7c0c31af73c11$var$modaImageContainer = (0, $8CUq3.xcss)({
    borderRadius: `${"var(--ds-border-radius, 3px)"} ${"var(--ds-border-radius, 3px)"} 0 0`,
    overflow: 'hidden'
});
const $4ad7c0c31af73c11$var$noBorderContainer = (0, $8CUq3.xcss)({
    border: 'none'
});

});
const $9a1c2f0a739f05ff$export$78f2c56846ab905c = 'jsm-cmdb-data-manager-changeboarding';

parcelRegister("jwaui", function(module, exports) {
module.exports = new URL("background.c046bea0.png", import.meta.url).toString();

});

parcelRegister("fHjhV", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a1818fb0f7acd668$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $a1818fb0f7acd668$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    modalHeroBannerImageAltText: {
        "id": "servicedesk-cmdb-data-manager-change-boarding.modal-hero-banner-image-alt-text",
        "defaultMessage": "Data Manager modal banner image"
    },
    modalTitle: {
        "id": "servicedesk-cmdb-data-manager-change-boarding.modal-title",
        "defaultMessage": "Introducing Data Manager"
    },
    modalContent: {
        "id": "servicedesk-cmdb-data-manager-change-boarding.modal-content",
        "defaultMessage": "<p>With Data Manager, you can now import your data from anywhere. Data Manager gathers, aggregates and analyses multiple sources of data, making it easy to pinpoint issues so you can move on to more important tasks.</p><p>Go to Assets configuration to enable Data Manager on your site.</p>"
    },
    cancelButton: {
        "id": "servicedesk-cmdb-data-manager-change-boarding.cancel-button",
        "defaultMessage": "Remind me later"
    },
    confirmButton: {
        "id": "servicedesk-cmdb-data-manager-change-boarding.confirm-button",
        "defaultMessage": "Read about Data Manager"
    }
});

});



parcelRegister("2XH7B", function(module, exports) {

$parcel$export(module.exports, "ConfigLink", () => $e5d59eda0dc867fb$export$69f8d6558940afc4);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $ik2d8 = parcelRequire("ik2d8");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $hDzhb = parcelRequire("hDzhb");
const $e5d59eda0dc867fb$export$69f8d6558940afc4 = ({ children: children, onClick: onClick, testId: testId, to: to })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $e5d59eda0dc867fb$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        href: to,
        component: (0, $hDzhb.default),
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ik2d8))), {
            label: "",
            size: "medium"
        }),
        testId: testId,
        onClick: (event, analyticsEvent)=>{
            onClick?.(analyticsEvent);
        }
    }, children));
const $e5d59eda0dc867fb$var$wrapperStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.100'
});

});
parcelRegister("ik2d8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d56bcf4208f0775d$var$_react = $d56bcf4208f0775d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $d56bcf4208f0775d$var$_settings = $d56bcf4208f0775d$var$_interopRequireDefault((parcelRequire("epOG5")));
function $d56bcf4208f0775d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d56bcf4208f0775d$var$EditorSettingsIcon = (props)=>/*#__PURE__*/ $d56bcf4208f0775d$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12.002 15.504a3.502 3.502 0 1 1 0-7.004 3.502 3.502 0 0 1 0 7.004m6.732-1.987a1.605 1.605 0 0 1-.001-3.034.386.386 0 0 0 .253-.462 7.2 7.2 0 0 0-.672-1.604.384.384 0 0 0-.481-.156c-.31.127-.668.16-1.039.065a1.6 1.6 0 0 1-1.129-1.124 1.64 1.64 0 0 1 .061-1.043.385.385 0 0 0-.157-.48 7.2 7.2 0 0 0-1.59-.665.385.385 0 0 0-.461.252 1.604 1.604 0 0 1-3.032 0 .387.387 0 0 0-.463-.252c-.57.16-1.11.39-1.613.677a.38.38 0 0 0-.159.468 1.611 1.611 0 0 1-2.088 2.108.385.385 0 0 0-.479.158 7.2 7.2 0 0 0-.67 1.604.386.386 0 0 0 .248.46 1.605 1.605 0 0 1 0 3.021.385.385 0 0 0-.249.46c.143.504.34.986.582 1.44.096.179.318.24.502.156.479-.22 1.08-.213 1.693.191a.9.9 0 0 1 .243.242c.424.643.412 1.272.16 1.76a.38.38 0 0 0 .134.506 7.2 7.2 0 0 0 1.697.721.38.38 0 0 0 .459-.251A1.605 1.605 0 0 1 12 17.645c.707 0 1.302.457 1.518 1.09.066.19.265.306.459.251a7.2 7.2 0 0 0 1.677-.71.38.38 0 0 0 .134-.508c-.256-.49-.271-1.12.154-1.766a.9.9 0 0 1 .243-.243c.62-.411 1.228-.413 1.71-.185a.384.384 0 0 0 .505-.153q.367-.683.585-1.443a.385.385 0 0 0-.252-.461"/></svg>`
    }, props, {
        newIcon: $d56bcf4208f0775d$var$_settings.default
    }));
$d56bcf4208f0775d$var$EditorSettingsIcon.displayName = 'EditorSettingsIcon';
var $d56bcf4208f0775d$var$_default = module.exports.default = $d56bcf4208f0775d$var$EditorSettingsIcon;

});


parcelRegister("dtVyR", function(module, exports) {

$parcel$export(module.exports, "messages", () => $5322456f49a431cb$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $5322456f49a431cb$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    descriptionCmdbAssets: {
        "id": "servicedesk-insight-landing-page.description-cmdb-assets",
        "defaultMessage": "Connect, track and manage the assets that matter to your team - application services, infrastructure, hardware, people, and much more. <link>Learn more about Assets</link>"
    },
    navRefreshAssetsSchemasTile: {
        "id": "servicedesk-insight-landing-page.nav-refresh-assets-schemas-tile",
        "defaultMessage": "Schemas"
    },
    assetsBreadcrumbs: {
        "id": "servicedesk-insight-landing-page.assets-breadcrumbs",
        "defaultMessage": "Assets"
    },
    documentTitleCmdbAssets: {
        "id": "servicedesk-insight-landing-page.document-title-cmdb-assets",
        "defaultMessage": "Asset and configuration management"
    },
    configLink: {
        "id": "servicedesk-insight-landing-page.config-link",
        "defaultMessage": "Configuration"
    },
    searchPlaceholder: {
        "id": "servicedesk-insight-landing-page.search-placeholder",
        "defaultMessage": "Search all schemas for objects..."
    },
    searchPlaceholderAriaLabel: {
        "id": "servicedesk-insight-landing-page.search-placeholder-aria-label",
        "defaultMessage": "Start typing, then use the up and down arrows to select an option from the list"
    },
    reportsLink: {
        "id": "servicedesk-insight-landing-page.reports-link",
        "defaultMessage": "Reports"
    },
    dataManagerLink: {
        "id": "servicedesk-insight-landing-page.data-manager-link",
        "defaultMessage": "Data Manager"
    },
    adaptersLink: {
        "id": "servicedesk-insight-landing-page.adapters-link",
        "defaultMessage": "Adapters"
    }
});

});

parcelRegister("cGbmp", function(module, exports) {

$parcel$export(module.exports, "AsyncInsightLandingPageReportsLink", () => $d190794f39a76c69$export$ade00b93735f7ab1);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d190794f39a76c69$var$ReportsLink = (0, $kxZPA.lazy)(()=>(parcelRequire("4rWly")), {
    moduleId: "./src/packages/servicedesk/insight-landing/insight-landing-page/src/ui/reports-link/link/index.tsx"
});
const $d190794f39a76c69$export$ade00b93735f7ab1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jsm-insight-landing-page-reports-link",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d190794f39a76c69$var$ReportsLink, props));

});
parcelRegister("4rWly", function(module, exports) {

let $33d6f174d9a2a206$var$load = (parcelRequire("28QjX"))(4);
module.exports = $33d6f174d9a2a206$var$load("3dxEI").then(()=>parcelRequire('9z2fR'));

});


parcelRegister("dppTu", function(module, exports) {

$parcel$export(module.exports, "UsagePanel", () => $ef08c685f609e460$export$3660c3fa9bf0d23c);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $l1N8i = parcelRequire("l1N8i");

var $17Ngn = parcelRequire("17Ngn");

var $820Wv = parcelRequire("820Wv");

var $1I7E8 = parcelRequire("1I7E8");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $5Zxxp = parcelRequire("5Zxxp");

var $koVbs = parcelRequire("koVbs");

var $j8qoE = parcelRequire("j8qoE");

var $blEB6 = parcelRequire("blEB6");

var $1CoNo = parcelRequire("1CoNo");
const $ef08c685f609e460$export$3660c3fa9bf0d23c = ()=>{
    const { formatMessage: formatMessage, formatNumber: formatNumber } = (0, $koVbs.default)();
    const [{ config: config }] = (0, $j8qoE.useInsightGlobalConfig)();
    const [isHelpOpen, setIsHelpOpen] = (0, $5uXOq.useState)(false);
    if (!config) return null;
    const { insightAdministrator: insightAdministrator, limitInfo: limitInfo } = config;
    const { objectCount: objectCount } = limitInfo;
    const calculationInfo = formatMessage((0, $1CoNo.messages).calculationInfo);
    const renderHelpContent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            padding: "space.200",
            xcss: $ef08c685f609e460$var$helpBoxStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $1CoNo.messages).excludedSchemasInfo)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Zxxp.default), {
            articleId: "3sbbZSMOEhRWrOLZI4UNNs",
            appearance: "link",
            spacing: "none",
            onClick: ()=>setIsHelpOpen(false),
            fallbackComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
                href: "https://support.atlassian.com/jira-service-management-cloud/docs/what-is-feature-usage-and-how-it-works",
                target: "_blank",
                rel: "noopener noreferrer"
            }, calculationInfo)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef08c685f609e460$var$HelpText, null, calculationInfo)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef08c685f609e460$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h2",
        size: "xsmall"
    }, formatMessage((0, $1CoNo.messages).objects), ' '), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.default), {
        isOpen: isHelpOpen,
        onClose: ()=>setIsHelpOpen(false),
        placement: "top-start",
        content: renderHelpContent,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                ...triggerProps,
                appearance: "subtle",
                spacing: "none",
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($820Wv))), {
                    label: formatMessage((0, $1CoNo.messages).assetsUsageInfo),
                    spacing: "spacious",
                    color: isHelpOpen ? "var(--ds-icon-selected, #0C66E4)" : "var(--ds-icon-subtle, #626F86)"
                }),
                isSelected: isHelpOpen,
                onClick: ()=>setIsHelpOpen(!isHelpOpen)
            })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "large"
    }, formatNumber(objectCount)), insightAdministrator && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
        href: (0, $blEB6.getFeatureUsagePageUrl)(),
        target: "_blank",
        rel: "noopener noreferrer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        color: "inherit"
    }, formatMessage((0, $1CoNo.messages).viewDetailedUsage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($17Ngn))), {
        size: "small",
        label: ""
    })))));
};
const $ef08c685f609e460$var$helpBoxStyles = (0, $8CUq3.xcss)({
    maxWidth: '210px'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ef08c685f609e460$var$HelpText = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_o5724jg8 _y3gnv2br",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ef08c685f609e460$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulputpp _1e0c1txw _2lx21bp4 _19pkpxbi _otyr1ejb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("820Wv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c8b47c8580de559edd6a7f4245d87179>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5d8f3dcf908a8bd0$var$_react = $5d8f3dcf908a8bd0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5d8f3dcf908a8bd0$var$_information = $5d8f3dcf908a8bd0$var$_interopRequireDefault((parcelRequire("jxZHv")));

var $5d8f3dcf908a8bd0$var$_panel = $5d8f3dcf908a8bd0$var$_interopRequireDefault((parcelRequire("kkuz9")));
function $5d8f3dcf908a8bd0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for InformationIcon.
 * This component is InformationIcon, with `UNSAFE_fallbackIcon` set to "EditorPanelIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5d8f3dcf908a8bd0$var$InformationIcon = (props)=>/*#__PURE__*/ $5d8f3dcf908a8bd0$var$_react.default.createElement($5d8f3dcf908a8bd0$var$_information.default, Object.assign({
        LEGACY_fallbackIcon: $5d8f3dcf908a8bd0$var$_panel.default
    }, props));
$5d8f3dcf908a8bd0$var$InformationIcon.Name = 'InformationIconMigration';
var $5d8f3dcf908a8bd0$var$_default = module.exports.default = $5d8f3dcf908a8bd0$var$InformationIcon;

});
parcelRegister("jxZHv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::27668a0671d09dc2613ff96651c1fef4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e3b0f5e112f2bb60$var$_react = $e3b0f5e112f2bb60$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e3b0f5e112f2bb60$var$_baseNew = $e3b0f5e112f2bb60$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $e3b0f5e112f2bb60$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Information".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e3b0f5e112f2bb60$var$InformationIcon = (props)=>/*#__PURE__*/ $e3b0f5e112f2bb60$var$_react.default.createElement($e3b0f5e112f2bb60$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12 6A6 6 0 1 1 0 6a6 6 0 0 1 12 0m-7.5-.75H6a.75.75 0 0 1 .75.75v4h-1.5V6.75H4.5zM6 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$e3b0f5e112f2bb60$var$InformationIcon.displayName = 'InformationIcon';
var $e3b0f5e112f2bb60$var$_default = module.exports.default = $e3b0f5e112f2bb60$var$InformationIcon;

});


parcelRegister("1CoNo", function(module, exports) {

$parcel$export(module.exports, "messages", () => $4dab16f205e6c175$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $4dab16f205e6c175$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    objects: {
        "id": "servicedesk-insight-landing-page.usage-panel.objects",
        "defaultMessage": "Objects"
    },
    excludedSchemasInfo: {
        "id": "servicedesk-insight-landing-page.usage-panel.excluded-schemas-info",
        "defaultMessage": "Excludes objects stored within system schemas."
    },
    assetsUsageInfo: {
        "id": "servicedesk-insight-landing-page.usage-panel.assets-usage-info",
        "defaultMessage": "Object usage information"
    },
    viewDetailedUsage: {
        "id": "servicedesk-insight-landing-page.usage-panel.view-detailed-usage",
        "defaultMessage": "View detailed usage"
    },
    calculationInfo: {
        "id": "servicedesk-insight-landing-page.usage-panel.calculation-info",
        "defaultMessage": "Read how Assets usage is calculated."
    }
});

});



parcelRegister("6GLlD", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1e4a0c92f65aa33$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iXVV6 = parcelRequire("iXVV6");

var $9noxX = parcelRequire("9noxX");

var $e9YVH = parcelRequire("e9YVH");

var $9dbF6 = parcelRequire("9dbF6");

var $9NiTW = parcelRequire("9NiTW");

var $cYaqS = parcelRequire("cYaqS");
const $b1e4a0c92f65aa33$var$ServiceDeskAppBase = ({ appName: appName, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9NiTW.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cYaqS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9dbF6.SubProductUpdater), {
        subProduct: "serviceDesk"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9noxX.ServiceDeskAnalyticsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: (0, $e9YVH.toPackageName)(appName),
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, children))));
var $b1e4a0c92f65aa33$export$2e2bcd8739ae039 = $b1e4a0c92f65aa33$var$ServiceDeskAppBase;

});
parcelRegister("9dbF6", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $5979c081afa32bfa$export$eb40d3df56aa5c53);

var $5uXOq = parcelRequire("5uXOq");

var $5h5Fg = parcelRequire("5h5Fg");

var $3iTiR = parcelRequire("3iTiR");

var $ero6m = parcelRequire("ero6m");

var $54I24 = parcelRequire("54I24");

var $8OHH4 = parcelRequire("8OHH4");
const $5979c081afa32bfa$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $8OHH4.isSubProductProps)(props) ? props.subProduct : (0, $ero6m.getSubProductFromProjectType)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5h5Fg.default), {
        op: (0, $54I24.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3iTiR.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("3iTiR", function(module, exports) {

$parcel$export(module.exports, "default", () => $1214b0731559b377$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $01Rn4 = parcelRequire("01Rn4");

var $hFChZ = parcelRequire("hFChZ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1214b0731559b377$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $01Rn4.default), {
        op: (0, $hFChZ.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("hFChZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e606430ead76cd8$export$2e2bcd8739ae039);

var $dJl1T = parcelRequire("dJl1T");

var $eusud = parcelRequire("eusud");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0e606430ead76cd8$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $eusud.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $dJl1T.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("ero6m", function(module, exports) {

$parcel$export(module.exports, "getSubProductFromProjectType", () => $0997694844c8a9e7$export$b1fe420ed15dff7b);

var $16v4H = parcelRequire("16v4H");
const $0997694844c8a9e7$export$b1fe420ed15dff7b = (projectType)=>{
    // for Analytics only 'product_discovery' is mapped to 'polaris'. In other cases it is mapped to 'software'
    if (projectType === 'product_discovery') return 'polaris';
    return (0, $16v4H.subProductFromProjectType)(projectType);
};

});

parcelRegister("54I24", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcbbcd48ca398ed4$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $7T84i = parcelRequire("7T84i");
var $9B86Q = parcelRequire("9B86Q");
var $cQZXC = parcelRequire("cQZXC");


var $dJl1T = parcelRequire("dJl1T");

var $fjcgS = parcelRequire("fjcgS");
const $bcbbcd48ca398ed4$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bcbbcd48ca398ed4$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $86344d58e71e925a$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $bcbbcd48ca398ed4$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $cQZXC.waitForHeritage)() : null, ()=>(0, $7T84i.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $9B86Q.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $dJl1T.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $86344d58e71e925a$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("8OHH4", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $701d07b56c3e3574$export$c3063d6d7a8c075f);
const $701d07b56c3e3574$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';

});


parcelRegister("cYaqS", function(module, exports) {

$parcel$export(module.exports, "default", () => $f72fff5a1e4c8937$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6jY6G = parcelRequire("6jY6G");

var $aTz47 = parcelRequire("aTz47");


var $4UFLs = parcelRequire("4UFLs");

var $g3A84 = parcelRequire("g3A84");
const $f72fff5a1e4c8937$var$AccessCheck = ({ children: children })=>{
    const isSettingsRoute = (0, $6jY6G.useCurrentRoute)().path.includes(`${(0, $7c914880cb332728$export$967ba7bfb5ce30bd)}/:projectKey/settings/`);
    const isHelpCenterSettingsRoute = (0, $aTz47.isHelpCenterSettingsPath)();
    const Gate = isSettingsRoute || isHelpCenterSettingsRoute ? (0, $g3A84.default) : (0, $4UFLs.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Gate, null, children);
};
var $f72fff5a1e4c8937$export$2e2bcd8739ae039 = $f72fff5a1e4c8937$var$AccessCheck;

});
const $7c914880cb332728$export$967ba7bfb5ce30bd = '/jira/servicedesk/projects';
const $7c914880cb332728$export$16a37d277dff22d6 = '/jira/helpcenter/projects';

parcelRegister("4UFLs", function(module, exports) {

$parcel$export(module.exports, "default", () => $9befbeaff9f5385d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $daoB1 = parcelRequire("daoB1");

var $7tQej = parcelRequire("7tQej");
var $bmKPg = parcelRequire("bmKPg");

var $iDvG9 = parcelRequire("iDvG9");
const $9befbeaff9f5385d$var$ProductAccessCheck = ({ children: children })=>{
    const { hasServiceDeskAccess: hasServiceDeskAccess } = (0, $daoB1.useApplicationPermissions)();
    const [projectKey = ''] = (0, $bmKPg.usePathParam)('projectKey');
    if (projectKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iDvG9.default), null, children);
    return hasServiceDeskAccess ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: "/jira"
    });
};
var $9befbeaff9f5385d$export$2e2bcd8739ae039 = $9befbeaff9f5385d$var$ProductAccessCheck;

});
parcelRegister("iDvG9", function(module, exports) {

$parcel$export(module.exports, "default", () => $34dd3dc578b1a167$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7tQej = parcelRequire("7tQej");
var $bmKPg = parcelRequire("bmKPg");

var $dFOAR = parcelRequire("dFOAR");


var $fhAnU = parcelRequire("fhAnU");
const $34dd3dc578b1a167$var$AgentCheck = ({ children: children })=>{
    const [projectKey = ''] = (0, $bmKPg.usePathParam)('projectKey');
    const [{ data: data, error: error }] = (0, $dFOAR.useServiceDeskContext)();
    if (data || error) {
        // @ts-expect-error - TS2345 - Argument of type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null' is not assignable to parameter of type '{ statusCode?: number | undefined; } | null'.
        if (!(0, $fhAnU.isAccessError)(error)) {
            const { userRole: userRole = '' } = data || {};
            if (userRole === 'agent' || userRole === 'agent-project-admin') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
            if (error) throw error;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
            to: `${(0, $7c914880cb332728$export$967ba7bfb5ce30bd)}/${projectKey}/issues`
        });
    }
    return null;
};
var $34dd3dc578b1a167$export$2e2bcd8739ae039 = $34dd3dc578b1a167$var$AgentCheck;

});
parcelRegister("dFOAR", function(module, exports) {

$parcel$export(module.exports, "useServiceDeskContext", () => $6c09349e97fba749$export$712ead87353ac687);

var $5uXOq = parcelRequire("5uXOq");

var $324W5 = parcelRequire("324W5");

var $cAofY = parcelRequire("cAofY");
const $6c09349e97fba749$var$getServiceDeskContextResource = ()=>(0, $cAofY.serviceDeskContextResource);
const $6c09349e97fba749$export$712ead87353ac687 = (projectKey, customContext)=>{
    const { data: data, loading: loading, error: error, refresh: refreshCache } = (0, $324W5.useResourceWithCustomRouterContext)($6c09349e97fba749$var$getServiceDeskContextResource(), customContext);
    (0, $5uXOq.useEffect)(()=>{
        if (!false) refreshCache();
    }, [
        projectKey,
        refreshCache
    ]);
    return [
        {
            data: data,
            loading: loading,
            error: error
        }
    ];
};

});

parcelRegister("fhAnU", function(module, exports) {

$parcel$export(module.exports, "isAccessError", () => $1a790f4bb1355504$export$ddaebe4928e793cb);

const $1a790f4bb1355504$var$RESTRICTED_ACCESS_CODES = [
    (0, $3cd8a0ece36fbae5$export$a3269a3914b007e3),
    (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef),
    (0, $3cd8a0ece36fbae5$export$67d19e9a991baa07)
];
const $1a790f4bb1355504$export$ddaebe4928e793cb = (error)=>error?.statusCode != null ? $1a790f4bb1355504$var$RESTRICTED_ACCESS_CODES.includes(error.statusCode) : false;

});
const $3cd8a0ece36fbae5$export$ff39ebd4bb12b718 = 201;
const $3cd8a0ece36fbae5$export$3288b14b6745c572 = 204;
const $3cd8a0ece36fbae5$export$9de493bcd9b1d977 = 400;
const $3cd8a0ece36fbae5$export$67d19e9a991baa07 = 401;
const $3cd8a0ece36fbae5$export$a3269a3914b007e3 = 403;
const $3cd8a0ece36fbae5$export$8bca792d963eb0ef = 404;
const $3cd8a0ece36fbae5$export$4a3cb39801694eee = 407;
const $3cd8a0ece36fbae5$export$fa405bbf47d510e2 = 408;
const $3cd8a0ece36fbae5$export$c09e7ea0fc79f34f = 409;
const $3cd8a0ece36fbae5$export$5244030134e99 = 412;
const $3cd8a0ece36fbae5$export$f90ac1df0b60853d = 413;
const $3cd8a0ece36fbae5$export$a447d0a965e16776 = 422;
const $3cd8a0ece36fbae5$export$3b48aba8957000cd = 426;
const $3cd8a0ece36fbae5$export$6763168a631449a2 = 429;
const $3cd8a0ece36fbae5$export$e813cd7045fcc98d = 500;
const $3cd8a0ece36fbae5$export$2ce38d41a306034e = 502;
const $3cd8a0ece36fbae5$export$974c37534b0191b1 = 503;
const $3cd8a0ece36fbae5$export$5400e8dddac3fcf3 = 504;




parcelRegister("g3A84", function(module, exports) {

$parcel$export(module.exports, "default", () => $60e7d6646168c089$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $aTz47 = parcelRequire("aTz47");

var $8pMQX = parcelRequire("8pMQX");

var $dFOAR = parcelRequire("dFOAR");

var $fhAnU = parcelRequire("fhAnU");
const $60e7d6646168c089$var$SettingsAccessCheck = ({ children: children })=>{
    const [{ data: serviceDeskContext, error: serviceDeskContextError }] = (0, $dFOAR.useServiceDeskContext)();
    const userRole = serviceDeskContext?.userRole;
    // @ts-expect-error - TS2345 - Argument of type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null' is not assignable to parameter of type '{ statusCode?: number | undefined; } | null'.
    const hasAccessError = (0, $fhAnU.isAccessError)(serviceDeskContextError);
    // Service desk context is updated on every route change
    // If context fails to give us an indicative result (e.g. fetch failed, 500 error)
    // We will continue to use current value to assess permissions
    if (userRole === 'agent-project-admin' && !hasAccessError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
    if (userRole !== undefined || hasAccessError) {
        const isHelpCenterSettingsRoute = (0, $aTz47.isHelpCenterSettingsPath)();
        if (isHelpCenterSettingsRoute) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8pMQX.ServiceHubNotFound), null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8pMQX.ProjectNotFound), null);
    }
    if (serviceDeskContextError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8pMQX.GenericError), null);
    return null;
};
var $60e7d6646168c089$export$2e2bcd8739ae039 = $60e7d6646168c089$var$SettingsAccessCheck;

});
parcelRegister("8pMQX", function(module, exports) {

$parcel$export(module.exports, "ProjectNotFound", () => $951f6bd200bf8b89$export$849d319c342682a2);
$parcel$export(module.exports, "ServiceHubNotFound", () => $951f6bd200bf8b89$export$1fbf518ac538659c);
$parcel$export(module.exports, "GenericError", () => $951f6bd200bf8b89$export$7d465be8efa67280);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");

var $hTEpF = parcelRequire("hTEpF");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $tcn7E = parcelRequire("tcn7E");

var $lVQn8 = parcelRequire("lVQn8");

var $id7K0 = parcelRequire("id7K0");

var $bTyOW = parcelRequire("bTyOW");

var $fC09Q = parcelRequire("fC09Q");

var $iVgQf = parcelRequire("iVgQf");

var $koVbs = parcelRequire("koVbs");

var $hDzhb = parcelRequire("hDzhb");

var $4R6GH = parcelRequire("4R6GH");

var $4AdE6 = parcelRequire("4AdE6");
const $951f6bd200bf8b89$export$849d319c342682a2 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const projectsPath = '/jira/projects';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $id7K0.DocumentTitle), {
        title: formatMessage((0, $4AdE6.default).notFoundDocumentTitleJsm)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        renderImage: (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $fC09Q.default)),
        maxImageWidth: 120,
        header: formatMessage((0, $4AdE6.default).notFoundTitle),
        description: formatMessage((0, $4AdE6.default).notFoundDescription),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hDzhb.default), {
            to: projectsPath
        }, formatMessage((0, $4AdE6.default).notFoundAction))
    }));
};
const $951f6bd200bf8b89$export$1fbf518ac538659c = ()=>{
    const projectsPath = '/jira/projects';
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $id7K0.DocumentTitle), {
        title: formatMessage((0, $4AdE6.default).serviceHubNotFoundDocumentTitleJsm)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        renderImage: (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $fC09Q.default)),
        maxImageWidth: 120,
        header: formatMessage((0, $4AdE6.default).serviceHubNotFoundTitle),
        description: formatMessage((0, $4AdE6.default).serviceHubNotFoundDescription),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hDzhb.default), {
            to: projectsPath
        }, formatMessage((0, $4AdE6.default).serviceHubNotFoundAction))
    }));
};
const $951f6bd200bf8b89$export$7d465be8efa67280 = ()=>{
    const interactionId = (0, $5uXOq.useContext)((0, $1u4q7.default)).current;
    const labelStack = (0, $5uXOq.useContext)((0, $1tcYS.default))?.labelStack;
    const traceId = (0, $5uXOq.useMemo)(()=>{
        const traceContext = (0, $tcn7E.getActiveTrace)();
        return traceContext?.traceId;
    }, []);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    let description = formatMessage((0, $4AdE6.default).genericErrorDescription);
    if (traceId) {
        const error = new Error('An error occurred while loading this page');
        description = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $951f6bd200bf8b89$var$styles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lVQn8.ErrorHashAndTraceId), {
            error: error,
            traceId: traceId
        })));
        if ((0, $4R6GH.fg)('add_ufo_error_in_service_desk_genericerror')) {
            const name = 'serviceDeskGenericError';
            if (interactionId) {
                (0, $bFU4G.addError)(interactionId, name, labelStack ?? null, error.name, error.message, error.stack);
                // NOTE: to account for awaiting BM3 TTI in UFO code, however we don't need to wait for BM3 TTI when there is an error
                // https://atlassian.slack.com/archives/C01AY8132S3/p1736380314352749?thread_ts=1736377740.484469&cid=C01AY8132S3
                const activeInteraction = (0, $bFU4G.getActiveInteraction)();
                activeInteraction?.holdActive.forEach((_, holdId)=>{
                    (0, $bFU4G.removeHoldByID)(activeInteraction.id, holdId);
                });
            } else (0, $bFU4G.addErrorToAll)(name, labelStack ?? null, error.name, error.message, error.stack);
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $id7K0.DocumentTitle), {
        title: formatMessage((0, $4AdE6.default).genericDocumentTitleJsm)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        renderImage: (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $bTyOW.default)),
        maxImageWidth: 120,
        header: formatMessage((0, $4AdE6.default).genericErrorTitle),
        description: description
    }));
};
const $951f6bd200bf8b89$var$styles = (0, $8CUq3.xcss)({
    marginTop: 'space.100'
});

});
parcelRegister("lVQn8", function(module, exports) {

$parcel$export(module.exports, "ErrorHashAndTraceId", () => $6bb63dde5e44a95e$export$61354a7dde2c2d3c);

var $5uXOq = parcelRequire("5uXOq");

var $5oFIy = parcelRequire("5oFIy");

var $kobfu = parcelRequire("kobfu");

var $hurrh = parcelRequire("hurrh");
const $6bb63dde5e44a95e$export$61354a7dde2c2d3c = ({ error: error, traceId: traceId })=>{
    const errorHash = (0, $kobfu.getErrorHash)(error);
    const source = `Hash ${errorHash}\nTrace ${traceId}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireOperationalAnalytics), {
        action: "rendered",
        actionSubject: "errorHashAndTraceId",
        attributes: {
            errorHash: errorHash,
            traceId: traceId
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        role: "note"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hurrh.CodeBlockWithCopyButton), {
        source: source,
        copyCodeActionSubjectId: "copyErrorHashAndTraceId"
    })));
};

});
parcelRegister("hurrh", function(module, exports) {

$parcel$export(module.exports, "CodeBlockWithCopyButton", () => $e48150d967598599$export$ced1fc74d907d387);

var $5uXOq = parcelRequire("5uXOq");

var $b8Qxt = parcelRequire("b8Qxt");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $irzxp = parcelRequire("irzxp");
const $e48150d967598599$export$ced1fc74d907d387 = ({ source: source, copyCodeActionSubjectId: copyCodeActionSubjectId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $e48150d967598599$var$wrapperStyles,
        role: "region"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $irzxp.ActionContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $irzxp.CopyAction), {
        source: source,
        actionSubjectId: copyCodeActionSubjectId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b8Qxt.default), {
        text: source,
        showLineNumbers: false,
        shouldWrapLongLines: false
    })));
const $e48150d967598599$var$wrapperStyles = (0, $8CUq3.xcss)({
    width: '100%',
    position: 'relative'
});

});
parcelRegister("b8Qxt", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fd53c1f9dbca185$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $e4VnT = parcelRequire("e4VnT");

var $1HkQx = parcelRequire("1HkQx");

var $eCBnN = parcelRequire("eCBnN");

var $9Xp6L = parcelRequire("9Xp6L");
/**
 * __Code block__
 *
 * A code block highlights an entire block of code and keeps the formatting.
 *
 * - [Examples](https://atlassian.design/components/code/code-block/examples)
 * - [Code](https://atlassian.design/components/code/code-block/code)
 * - [Usage](https://atlassian.design/components/code/code-block/usage)
 */ const $4fd53c1f9dbca185$var$CodeBlock = /*#__PURE__*/ (0, $5uXOq.memo)(function CodeBlock({ showLineNumbers: showLineNumbers = true, firstLineNumber: firstLineNumber = 1, language: providedLanguage = 'text', highlight: highlight = '', highlightedStartText: highlightedStartText = 'Highlight start', highlightedEndText: highlightedEndText = 'Highlight end', testId: testId, text: text, codeBidiWarnings: codeBidiWarnings = true, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, shouldWrapLongLines: shouldWrapLongLines = false }) {
    const numLines = (text || '').split('\n').length + (firstLineNumber > 0 ? firstLineNumber : 1) - 1;
    const theme = (0, $5uXOq.useMemo)(()=>(0, $1HkQx.getCodeBlockTheme)(numLines), [
        numLines
    ]);
    const getStyles = (0, $5uXOq.useMemo)(()=>(0, $1HkQx.getCodeBlockStyles)(theme), [
        theme
    ]);
    const styles = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, $f8Sb3.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        getStyles(highlightedStartText, highlightedEndText, showLineNumbers, shouldWrapLongLines)), [
        highlightedStartText,
        highlightedEndText,
        showLineNumbers,
        shouldWrapLongLines,
        getStyles
    ]);
    const { getHighlightStyles: getHighlightStyles, highlightedLines: highlightedLines } = (0, $e4VnT.useHighlightLines)({
        highlight: highlight,
        testId: testId
    });
    const getLineProps = (0, $5uXOq.useCallback)((line)=>getHighlightStyles(line, highlightedLines), [
        getHighlightStyles,
        highlightedLines
    ]);
    const language = (0, $5uXOq.useMemo)(()=>(0, $eCBnN.normalizeLanguage)(providedLanguage), [
        providedLanguage
    ]);
    // https://product-fabric.atlassian.net/browse/DST-2472
    const languageToUse = text ? language : 'text';
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9Xp6L.default), {
        "data-code-lang": language,
        "data-ds--code--code-block": "",
        testId: testId,
        language: languageToUse,
        css: styles,
        showLineNumbers: showLineNumbers,
        firstLineNumber: firstLineNumber,
        lineProps: getLineProps,
        // shouldCreateParentElementForLines is needed to pass down props to each line.
        // This is necessary for both line highlighting and testId's, as each of
        // these rely on a data attribute being passed down to lines.
        shouldCreateParentElementForLines: highlight.length > 0 || !!testId,
        shouldWrapLongLines: shouldWrapLongLines,
        codeBidiWarnings: codeBidiWarnings,
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled,
        text: text
    });
});
$4fd53c1f9dbca185$var$CodeBlock.displayName = 'CodeBlock';
var $4fd53c1f9dbca185$export$2e2bcd8739ae039 = $4fd53c1f9dbca185$var$CodeBlock;

});
parcelRegister("e4VnT", function(module, exports) {

$parcel$export(module.exports, "useHighlightLines", () => $a32b74c088f4b53f$export$84415a200bdf33ed);

var $5uXOq = parcelRequire("5uXOq");
const $a32b74c088f4b53f$var$DEFAULT_LINE_EL_ATTR_OBJ = {
    'data-ds--code--row': ''
};
const $a32b74c088f4b53f$var$getLineStyleObject = (lineNumber, testId)=>{
    return testId ? {
        'data-testid': `${testId}-line-${lineNumber}`,
        ...$a32b74c088f4b53f$var$DEFAULT_LINE_EL_ATTR_OBJ
    } : $a32b74c088f4b53f$var$DEFAULT_LINE_EL_ATTR_OBJ;
};
const $a32b74c088f4b53f$export$84415a200bdf33ed = ({ highlight: highlight = '', testId: testId })=>{
    const highlightedLines = (0, $5uXOq.useMemo)(()=>{
        if (!highlight) return [];
        return highlight.split(',').map((num)=>{
            if (num.indexOf('-') > 0) {
                // We found a line group, e.g. 1-3
                const [from, to] = num.split('-').map(Number)// Sort by lowest value first, highest value last.
                .sort((a, b)=>a - b);
                return Array(to + 1).fill(undefined).map((_, index)=>index).slice(from, to + 1);
            }
            return Number(num);
        }).reduce((acc, val)=>acc.concat(val), []) || [];
    }, [
        highlight
    ]);
    const getHighlightStyles = (0, $5uXOq.useCallback)((lineNumber, highlightedLines)=>{
        if (!highlight || highlightedLines.length === 0) return $a32b74c088f4b53f$var$getLineStyleObject(lineNumber, testId);
        if (highlightedLines.includes(lineNumber)) {
            const highlightedDataAttrObj = {
                'data-ds--code--row--highlight': ''
            };
            return {
                ...highlightedDataAttrObj,
                ...$a32b74c088f4b53f$var$getLineStyleObject(lineNumber, testId)
            };
        }
        return $a32b74c088f4b53f$var$getLineStyleObject(lineNumber, testId);
    }, [
        highlight,
        testId
    ]);
    return {
        getHighlightStyles: getHighlightStyles,
        highlightedLines: highlightedLines
    };
};

});

parcelRegister("1HkQx", function(module, exports) {

$parcel$export(module.exports, "getCodeBlockStyles", () => $a9c1aabaca189fa1$export$b571c24d82780698);
$parcel$export(module.exports, "getCodeStyles", () => $a9c1aabaca189fa1$export$d5fcf1b7ff23707b);
$parcel$export(module.exports, "getCodeBlockTheme", () => $a9c1aabaca189fa1$export$57a2d4b573afd64a);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lBXbx = parcelRequire("lBXbx");

var $8CJbG = parcelRequire("8CJbG");
const $a9c1aabaca189fa1$export$cb7aec0206b595d2 = (numLines)=>{
    if (!numLines) return '1ch';
    return `${numLines.toFixed(0).length}ch`;
};
const $a9c1aabaca189fa1$var$lineNumberStyle = (theme)=>({
        // width of the line number gutter
        minWidth: `calc(${theme.lineNumberWidth} + ${0, $lBXbx.LINE_NUMBER_GUTTER}px) !important`,
        // this needs to be important or it gets overwritten by inline styles
        fontStyle: 'normal !important',
        // this needs to be important or it gets overwritten by inline styles
        color: `${theme.lineNumberColor} !important`,
        flexShrink: 0,
        // needed to replicate existing design spec
        boxSizing: 'border-box',
        paddingRight: `${0, $lBXbx.SPACING}px !important`,
        paddingLeft: (0, $lBXbx.SPACING),
        marginRight: (0, $lBXbx.SPACING),
        textAlign: 'right',
        userSelect: 'none',
        // this is to fix SSR spacing issue
        display: 'block',
        // This is how we are preventing line numbers being copied to clipboard.
        // (`user-select: none;` was not sufficent).
        // https://product-fabric.atlassian.net/browse/DSP-2729
        '&::after': {
            content: `attr(data-ds--line-number)`
        }
    });
// order of these keys does matter as it will affect the css precedence
const $a9c1aabaca189fa1$var$syntaxKeywordColors = (theme)=>({
        '.token': {
            // this specifically stops prism css cascading.
            '&:not([class=token],[data-ds--code--row--highlight],[data-ds--code--row])': {
                all: 'unset'
            },
            // additional specificity required to match the all: unset
            '&.key,&.keyword': {
                color: theme.keywordColor,
                fontWeight: 'bolder'
            },
            '&.attr-name': {
                color: theme.attributeColor
            },
            '&.selector': {
                color: theme.selectorTagColor
            },
            '&.comment,&.block-comment': {
                color: theme.commentColor,
                fontFamily: theme.fontFamilyItalic,
                fontStyle: 'italic'
            },
            '&.function-name': {
                color: theme.sectionColor
            },
            '&.doctype': {
                color: theme.docTagColor
            },
            '&.substr': {
                color: theme.substringColor
            },
            '&.namespace': {
                color: theme.nameColor
            },
            '&.builtin': {
                color: theme.builtInColor
            },
            '&.entity': {
                color: theme.literalColor
            },
            '&.bullet': {
                color: theme.bulletColor
            },
            '&.code': {
                color: theme.codeColor
            },
            '&.regex': {
                color: theme.regexpColor
            },
            '&.symbol': {
                color: theme.symbolColor
            },
            '&.variable': {
                color: theme.variableColor
            },
            '&.url': {
                color: theme.linkColor
            },
            '&.selector-attr': {
                color: theme.selectorAttributeColor
            },
            '&.selector-pseudo': {
                color: theme.selectorPseudoColor
            },
            '&.type': {
                color: theme.typeColor
            },
            '&.quote': {
                color: theme.quoteColor
            },
            '&.tag': {
                color: theme.templateTagColor
            },
            '&.string': {
                color: theme.stringColor
            },
            '&.class-name': {
                color: theme.sectionColor
            },
            '&.title': {
                color: theme.titleColor
            },
            '&.section': {
                color: theme.sectionColor
            },
            '&.meta-keyword': {
                color: theme.metaKeywordColor
            },
            '&.meta': {
                color: theme.metaColor
            },
            '&.italic': {
                fontStyle: 'italic'
            },
            '&.bold': {
                fontWeight: 'bolder'
            },
            '&.function': {
                color: theme.functionColor
            },
            '&.number': {
                color: theme.numberColor
            },
            '&.attr-value': {
                color: theme.attributeColor
            },
            '&.prolog': {
                color: theme.prologColor
            },
            '&.cdata': {
                color: theme.cdataColor
            },
            '&.punctuation': {
                color: theme.punctuationColor
            },
            '&.property': {
                color: theme.propertyColor
            },
            '&.constant': {
                color: theme.constantColor
            },
            '&.deleted': {
                color: theme.deletedColor
            },
            '&.boolean': {
                color: theme.booleanColor
            },
            '&.char': {
                color: theme.charColor
            },
            '&.inserted': {
                color: theme.insertedColor
            },
            '&.operator': {
                color: theme.operatorColor
            },
            '&.atrule': {
                color: theme.atruleColor
            },
            '&.important': {
                color: theme.importantColor,
                fontWeight: "var(--ds-font-weight-bold, 700)"
            }
        }
    });
const $a9c1aabaca189fa1$export$ee58a26b5d612ac1 = (theme)=>({
        fontSize: (0, $lBXbx.CODE_FONT_SIZE),
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontFamily: theme.fontFamily,
        fontWeight: "var(--ds-font-weight-regular, 400)",
        backgroundColor: `var(${0, $lBXbx.VAR_CODE_BG_COLOR},${theme.backgroundColor})`,
        color: theme.textColor,
        borderStyle: 'none',
        borderRadius: "var(--ds-border-radius, 3px)"
    });
const $a9c1aabaca189fa1$export$b571c24d82780698 = (theme)=>(highlightedStartText, highlightedEndText, showLineNumbers, shouldWrapLongLines)=>({
            // this is required to account for prismjs styles leaking into the codeblock
            'code[class*="language-"], pre[class*="language-"], code': {
                all: 'unset',
                padding: showLineNumbers ? `${0, $lBXbx.SPACING}px 0` : (0, $lBXbx.SPACING),
                tabSize: 4
            },
            display: 'flex',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: (0, $lBXbx.CODE_LINE_HEIGHT),
            overflowX: 'auto',
            whiteSpace: 'pre',
            direction: 'ltr',
            ...$a9c1aabaca189fa1$export$ee58a26b5d612ac1(theme),
            ...$a9c1aabaca189fa1$var$syntaxKeywordColors(theme),
            // this is to account for SSR spacing issue once loaded in browser
            '& .linenumber, .ds-sh-line-number': $a9c1aabaca189fa1$var$lineNumberStyle(theme),
            '& .linenumber': {
                display: 'inline-block !important',
                float: 'left'
            },
            // these styles are for line highlighting
            '& [data-ds--code--row]': {
                display: showLineNumbers ? 'flex' : 'block',
                paddingRight: `${0, $lBXbx.SPACING}px !important`,
                marginRight: `-${0, $lBXbx.SPACING}px`
            },
            '& [data-ds--code--row--highlight]': {
                background: `${theme.highlightedLineBgColor}`,
                // eslint-disable-next-line @atlaskit/design-system/use-visually-hidden
                '&::before, &::after': {
                    clipPath: 'inset(100%)',
                    clip: 'rect(1px, 1px, 1px, 1px)',
                    height: '1px',
                    overflow: 'hidden',
                    position: 'absolute',
                    whiteSpace: 'nowrap',
                    width: '1px'
                },
                // The formatting here is an accessibility convention
                '&::before': {
                    content: `" [${highlightedStartText}] "`
                },
                '&::after': {
                    content: `" [${highlightedEndText}] "`
                }
            },
            '& [data-ds--code--row--highlight] .linenumber': {
                borderLeft: `${0, $lBXbx.HIGHLIGHT_BORDER_WIDTH} solid ${theme.highlightedLineBorderColor}`,
                paddingLeft: `${(0, $lBXbx.SPACING) / 2}px !important`,
                position: 'relative'
            },
            // fill in space caused by parent border top
            '& [data-ds--code--row--highlight] .linenumber::before': {
                content: '""',
                position: 'absolute',
                width: (0, $lBXbx.HIGHLIGHT_BORDER_WIDTH),
                top: '-1px',
                left: `-${0, $lBXbx.HIGHLIGHT_BORDER_WIDTH}`,
                borderTop: `1px solid ${theme.highlightedLineBorderColor}`
            },
            '[data-ds--code--row--highlight] + [data-ds--code--row]:not([data-ds--code--row--highlight]), [data-ds--code--row]:not([data-ds--code--row--highlight]) + [data-ds--code--row--highlight]': {
                borderTop: '1px dashed transparent'
            },
            '[data-ds--code--row--highlight]:last-child': {
                borderBottom: '1px dashed transparent'
            },
            '& code:first-of-type': {
                paddingRight: `0px !important`,
                backgroundImage: showLineNumbers ? `linear-gradient(to right, var(${0, $lBXbx.VAR_CODE_LINE_NUMBER_BG_COLOR},${theme.lineNumberBgColor}), var(${0, $lBXbx.VAR_CODE_LINE_NUMBER_BG_COLOR},${theme.lineNumberBgColor})
    calc(${theme.lineNumberWidth} + ${0, $lBXbx.LINE_NUMBER_GUTTER}px), transparent calc(${theme.lineNumberWidth} + ${0, $lBXbx.LINE_NUMBER_GUTTER}px), transparent)` : undefined
            },
            // we need to use last-of-type because when Code is SSR'd
            // 2 <code> elements are created and we don't want this style
            // applied to the first one
            '& code:last-of-type': {
                paddingRight: `${0, $lBXbx.SPACING}px !important`,
                flexBasis: 'auto',
                flexGrow: 1,
                // Needed for the highlight line to extend full-width
                flexShrink: shouldWrapLongLines ? 1 : 0,
                wordBreak: 'break-word'
            },
            // Prevents empty code blocks from vertically collapsing
            'code > span:only-child:empty:before, code > span:only-child > span:only-child:empty:before': {
                content: '" "'
            }
        });
const $a9c1aabaca189fa1$export$d5fcf1b7ff23707b = ()=>{
    const theme = (0, $8CJbG.getBaseTheme)();
    const baseStyles = $a9c1aabaca189fa1$export$ee58a26b5d612ac1(theme);
    return {
        ...baseStyles,
        display: 'inline',
        padding: '2px 0.5ch',
        boxDecorationBreak: 'clone',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '0.875em',
        overflow: 'auto',
        overflowWrap: 'break-word',
        whiteSpace: 'pre-wrap'
    };
};
const $a9c1aabaca189fa1$export$57a2d4b573afd64a = (maxLines)=>{
    return {
        ...(0, $8CJbG.getBaseTheme)(),
        ...(0, $8CJbG.getColorPalette)(),
        lineNumberWidth: maxLines ? $a9c1aabaca189fa1$export$cb7aec0206b595d2(maxLines) : undefined
    };
};

});
parcelRegister("lBXbx", function(module, exports) {

$parcel$export(module.exports, "CODE_FONT_SIZE", () => $6ec31795911692d1$export$431ac46d758d98c8);
$parcel$export(module.exports, "CODE_LINE_HEIGHT", () => $6ec31795911692d1$export$8e3c04032121c606);
$parcel$export(module.exports, "HIGHLIGHT_BORDER_WIDTH", () => $6ec31795911692d1$export$c8b5dc30e9f2b86e);
$parcel$export(module.exports, "SPACING", () => $6ec31795911692d1$export$82ea42e772d49e5b);
$parcel$export(module.exports, "LINE_NUMBER_GUTTER", () => $6ec31795911692d1$export$eeeea0ff98e06fff);
$parcel$export(module.exports, "VAR_CODE_LINE_NUMBER_BG_COLOR", () => $6ec31795911692d1$export$254015fe817dcb9e);
$parcel$export(module.exports, "VAR_CODE_BG_COLOR", () => $6ec31795911692d1$export$1758fda69688282e);
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports

var $k5uoT = parcelRequire("k5uoT");
const $6ec31795911692d1$export$431ac46d758d98c8 = 12;
const $6ec31795911692d1$export$8e3c04032121c606 = '20px';
const $6ec31795911692d1$export$c8b5dc30e9f2b86e = '4px';
const $6ec31795911692d1$export$82ea42e772d49e5b = (0, $k5uoT.gridSize)();
const $6ec31795911692d1$export$eeeea0ff98e06fff = $6ec31795911692d1$export$82ea42e772d49e5b * 2;
const $6ec31795911692d1$export$254015fe817dcb9e = '--ds--code--line-number-bg-color';
const $6ec31795911692d1$export$1758fda69688282e = '--ds--code--bg-color';
const $6ec31795911692d1$export$2cd00c745c539a1 = `data-ds--code--code-block`;

});

parcelRegister("8CJbG", function(module, exports) {

$parcel$export(module.exports, "getBaseTheme", () => $eac5fe855702cfc1$export$4464aa303b3e4fda);
$parcel$export(module.exports, "getColorPalette", () => $eac5fe855702cfc1$export$fe2a6478976e8b17);

var $8QpSo = parcelRequire("8QpSo");


var $kTHGn = parcelRequire("kTHGn");
// Hardcoded values have been used due to the current color palette not having any
// accessible color options for Teal and Yellow and +20A
const $eac5fe855702cfc1$var$T800 = '#067384';
const $eac5fe855702cfc1$var$Y1100 = '#7A5D1A';
const $eac5fe855702cfc1$export$4464aa303b3e4fda = ()=>({
        fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontFamilyItalic: `SFMono-MediumItalic, ${(0, $kTHGn.default)('font.family.code')}`,
        backgroundColor: `var(--ds-background-neutral, ${$829f609a65d26a98$export$9fdfb749e33cdf97})`,
        textColor: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        lineNumberColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$eece5f492e429f08})`,
        lineNumberBgColor: `var(--ds-background-neutral, ${$829f609a65d26a98$export$3e51e8f1440314ba})`
    });
const $eac5fe855702cfc1$export$fe2a6478976e8b17 = (0, $8QpSo.default)(()=>{
    return {
        highlightedLineBgColor: `var(--ds-background-neutral, ${$829f609a65d26a98$export$3e51e8f1440314ba})`,
        highlightedLineBorderColor: `var(--ds-border-focused, ${$829f609a65d26a98$export$215b7063051591f1})`,
        substringColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$eece5f492e429f08})`,
        keywordColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        attributeColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        selectorTagColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        docTagColor: `var(--ds-text-accent-yellow, ${$eac5fe855702cfc1$var$Y1100})`,
        nameColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        builtInColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        literalColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        bulletColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        codeColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        regexpColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        symbolColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        variableColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        templateVariableColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        linkColor: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$b48405b95304b5a1})`,
        selectorAttributeColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        selectorPseudoColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        typeColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        stringColor: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
        selectorIdColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        selectorClassColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        quoteColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        templateTagColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        titleColor: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$b48405b95304b5a1})`,
        sectionColor: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$b48405b95304b5a1})`,
        commentColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$eece5f492e429f08})`,
        metaKeywordColor: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
        metaColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$eece5f492e429f08})`,
        functionColor: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        numberColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        prologColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        cdataColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$eece5f492e429f08})`,
        punctuationColor: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        propertyColor: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$b48405b95304b5a1})`,
        constantColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        booleanColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        charColor: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        insertedColor: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
        deletedColor: `var(--ds-text-accent-red, ${$829f609a65d26a98$export$2837b5a1a71d5c02})`,
        operatorColor: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        atruleColor: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
        importantColor: `var(--ds-text-accent-yellow, ${$eac5fe855702cfc1$var$Y1100})`
    };
});
const $eac5fe855702cfc1$var$getTheme = ()=>({
        ...$eac5fe855702cfc1$export$4464aa303b3e4fda(),
        ...$eac5fe855702cfc1$export$fe2a6478976e8b17()
    });
var $eac5fe855702cfc1$export$2e2bcd8739ae039 = $eac5fe855702cfc1$var$getTheme;

});


parcelRegister("eCBnN", function(module, exports) {

$parcel$export(module.exports, "normalizeLanguage", () => $d00516a0f8207944$export$f38728011c178796);

var $8QpSo = parcelRequire("8QpSo");

var $8Y2ZY = parcelRequire("8Y2ZY");
const $d00516a0f8207944$export$f38728011c178796 = (0, $8QpSo.default)((language)=>{
    if (!language) return '';
    const match = (0, $8Y2ZY.SUPPORTED_LANGUAGES).find((val)=>{
        return val.name === language || val.alias.includes(language);
    });
    // Fallback to plain monospaced text if language passed but not supported
    return match ? match.value : 'text';
});

});
parcelRegister("8Y2ZY", function(module, exports) {

$parcel$export(module.exports, "SUPPORTED_LANGUAGES", () => $012a854d92762508$export$7c77c3a9bb93870d);
// The full list of languages that can potentially be supported is found in
// https://prismjs.com/#supported-languages

const $012a854d92762508$export$7c77c3a9bb93870d = [
    {
        name: 'PHP',
        alias: [
            'php',
            'php3',
            'php4',
            'php5'
        ],
        value: 'php'
    },
    {
        name: 'Java',
        alias: [
            'java'
        ],
        value: 'java'
    },
    {
        name: 'CSharp',
        alias: [
            'csharp',
            'c#'
        ],
        value: 'cs'
    },
    {
        name: 'Python',
        alias: [
            'python',
            'py'
        ],
        value: 'python'
    },
    {
        name: 'JavaScript',
        alias: [
            'javascript',
            'js'
        ],
        value: 'javascript'
    },
    {
        name: 'Html',
        alias: [
            'html'
        ],
        value: 'xml'
    },
    {
        name: 'C++',
        alias: [
            'c++',
            'cpp',
            'clike'
        ],
        value: 'cpp'
    },
    {
        name: 'Ruby',
        alias: [
            'ruby',
            'rb',
            'duby'
        ],
        value: 'ruby'
    },
    {
        name: 'Objective-C',
        alias: [
            'objective-c',
            'objectivec',
            'obj-c',
            'objc'
        ],
        value: 'objectivec'
    },
    {
        name: 'C',
        alias: [
            'c'
        ],
        value: 'cpp'
    },
    {
        name: 'Swift',
        alias: [
            'swift'
        ],
        value: 'swift'
    },
    {
        name: 'TeX',
        alias: [
            'tex',
            'latex'
        ],
        value: 'tex'
    },
    {
        name: 'Shell',
        alias: [
            'shell',
            'bash',
            'sh',
            'ksh',
            'zsh'
        ],
        value: 'shell'
    },
    {
        name: 'Scala',
        alias: [
            'scala'
        ],
        value: 'scala'
    },
    {
        name: 'Go',
        alias: [
            'go'
        ],
        value: 'go'
    },
    {
        name: 'ActionScript',
        alias: [
            'actionscript',
            'actionscript3',
            'as'
        ],
        value: 'actionscript'
    },
    {
        name: 'ColdFusion',
        alias: [
            'coldfusion'
        ],
        value: 'xml'
    },
    {
        name: 'JavaFX',
        alias: [
            'javafx',
            'jfx'
        ],
        value: 'java'
    },
    {
        name: 'VbNet',
        alias: [
            'vbnet',
            'vb.net',
            'vfp',
            'clipper',
            'xbase'
        ],
        value: 'vbnet'
    },
    {
        name: 'JSON',
        alias: [
            'json'
        ],
        value: 'json'
    },
    {
        name: 'MATLAB',
        alias: [
            'matlab'
        ],
        value: 'matlab'
    },
    {
        name: 'Groovy',
        alias: [
            'groovy'
        ],
        value: 'groovy'
    },
    {
        name: 'SQL',
        alias: [
            'sql',
            'postgresql',
            'postgres',
            'plpgsql',
            'psql',
            'postgresql-console',
            'postgres-console',
            'tsql',
            't-sql',
            'mysql',
            'sqlite'
        ],
        value: 'sql'
    },
    {
        name: 'R',
        alias: [
            'r'
        ],
        value: 'r'
    },
    {
        name: 'Perl',
        alias: [
            'perl',
            'pl'
        ],
        value: 'perl'
    },
    {
        name: 'Lua',
        alias: [
            'lua'
        ],
        value: 'lua'
    },
    {
        name: 'Pascal',
        alias: [
            'pas',
            'pascal',
            'objectpascal',
            'delphi'
        ],
        value: 'pascal'
    },
    {
        name: 'XML',
        alias: [
            'xml'
        ],
        value: 'xml'
    },
    {
        name: 'TypeScript',
        alias: [
            'typescript',
            'ts'
        ],
        value: 'typescript'
    },
    {
        name: 'CoffeeScript',
        alias: [
            'coffeescript',
            'coffee-script',
            'coffee'
        ],
        value: 'coffeescript'
    },
    {
        name: 'Haskell',
        alias: [
            'haskell',
            'hs'
        ],
        value: 'haskell'
    },
    {
        name: 'Puppet',
        alias: [
            'puppet'
        ],
        value: 'puppet'
    },
    {
        name: 'Arduino',
        alias: [
            'arduino'
        ],
        value: 'arduino'
    },
    {
        name: 'Fortran',
        alias: [
            'fortran'
        ],
        value: 'fortran'
    },
    {
        name: 'Erlang',
        alias: [
            'erlang',
            'erl'
        ],
        value: 'erlang'
    },
    {
        name: 'PowerShell',
        alias: [
            'powershell',
            'posh',
            'ps1',
            'psm1'
        ],
        value: 'powershell'
    },
    {
        name: 'Haxe',
        alias: [
            'haxe',
            'hx',
            'hxsl'
        ],
        value: 'haxe'
    },
    {
        name: 'Elixir',
        alias: [
            'elixir',
            'ex',
            'exs'
        ],
        value: 'elixir'
    },
    {
        name: 'Verilog',
        alias: [
            'verilog',
            'v'
        ],
        value: 'verilog'
    },
    {
        name: 'Rust',
        alias: [
            'rust'
        ],
        value: 'rust'
    },
    {
        name: 'VHDL',
        alias: [
            'vhdl'
        ],
        value: 'vhdl'
    },
    {
        name: 'Sass',
        alias: [
            'sass'
        ],
        value: 'less'
    },
    {
        name: 'OCaml',
        alias: [
            'ocaml'
        ],
        value: 'ocaml'
    },
    {
        name: 'Dart',
        alias: [
            'dart'
        ],
        value: 'dart'
    },
    {
        name: 'CSS',
        alias: [
            'css'
        ],
        value: 'css'
    },
    {
        name: 'reStructuredText',
        alias: [
            'restructuredtext',
            'rst',
            'rest'
        ],
        value: 'rest'
    },
    {
        name: 'Kotlin',
        alias: [
            'kotlin'
        ],
        value: 'kotlin'
    },
    {
        name: 'D',
        alias: [
            'd'
        ],
        value: 'd'
    },
    {
        name: 'Octave',
        alias: [
            'octave'
        ],
        value: 'matlab'
    },
    {
        name: 'QML',
        alias: [
            'qbs',
            'qml'
        ],
        value: 'qml'
    },
    {
        name: 'Prolog',
        alias: [
            'prolog'
        ],
        value: 'prolog'
    },
    {
        name: 'FoxPro',
        alias: [
            'foxpro',
            'purebasic'
        ],
        value: 'purebasic'
    },
    {
        name: 'Scheme',
        alias: [
            'scheme',
            'scm'
        ],
        value: 'scheme'
    },
    {
        name: 'CUDA',
        alias: [
            'cuda',
            'cu'
        ],
        value: 'cpp'
    },
    {
        name: 'Julia',
        alias: [
            'julia',
            'jl'
        ],
        value: 'julia'
    },
    {
        name: 'Racket',
        alias: [
            'racket',
            'rkt'
        ],
        value: 'lisp'
    },
    {
        name: 'Ada',
        alias: [
            'ada',
            'ada95',
            'ada2005'
        ],
        value: 'ada'
    },
    {
        name: 'Tcl',
        alias: [
            'tcl'
        ],
        value: 'tcl'
    },
    {
        name: 'Mathematica',
        alias: [
            'mathematica',
            'mma',
            'nb'
        ],
        value: 'mathematica'
    },
    {
        name: 'Autoit',
        alias: [
            'autoit'
        ],
        value: 'autoit'
    },
    {
        name: 'StandardML',
        alias: [
            'standardmL',
            'sml',
            'standardml'
        ],
        value: 'sml'
    },
    {
        name: 'Objective-J',
        alias: [
            'objective-j',
            'objectivej',
            'obj-j',
            'objj'
        ],
        value: 'objectivec'
    },
    {
        name: 'Smalltalk',
        alias: [
            'smalltalk',
            'squeak',
            'st'
        ],
        value: 'smalltalk'
    },
    {
        name: 'Vala',
        alias: [
            'vala',
            'vapi'
        ],
        value: 'vala'
    },
    {
        name: 'ABAP',
        alias: [
            'abap'
        ],
        value: 'sql'
    },
    {
        name: 'LiveScript',
        alias: [
            'livescript',
            'live-script'
        ],
        value: 'livescript'
    },
    {
        name: 'XQuery',
        alias: [
            'xquery',
            'xqy',
            'xq',
            'xql',
            'xqm'
        ],
        value: 'xquery'
    },
    {
        name: 'PlainText',
        alias: [
            'text',
            'plaintext'
        ],
        value: 'text'
    },
    {
        name: 'Yaml',
        alias: [
            'yaml',
            'yml'
        ],
        value: 'yaml'
    },
    {
        name: 'GraphQL',
        alias: [
            'graphql'
        ],
        value: 'graphql'
    },
    {
        name: 'AppleScript',
        alias: [
            'applescript'
        ],
        value: 'applescript'
    },
    {
        name: 'Clojure',
        alias: [
            'clojure'
        ],
        value: 'clojure'
    },
    {
        name: 'Diff',
        alias: [
            'diff'
        ],
        value: 'diff'
    },
    {
        name: 'VisualBasic',
        alias: [
            'visualbasic'
        ],
        value: 'visual-basic'
    },
    {
        name: 'JSX',
        alias: [
            'jsx'
        ],
        value: 'jsx'
    },
    {
        name: 'TSX',
        alias: [
            'tsx'
        ],
        value: 'tsx'
    },
    {
        name: 'SplunkSPL',
        alias: [
            'splunk-spl'
        ],
        value: 'splunk-spl'
    },
    {
        name: 'Dockerfile',
        alias: [
            'docker',
            'dockerfile'
        ],
        value: 'dockerfile'
    },
    {
        name: 'HCL',
        alias: [
            'hcl',
            'terraform'
        ],
        value: 'hcl'
    },
    {
        name: 'NGINX',
        alias: [
            'nginx'
        ],
        value: 'nginx'
    },
    {
        name: 'Protocol Buffers',
        alias: [
            'protobuf',
            'proto'
        ],
        value: 'protobuf'
    }
];

});


parcelRegister("9Xp6L", function(module, exports) {

$parcel$export(module.exports, "default", () => $e296c4d390ff4a21$export$2e2bcd8739ae039);
/**
 * Original library: https://github.com/react-syntax-highlighter/react-syntax-highlighter
 * All modifications by Atlassian
 */ /**
 * MIT License
 *
 * Copyright (c) 2019 Conor Hastings
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ /**
 * __Syntax Highlighter__
 *
 * A syntax highlighter based on top of [refractor](https://github.com/wooorm/refractor).
 * @atlaskit/code uses this under-the-hood, but it is not intended for public consumption.
 * You should be using @atlaskit/code directly.
 */ 
var $c8FD2 = parcelRequire("c8FD2");
var $e296c4d390ff4a21$export$2e2bcd8739ae039 = (0, $c8FD2.default);

});
parcelRegister("c8FD2", function(module, exports) {

$parcel$export(module.exports, "default", () => $64df4f4e00539958$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lp89O = parcelRequire("lp89O");
// Uses the loader method of async bundling
// Instantiates highligher as a singleton, loading refractor only once per page (refractor/prism are singleton modules)
const $64df4f4e00539958$var$generator = (options)=>{
    const { loader: loader } = options;
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class AsyncHighlighter extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
        static{
            this.astGenerator = null;
        }
        static{
            this.highlightInstance = (0, $lp89O.default);
        }
        // Useful in tests
        static preload() {
            return AsyncHighlighter.loadAstGenerator();
        }
        static loadAstGenerator() {
            AsyncHighlighter.astGeneratorPromise = loader().then((astGenerator)=>{
                AsyncHighlighter.astGenerator = astGenerator;
                return astGenerator;
            });
            return AsyncHighlighter.astGeneratorPromise;
        }
        componentDidMount() {
            if (!AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.loadAstGenerator();
            if (!AsyncHighlighter.astGenerator && AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.astGeneratorPromise.then(()=>{
                this.forceUpdate();
            });
        }
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AsyncHighlighter.highlightInstance, {
                ...this.props,
                astGenerator: AsyncHighlighter.astGenerator
            });
        }
    }
    return AsyncHighlighter;
};

const $64df4f4e00539958$var$asyncGenerator = $64df4f4e00539958$var$generator({
    loader: ()=>(parcelRequire("7t3wc")).then((module)=>{
            // Webpack 3 returns module.exports as default as module, but webpack 4 returns module.exports as module.default
            return module.default || module;
        })
});
var $64df4f4e00539958$export$2e2bcd8739ae039 = $64df4f4e00539958$var$asyncGenerator;

});
parcelRegister("lp89O", function(module, exports) {

$parcel$export(module.exports, "default", () => $a813ccd1d5fae376$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iQkqt = parcelRequire("iQkqt");

var $jVB7m = parcelRequire("jVB7m");
/**
 * Takes in a code string and (in the default behaviour):
 * - Uses refractor to turn it into a tree structure with highlighting metadata
 * - Collapses this tree into lines for a renderer
 * - Passes these lines to a React renderer
 *
 * In future, the final step could have a custom renderer.
 */ const $a813ccd1d5fae376$var$Highlight = /*#__PURE__*/ (0, $5uXOq.memo)(function Highlight({ language: language = 'text', testId: testId, text: text = '', codeTagProps: codeTagProps = {
    className: `language-${language}`
}, showLineNumbers: showLineNumbers = false, firstLineNumber: firstLineNumber = 1, shouldCreateParentElementForLines: shouldCreateParentElementForLines = false, shouldWrapLongLines: shouldWrapLongLines = false, lineProps: lineProps = {}, codeBidiWarnings: codeBidiWarnings, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled, astGenerator: astGenerator = null, ...rest }) {
    // TODO maybe we call this code or text everywhere; for now we match the API in
    // @atlaskit/codeblock
    const code = text;
    const generatorClassName = 'prismjs';
    const containerProps = {
        ...rest,
        'data-testid': testId,
        className: rest.className ? `${generatorClassName} ${rest.className}` : generatorClassName
    };
    if (shouldWrapLongLines) codeTagProps.style = {
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word'
    };
    else codeTagProps.style = {
        whiteSpace: 'pre'
    };
    const codeBidiWarningConfig = {
        codeBidiWarnings: codeBidiWarnings,
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
    };
    // Tree + logic into rows
    const rows = (0, $iQkqt.default)({
        astGenerator: astGenerator,
        code: code,
        language: language,
        shouldCreateParentElementForLines: shouldCreateParentElementForLines || !!shouldWrapLongLines,
        lineProps: lineProps,
        showLineNumbers: showLineNumbers,
        firstLineNumber: firstLineNumber
    });
    // Rows + logic into a renderer
    return (0, $jVB7m.default)({
        containerProps: containerProps,
        codeTagProps: codeTagProps,
        rows: rows,
        codeBidiWarningConfig: codeBidiWarningConfig
    });
});
var $a813ccd1d5fae376$export$2e2bcd8739ae039 = $a813ccd1d5fae376$var$Highlight;

});
parcelRegister("iQkqt", function(module, exports) {

$parcel$export(module.exports, "default", () => $55dc1424d34091d6$export$2e2bcd8739ae039);

var $eJUOt = parcelRequire("eJUOt");

var $eTMIA = parcelRequire("eTMIA");

var $8bliZ = parcelRequire("8bliZ");

var $g6MVu = parcelRequire("g6MVu");
const $55dc1424d34091d6$var$newLineRegex = /\n/g;
function $55dc1424d34091d6$var$getNewLines(str) {
    return str.match($55dc1424d34091d6$var$newLineRegex);
}
function $55dc1424d34091d6$export$2e2bcd8739ae039({ astGenerator: astGenerator, code: code, language: language, shouldCreateParentElementForLines: shouldCreateParentElementForLines, lineProps: lineProps, showLineNumbers: showLineNumbers, firstLineNumber: firstLineNumber = 1 }) {
    const codeTree = (0, $g6MVu.default)(language, code, astGenerator);
    const startingLineNumber = firstLineNumber > 0 ? firstLineNumber : 1;
    const createLine = (0, $eJUOt.default)(lineProps, shouldCreateParentElementForLines, showLineNumbers);
    const newTree = [];
    let lastLineBreakIndex = -1;
    let index = 0;
    // Seems odd we flatten the tree immediately - what work could we do on it more performantly than on the lines?
    const tree = (0, $8bliZ.default)(codeTree);
    while(index < tree.length){
        const testNode = tree[index];
        if (testNode.type === 'text') {
            index++;
            continue;
        }
        const node = testNode;
        const firstChildNode = node.children[0];
        if (firstChildNode.type === 'text') {
            const { value: value } = firstChildNode;
            const newLines = $55dc1424d34091d6$var$getNewLines(value);
            if (newLines) {
                const splitValue = value.split('\n');
                splitValue.forEach((text, i)=>{
                    const lineNumber = newTree.length + startingLineNumber;
                    const newChild = {
                        type: 'text',
                        value: `${text}\n`
                    };
                    // if it's the first line
                    if (i === 0) {
                        const children = tree.slice(lastLineBreakIndex + 1, index).concat((0, $eTMIA.default)({
                            children: [
                                newChild
                            ],
                            className: node.properties.className,
                            lineNumber: lineNumber
                        }));
                        const line = createLine(children, lineNumber);
                        newTree.push(line);
                    // if it's the last line
                    } else if (i === splitValue.length - 1) {
                        const nextNode = tree[index + 1];
                        const stringChild = nextNode && nextNode.children && nextNode.children[0];
                        // Similar to newChild above, but no newline
                        const lastLineInPreviousSpan = {
                            type: 'text',
                            value: `${text}`
                        };
                        if (stringChild) {
                            const newElem = (0, $eTMIA.default)({
                                children: [
                                    lastLineInPreviousSpan
                                ],
                                className: node.properties.className,
                                lineNumber: lineNumber
                            });
                            tree.splice(index + 1, 0, newElem);
                        } else {
                            const children = [
                                lastLineInPreviousSpan
                            ];
                            const line = createLine(children, lineNumber, node.properties.className);
                            newTree.push(line);
                        }
                    // if it's neither the first nor the last line
                    } else {
                        const children = [
                            newChild
                        ];
                        const line = createLine(children, lineNumber, node.properties.className);
                        newTree.push(line);
                    }
                });
                lastLineBreakIndex = index;
            }
        }
        index++;
    }
    if (lastLineBreakIndex !== tree.length - 1) {
        const children = tree.slice(lastLineBreakIndex + 1, tree.length);
        if (children && children.length) {
            const lineNumber = newTree.length + startingLineNumber;
            const line = createLine(children, lineNumber);
            newTree.push(line);
        }
    }
    if (shouldCreateParentElementForLines) return newTree;
    // If shouldCreateParentElementForLines was off, we still have a tree structure we need to flatten
    // We have (RefractorNode | RefractorNode[])[] but need RefractorNode[]
    // This seems like a code smell to review
    return newTree.flat(1);
}

});
parcelRegister("eJUOt", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9ccdbf71436a137$export$2e2bcd8739ae039);

var $eTMIA = parcelRequire("eTMIA");

var $5FOwT = parcelRequire("5FOwT");
function $b9ccdbf71436a137$var$createLineGenerator(lineProps, shouldCreateParentElementForLines, showLineNumbers) {
    return (children, lineNumber, className = [])=>{
        // Needed for more complex line creation
        if (shouldCreateParentElementForLines || className.length > 0) return (0, $eTMIA.default)({
            children: children,
            lineNumber: lineNumber,
            showLineNumbers: showLineNumbers,
            lineProps: lineProps,
            className: className
        });
        else {
            // Simple line creation without the bells and whistles
            if (showLineNumbers && lineNumber) children.unshift((0, $5FOwT.default)(lineNumber));
            return children;
        }
    };
}
var $b9ccdbf71436a137$export$2e2bcd8739ae039 = $b9ccdbf71436a137$var$createLineGenerator;

});
parcelRegister("eTMIA", function(module, exports) {

$parcel$export(module.exports, "default", () => $6df5b208b9d23752$export$2e2bcd8739ae039);

var $5FOwT = parcelRequire("5FOwT");
function $6df5b208b9d23752$export$2e2bcd8739ae039({ children: children, lineNumber: lineNumber, showLineNumbers: showLineNumbers, lineProps: lineProps = {}, className: className = [] }) {
    const propsPassedInFromCodeBlock = typeof lineProps === 'function' ? lineProps(lineNumber) : lineProps;
    const properties = {
        ...propsPassedInFromCodeBlock,
        className: className
    };
    let currentChildren = children;
    if (lineNumber && showLineNumbers) {
        // When syntax highlighting is NOT turned on, the entire LOC is just a single
        // child. We can then happily create the line number and the LOC as siblings...
        if (currentChildren.length === 1) currentChildren = [
            (0, $5FOwT.default)(lineNumber),
            ...currentChildren
        ];
        else // ... However, when syntax highlighting IS on, a span is created for each
        // tokenised node in the AST (eg. <span>import</span><span>React</span>).
        // When shouldWrapLongLines is true, the row becomes `display: flex` and
        // forces all its children to be equal height. This can be a source of
        // visual bugs where a LOC is broken up weirdly into segments.
        //
        //  +---------------------------------------+
        //  | row                                   |
        //  |  +----+ +-------+ +--------+ +------+ |
        //  |  |line| |key    | |keywords| |key   | |
        //  |  |no. | |word   | |        | |word  | |
        //  |  |    | |       | |        | |      | |
        //  |  +----+ +-------+ +--------+ +------+ |
        //  +---------------------------------------+
        //
        // Nesting the children one layer deeper (i.e. creating an extra span)
        // ensures that the line number and the ENTIRE line of code are aligned by
        // the parent flexbox (the row).
        //
        //  +---------------------------------------------+
        //  | row                                         |
        //  | +----+  +--------------------------------+  |
        //  | |line|  | extra span we are creating     |  |
        //  | |no. |  |  +-------+ +--------+ +------+ |  |
        //  | |    |  |  |key    | |keywords| |key   | |  |
        //  | |    |  |  |word   | |        | |word  | |  |
        //  | |    |  |  |       | |        | |      | |  |
        //  | |    |  |  +-------+ +--------+ +------+ |  |
        //  | +----+  +--------------------------------+  |
        //  +---------------------------------------------+
        //
        currentChildren = [
            (0, $5FOwT.default)(lineNumber),
            {
                type: 'element',
                tagName: 'span',
                properties: {
                    className: []
                },
                children: currentChildren
            }
        ];
    }
    return {
        type: 'element',
        tagName: 'span',
        properties: properties,
        children: currentChildren
    };
}

});
parcelRegister("5FOwT", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6257c3f70e94feb$export$2e2bcd8739ae039);
function $c6257c3f70e94feb$export$2e2bcd8739ae039(lineNumber) {
    return {
        type: 'element',
        tagName: 'span',
        properties: {
            key: `line-number--${lineNumber}`,
            className: [
                'comment',
                'linenumber',
                'ds-line-number'
            ],
            // We're placing the lineNumber in a data-attr on an empty span (hence the
            // empty children array below). This allows CodeBlock to use CSS to
            // generate the content in a pseudo-element, which is a fix for a bug
            // where line numbers were being copied (CSS content can't be copied)
            // https://product-fabric.atlassian.net/browse/DSP-2729
            'data-ds--line-number': lineNumber
        },
        children: []
    };
}

});



parcelRegister("8bliZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9f6debfd276481a$export$2e2bcd8739ae039);

var $eTMIA = parcelRequire("eTMIA");
function $c9f6debfd276481a$export$2e2bcd8739ae039(tree, offset = 0, className = []) {
    let newTree = [];
    for(let i = 0; i < tree.length; i++){
        const node = tree[i];
        if (node.type === 'text') newTree.push((0, $eTMIA.default)({
            children: [
                node
            ],
            lineNumber: offset,
            className: className
        }));
        else if (node.children) {
            const classNames = className.concat(node.properties.className || []);
            $c9f6debfd276481a$export$2e2bcd8739ae039(node.children, offset + 1, classNames).forEach((i)=>newTree.push(i));
        }
    }
    return newTree;
}

});

parcelRegister("g6MVu", function(module, exports) {

$parcel$export(module.exports, "default", () => $8213b6c690eefe35$export$2e2bcd8739ae039);
function $8213b6c690eefe35$export$2e2bcd8739ae039(language, code, astGenerator) {
    if (language === 'text' || !astGenerator) return [
        {
            type: 'text',
            value: code
        }
    ];
    try {
        return astGenerator.highlight(code, language);
    } catch (e) {
        return [
            {
                type: 'text',
                value: code
            }
        ];
    }
}

});


parcelRegister("jVB7m", function(module, exports) {

$parcel$export(module.exports, "default", () => $b98c01cbb865d4c1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fBvqm = parcelRequire("fBvqm");
function $b98c01cbb865d4c1$export$2e2bcd8739ae039({ containerProps: containerProps, codeTagProps: codeTagProps, rows: rows, codeBidiWarningConfig: codeBidiWarningConfig }) {
    const renderedRows = rows.map((node, i)=>(0, $fBvqm.default)({
            node: node,
            codeBidiWarningConfig: codeBidiWarningConfig,
            key: `code-segment${i}`
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", containerProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("code", codeTagProps, renderedRows));
}

});
parcelRegister("fBvqm", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fdda3a2c4411588$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lrHA4 = parcelRequire("lrHA4");

var $31cgS = parcelRequire("31cgS");

var $d3zI6 = parcelRequire("d3zI6");
function $2fdda3a2c4411588$var$createClassNameString(classNames) {
    return classNames ? classNames.join(' ') : '';
}
function $2fdda3a2c4411588$export$2e2bcd8739ae039({ node: node, codeBidiWarningConfig: codeBidiWarningConfig, key: key }) {
    if (node.type === 'text') {
        const { value: value } = node;
        // occasionally a numeric value is passed when the type is text
        const textValue = `${value}`;
        if (codeBidiWarningConfig.codeBidiWarnings) {
            const decorated = (0, $31cgS.default)(textValue, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lrHA4.default), {
                    bidiCharacter: bidiCharacter,
                    key: index,
                    label: codeBidiWarningConfig.codeBidiWarningLabel,
                    tooltipEnabled: codeBidiWarningConfig.codeBidiWarningTooltipEnabled
                }));
            return decorated;
        }
        return textValue;
    } else {
        const { properties: properties, tagName: tagName } = node;
        const childrenCreator = (0, $d3zI6.default)(codeBidiWarningConfig);
        const props = {
            ...properties,
            className: $2fdda3a2c4411588$var$createClassNameString(properties.className)
        };
        const children = childrenCreator(node.children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(tagName, {
            key: key,
            ...props
        }, children);
    }
}

});
parcelRegister("lrHA4", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e6443bd1dfeaac7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $abxiq = parcelRequire("abxiq");
function $2e6443bd1dfeaac7$export$2e2bcd8739ae039({ testId: testId, bidiCharacter: bidiCharacter, skipChildren: skipChildren, tooltipEnabled: tooltipEnabled, label: label = 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.' }) {
    if (tooltipEnabled) return(// Following patches, this should be updated to use the render props signature which will provide aria attributes.
    // Note: this should be tested, as initial testing did not see attributes work with current tooltip implementation.
    // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: label,
        tag: $2e6443bd1dfeaac7$var$CustomizedTagWithRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $abxiq.Decorator), {
        testId: testId,
        bidiCharacter: bidiCharacter
    }, skipChildren ? null : bidiCharacter)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $abxiq.Decorator), {
        testId: testId,
        bidiCharacter: bidiCharacter
    }, skipChildren ? null : bidiCharacter);
}
const $2e6443bd1dfeaac7$var$CustomizedTagWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        ...rest,
        ref: ref
    }, children);
});

});
parcelRegister("abxiq", function(module, exports) {

$parcel$export(module.exports, "Decorator", () => $59fdc1b7b0ae96c9$export$a592b67c93d52467);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");


var $jldZL = parcelRequire("jldZL");
const $59fdc1b7b0ae96c9$var$decoration = /*#__PURE__*/ (0, $f8Sb3.css)({
    // Required as otherwise the following bidi characters cause the span
    // to not receive hover events.
    //
    // U+2066 LEFT-TO-RIGHT ISOLATE (when using pseudo element before)
    // U+202E RIGHT-TO-LEFT OVERRIDE' (when using pseudo element after)
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':before': {
        display: 'inline-flex',
        padding: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'row',
        background: `var(--ds-background-warning, ${(0, $829f609a65d26a98$export$41060a744ab0b7ae)})`,
        color: "var(--ds-text-warning, #7F5F01)",
        content: '"<"attr(data-bidi-character-code)">"',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        fontStyle: 'normal',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: '18px',
        /**
     * Ensures the decoration receives pointer events when it occurs with
     * an ancestor that disables them.
     */ pointerEvents: 'auto'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover:before': {
        background: `var(--ds-background-warning-hovered, ${(0, $829f609a65d26a98$export$41060a744ab0b7ae)})`,
        color: "var(--ds-text-warning, #533F04)"
    }
});
function $59fdc1b7b0ae96c9$export$a592b67c93d52467({ bidiCharacter: bidiCharacter, children: children, testId: testId }) {
    const bidiCharacterCode = $59fdc1b7b0ae96c9$var$getBidiCharacterCode(bidiCharacter);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $59fdc1b7b0ae96c9$var$decoration,
        "data-testid": testId,
        "data-bidi-character-code": bidiCharacterCode,
        // This is set to true so that the content is not read out by
        // screen readers as the content includes angle brackets for
        // visual decoration purposes.
        // We use a visually hidden `mark` element below for screen readers
        "aria-hidden": "true"
    }, children), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jldZL.default), {
        testId: testId && `${testId}--visually-hidden`
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("mark", null, bidiCharacterCode)));
}
function $59fdc1b7b0ae96c9$var$getBidiCharacterCode(bidiCharacter) {
    const bidiCharacterCode = bidiCharacter.codePointAt(0)?.toString(16);
    return `U+${bidiCharacterCode}`;
}

});


parcelRegister("31cgS", function(module, exports) {

$parcel$export(module.exports, "default", () => $e16562bd8c2aca9b$export$2e2bcd8739ae039);
const $e16562bd8c2aca9b$export$ecb256e6a1f5ee7e = /[\u202A-\u202E\u2066-\u2069]/g;
function $e16562bd8c2aca9b$export$2e2bcd8739ae039(originalText, decorate) {
    const matches = [
        ...originalText.matchAll($e16562bd8c2aca9b$export$ecb256e6a1f5ee7e)
    ];
    if (matches.length === 0) // No matches encountered, so we return the originalText value
    return originalText;
    let children = [];
    let mappedTo = 0;
    for (const match of matches){
        if (mappedTo !== match.index) // There were unmatched characters prior to this match which haven't been
        // mapped to the children.
        // Add them as plain text.
        children.push(originalText.substring(mappedTo, match.index));
        children.push(decorate({
            bidiCharacter: match[0],
            index: match.index
        }));
        // While index is guaranteed to be present, it needs to be asserted due
        // to a limitation of typescripts regex handling
        //
        // https://github.com/microsoft/TypeScript/issues/36788
        // Decorate bidi character
        mappedTo = match.index + match[0].length;
    }
    if (mappedTo !== originalText.length) // There is text following the final match, which needs to be mapped
    // to the children.
    // Added as plain text.
    children.push(originalText.substring(mappedTo, originalText.length));
    // return the mapped children with decorated bidi characters
    return children;
}

});

parcelRegister("d3zI6", function(module, exports) {

$parcel$export(module.exports, "default", () => $dcbc4a00f80b5d8f$export$2e2bcd8739ae039);

var $fBvqm = parcelRequire("fBvqm");
function $dcbc4a00f80b5d8f$export$2e2bcd8739ae039(codeBidiWarningConfig) {
    let childrenCount = 0;
    return (children)=>{
        childrenCount += 1;
        return children.map((child, i)=>(0, $fBvqm.default)({
                node: child,
                codeBidiWarningConfig: codeBidiWarningConfig,
                key: `code-segment-${childrenCount}-${i}`
            }));
    };
}

});




parcelRegister("7t3wc", function(module, exports) {

let $56fdf880767119f7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $56fdf880767119f7$var$load("as9qs").then(()=>parcelRequire('5zvIl'));

});




parcelRegister("irzxp", function(module, exports) {

$parcel$export(module.exports, "CopyAction", () => $64e12044af483692$export$958df07cbf9735fc);
$parcel$export(module.exports, "ActionContainer", () => $64e12044af483692$export$37ab3bdebc286ca);

var $5uXOq = parcelRequire("5uXOq");

var $ldJSL = parcelRequire("ldJSL");

var $3Fq5M = parcelRequire("3Fq5M");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $8zOmE = parcelRequire("8zOmE");

var $fEogx = parcelRequire("fEogx");
const $64e12044af483692$export$2ce9877c9c1aa16 = {
    PROMPT: 'Copy',
    SUCCESS: 'Copied!',
    FAILURE: 'Copy to clipboard failed'
};
const $64e12044af483692$export$958df07cbf9735fc = ({ source: source, actionSubjectId: actionSubjectId })=>{
    const [tooltipMessage, setTooltipMessage] = (0, $5uXOq.useState)($64e12044af483692$export$2ce9877c9c1aa16.PROMPT);
    const handleSuccess = (0, $5uXOq.useCallback)(()=>{
        setTooltipMessage($64e12044af483692$export$2ce9877c9c1aa16.SUCCESS);
    }, [
        setTooltipMessage
    ]);
    const handleError = (0, $5uXOq.useCallback)(()=>{
        setTooltipMessage($64e12044af483692$export$2ce9877c9c1aa16.FAILURE);
    }, [
        setTooltipMessage
    ]);
    const writeToClipboard = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
        actionSubjectId && (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'clicked button', actionSubjectId);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        navigator.clipboard.writeText(source).then(handleSuccess, handleError);
    }, [
        source,
        handleSuccess,
        handleError,
        actionSubjectId
    ]);
    const resetMessage = (0, $5uXOq.useCallback)(()=>{
        setTooltipMessage($64e12044af483692$export$2ce9877c9c1aa16.PROMPT);
    }, [
        setTooltipMessage
    ]);
    function shouldRender() {
        if (typeof document !== 'undefined') // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        return Boolean(navigator?.clipboard?.writeText);
    }
    return shouldRender() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fEogx.Action), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3Fq5M))),
        label: tooltipMessage,
        onClick: writeToClipboard,
        onMouseOver: resetMessage,
        onFocus: resetMessage,
        "aria-live": "assertive",
        "aria-atomic": "true",
        name: "Copy"
    }) : null;
};
const $64e12044af483692$var$stopPropagation = (event)=>event.stopPropagation();
const $64e12044af483692$export$37ab3bdebc286ca = ({ children: children })=>/**
	 * This element uses an `onMouseDown` to block event propagation
	 * to its parent but is not itself interactive.
	 */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $64e12044af483692$var$absolutePositionWrapperStyles,
        onMouseDown: $64e12044af483692$var$stopPropagation
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ldJSL.default), {
        label: "actions"
    }, children));
const $64e12044af483692$var$absolutePositionWrapperStyles = (0, $8CUq3.xcss)({
    position: 'absolute',
    top: 'space.0',
    right: 'space.0',
    padding: 'space.050',
    zIndex: 'flag'
});

});
parcelRegister("fEogx", function(module, exports) {

$parcel$export(module.exports, "Action", () => $e6da05ade6347218$export$e19cd5f9376f8cee);

var $5uXOq = parcelRequire("5uXOq");

var $42CjB = parcelRequire("42CjB");

var $3bDjY = parcelRequire("3bDjY");
const $e6da05ade6347218$export$e19cd5f9376f8cee = ({ icon: icon, label: label, tooltipLabel: tooltipLabel, isLoading: isLoading, ...buttonProps })=>{
    const updateTooltip = (0, $5uXOq.useRef)();
    (0, $5uXOq.useLayoutEffect)(()=>{
        updateTooltip.current?.();
    }, [
        tooltipLabel,
        label
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: ({ update: update })=>{
            updateTooltip.current = update;
            return tooltipLabel || label;
        },
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        isLoading: isLoading,
        appearance: "subtle",
        icon: icon,
        label: label,
        spacing: "compact",
        ...buttonProps
    }));
};

});




parcelRegister("bTyOW", function(module, exports) {

$parcel$export(module.exports, "default", () => $5073396748f92b4e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "viewBox", () => $5073396748f92b4e$export$a179c88182cb9d56);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("5I4tL")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("h8kvT")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = m5v37k2r2scm86wgmrk6
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/m5v37k2r2scm86wgmrk6

var $dCLgq = parcelRequire("dCLgq");

var $h8kvT = parcelRequire("h8kvT");

var $5I4tL = parcelRequire("5I4tL");
const $5073396748f92b4e$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($5I4tL)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($h8kvT))
});
var $5073396748f92b4e$export$2e2bcd8739ae039 = $5073396748f92b4e$var$Illustration;
// for advanced use only
const $5073396748f92b4e$export$a179c88182cb9d56 = [
    0,
    0,
    164,
    218
];

});
parcelRegister("h8kvT", function(module, exports) {
module.exports = new URL("error-darkmode.9dba78cd.svg", import.meta.url).toString();

});

parcelRegister("5I4tL", function(module, exports) {
module.exports = new URL("error.b7de7f77.svg", import.meta.url).toString();

});


parcelRegister("fC09Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb376757c4acc5ab$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("3pGSh")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("3pGSh")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 53grvvhrxck68z6q4s7ztq4p
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/53grvvhrxck68z6q4s7ztq4p

var $dCLgq = parcelRequire("dCLgq");

var $3pGSh = parcelRequire("3pGSh");
const $bb376757c4acc5ab$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($3pGSh)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($3pGSh))
});
var $bb376757c4acc5ab$export$2e2bcd8739ae039 = $bb376757c4acc5ab$var$Illustration;
// for advanced use only
const $bb376757c4acc5ab$export$a179c88182cb9d56 = [
    0,
    0,
    167,
    226
];

});
parcelRegister("3pGSh", function(module, exports) {
module.exports = new URL("search-error.a6df7c97.svg", import.meta.url).toString();

});


parcelRegister("4AdE6", function(module, exports) {

$parcel$export(module.exports, "default", () => $135a9e70a6f11b3e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $135a9e70a6f11b3e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    notFoundDocumentTitleJsm: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-document-title-jsm",
        "defaultMessage": "Project not found - Service project"
    },
    notFoundTitle: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-title",
        "defaultMessage": "This project isn't available"
    },
    notFoundDescription: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-description",
        "defaultMessage": "It may have been deleted or your permissions may have changed"
    },
    notFoundAction: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-action",
        "defaultMessage": "View a list of all projects"
    },
    genericDocumentTitleJsm: {
        "id": "servicedesk-spa-commons.common.utils.errors.generic-document-title-jsm",
        "defaultMessage": "Error - Service project"
    },
    genericErrorTitle: {
        "id": "servicedesk-spa-commons.common.utils.errors.generic-error-title",
        "defaultMessage": "An error occurred"
    },
    genericErrorDescription: {
        "id": "servicedesk-spa-commons.common.utils.errors.generic-error-description",
        "defaultMessage": "An error occurred while loading this page"
    },
    serviceHubNotFoundDocumentTitleJsm: {
        "id": "servicedesk-spa-commons.common.utils.errors.servicehub-not-found-document-title-jsm",
        "defaultMessage": "Service hub not found - Service project"
    },
    serviceHubNotFoundTitle: {
        "id": "servicedesk-spa-commons.common.utils.errors.servicehub-not-found-title",
        "defaultMessage": "This service hub isn't available"
    },
    serviceHubNotFoundDescription: {
        "id": "servicedesk-spa-commons.common.utils.errors.servicehub-not-found-description",
        "defaultMessage": "It may have been deleted or your permissions may have changed"
    },
    serviceHubNotFoundAction: {
        "id": "servicedesk-spa-commons.common.utils.errors.servicehub-not-found-action",
        "defaultMessage": "View a list of all service hubs"
    }
});

});





parcelRegister("ivzw9", function(module, exports) {

$parcel$export(module.exports, "InsightAppBaseV2", () => $24af6a5656140d82$export$c9b1085d6a7138ac);

var $5uXOq = parcelRequire("5uXOq");

var $85JfV = parcelRequire("85JfV");

var $beRD7 = parcelRequire("beRD7");

var $ktP1V = parcelRequire("ktP1V");

var $7DxXA = parcelRequire("7DxXA");

var $ahEft = parcelRequire("ahEft");

var $4S0uJ = parcelRequire("4S0uJ");

var $9OXo1 = parcelRequire("9OXo1");

var $6u2pX = parcelRequire("6u2pX");
const $24af6a5656140d82$export$c9b1085d6a7138ac = ({ children: children })=>{
    const { workspaceId: workspaceId, error: error, loading: loading } = (0, $7DxXA.useWorkspaceContext)();
    const hasInsightPermission = (0, $7DxXA.useInsightVisibility)();
    const tenantContext = (0, $9OXo1.useTenantContext)();
    if (!(0, $ktP1V.isCMDBEnabledInEnvironment)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $beRD7.NotFoundErrorPageAsync), null);
    if (!(0, $ahEft.isLicensedPremiumUser)(tenantContext)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $85JfV.AsyncCmdbUpsellPage), null);
    if (workspaceId == null) return !loading && !error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $beRD7.NotFoundErrorPageAsync), null) : null;
    if (hasInsightPermission === false || error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $beRD7.GenericPermissionErrorPageAsync), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4S0uJ.PageStyle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6u2pX.CmdbArchitectureAnalyticsData), null, children({
        workspaceId: workspaceId
    })));
};

});
parcelRegister("4S0uJ", function(module, exports) {

$parcel$export(module.exports, "PageStyle", () => $7307247c9fc02c84$export$c59987a647e9a55);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $bAkIV = parcelRequire("bAkIV");
const $7307247c9fc02c84$export$c59987a647e9a55 = ({ Page: Page = (0, $bAkIV.default), children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7307247c9fc02c84$var$JSDSpaPageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Page, null, children));
var $7307247c9fc02c84$export$2e2bcd8739ae039 = $7307247c9fc02c84$export$c59987a647e9a55;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7307247c9fc02c84$var$JSDSpaPageWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1jfw _otyridpf _18u01jfw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bAkIV", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e769a1b108c1b03$export$2e2bcd8739ae039);

var $cE92Q = parcelRequire("cE92Q");

var $bJcWY = parcelRequire("bJcWY");

var $aZdfU = parcelRequire("aZdfU");
var // Page already has a jsdoc where it is defined
// eslint-disable-next-line @repo/internal/react/require-jsdoc
$5e769a1b108c1b03$export$2e2bcd8739ae039 = (0, $cE92Q.default);

});
parcelRegister("cE92Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f4d1a89146de6ed$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $f1WIN = parcelRequire("f1WIN");
function $2f4d1a89146de6ed$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2f4d1a89146de6ed$var$bannerStyles = {
    name: "4oew4k",
    styles: "width:100%;position:fixed"
};
const $2f4d1a89146de6ed$var$bannerContainerStyles = {
    name: "1x3pv69",
    styles: "width:100%;position:relative;z-index:3;flex:1 0 auto;transition:height 0.25s ease-in-out"
};
const $2f4d1a89146de6ed$var$pageContentStyles = {
    name: "15n167b",
    styles: "min-width:0;position:relative;z-index:1;flex:1 1 auto"
};
const $2f4d1a89146de6ed$var$wrapperStyles = {
    name: "m5v4sl",
    styles: "display:flex;width:100%;min-height:100%;flex-direction:column"
};
const $2f4d1a89146de6ed$var$mainContainerStyles = {
    name: "1cete8c",
    styles: "display:flex;flex:1 1 auto"
};
const $2f4d1a89146de6ed$var$navigationStyles = {
    name: "wrqbg1",
    styles: "position:relative;z-index:2"
};
/**
 * __Page__
 *
 * Used to build page layouts.
 *
 * Has built in support for positioning [banners](https://atlassian.design/components/banner/examples)
 * and the deprecated `@atlaskit/navigation`.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $2f4d1a89146de6ed$var$Page = ({ isBannerOpen: isBannerOpen = false, bannerHeight: bannerHeight = (0, $f1WIN.defaultBannerHeight), banner: banner, navigation: navigation, children: children, testId: testId })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $2f4d1a89146de6ed$var$wrapperStyles,
        "data-testid": testId
    }, banner ? /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $2f4d1a89146de6ed$var$bannerContainerStyles,
        style: {
            height: isBannerOpen ? `${bannerHeight}px` : '0'
        },
        "aria-hidden": !isBannerOpen,
        "data-testid": testId ? `${testId}--banner-container` : undefined
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $2f4d1a89146de6ed$var$bannerStyles
    }, banner)) : null, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $2f4d1a89146de6ed$var$mainContainerStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $2f4d1a89146de6ed$var$navigationStyles
    }, navigation), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $2f4d1a89146de6ed$var$pageContentStyles
    }, children)));
};
var $2f4d1a89146de6ed$export$2e2bcd8739ae039 = $2f4d1a89146de6ed$var$Page;

});
parcelRegister("f1WIN", function(module, exports) {

$parcel$export(module.exports, "defaultGridColumns", () => $196a11a7b8c2fbef$export$74797698e12f8baa);
$parcel$export(module.exports, "defaultGridColumnWidth", () => $196a11a7b8c2fbef$export$b8241a1616ab1b96);
$parcel$export(module.exports, "spacingMapping", () => $196a11a7b8c2fbef$export$2a89a65a43bab52d);
$parcel$export(module.exports, "defaultSpacing", () => $196a11a7b8c2fbef$export$8ec7372efd74b753);
$parcel$export(module.exports, "defaultBannerHeight", () => $196a11a7b8c2fbef$export$d77f83c3d17a7b8a);
$parcel$export(module.exports, "defaultMedium", () => $196a11a7b8c2fbef$export$f8725d21f81f3e01);
$parcel$export(module.exports, "defaultLayout", () => $196a11a7b8c2fbef$export$2303d2bd9eeff99a);
$parcel$export(module.exports, "varColumnsNum", () => $196a11a7b8c2fbef$export$9ddc3632bbfb8966);
$parcel$export(module.exports, "varColumnSpan", () => $196a11a7b8c2fbef$export$8b7e31f391e6e681);
$parcel$export(module.exports, "varGridSpacing", () => $196a11a7b8c2fbef$export$936829b4511db3e4);
const $196a11a7b8c2fbef$export$3aaf3a78c909ea56 = 8;
const $196a11a7b8c2fbef$export$74797698e12f8baa = 12;
const $196a11a7b8c2fbef$export$b8241a1616ab1b96 = $196a11a7b8c2fbef$export$3aaf3a78c909ea56 * 10;
const $196a11a7b8c2fbef$export$2a89a65a43bab52d = {
    comfortable: $196a11a7b8c2fbef$export$3aaf3a78c909ea56 * 5,
    cosy: $196a11a7b8c2fbef$export$3aaf3a78c909ea56 * 2,
    compact: $196a11a7b8c2fbef$export$3aaf3a78c909ea56 * 0.5
};
const $196a11a7b8c2fbef$export$8ec7372efd74b753 = 'cosy';
const $196a11a7b8c2fbef$export$d77f83c3d17a7b8a = 52;
const $196a11a7b8c2fbef$export$f8725d21f81f3e01 = 0;
const $196a11a7b8c2fbef$export$2303d2bd9eeff99a = 'fixed';
const $196a11a7b8c2fbef$export$9ddc3632bbfb8966 = '--ds-columns-num';
const $196a11a7b8c2fbef$export$8b7e31f391e6e681 = '--ds-column-span';
const $196a11a7b8c2fbef$export$936829b4511db3e4 = '--ds-grid-spacing';

});


parcelRegister("bJcWY", function(module, exports) {

$parcel$export(module.exports, "default", () => $08fe944bdcd177c2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $f1WIN = parcelRequire("f1WIN");

var $itnZ9 = parcelRequire("itnZ9");

var $aZdfU = parcelRequire("aZdfU");

var $ephoW = parcelRequire("ephoW");
/**
 * __Grid__
 *
 * A grid contains one or more `GridColumn` to provide a grid layout.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $08fe944bdcd177c2$var$GridWrapper = ({ spacing: spacingProp, columns: columnsProp, layout: layout, testId: testId, children: children, theme: theme })=>{
    /**
	 * isRoot is `true` only in the default context (i.e. no ancestor Grid).
	 */ const { isRoot: isRoot } = (0, $5uXOq.useContext)((0, $ephoW.GridContext));
    const { medium: medium } = (0, $5uXOq.useContext)((0, $aZdfU.GridColumnContext));
    /**
	 * The colspan of the current containing GridColumn provides
	 * the default amount of columns in a nested grid.
	 */ const defaultColumns = medium > 0 ? medium : (0, $f1WIN.defaultGridColumns);
    /**
	 * This is to account for the eventual removal of the `theme` prop. In theory, this should not be exposed.
	 * However, consumers are still using it - there should be a major rerelease with the complete removal of this prop later.
	 */ const spacing = spacingProp ?? theme?.spacing ?? (0, $f1WIN.defaultSpacing);
    const columns = columnsProp ?? theme?.columns ?? defaultColumns;
    const isNested = theme?.isNestedGrid ?? !isRoot;
    const contextValue = (0, $5uXOq.useMemo)(()=>({
            isRoot: false,
            isNested: isNested,
            spacing: spacing,
            columns: columns
        }), [
        spacing,
        columns,
        isNested
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ephoW.GridContext).Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $itnZ9.Grid), {
        layout: layout,
        testId: testId
    }, children));
};
var $08fe944bdcd177c2$export$2e2bcd8739ae039 = $08fe944bdcd177c2$var$GridWrapper;

});
parcelRegister("itnZ9", function(module, exports) {

$parcel$export(module.exports, "Grid", () => $92e4fcbfc398e3a4$export$ef2184bd89960b14);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $f1WIN = parcelRequire("f1WIN");

var $ephoW = parcelRequire("ephoW");
function $92e4fcbfc398e3a4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $92e4fcbfc398e3a4$var$gridStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    margin: '0 auto',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `0 calc(var(${(0, $f1WIN.varGridSpacing)}) / 2)`,
    position: 'relative',
    alignItems: 'flex-start',
    flexWrap: 'wrap'
});
const $92e4fcbfc398e3a4$var$gridLayoutStyles = {
    fixed: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(var(${(0, $f1WIN.varColumnsNum)}) * ${(0, $f1WIN.defaultGridColumnWidth)}px)`
    }),
    fluid: {
        name: "qhxz92",
        styles: "max-width:100%"
    }
};
const $92e4fcbfc398e3a4$var$nestedGridStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `0 calc(-1 * var(${(0, $f1WIN.varGridSpacing)}))`
});
const $92e4fcbfc398e3a4$export$ef2184bd89960b14 = ({ layout: layout = (0, $f1WIN.defaultLayout), testId: testId, children: children })=>{
    const { isNested: isNested, columns: columns, spacing: spacing } = (0, $5uXOq.useContext)((0, $ephoW.GridContext));
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $92e4fcbfc398e3a4$var$gridStyles,
            $92e4fcbfc398e3a4$var$gridLayoutStyles[layout],
            isNested && $92e4fcbfc398e3a4$var$nestedGridStyles
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $f1WIN.varColumnsNum)]: columns,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $f1WIN.varGridSpacing)]: `${(0, $f1WIN.spacingMapping)[spacing]}px`
        },
        "data-testid": testId
    }, children);
};

});
parcelRegister("ephoW", function(module, exports) {

$parcel$export(module.exports, "GridContext", () => $529bf77650fbff0f$export$11cae3e04ab99fae);

var $5uXOq = parcelRequire("5uXOq");

var $f1WIN = parcelRequire("f1WIN");
const $529bf77650fbff0f$export$11cae3e04ab99fae = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isRoot: true,
    isNested: false,
    spacing: (0, $f1WIN.defaultSpacing),
    columns: (0, $f1WIN.defaultGridColumns)
});

});


parcelRegister("aZdfU", function(module, exports) {

$parcel$export(module.exports, "GridColumnContext", () => $11b791725219e059$export$1229ad7112b989f5);
$parcel$export(module.exports, "default", () => $11b791725219e059$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $f1WIN = parcelRequire("f1WIN");

var $ephoW = parcelRequire("ephoW");
/**
 * Determines the method by which column width is calculated.
 */ var $11b791725219e059$var$ColumnVariant = /*#__PURE__*/ function(ColumnVariant) {
    /**
   * Column occupies available space.
   *
   * Used when `medium` is 0 (the default).
   */ ColumnVariant["Auto"] = "auto";
    /**
   * Column occupies specified space.
   *
   * Used when 0 < `medium` < `columns`.
   */ ColumnVariant["Bounded"] = "bounded";
    /**
   * Column occupies entire row.
   *
   * Used when `medium` >= `columns`.
   *
   * This case is handled separately because of rounding.
   */ ColumnVariant["FullWidth"] = "fullWidth";
    return ColumnVariant;
}($11b791725219e059$var$ColumnVariant || {});
const $11b791725219e059$var$getVariant = ({ medium: medium, columns: columns })=>{
    if (medium === (0, $f1WIN.defaultMedium)) return "auto";
    else if (medium < columns) return "bounded";
    return "fullWidth";
};
/**
 * IE11 and Edge both have rounding issues for flexbox which is why a width of
 * 99.9999% is used. Using 100% here causes columns to wrap prematurely.
 */ const $11b791725219e059$var$availableWidth = '99.9999%';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $11b791725219e059$var$singleColumnWidth = `(${$11b791725219e059$var$availableWidth} / var(${(0, $f1WIN.varColumnsNum)}))`;
const $11b791725219e059$var$gridColumnStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minWidth: `calc(${$11b791725219e059$var$singleColumnWidth} - var(${(0, $f1WIN.varGridSpacing)}))`,
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `0 calc(var(${(0, $f1WIN.varGridSpacing)}) / 2)`,
    flexGrow: 1,
    flexShrink: 0,
    wordWrap: 'break-word'
});
const $11b791725219e059$var$gridColumnWidthStyles = {
    ["auto"]: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(100% - var(${(0, $f1WIN.varGridSpacing)}))`,
        flexBasis: `auto`
    }),
    ["bounded"]: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(${$11b791725219e059$var$singleColumnWidth} *  var(${(0, $f1WIN.varColumnSpan)}) - var(${(0, $f1WIN.varGridSpacing)}))`,
        flexBasis: `100%`
    }),
    ["fullWidth"]: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(100% - var(${(0, $f1WIN.varGridSpacing)}))`,
        flexBasis: `100%`
    })
};
const $11b791725219e059$export$1229ad7112b989f5 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    medium: (0, $f1WIN.defaultMedium)
});
/**
 * __Grid column__
 *
 * A grid column can span one or more column positions within a grid.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $11b791725219e059$var$GridColumn = ({ medium: medium = (0, $f1WIN.defaultMedium), children: children, testId: testId })=>{
    const { columns: columns } = (0, $5uXOq.useContext)((0, $ephoW.GridContext));
    const contextValue = (0, $5uXOq.useMemo)(()=>({
            medium: medium
        }), [
        medium
    ]);
    /**
   * The real column span,
   * obtained by clamping the passed `medium` value within the allowed range.
   */ const colSpan = Math.max(1, Math.min(medium, columns));
    /**
   * How we should calculate the column width.
   */ const variant = $11b791725219e059$var$getVariant({
        medium: medium,
        columns: columns
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($11b791725219e059$export$1229ad7112b989f5.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $11b791725219e059$var$gridColumnStyles,
            $11b791725219e059$var$gridColumnWidthStyles[variant]
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            /**
       * The 'auto' value here isn't actually consumed anywhere and is
       * just to better reflect what is happening when inspecting CSS.
       */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $f1WIN.varColumnSpan)]: variant === "auto" ? 'auto' : colSpan
        },
        "data-testid": testId
    }, children));
};
var $11b791725219e059$export$2e2bcd8739ae039 = $11b791725219e059$var$GridColumn;

});







//# sourceMappingURL=async-servicedesk-cmdb-landing-page.130fe69e.js.map
